
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5hBzO", function(module, exports) {
/* InvitePeople.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ggbZE = parcelRequire("ggbZE");


var $u9agA = parcelRequire("u9agA");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $lMdlY = parcelRequire("lMdlY");


var $es0xC = parcelRequire("es0xC");

var $24xEE = parcelRequire("24xEE");


var $5LksM = parcelRequire("5LksM");


var $bTj8C = parcelRequire("bTj8C");

/* InvitePeopleComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $7hXDW = parcelRequire("7hXDW");


var $gdv5Z = parcelRequire("gdv5Z");



var $iXCQx = parcelRequire("iXCQx");


var $6Co6F = parcelRequire("6Co6F");


var $dh538 = parcelRequire("dh538");


var $2dswi = parcelRequire("2dswi");


var $7XlxB = parcelRequire("7XlxB");




const $bc2394fc0ac6358f$var$mapToInviteResultList = (result = {})=>Object.keys(result).map((resourceAri)=>({
            resourceAri: resourceAri,
            status: result[resourceAri]
        }));
const $bc2394fc0ac6358f$export$9ef30cb834a0dc18 = 'productSelect';
class $bc2394fc0ac6358f$export$314fcea5dcdb0997 extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    inviteRequestSucceeded(products, response, isRecaptchaTokenPresent, inviteFromSuccessModal) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITE_REQUEST,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: {
                integration: source,
                permissionLevel: userRole,
                products: products,
                invited: response.invited,
                accessRequested: response.accessRequested,
                error: response.error,
                isRecaptchaTokenPresent: isRecaptchaTokenPresent,
                inviteFromSuccessModal: inviteFromSuccessModal
            }
        });
    }
    productSelectDropdownOpened(attributes) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        const { productOptions: productOptions, selectedProducts: selectedProducts } = attributes;
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).DROPDOWN,
            actionSubjectId: $bc2394fc0ac6358f$export$9ef30cb834a0dc18,
            action: (0, $5LksM.AnalyticsAction).OPENED,
            attributes: {
                integration: source,
                source: source,
                userRole: userRole,
                productOptions: productOptions,
                selectedProducts: selectedProducts
            }
        });
    }
    userInvited(attributes) {
        const { originAttributes: originAttributes, userId: userId, products: products, inviteResult: inviteResult, externalUserType: externalUserType, externalUserSubtype: externalUserSubtype, isUserEmailVisible: isUserEmailVisible, ...rest } = attributes;
        const { inviteFromAssignModalCohort: inviteFromAssignModalCohort, isEligibleForInviteAndAssignFromBoard: isEligibleForInviteAndAssignFromBoard, source: source, userRole: userRole, experimentalFeatures: experimentalFeatures } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER,
            actionSubjectId: userId,
            action: (0, $5LksM.AnalyticsAction).INVITED,
            attributes: {
                ...originAttributes,
                permissionLevel: userRole,
                products: products,
                integration: source,
                inviteResult: $bc2394fc0ac6358f$var$mapToInviteResultList(inviteResult),
                externalUserType: externalUserType,
                externalUserSubtype: externalUserSubtype,
                isUserEmailVisible: isUserEmailVisible,
                ...isEligibleForInviteAndAssignFromBoard && {
                    inviteAndAssignFromBoardCohort: 'control'
                },
                experimentalFeatures: experimentalFeatures,
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                ...rest
            }
        });
    }
    userAccessRequested(attributes) {
        const { originAttributes: originAttributes, userId: userId, products: products, inviteResult: inviteResult, externalUserType: externalUserType, externalUserSubtype: externalUserSubtype, isUserEmailVisible: isUserEmailVisible, ...rest } = attributes;
        const { inviteFromAssignModalCohort: inviteFromAssignModalCohort, source: source, userRole: userRole } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).PRODUCT_ACCESS,
            actionSubjectId: userId,
            action: (0, $5LksM.AnalyticsAction).REQUESTED,
            attributes: {
                ...originAttributes,
                permissionLevel: userRole,
                products: products,
                requestedForUserId: userId,
                integration: source,
                inviteResult: $bc2394fc0ac6358f$var$mapToInviteResultList(inviteResult),
                externalUserType: externalUserType,
                externalUserSubtype: externalUserSubtype,
                isUserEmailVisible: isUserEmailVisible,
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                ...rest
            }
        });
    }
    inviteRequestFailed(products, isRecaptchaTokenPresent, code, message, status, inviteFromSuccessModal) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITE_REQUEST,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                code: code,
                message: message,
                permissionLevel: userRole,
                products: products,
                integration: source,
                status: status,
                isRecaptchaTokenPresent: isRecaptchaTokenPresent,
                inviteFromSuccessModal: inviteFromSuccessModal
            }
        });
    }
    fetchingEligibleUsersFailed(products) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).FETCH_ELIGIBLE_USERS,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                permissionLevel: userRole,
                products: products,
                integration: source
            }
        });
    }
    userInviteSettingsFailed(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_INVITE_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    inviteFormLoaded(duration, hasPermissionToInviteOrRequestAccess) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITE_FORM,
            action: (0, $5LksM.AnalyticsAction).LOADED,
            attributes: {
                integration: source,
                duration: duration,
                hasPermissionToInviteOrRequestAccess: hasPermissionToInviteOrRequestAccess
            }
        });
    }
    componentCompleteLoaded(duration, hasPermissionToInviteOrRequestAccess) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).CORE_INVITE_COMPONENT,
            action: (0, $5LksM.AnalyticsAction).LOADED,
            attributes: {
                integration: source,
                duration: duration,
                hasPermissionToInviteOrRequestAccess: hasPermissionToInviteOrRequestAccess
            }
        });
    }
    inviteComponentViewed(attributes) {
        const { disableNoInviteError: disableNoInviteError, inviteFromAssignModalCohort: inviteFromAssignModalCohort, plugins: plugins, productTitle: productTitle, source: source, userRole: userRole, viewAs: viewAs, experimentalFeatures: experimentalFeatures } = this.commonAttributes;
        const pluginsLocation = plugins ? Object.keys(plugins).map((location)=>location) : undefined;
        this.fireScreen({
            name: (0, $5LksM.AnalyticsActionSubject).CORE_INVITE_COMPONENT,
            attributes: {
                ...attributes,
                disableNoInviteError: disableNoInviteError,
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                pluginsLocation: pluginsLocation,
                product: productTitle,
                source: source,
                userRole: userRole,
                viewAs: viewAs,
                invitePromptOnLinkV3Cohort: experimentalFeatures?.invitePromptOnLinkV3 ?? false
            }
        });
    }
    getPermsFailed(resourceId, message) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).PERMS,
            actionSubjectId: resourceId,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                message: message
            }
        });
    }
    getPermsSucceeded(resourceId, isInviteUsersPermitted, isManagePermitted) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).PERMS,
            actionSubjectId: resourceId,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: {
                isInviteUsersPermitted: isInviteUsersPermitted,
                isManagePermitted: isManagePermitted
            }
        });
    }
    accountInfoFailed(error) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).ACCOUNT_INFO,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
    approvedDomainsSettingsFailed(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).APPROVED_DOMAIN_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    inviteFailedSLO(isAioliv3Enabled, code, message, status) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_INVITE_REQUEST,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                isAioliv3Enabled: isAioliv3Enabled,
                status: status,
                code: code,
                message: message,
                integration: source
            }
        });
    }
    inviteSucceededSLO(isAioliv3Enabled) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_INVITE_REQUEST,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: {
                isAioliv3Enabled: isAioliv3Enabled,
                integration: source
            }
        });
    }
    approvedDomainsSettingsSucceededSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireTrack({
            // Matches naming from admin hub
            actionSubject: (0, $5LksM.AnalyticsActionSubject).APPROVED_DOMAIN_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).UPDATED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    approvedDomainsSettingsFailedSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_APPROVED_DOMAIN_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    userInviteSettingsSucceededSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireTrack({
            // Matches naming from admin hub
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_INVITE_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).UPDATED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    userInviteSettingsFailedSLO(attributes) {
        const { flow: flow } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_USER_INVITE_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).UPDATE_FAILED,
            attributes: {
                flow: flow,
                ...attributes
            }
        });
    }
    featuredUserTagClicked(attr) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        const attributes = {
            featuredUserId: attr.featuredUser.id
        };
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).FEATURED_USER_TAG,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                integration: source,
                permissionLevel: userRole,
                ...attributes
            }
        });
    }
    featuredUsersInviteSucceeded(attributes) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).FEATURED_USERS,
            action: (0, $5LksM.AnalyticsAction).INVITED,
            attributes: {
                integration: source,
                permissionLevel: userRole,
                ...attributes
            }
        });
    }
    copyLinkButtonClicked({ originAttributes: originAttributes }) {
        this.fireUI({
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: 'copyInviteLink',
            attributes: {
                ...this.commonAttributes,
                ...originAttributes
            }
        });
    }
}



var $j9g2s = parcelRequire("j9g2s");


var $cgtv4 = parcelRequire("cgtv4");

const $c35877e38bf8c63c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    formTitle: {
        id: "ptc.ip.form.title.people.experiment",
        defaultMessage: "Add people"
    },
    formTitleProduct: {
        id: "ptc.ip.users.form.title.product.people.experiment",
        defaultMessage: "Add people to {product}"
    },
    formMoreActionsButtonLabel: {
        id: "ptc.ip.form.moreActionsDropdown.label",
        defaultMessage: "More actions"
    },
    formManageAccessSettingsLabel: {
        id: "ptc.ip.form.siteAccessSettings.label",
        defaultMessage: "Site access settings"
    },
    sendInviteButton: {
        id: "ptc.ip.form.sendButton.count.experiment",
        defaultMessage: "{numberOfInputs, plural, =0 {Add} one {Add {numberOfInputs} person} other {Add {numberOfInputs} people}}"
    },
    usersSendInviteButton: {
        id: "ptc.ip.users.form.sendButton",
        defaultMessage: "Add teammates"
    },
    cancelButton: {
        id: "ptc.ip.form.cancelButton",
        defaultMessage: "Cancel"
    },
    invalidEmailMessage: {
        id: "ptc.ip.form.invalid-email-message",
        defaultMessage: "Please enter a valid email address"
    },
    emptyEmailMessage: {
        id: "ptc.ip.form.empty-email-message.person",
        defaultMessage: "Choose at least one person"
    },
    noProductSelectedMessage: {
        id: "ptc.ip.form.no-product-selected-message.choose.alt",
        defaultMessage: "Select at least one product"
    },
    productSelect: {
        id: "ptc.ip.form.select-products.label.choose.experiment",
        defaultMessage: "Add to other Atlassian products?"
    },
    productSelectNoCurrentProduct: {
        id: "ptc.ip.form.select-products.label.no.current.product",
        defaultMessage: "Select one or more products"
    },
    jiraCoreMessage: {
        id: "ptc.ip.form.jira-core-message",
        defaultMessage: "Jira Core is included with other Jira products."
    },
    optionIncludedWithOtherJiraProducts: {
        id: "people-and-teams.invite-people.form.option-included-with-other-jira-products",
        defaultMessage: "Included with other Jira products"
    },
    emailInputLabel: {
        id: "ptc.ip.form.email-input-label",
        defaultMessage: "Email address"
    },
    inviteSuccessFlagDescriptionSingleProduct: {
        id: "ptc.ip.flag.invite-success-flag-description-single-product",
        defaultMessage: "{inviteCount, plural, one {You've invited {emailInvited} to {product}.} other {You've invited {inviteCount} people to {product}.}}"
    },
    zeroRequestAccessFlagDescription: {
        id: "ptc.ip.flag.zero-request-access-flag-description",
        defaultMessage: "You have not requested access for anyone."
    },
    contactSupportActionLabel: {
        id: "ptc.ip.flag.contact-support-action-label",
        defaultMessage: "Contact support"
    },
    viewUsersActionLabel: {
        id: "ptc.ip.flag.view-users-action-label",
        defaultMessage: "View users"
    },
    upgradePlanActionLabel: {
        id: "ptc.ip.flag.upgrade-plan-action-label",
        defaultMessage: "Upgrade plan"
    },
    jiraCoreOptionSubText: {
        id: "ptc.ip.jira.core.option.subtext",
        defaultMessage: "Included with other Jira products"
    },
    selectPlaceholder: {
        id: "ptc.ip.product.select.placeholder.experiment",
        defaultMessage: "Select products"
    },
    selectAllOption: {
        id: "ptc.ip.product.select.alloption.choose",
        defaultMessage: "Choose all"
    },
    inviteeListUserPickerPlaceholder: {
        id: "ptc.ip.form.invitee-list.user-picker.email.placeholder.experiment",
        defaultMessage: "e.g., Maria, maria@company.com"
    },
    inviteeListLabel: {
        id: "ptc.ip.form.invitee-list.label",
        defaultMessage: "Add with email"
    },
    inviteeListLabelThirdParty: {
        id: "ptc.ip.form.invitee-list-third-party.no-integrations.label.invite.experiment",
        defaultMessage: "Names or emails"
    },
    inviteSelfMessage: {
        id: "ptc.ip.form.invalid-self-invite",
        defaultMessage: "Remove your own name or email \u2014 you can't add yourself."
    },
    invalidMultipleEmailMessage: {
        id: "ptc.ip.form.invalid-multiple-email-message",
        defaultMessage: "To send your invites, please correct any invalid addresses."
    },
    tooManyEmailAddresses: {
        id: "ptc.ip.form.too-many-email-addresses",
        defaultMessage: "You can only send up to {maxEmails, plural, one {{maxEmails} email invite} other {{maxEmails} email invites}} at once."
    },
    tooManyEmailAddressesInProject: {
        id: "ptc.ip.form.too-many-email-addresses-in-projects",
        defaultMessage: "You can only add up to {maxEmails, plural, one {{maxEmails} person} other {{maxEmails} people}} at once."
    },
    inviteeListNote: {
        id: "ptc.ip.form.invitee-list.note",
        defaultMessage: "Enter up to {maxEmails, plural, one {{maxEmails} email address} other {{maxEmails} email addresses}}, separated by a comma."
    },
    inviteeListPickerNote: {
        id: "ptc.ip.form.invitee-list-picker.note.choose",
        defaultMessage: "Choose at least one person"
    },
    inviteeListPickerNoteAlt: {
        id: "ptc.ip.form.invitee-list-picker.note.choose.alt",
        defaultMessage: "Select at least one person"
    },
    googleThirdPartyConnectedTooltip: {
        id: "ptc.ip.thirdparty.google.connected.tooltip",
        defaultMessage: "Disconnect Google"
    },
    googleThirdPartyButton: {
        id: "ptc.ip.thirdparty.google.button",
        defaultMessage: "Google"
    },
    microsoftThirdPartyConnectedTooltip: {
        id: "ptc.ip.thirdparty.microsoft.connected.tooltip",
        defaultMessage: "Disconnect Microsoft"
    },
    microsoftThirdPartyButton: {
        id: "ptc.ip.thirdparty.microsoft.button",
        defaultMessage: "Microsoft"
    },
    slackThirdPartyConnectedTooltip: {
        id: "ptc.ip.thirdparty.slack.connected.tooltip",
        defaultMessage: "Manage this connection"
    },
    slackThirdPartyButton: {
        id: "ptc.ip.thirdparty.slack.button",
        defaultMessage: "Slack"
    },
    unknownThirdParty: {
        id: "ptc.ip.thirdparty.unknown.button",
        defaultMessage: "Unknown"
    },
    thirdPartyConnect: {
        id: "ptc.ip.thirdparty-connect.connect.label.people.experiment",
        defaultMessage: "or add from"
    },
    thirdPartyConnectedTo: {
        id: "ptc.ip.thirdparty.connect-to.label",
        defaultMessage: "Connected to"
    },
    slackWorkspacesConnectDialogHeading: {
        id: "ptc.ip.slack.workspaces.connect.dialog.heading",
        defaultMessage: "Connect Slack workspace"
    },
    slackWorkspacesManageDialogHeading: {
        id: "ptc.ip.slack.workspaces.manage.dialog.heading",
        defaultMessage: "Manage Slack connection"
    },
    slackWorkspacesDialogBody: {
        id: "ptc.ip.slack.workspaces.dialog.body",
        defaultMessage: "Select one workspace that you\u2019d like to invite users from."
    },
    slackWorkspacesDialogDisconnectSlack: {
        id: "ptc.ip.slack.workspaces.dialog.disconnect.slack",
        defaultMessage: "Disconnect Slack"
    },
    slackWorkspacesDoneButton: {
        id: "ptc.ip.slack.workspaces.dialog.connet-workspace",
        defaultMessage: "Connect workspace"
    },
    slackWorkspacesDisconnectDialogHeading: {
        id: "ptc.ip.slack.workspaces.disconnect.dialog.heading",
        defaultMessage: "Disconnect Slack"
    },
    slackWorkspacesDisconnectDialogBody: {
        id: "ptc.ip.slack.workspaces.disconnect.dialog.body",
        defaultMessage: "You're about to disconnect this Slack workspace and limit your ability to search through its contacts."
    },
    disconnectButton: {
        id: "ptc.ip.slack.disconnect.dialog.disconnect.button",
        defaultMessage: "Disconnect"
    },
    slackConnectSuccessFlagTitle: {
        id: "ptc.ip.flag.slack-connect-success-flag-title",
        defaultMessage: "\u2018{workspace}\u2019 from Slack connected"
    },
    slackConnectSuccessFlagDescription: {
        id: "ptc.ip.flag.slack-connect-success-flag-description",
        defaultMessage: "You can now search through this workspace\u2019s list of contacts."
    },
    slackDisconnectSuccessFlagTitle: {
        id: "ptc.ip.flag.slack-disconnect-success-flag-title",
        defaultMessage: "Slack disconnected"
    },
    slackDiscnnectSuccessFlagDescription: {
        id: "ptc.ip.flag.slack-disconnect-success-flag-description",
        defaultMessage: "You can no longer search through this workspace\u2019s list of contacts."
    },
    microsoftConnectSuccessFlagTitle: {
        id: "ptc.ip.flag.microsoft-connect-success-flag-title",
        defaultMessage: "Microsoft connected"
    },
    microsoftConnectSuccessFlagDescription: {
        id: "ptc.ip.flag.microsoft-connect-success-flag-description",
        defaultMessage: "You can now search through its list of contacts."
    },
    googleConnectSuccessFlagTitle: {
        id: "ptc.ip.flag.google-connect-success-flag-title",
        defaultMessage: "Google Workspace connected"
    },
    googleConnectSuccessFlagDescription: {
        id: "ptc.ip.flag.google-connect-success-flag-description",
        defaultMessage: "You can now search through its list of contacts."
    },
    errorHeading: {
        id: "ptc.ip.error-heading",
        defaultMessage: "Something\u2019s gone wrong"
    },
    errorText: {
        id: "ptc.ip.error-text",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things"
    },
    errorImageAltText: {
        id: "ptc.ip.error-image-alt-text",
        defaultMessage: "A broken robot and a number of people busy fixing it."
    },
    viralSettingsHeading: {
        id: "ptc.ip.viral-settings.heading.experiment",
        defaultMessage: "Allow"
    },
    directAccessDescription: {
        id: "ptc.ip.viral-settings.direct-access.description.experiment",
        defaultMessage: "Verified {domainWithStyling} email users to join."
    },
    directAccessExtendedDescription: {
        id: "ptc.ip.viral-settings.open-invite.extended-description",
        defaultMessage: "People in your org can join without an invite when they need to collaborate."
    },
    openInviteDescription: {
        id: "ptc.ip.viral-settings.open-invite.description.users.experiment",
        defaultMessage: "Site users to invite other people."
    },
    openInviteSuccessFlagTitle: {
        id: "ptc.ip.flag.viral-settings.open-invite.success.title",
        defaultMessage: "You updated {product} invite settings"
    },
    openInviteSuccessFlagDescription: {
        id: "ptc.ip.flag.viral-settings.open-invite.success.description",
        defaultMessage: "Your teammates can now invite other people without your approval."
    },
    openInviteFailureFlagTitle: {
        id: "ptc.ip.flag.viral-settings.open-invite.failure.title",
        defaultMessage: "We couldn\u2019t save your invite settings"
    },
    openInviteFailureFlagDescription: {
        id: "ptc.ip.flag.viral-settings.open-invite.failure.description",
        defaultMessage: "Go to Administration to allow your teammates to invite other people to {product}."
    },
    viralSettingsSuccessFlagActionLabel: {
        id: "ptc.ip.flag.viral-settings.success.action-label",
        defaultMessage: "See access settings"
    },
    viralSettingsFailureFlagActionLabel: {
        id: "ptc.ip.flag.viral-settings.failure.action-label",
        defaultMessage: "See access settings in Administration"
    },
    directAccessSuccessFlagTitle: {
        id: "ptc.ip.flag.viral-settings.direct-access.success.title",
        defaultMessage: "You updated {product} join settings"
    },
    directAccessSuccessFlagDescription: {
        id: "ptc.ip.flag.viral-settings.direct-access.success.description",
        defaultMessage: "New users with a verified {domains} email address can now join without an invite."
    },
    directAccessFailureFlagTitle: {
        id: "ptc.ip.flag.viral-settings.direct-access.failure.title",
        defaultMessage: "We couldn\u2019t save your join settings"
    },
    directAccessFailureFlagDescription: {
        id: "ptc.ip.flag.viral-settings.direct-access.failure.description",
        defaultMessage: "Go to Administration to allow new users with a verified {domain} email address to join {product}."
    },
    viralSettingsSuccessFlagTitle: {
        id: "ptc.ip.flag.viral-settings.success.title",
        defaultMessage: "You updated {product} access settings"
    },
    viralSettingsSuccessFlagDescription: {
        id: "ptc.ip.flag.viral-settings.success.description",
        defaultMessage: "Users can invite new users, and org members with a verified {domains} email can join without an invite."
    },
    viewTeamActionLabel: {
        id: "ptc.ip.flag.view-team-action-label",
        defaultMessage: "View team"
    },
    openInviteExtendedDescription: {
        id: "ptc.ip.viral-settings.direct-access.extended-description",
        defaultMessage: "Your users will be able to invite new collaborators as needed."
    },
    slackWorkspaceAddNewWorkspaceOption: {
        id: "ptc.ip.slack.workspace.dropdown.add-new-workspace",
        defaultMessage: "Add a new Workspace"
    },
    infiSpotlightTitle: {
        id: "ptc.ip.thirdparty.spotlight.title",
        defaultMessage: "Connect and find people faster"
    },
    infiSpotlightDescription: {
        id: "ptc.ip.thirdparty.spotlight.description",
        defaultMessage: "Connect your Google, Microsoft, and Slack accounts to quickly find and add your teammates to this site."
    },
    infiSpotlightAction: {
        id: "ptc.ip.infi.spotlight.action",
        defaultMessage: "OK"
    },
    adminSyncSlackContactsDescription: {
        id: "ptc.ip.third.party.users.dropdown.sync-option-description",
        defaultMessage: "Allow people to search for Slack contacts. Manage in admin.atlassian.com"
    },
    adminSyncSlackContactsOption: {
        id: "ptc.ip.third.party.users.dropdown.sync-option-label",
        defaultMessage: "Help teams find Slack contacts"
    },
    adminManageConnectionOption: {
        id: "ptc.ip.slack.menu.dropdown.manage-connection-label",
        defaultMessage: "Manage Slack connection"
    },
    thirdPartyAdminOnboardingSpotlight1Heading: {
        id: "ptc.ip.slack.admin-onboarding.spotlight1.heading",
        defaultMessage: "Help teams find the right people"
    },
    thirdPartyAdminOnboardingSpotlight1Body: {
        id: "ptc.ip.slack.admin-onboarding.spotlight1.body",
        defaultMessage: "Allow users to quickly find and add people from Slack."
    },
    thirdPartyAdminOnboardingSpotlight1Next: {
        id: "ptc.ip.slack.admin-onboarding.spotlight1.next",
        defaultMessage: "See how"
    },
    thirdPartyAdminOnboardingSpotlight2Body: {
        id: "ptc.ip.slack.admin-onboarding.spotlight2.body",
        defaultMessage: "Add Slack accounts, control access in admin.atlassian.com"
    },
    thirdPartyAdminOnboardingSpotlight2Import: {
        id: "ptc.ip.slack.admin-onboarding.spotlight1.import",
        defaultMessage: "Add accounts"
    },
    thirdPartyAdminOnboardingSpotlightDismiss: {
        id: "ptc.ip.slack.admin-onboarding.spotlight.dismiss",
        defaultMessage: "Not now"
    },
    reviewConnection: {
        id: "ptc.ip.thirdparty.review-connection.notification",
        defaultMessage: "{integration} was disconnected because of an update. Reconnect to invite people from {integration}."
    },
    reviewConnectionTitle: {
        id: "ptc.ip.thirdparty.review-connection.title",
        defaultMessage: "Reconnect {integration}"
    },
    reviewConnectionDescription: {
        id: "ptc.ip.thirdparty.review-connection.description",
        defaultMessage: "To continue inviting teammates from {integration}, reconnect to the app."
    },
    reviewAccessNoScope: {
        id: "ptc.ip.thirdparty.review-access.no.access.notification",
        defaultMessage: "We can\u2019t access your {integration} contacts. Let\u2019s fix it."
    },
    reviewAccessNoScopeTitle: {
        id: "ptc.ip.thirdparty.review-access.no.acess.title",
        defaultMessage: "Finish approving access"
    },
    reviewAccessNoScopeDescription: {
        id: "ptc.ip.thirdparty.review-access.no.access.description",
        defaultMessage: "To help you find people from {integration}, we need to access your contacts list."
    },
    reviewAccessPartialScope: {
        id: "ptc.ip.thirdparty.review-access.partial.notification",
        defaultMessage: "Check {integration} access settings"
    },
    reviewAccessPartialAccessTitle: {
        id: "ptc.ip.thirdparty.review-access.partial.title",
        defaultMessage: "Accessing your {integration} {space}"
    },
    reviewAccessPartialAccessDescription: {
        id: "ptc.ip.thirdparty.review-access.partial.access.description",
        defaultMessage: "We can only search your {integration} contact's list. Want to find more people? Give us access to your {integration} {space} too."
    },
    reviewAccessContinue: {
        id: "ptc.ip.thirdparty.review-access.continue",
        defaultMessage: "Continue"
    },
    reviewAccessDisconnect: {
        id: "ptc.ip.thirdparty.review-access.disconnect",
        defaultMessage: "Disconnect"
    },
    reviewAccessNotNow: {
        id: "ptc.ip.thirdparty.review-access.not-now",
        defaultMessage: "Not now"
    },
    googleSpace: {
        id: "ptc.ip.thirdparty.google.space",
        defaultMessage: "Workspace"
    },
    secondarySectionHeading: {
        id: "ptc.ip.secondary.section.heading",
        defaultMessage: "Other products and access"
    },
    secondarySectionHeadingWithProductSelector: {
        id: "ptc.ip.secondary.section.heading.product.selector.only",
        defaultMessage: "Other products"
    },
    secondarySectionHeadingWithViralSettings: {
        id: "ptc.ip.secondary.section.heading.viral.settings.only",
        defaultMessage: "Access"
    },
    secondarySectionHeadingNoCurrentProduct: {
        id: "ptc.ip.secondary.section.heading.no.current.product.and.viral.settings",
        defaultMessage: "Select products and access"
    },
    secondarySectionHeadingWithProductSelectorNoCurrentProduct: {
        id: "ptc.ip.secondary.section.heading.no.current.product",
        defaultMessage: "Select products"
    },
    teamsInviteSectionHeading: {
        id: "ptc.ip.teams-invite-section.heading",
        defaultMessage: "Teams"
    },
    teamsInviteSectionNewLozenge: {
        id: "ptc.ip.teams-invite-section.new-lozenge",
        defaultMessage: "New"
    },
    teamsInviteSectionCheckboxLabel: {
        id: "ptc.ip.teams-invite-section.checkbox-label",
        defaultMessage: "Add invited people to a new or existing team"
    },
    teamsInviteSectionCheckboxTooltipPart1: {
        id: "ptc.ip.teams-invite-section.checkbox-tooltip-part-1",
        defaultMessage: "Add invited people to a team and collaborate with @mentions, your own team profile, and search results filtered to your team."
    },
    teamsInviteSectionCheckboxTooltipPart2: {
        id: "ptc.ip.teams-invite-section.checkbox-tooltip-part-2",
        defaultMessage: "You can use the same team across Atlassian products and projects."
    },
    genericSuccessFlagTitle: {
        id: "ptc.ip.flag.generic-success-flag-title.experiment",
        defaultMessage: "Successfully added"
    },
    inviteSuccessFlagDescriptionSingleProductNamed: {
        id: "ptc.ip.flag.invite-success-flag-description-single-product.named.experiment",
        defaultMessage: "{lessThanFiveInviteNames, select, true {We sent {formattedInviteNames} a Slack message confirming you added them to {product}.} other {We sent a Slack message to <b>everyone</b> confirming you added them to {product}.}}"
    },
    inviteSuccessFlagDescriptionSingleProductEmail: {
        id: "ptc.ip.flag.invite-success-flag-description-single-product.email.experiment",
        defaultMessage: "{inviteCount, plural, one {We sent an email to <b>{emailInvited}</b> confirming you added them to {product}.} other {We sent an email to <b>everyone</b> confirming you added them to {product}.}}"
    },
    requestAccessSuccessFlagTitle: {
        id: "ptc.ip.flag.request-access-success-flag-title.experiment",
        defaultMessage: "Access request sent to your admin"
    },
    requestAccessSuccessFlagDescription: {
        id: "ptc.ip.flag.request-access-success-flag-description.experiment",
        defaultMessage: "{requestAccessCount, plural, one {Your admin needs to approve access for <b>{emailRequestedAccess}</b>.} other {Your admin needs to approve access for <b>everyone</b>.}}"
    },
    hybridSuccessFlagTitle: {
        id: "ptc.ip.flag.hybrid-success-flag-title.experiment",
        defaultMessage: "Nearly done..."
    },
    hybridSuccessFlagDescriptionOneEach: {
        id: "ptc.ip.flag.hybrid-success-flag-description-one-each.experiment",
        defaultMessage: "<p><b>{emailInvited}</b> has been added.</p><p>An access request for <b>{emailRequestedAccess}</b> has been sent to your admin.</p>"
    },
    invitedHybridPlural: {
        id: "ptc.ip.flag.invited-hybrid-plural.experiment",
        defaultMessage: "{inviteCount, plural, one {You added <b>{emailInvited}</b>} other {You've added {inviteCount} people}}"
    },
    requestAccessHybridPlural: {
        id: "ptc.ip.flag.request-access-hybrid-plural.experiment",
        defaultMessage: "{requestAccessCount, plural, one {requested access for <b>{emailRequestedAccess}</b>} other {requested access for {requestAccessCount} others}}"
    },
    hybridSuccessFlagDescription: {
        id: "ptc.ip.flag.hybrid-success-flag-description.experiment",
        defaultMessage: "{invitedHybridPluralCoreInvitesOptimisation}, and {requestAccessHybridPluralCoreInvitesOptimisation}."
    },
    inviteFailedFlagTitle: {
        id: "ptc.ip.flag.invite-failed-flag-title.experiment",
        defaultMessage: "{failedInviteCount, plural, one {Can't add this person right now} other {We can't add those people right now}}"
    },
    inviteFailedFlagDescription: {
        id: "ptc.ip.flag.invite-failed-flag-description.experiment",
        defaultMessage: "We {failedInviteCount, plural, one {can't add <b>{emailFailedToInvite}</b> right now.} other {couldn\u2019t send {failedInviteCount} of your invites}}. {isAdmin, select, false {Contact your admin for help.} other { }}"
    },
    requestAccessFailedFlagTitleCoreInvitesOptimisation: {
        id: "ptc.ip.flag.request-access-failed-flag-title.experiment",
        defaultMessage: "Access request wasn't sent"
    },
    requestAccessFailedFlagDescriptionCoreInvitesOptimisation: {
        id: "ptc.ip.flag.request-access-failed-flag-description.experiment",
        defaultMessage: "{failedRequestCount, plural, one {We can't request access for <b>{emailRequestedAccess}</b>. Contact your admin for help.} other {We can't send those access requests. Contact your admin for help}}"
    },
    genericFailedFlagTitle: {
        id: "ptc.ip.flag.generic-failed-flag-title.experiment",
        defaultMessage: "Something went wrong"
    },
    genericFailedFlagDescription: {
        id: "ptc.ip.flag.generic-failed-flag-description.experiment",
        defaultMessage: "We can't add anyone right now. {isAdmin, select, false {Contact your admin for help.} true {} other {}}"
    },
    licenceExceededFlagDescription: {
        id: "ptc.ip.flag.license-exceeded-flag-description.experiment",
        defaultMessage: "{userRole, select, admin {You've reached your user limit. Upgrade your plan or remove other users.} other {You've reached your user limit. Contact your admin for help.}}"
    },
    licenceExceededFlagTitle: {
        id: "ptc.ip.flag.license-exceeded-flag-title.experiment",
        defaultMessage: "Can't add more people"
    },
    addMorePeopleActionLabel: {
        id: "ptc.ip.flag.add-more-people-action-label.experiment",
        defaultMessage: "Add more people"
    },
    manageUserAccessActionLabel: {
        id: "ptc.ip.flag.manage-user-access-action-label",
        defaultMessage: "Manage user access"
    },
    manageUsersAccessActionLabel: {
        id: "ptc.ip.flag.manage-users-access-action-label",
        defaultMessage: "Manage users access"
    },
    gotItActionLabelCoreInvitesOptimisation: {
        id: "ptc.ip.flag.ok-got-it-action-label.experiment",
        defaultMessage: "OK, got it"
    },
    formUserManagementLabel: {
        id: "ptc.ip.form.userManagement.label",
        defaultMessage: "User management"
    },
    adminDropdownItemGroupTitle: {
        id: "ptc.ip.dropdown-menu.admin.title",
        defaultMessage: "Admin"
    },
    connectToDropdownItemGroupTitle: {
        id: "ptc.ip.dropdown-menu.connect-to.title",
        defaultMessage: "Connect More"
    },
    manageConnectionsDropItemGroupTitle: {
        id: "ptc.ip.dropdown-menu.manage-connections.title",
        defaultMessage: "Manage Connections"
    },
    revokeGoogleMenuItemTitle: {
        id: "ptc.ip.dropdown-menu.revoke-google.title",
        defaultMessage: "Revoke Google"
    },
    manageSlackMenuItemTitle: {
        id: "ptc.ip.dropdown-menu.manage-slack.title",
        defaultMessage: "Manage Slack"
    },
    revokeMicrosoftMenuItemTitle: {
        id: "ptc.ip.dropdown-menu.revoke-slack.title",
        defaultMessage: "Revoke Microsoft"
    },
    noInvitePermissionTitle: {
        id: "ptc.ip.no-invite-permission.title",
        defaultMessage: "You can't invite people"
    },
    defaultNoInvitePermissionDescription: {
        id: "ptc.ip.no-invite-permission.description",
        defaultMessage: "You don't have permission to invite people to {productName}. Contact your admin for more information."
    },
    noInvitePermissionButtonTitle: {
        id: "ptc.ip.no-invite-permission.button.title",
        defaultMessage: "OK"
    },
    optionalMessageLabel: {
        id: "ptc.ip.form.invite-optional-message.label",
        defaultMessage: "Add a personalized message (Optional)"
    },
    optionalMessageCharacterCountHelper: {
        id: "ptc.ip.form.invite-optional-message.character-count-helper",
        defaultMessage: "{count, plural, one {{count} character remaining} other {{count} characters remaining}}"
    },
    copyLinkButtonText: {
        id: "ptc.elements.share.copylink.button.text",
        defaultMessage: "Copy link"
    },
    copiedToClipboardMessage: {
        id: "ptc.elements.share.copied.to.clipboard.message",
        defaultMessage: "Link copied to clipboard"
    },
    noProductSelectedMessageAppify: {
        id: "ptc.ip.form.no-product-selected-message.choose-appify",
        defaultMessage: "Choose at least one app"
    },
    productSelectAppify: {
        id: "ptc.ip.form.select-products.label.choose.experiment-appify",
        defaultMessage: "Add to other Atlassian apps?"
    },
    productSelectNoCurrentProductAppify: {
        id: "ptc.ip.form.select-products.label.no.current.product-appify",
        defaultMessage: "Select one or more apps"
    },
    optionIncludedWithOtherJiraProductsAppify: {
        id: "people-and-teams.invite-people.form.option-included-with-other-jira-products-appify",
        defaultMessage: "Included with other Jira apps"
    },
    selectPlaceholderAppify: {
        id: "ptc.ip.product.select.placeholder.experiment-appify",
        defaultMessage: "Select apps"
    },
    secondarySectionHeadingAppify: {
        id: "ptc.ip.secondary.section.heading-appify",
        defaultMessage: "Other apps and access"
    },
    secondarySectionHeadingWithProductSelectorAppify: {
        id: "ptc.ip.secondary.section.heading.product.selector.only-appify",
        defaultMessage: "Other apps"
    },
    secondarySectionHeadingNoCurrentProductAppify: {
        id: "ptc.ip.secondary.section.heading.no.current.product.and.viral.settings-appify",
        defaultMessage: "Select apps and access"
    },
    secondarySectionHeadingWithProductSelectorNoCurrentProductAppify: {
        id: "ptc.ip.secondary.section.heading.no.current.product-appify",
        defaultMessage: "Select apps"
    },
    noProductSelectedMessageAltAppify: {
        id: "ptc.ip.form.no-product-selected-message.choose.alt-appify",
        defaultMessage: "Select at least one app"
    }
});



var $7oH3p = parcelRequire("7oH3p");


var $4KS7f = parcelRequire("4KS7f");
















class $0a8f3946a5df7746$export$fec0684eff51fa44 extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    buttonClicked(actionSubjectId, attributes) {
        this.fireUI({
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
}


const $ebd9bdd3be3f4d51$export$e2c7c81b8d84c16f = (Button)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ actionSubjectId: actionSubjectId, analyticsAttributes: analyticsAttributes, ...props }, ref)=>{
        const analytics = (0, $2dswi.useAnalytics)((0, $0a8f3946a5df7746$export$fec0684eff51fa44));
        const onClick = (reactEvent, analyticsEvent)=>{
            analytics.buttonClicked(actionSubjectId, typeof analyticsAttributes === 'function' ? analyticsAttributes() : analyticsAttributes);
            return props.onClick?.(reactEvent, analyticsEvent);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useImperativeHandle(ref, ()=>({
                onClick: async (event, analyticsEvent)=>{
                    await onClick(event, analyticsEvent);
                }
            }));
        if (ref) return null;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $l998X.jsx)(Button, {
            ...props,
            onClick: onClick,
            ref: ref
        });
    });


var $e7b7940dcdf139c7$export$2e2bcd8739ae039 = (0, $ebd9bdd3be3f4d51$export$e2c7c81b8d84c16f)((0, $4KS7f.default));


/* SlackWorkspacesDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");




var $fVUfS = parcelRequire("fVUfS");











var $6e2bacb232cd6284$export$2e2bcd8739ae039 = (0, $ebd9bdd3be3f4d51$export$e2c7c81b8d84c16f)((0, $eEA8O.default));








const $51715e1248b3403e$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX = 'infi-slack-workspace-';
const $51715e1248b3403e$export$fa39fb16b65ab54f = 'platform';
const $51715e1248b3403e$export$85295e886b0bc188 = ()=>(0, $j9g2s.getLocalStorageKey)(`${$51715e1248b3403e$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${$51715e1248b3403e$export$fa39fb16b65ab54f}`);
const $51715e1248b3403e$export$16d6297e9e3fb8ee = (value)=>(0, $j9g2s.updateLocalStorageKey)(`${$51715e1248b3403e$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${$51715e1248b3403e$export$fa39fb16b65ab54f}`, value);
const $51715e1248b3403e$export$ced2c8904ba748c6 = ()=>(0, $j9g2s.removeLocalStorageKey)(`${$51715e1248b3403e$var$CONNECTED_SLACK_WORKSPACE_KEY_PREFIX}${$51715e1248b3403e$export$fa39fb16b65ab54f}`);


/* SlackWorkspacesDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");





var $2gD2K = parcelRequire("2gD2K");

const $6e01042a1bb4acb4$var$styles = {
    optionWrapper: "",
    image: "_1bsbgktf _4t3igktf _u5f3u2gc"
};
const $6e01042a1bb4acb4$var$SlackWorkspacesDropdown = ({ slackWorkspaces: slackWorkspaces, selectedOption: selectedOption, onSelect: onSelect })=>{
    const formatOptionLabel = (option)=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            xcss: $6e01042a1bb4acb4$var$styles.optionWrapper,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    alt: option.avatar,
                    src: option.avatar,
                    className: (0, $gMc0m.default)([
                        $6e01042a1bb4acb4$var$styles.image
                    ])
                }),
                option.name
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
        name: "slack-workspace-select",
        isSearchable: false,
        value: selectedOption,
        className: "single-select",
        classNamePrefix: "react-select",
        getOptionValue: (w)=>w.id,
        options: slackWorkspaces,
        formatOptionLabel: formatOptionLabel,
        isDisabled: slackWorkspaces.length === 1,
        onChange: (selectedSlackWorkspace)=>onSelect(selectedSlackWorkspace)
    });
};
var $6e01042a1bb4acb4$export$2e2bcd8739ae039 = $6e01042a1bb4acb4$var$SlackWorkspacesDropdown;


/*
  This Component sets the z-index of a modal to greater than that of
  drawers where they will be triggered to show from.
  The invite drawer modal sets their z-index to 550 when
  triggered by another modal as shown in this PR:
  https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/7042

  */ 








const $3ce6ff93cec29bbc$var$DrawerDialogZIndexSetter = ()=>{
    const zIndexRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        if (node !== null) {
            const portalElement = node.closest && node.closest('.atlaskit-portal');
            if (portalElement) // We set it to 560 because we want it to stay above the drawer (set at 550),
            // and below the flag, spotlight and tooltip.
            // See https://atlaskit.atlassian.com/packages/design-system/theme/docs/constants
            // Directly setting the style property is the safer option than setAttribute()
            // because we don't know what other possible style properties could be.
            portalElement.style['z-index'] = (0, $5LksM.ZIndex).FLOATING;
        }
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: zIndexRef
    });
};
var $3ce6ff93cec29bbc$export$2e2bcd8739ae039 = $3ce6ff93cec29bbc$var$DrawerDialogZIndexSetter;









var $dQl1W = parcelRequire("dQl1W");


var $inPa6 = parcelRequire("inPa6");


var $1LFpx = parcelRequire("1LFpx");





var $ktS3V = parcelRequire("ktS3V");







var $5YNlj = parcelRequire("5YNlj");


var $6qdyn = parcelRequire("6qdyn");


var $5aVN7 = parcelRequire("5aVN7");

class $a9c5346495e3d8ee$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $5aVN7.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $6qdyn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}


var $9NDUe = parcelRequire("9NDUe");



var $91dcab74875d7081$export$1f2009f2d8a17b6c = /*#__PURE__*/ function(UfoExperience) {
    UfoExperience["InvitePeopleRendered"] = "invite-people-rendered";
    UfoExperience["InviteFormSubmitted"] = "invite-form-submitted";
    UfoExperience["RecaptchaExecuted"] = "recaptcha-executed";
    UfoExperience["ThirdPartyResultsLoaded"] = "third-party-results-loaded";
    UfoExperience["ExternalUsersLoaded"] = "external-users-loaded";
    UfoExperience["ControlSettingsLoaded"] = "control-settings-loaded";
    UfoExperience["NoInvitePermissionRendered"] = "no-invite-permission-rendered";
    UfoExperience["InviteSettingsUpdated"] = "invite-settings-updated";
    UfoExperience["DomainSettingsUpdated"] = "domain-settings-updated";
    UfoExperience["parallelInviteRequestSubmitted"] = "parallel-invite-request-submitted";
    UfoExperience["TeamsInviteSectionExperience"] = "teams-invite-section-experience";
    UfoExperience["RecaptchaLoaded"] = "recaptcha-loaded";
    return UfoExperience;
}({});
var $91dcab74875d7081$var$ExperienceComponent = /*#__PURE__*/ function(ExperienceComponent) {
    ExperienceComponent["InvitePeople"] = "invite-people";
    ExperienceComponent["InviteeList"] = "invitee-list";
    return ExperienceComponent;
}($91dcab74875d7081$var$ExperienceComponent || {});
const $91dcab74875d7081$var$buildExperience = (performanceType, component = "invite-people", experienceType = (0, $9NDUe.ExperienceTypes).Load)=>{
    return {
        type: experienceType,
        performanceType: performanceType,
        platform: {
            component: component
        }
    };
};
const $91dcab74875d7081$var$createUFOTimings = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $91dcab74875d7081$export$a968444c71dc68c6 = {
    getAccountInfo: $91dcab74875d7081$var$createUFOTimings('get_account_info'),
    getInviteCapabilities: $91dcab74875d7081$var$createUFOTimings('get_invite_capabilities'),
    checkEligibility: $91dcab74875d7081$var$createUFOTimings('check_eligibility'),
    fetchOrgSettings: $91dcab74875d7081$var$createUFOTimings('fetch_org_settings'),
    fetchExistingIntegrations: $91dcab74875d7081$var$createUFOTimings('fetch_existing_integrations'),
    initSlack: $91dcab74875d7081$var$createUFOTimings('init_slack'),
    getUserPermission: $91dcab74875d7081$var$createUFOTimings('get_user_permission'),
    getCollections: $91dcab74875d7081$var$createUFOTimings('get_collections')
};
const $91dcab74875d7081$export$2a3414fdbfd8a2af = new (0, $5aVN7.UFOExperience)("invite-people-rendered", {
    ...$91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad),
    timings: Object.values($91dcab74875d7081$export$a968444c71dc68c6)
});
const $91dcab74875d7081$export$d9b2187d827ca57a = {
    updateOpenInviteSettings: $91dcab74875d7081$var$createUFOTimings('update_open_invites_settings'),
    updateDirectAccessSettings: $91dcab74875d7081$var$createUFOTimings('update_direct_access_settings'),
    inviteUsersPromise: $91dcab74875d7081$var$createUFOTimings('invite_users'),
    getRecaptchaToken: $91dcab74875d7081$var$createUFOTimings('get_recaptcha_token')
};
const $91dcab74875d7081$export$57415b8193dc14c8 = new (0, $5aVN7.UFOExperience)("invite-form-submitted", {
    ...$91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad),
    timings: Object.values($91dcab74875d7081$export$d9b2187d827ca57a)
});
const $91dcab74875d7081$export$c27b328e50448605 = new (0, $a9c5346495e3d8ee$export$ac1cddfee07ba6ac)("third-party-results-loaded", $91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad, "invitee-list"));
const $91dcab74875d7081$export$a408090913cd7114 = new (0, $a9c5346495e3d8ee$export$ac1cddfee07ba6ac)("external-users-loaded", $91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad, "invitee-list"));
const $91dcab74875d7081$export$cdabcb904f0492f = new (0, $5aVN7.UFOExperience)("control-settings-loaded", $91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).Custom));
const $91dcab74875d7081$export$323b055db80365a2 = new (0, $5aVN7.UFOExperience)("domain-settings-updated", $91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).Custom));
const $91dcab74875d7081$export$78c49e7734a12bcb = new (0, $5aVN7.UFOExperience)("invite-settings-updated", $91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).Custom));
const $91dcab74875d7081$export$f4c946ac2a44c48a = new (0, $5aVN7.UFOExperience)("parallel-invite-request-submitted", $91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).Custom));
const $91dcab74875d7081$export$b97b16bc7fe47920 = new (0, $5aVN7.UFOExperience)("recaptcha-loaded", $91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad));
const $91dcab74875d7081$export$5e9287b6a10f8075 = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $91dcab74875d7081$export$c5a5cf072c836c0e = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $91dcab74875d7081$export$8dda83bafca11b77 = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $91dcab74875d7081$export$b1021040eb94cdca = (ufoExperience, id, properties)=>{
    const experience = ufoExperience.getInstance(id);
    experience.abort({
        metadata: properties
    });
};
const $91dcab74875d7081$export$d90144118191fa45 = {
    getOpenInviteNote: $91dcab74875d7081$var$createUFOTimings('get_open_invite_note')
};
const $91dcab74875d7081$export$afcd850890541869 = new (0, $5aVN7.UFOExperience)("no-invite-permission-rendered", {
    ...$91dcab74875d7081$var$buildExperience((0, $9NDUe.ExperiencePerformanceTypes).PageLoad),
    timings: Object.values($91dcab74875d7081$export$a968444c71dc68c6)
});





















class $67b18dfce6f55bd9$export$1d5f1019c49a0a8b extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    teamsFieldToggled(opened) {
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).TEAM_INVITES,
            action: (0, $5LksM.AnalyticsAction).CHANGED,
            attributes: {
                opened: opened
            }
        });
    }
    teamsFieldUsersInvited(attributes) {
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).TEAM_INVITES,
            action: (0, $5LksM.AnalyticsAction).INVITED,
            attributes: attributes
        });
    }
    fetchOrgSettingsFailed(attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).FETCH_ORG_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
}





const $15755675f42f0917$export$eef572fe72ca98c3 = (orgId)=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $67b18dfce6f55bd9$export$1d5f1019c49a0a8b));
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [settings, setData] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        if (!orgId) {
            setIsLoading(false);
            return;
        }
        (async ()=>{
            (0, $91dcab74875d7081$export$cdabcb904f0492f).start();
            setIsLoading(true);
            try {
                (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).fetchOrgSettings.startMark);
                const settings = await (0, $ktS3V.fetchOrgSettings)(orgId);
                (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).fetchOrgSettings.endMark);
                (0, $91dcab74875d7081$export$cdabcb904f0492f).success();
                setData(settings);
            } catch (error) {
                const { errorMessage: errorMessage, responseCode: responseCode } = (0, $j9g2s.resolveError)(error);
                analytics.fetchOrgSettingsFailed({
                    orgId: orgId,
                    errorMessage: errorMessage,
                    responseCode: responseCode
                });
                (0, $91dcab74875d7081$export$cdabcb904f0492f).failure();
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        analytics,
        orgId
    ]);
    return {
        isLoading: isLoading,
        settings: settings
    };
};











parcelRequire("42omo");


var $8Y8Qi = parcelRequire("8Y8Qi");


var $6fnsQ = parcelRequire("6fnsQ");


var $9kYFb = parcelRequire("9kYFb");


const $32d9eddd7b4e8671$export$9419a7a0b292dbaa = (serviceKey, intl, workspace)=>{
    let title;
    let description;
    switch(serviceKey){
        case 0, $9kYFb.PLATFORM_SLACK_SERVICE:
            title = intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackConnectSuccessFlagTitle, {
                workspace: workspace
            });
            description = intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackConnectSuccessFlagDescription);
            break;
        case 0, $9kYFb.MICROSOFT_SERVICE:
            title = intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).microsoftConnectSuccessFlagTitle);
            description = intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).microsoftConnectSuccessFlagDescription);
            break;
        case 0, $9kYFb.GOOGLE_SERVICE:
            title = intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).googleConnectSuccessFlagTitle);
            description = intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).googleConnectSuccessFlagDescription);
            break;
    }
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $6fnsQ).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: title,
        description: description
    };
};
const $32d9eddd7b4e8671$export$3a56bd38da99afd0 = (intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $6fnsQ).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackDisconnectSuccessFlagTitle),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackDiscnnectSuccessFlagDescription)
    };
};


const $2233c50e8bb90c97$export$bc49b6d3cc4ab213 = ()=>{
    const intl = (0, $8C5kA.default)();
    return {
        success: (serviceKey, workspace)=>(0, $32d9eddd7b4e8671$export$9419a7a0b292dbaa)(serviceKey, intl, workspace),
        slackDisconnect: ()=>(0, $32d9eddd7b4e8671$export$3a56bd38da99afd0)(intl)
    };
};



var $9xnOK = parcelRequire("9xnOK");





var $3uVVG = parcelRequire("3uVVG");


var $3KVX0 = parcelRequire("3KVX0");





var $7GQiN = parcelRequire("7GQiN");

function $16469612d1ee3fff$var$getAuthUrl(serviceKey) {
    return `${0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL}${0, $7GQiN.EXUS_THIRDPARTY_PATH}/connect?serviceKey=${serviceKey}`;
}
function $16469612d1ee3fff$export$14154b2d1be1b2ff(serviceKey, callback) {
    const url = $16469612d1ee3fff$var$getAuthUrl(serviceKey);
    const windowLeft = window.screen.width / 2 - (0, $9kYFb.WINDOW_WIDTH) / 2;
    const windowTop = window.screen.height / 2 - (0, $9kYFb.WINDOW_HEIGHT) / 2;
    const options = 'menubar, width=' + (0, $9kYFb.WINDOW_WIDTH) + ', height=' + (0, $9kYFb.WINDOW_HEIGHT) + ', top=' + windowTop + ', left=' + windowLeft;
    (0, $3uVVG.auth)(url, options).then(()=>{
        if (callback) callback(true);
    }).catch((error)=>{
        if (callback) callback(false, error);
    });
}
function $16469612d1ee3fff$var$deleteFalsyValues(obj) {
    Object.keys(obj).filter((k)=>!obj[k]).forEach((k)=>delete obj[k]);
    return obj;
}
function $16469612d1ee3fff$export$6b9f91f1f35a2e37(userLists) {
    const usersById = userLists.reduce((flatUsersList, users)=>{
        flatUsersList.push(...users);
        return flatUsersList;
    }, []).reduce((result, currentValue)=>{
        const key = currentValue.email || currentValue.id;
        if (!result[key]) result[key] = [];
        result[key].push(currentValue);
        return result;
    }, {});
    return Object.keys(usersById).map((userId)=>{
        return usersById[userId].reduce((result, currentValue)=>{
            const sources = [
                ...new Set([
                    ...result.sources,
                    ...currentValue.sources
                ])
            ];
            const mergedUser = {
                ...$16469612d1ee3fff$var$deleteFalsyValues(result),
                ...$16469612d1ee3fff$var$deleteFalsyValues(currentValue)
            };
            mergedUser.sources = sources;
            return mergedUser;
        });
    });
}
const $16469612d1ee3fff$export$8970233c3a7a7b7e = (isConnected, slackWorkspaces, isSlackConnectDialogOpen, openSlackConnectDialog, onSelectedSlackWorkspaceChange, product, closeModal)=>{
    if (slackWorkspaces.length === 0) {
        if (product === 'jira') {
            window.open((0, $9kYFb.JIRA_SLACK_URL));
            if (closeModal) closeModal();
        } else if (product === 'confluence') {
            window.open((0, $9kYFb.CONFLUENCE_SLACK_URL));
            if (closeModal) closeModal();
        }
    } else if (!isConnected && slackWorkspaces.length === 1) onSelectedSlackWorkspaceChange(slackWorkspaces[0]);
    else if (!isSlackConnectDialogOpen) openSlackConnectDialog();
};
const $16469612d1ee3fff$export$a23f84077156f281 = (data)=>{
    const { providedAdditionalUsers: providedAdditionalUsers, connectedThirdPartyUsers: connectedThirdPartyUsers, searchText: searchText } = data;
    const additionalUsersWithEmail = providedAdditionalUsers.filter((user)=>user.email);
    const additionalUsersWithoutEmail = providedAdditionalUsers.filter((user)=>!user.email);
    const users = $16469612d1ee3fff$export$6b9f91f1f35a2e37([
        additionalUsersWithEmail,
        connectedThirdPartyUsers
    ]);
    const fuse = $16469612d1ee3fff$export$459d5a134a493201(users);
    const searchResult = fuse.search(searchText).map((result)=>result.item);
    const searchResultWithAdditionalUsers = [
        // Unable to include additional users in search as emails are filtered via the API
        ...additionalUsersWithoutEmail.slice(0, Math.min(additionalUsersWithoutEmail.length, (0, $9kYFb.MAX_USERS))),
        ...searchResult
    ];
    return searchResultWithAdditionalUsers.slice(0, Math.min(searchResultWithAdditionalUsers.length, (0, $9kYFb.MAX_USERS)));
};
function $16469612d1ee3fff$export$459d5a134a493201(items) {
    return new (0, $3KVX0.default)(items, {
        keys: [
            'displayName',
            'name',
            'email',
            'publicName'
        ],
        threshold: 0.2
    });
}




var $dedJV = parcelRequire("dedJV");







class $a98060ac8c7bcb95$export$f307a6cb9ff48fb9 extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    integrationsFetched(attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).THIRD_PARTY_INTEGRATIONS,
            action: (0, $5LksM.AnalyticsAction).FETCHED,
            attributes: attributes
        });
    }
    fetchExistingIntegrationsFailed(attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).FETCH_EXISTING_INTEGRATIONS,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
    integrationConnected({ previousStatus: previousStatus = 'neverConnected', serviceKey: serviceKey, teamId: teamId, auto: auto = false }) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).THIRD_PARTY_INTEGRATION,
            action: (0, $5LksM.AnalyticsAction).CONNECTED,
            attributes: {
                integration: serviceKey,
                teamId: teamId,
                auto: auto,
                previousStatus: previousStatus
            }
        });
    }
    integrationFailed(serviceKey, error) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).THIRD_PARTY_INTEGRATION,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                integration: serviceKey,
                errorType: error ? error.type : undefined
            }
        });
    }
    sloThirdPartyInitSuccess(attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_THIRD_PARTY_INIT,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: attributes
        });
    }
    sloThirdPartyInitFailed(error) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_THIRD_PARTY_INIT,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
    thirdPartyInitFailed(error) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).THIRD_PARTY_INIT,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
    slackChannelFailed(errorMessage, status) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLACK_CHANNEL,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                context: 'invite-user-picker',
                pickerType: 'multi',
                errorMessage: errorMessage,
                status: status
            }
        });
    }
    getSlackChannelsSucceeded() {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_SLACK_CHANNELS,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED
        });
    }
    getSlackChannelsFailed() {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_SLACK_CHANNELS,
            action: (0, $5LksM.AnalyticsAction).FAILED
        });
    }
}










const $f665bec07506eb24$export$231dc27510b9dc3b = ({ analytics: analytics, setSelectedSlackWorkspace: setSelectedSlackWorkspace, showFlag: showFlag })=>{
    const thirdPartyIntegrationsFlags = (0, $2233c50e8bb90c97$export$bc49b6d3cc4ab213)();
    return (0, $42omo.useCallback)((selectedSlackWorkspace)=>{
        setSelectedSlackWorkspace(selectedSlackWorkspace);
        // We'll make sure to remove the settings for the product slack app if
        // we are using the platform slack app
        (0, $51715e1248b3403e$export$ced2c8904ba748c6)();
        (0, $51715e1248b3403e$export$16d6297e9e3fb8ee)(selectedSlackWorkspace.id);
        analytics.integrationConnected({
            serviceKey: (0, $9kYFb.PLATFORM_SLACK_SERVICE),
            teamId: selectedSlackWorkspace.id
        });
        if (showFlag) showFlag(thirdPartyIntegrationsFlags.success((0, $9kYFb.PLATFORM_SLACK_SERVICE), selectedSlackWorkspace.name));
    }, [
        analytics,
        setSelectedSlackWorkspace,
        showFlag,
        thirdPartyIntegrationsFlags
    ]);
};













const $b47ec171650f5108$export$1ce02b3868b8dd2f = ({ analytics: analytics, integrations: integrations, onThirdPartyIntegrationsChange: onThirdPartyIntegrationsChange, openSlackSettings: openSlackSettings, setIsAfterSlackConnect: setIsAfterSlackConnect, showFlag: showFlag, slackWorkspaces: slackWorkspaces })=>{
    const thirdPartyIntegrationsFlags = (0, $2233c50e8bb90c97$export$bc49b6d3cc4ab213)();
    return (0, $42omo.useCallback)((args)=>{
        const { serviceKey: serviceKey, scopeState: scopeState } = args;
        // Open slack settings instead of reconnecting if we are already
        // connected and have slack workspaces with valid scope
        if (serviceKey === (0, $9kYFb.PLATFORM_SLACK_SERVICE) && integrations?.includes((0, $9kYFb.PLATFORM_SLACK_SERVICE)) && slackWorkspaces.length > 0) {
            openSlackSettings();
            return;
        }
        (0, $16469612d1ee3fff$export$14154b2d1be1b2ff)(serviceKey, (success, error)=>{
            onThirdPartyIntegrationsChange().then(()=>{
                // show slack workspaces dialog if just connected platform slack
                if (success && serviceKey === (0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE) setIsAfterSlackConnect(true);
            });
            if (success) {
                analytics.integrationConnected({
                    serviceKey: serviceKey,
                    previousStatus: scopeState
                });
                if (serviceKey !== (0, $9kYFb.PLATFORM_SLACK_SERVICE) && showFlag) showFlag(thirdPartyIntegrationsFlags.success(serviceKey));
            } else analytics.integrationFailed(serviceKey, error);
        });
    }, [
        analytics,
        integrations,
        onThirdPartyIntegrationsChange,
        openSlackSettings,
        setIsAfterSlackConnect,
        showFlag,
        slackWorkspaces.length,
        thirdPartyIntegrationsFlags
    ]);
};





const $b4a897aaacefb85d$var$getThirdPartyUsersKey = (source, id)=>`${source}:${id}`;
const $b4a897aaacefb85d$export$e0935aa995f7eb20 = ()=>{
    const usersByThirdPartyId = (0, $42omo.useRef)(new Map());
    const getUserByThirdPartyId = (0, $42omo.useCallback)((source, id)=>usersByThirdPartyId.current.get($b4a897aaacefb85d$var$getThirdPartyUsersKey(source, id)), []);
    const cacheUserByThirdPartyId = (0, $42omo.useCallback)((source, id, user)=>usersByThirdPartyId.current.set($b4a897aaacefb85d$var$getThirdPartyUsersKey(source, id), user), []);
    return {
        getUserByThirdPartyId: getUserByThirdPartyId,
        cacheUserByThirdPartyId: cacheUserByThirdPartyId
    };
};



var $c6GJD = parcelRequire("c6GJD");

const $1f7bcce4a8632612$export$df4f69f663fe2d96 = (experimentKey, defaultCohort, fireExperimentExposure)=>{
    if ((0, $c6GJD.default).initializeCalled()) return (0, $c6GJD.default).getExperimentValue(experimentKey, 'cohort', defaultCohort, {
        fireExperimentExposure: fireExperimentExposure
    });
    return defaultCohort;
};
const $1f7bcce4a8632612$export$c123608fb702e1aa = (experimentKey)=>(0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).checkGate(experimentKey);


const $061c9fd816a80862$var$ThirdPartyStateContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $061c9fd816a80862$export$7e31acee6ee63234 = ({ enableThirdParty: enableThirdParty, showFlag: showFlag, displayInfiSpotlight: displayInfiSpotlight = false, children: children, onCancelButtonClick: onCancelButtonClick, hideThirdPartyConnectLegend: hideThirdPartyConnectLegend })=>{
    const { orgId: orgId, cloudId: cloudId, productId: productId } = (0, $9xnOK.useInvitePeopleContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const analytics = (0, $2dswi.useAnalytics)((0, $a98060ac8c7bcb95$export$f307a6cb9ff48fb9));
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [isAfterSlackConnect, setIsAfterSlackConnect] = (0, $42omo.useState)(false);
    const [isOk, setIsOk] = (0, $42omo.useState)(undefined);
    const [isConnected, setIsConnected] = (0, $42omo.useState)(false);
    const [slackService, setSlackService] = (0, $42omo.useState)(undefined);
    const [slackWorkspaces, setSlackWorkspaces] = (0, $42omo.useState)([]);
    const [selectedSlackWorkspace, setSelectedSlackWorkspace] = (0, $42omo.useState)(null);
    const [integrations, setIntegrations] = (0, $42omo.useState)(null);
    const [isSlackConnectDialogOpen, setIsSlackConnectDialogOpen] = (0, $42omo.useState)(false);
    const [updateThirdPartyIntegrations, setUpdateThirdPartyIntegrations] = (0, $42omo.useState)({
        noScope: new Set(),
        partialScope: new Set()
    });
    const [integrationMetadata, setIntegrationMetadata] = (0, $42omo.useState)(undefined);
    const { isLoading: isOrgSettingsLoading, settings: orgSettings } = (0, $15755675f42f0917$export$eef572fe72ca98c3)(orgId || null);
    const [enabledIntegrations, setEnabledIntegrations] = (0, $42omo.useState)(new Set());
    const abortThirdPartyRequests = (0, $42omo.useCallback)(()=>{
        if (slackService) slackService.abort();
    }, [
        slackService
    ]);
    const slackUserSearcher = (0, $42omo.useRef)((0, $16469612d1ee3fff$export$459d5a134a493201)([]));
    const { getUserByThirdPartyId: getUserByThirdPartyId, cacheUserByThirdPartyId: cacheUserByThirdPartyId } = (0, $b4a897aaacefb85d$export$e0935aa995f7eb20)();
    (0, $42omo.useEffect)(()=>{
        async function onSetWorkspace() {
            if (!cloudId || !productId) return;
            slackUserSearcher.current = (0, $16469612d1ee3fff$export$459d5a134a493201)([]);
            if (selectedSlackWorkspace && slackService) {
                slackService.abort();
                slackService.streamUsers(selectedSlackWorkspace.id, (slackUsers)=>{
                    if (slackUsers && slackUsers.ok) for (const slackUser of slackUsers.result){
                        const externalUser = (0, $j9g2s.slackToExternalUser)(slackUser);
                        slackUserSearcher.current.add(externalUser);
                        cacheUserByThirdPartyId((0, $9kYFb.SLACK_SOURCE), slackUser.id, externalUser);
                    }
                });
            }
        }
        onSetWorkspace();
    }, [
        selectedSlackWorkspace,
        cloudId,
        productId,
        slackService,
        cacheUserByThirdPartyId
    ]);
    const connectedIntegrations = (0, $42omo.useMemo)(()=>{
        if (!integrations) return new Set();
        const res = new Set([
            // connected integrations aside from slack
            ...integrations.filter((integration)=>integration !== (0, $9kYFb.PLATFORM_SLACK_SERVICE)),
            // we only want to set slack as connected if it is connected according
            // to exus and a workspace is selected
            ...integrations.includes((0, $9kYFb.PLATFORM_SLACK_SERVICE)) && selectedSlackWorkspace ? [
                (0, $9kYFb.PLATFORM_SLACK_SERVICE)
            ] : []
        ]);
        analytics.integrationsFetched({
            integrations: [
                ...res
            ]
        });
        return res;
    }, [
        analytics,
        integrations,
        selectedSlackWorkspace
    ]);
    const initSlack = (0, $42omo.useCallback)(()=>{
        if (!cloudId) return [];
        const productSlackService = (0, $1LFpx.slackServiceFactory)(cloudId, 'platform', createAnalyticsEvent);
        setSlackService(productSlackService);
    }, [
        cloudId,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!integrationMetadata) {
            setIsConnected(connectedIntegrations.size > 0);
            return;
        }
        const noScope = new Set();
        const partialScope = new Set();
        const connectedProductSlackWorkspace = (0, $51715e1248b3403e$export$85295e886b0bc188)();
        if (connectedProductSlackWorkspace) {
            const connectedTeam = integrationMetadata?.[(0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE]?.teams?.find((team)=>team.id === connectedProductSlackWorkspace);
            if (connectedTeam) {
                if (connectedTeam.scopeState === (0, $7oH3p.ScopeState).NO_SCOPE) noScope.add((0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE);
            } else noScope.add((0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE);
        }
        connectedIntegrations.forEach((product)=>{
            if (product !== (0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE) {
                if (integrationMetadata?.[product]?.scopeState === (0, $7oH3p.ScopeState).NO_SCOPE) noScope.add(product);
                if (integrationMetadata?.[product]?.scopeState === (0, $7oH3p.ScopeState).PARTIAL_SCOPE) partialScope.add(product);
            }
        });
        setIsConnected(connectedIntegrations.size > noScope.size);
        setUpdateThirdPartyIntegrations({
            noScope: noScope,
            partialScope: partialScope
        });
    }, [
        integrationMetadata,
        connectedIntegrations,
        selectedSlackWorkspace?.id,
        productId
    ]);
    const fetchExistingIntegrationsWithMarker = (0, $42omo.useCallback)(async (cloudId)=>{
        (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).fetchExistingIntegrations.startMark);
        const integrationsResponse = await (0, $ktS3V.fetchExistingIntegrations)(cloudId);
        (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).fetchExistingIntegrations.endMark);
        return integrationsResponse;
    }, []);
    (0, $42omo.useEffect)(()=>{
        async function getThirdPartyIntegrations() {
            if (!cloudId || !productId) {
                setIsLoading(false);
                return;
            }
            try {
                if (enableThirdParty === true) {
                    setIsLoading(true);
                    initSlack();
                    const integrationsResponse = await fetchExistingIntegrationsWithMarker(cloudId);
                    if (!integrationsResponse) throw new Error((0, $9kYFb.FETCH_INTEGRATIONS_FAILURE_MESSAGE));
                    setIntegrations(integrationsResponse.connectedIntegrations);
                    setEnabledIntegrations(new Set(integrationsResponse.enabledIntegrations));
                    setIntegrationMetadata(integrationsResponse?.integrationMetadata);
                    // slack workspaces from EXUS filtered by valid scope
                    const workspaces = integrationsResponse?.integrationMetadata?.[(0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE]?.teams?.filter((workspace)=>workspace.scopeState !== (0, $7oH3p.ScopeState).NO_SCOPE) || [];
                    setSlackWorkspaces(workspaces);
                    const slackWorkspaceId = (0, $51715e1248b3403e$export$85295e886b0bc188)();
                    if (workspaces.length > 0) {
                        const slackWorkspace = slackWorkspaceId ? workspaces.find((slackWorkspace)=>slackWorkspace.id === slackWorkspaceId) : undefined;
                        if (slackWorkspace) setSelectedSlackWorkspace(slackWorkspace);
                        else {
                            const shouldAutoConnect = (0, $1f7bcce4a8632612$export$df4f69f663fe2d96)((0, $5LksM.ExperimentKeys).SLACK_AUTO_CONNECT, (0, $5LksM.Cohort).NOT_ENROLLED, true) === (0, $5LksM.Cohort).VARIATION;
                            if (shouldAutoConnect) {
                                setSelectedSlackWorkspace(workspaces[0]);
                                (0, $51715e1248b3403e$export$16d6297e9e3fb8ee)(workspaces[0].id);
                                analytics.integrationConnected({
                                    serviceKey: (0, $9kYFb.PLATFORM_SLACK_SERVICE),
                                    teamId: workspaces[0].id,
                                    auto: true
                                });
                            }
                        }
                    }
                    setIsOk(integrationsResponse.enabledIntegrations.length > 0);
                    analytics.sloThirdPartyInitSuccess({
                        enabledIntegrations: integrationsResponse.enabledIntegrations,
                        connectedIntegrations: integrationsResponse.connectedIntegrations,
                        selectedSlackWorkspace: slackWorkspaceId ?? undefined
                    });
                } else setIsOk(false);
            } catch (error) {
                setIsOk(false);
                const { errorMessage: errorMessage, responseCode: responseCode } = (0, $j9g2s.resolveError)(error);
                const is4xxError = responseCode && [
                    400,
                    401,
                    403
                ].includes(responseCode);
                if (errorMessage === (0, $9kYFb.FETCH_INTEGRATIONS_FAILURE_MESSAGE)) analytics.fetchExistingIntegrationsFailed({
                    ari: cloudId,
                    errorMessage: errorMessage,
                    responseCode: responseCode
                });
                if (is4xxError || (0, $j9g2s.isAcceptableFailure)(errorMessage, responseCode)) // Only fired in error cases that should not be measured in the SLO
                analytics.thirdPartyInitFailed(String(error));
                else if ((0, $5YNlj.isSLOFailure)(error)) analytics.sloThirdPartyInitFailed(String(error));
            } finally{
                setIsLoading(false);
            }
        }
        getThirdPartyIntegrations();
    }, [
        cloudId,
        productId,
        createAnalyticsEvent,
        enableThirdParty,
        initSlack,
        analytics,
        fetchExistingIntegrationsWithMarker
    ]);
    const onChangeSelectedSlackWorkspace = (0, $f665bec07506eb24$export$231dc27510b9dc3b)({
        analytics: analytics,
        setSelectedSlackWorkspace: setSelectedSlackWorkspace,
        showFlag: showFlag
    });
    const { slackDisconnect: slackDisconnect } = (0, $2233c50e8bb90c97$export$bc49b6d3cc4ab213)();
    const onDisconnectSlackWorkspace = (0, $42omo.useCallback)(()=>{
        if (showFlag) showFlag(slackDisconnect());
        setSelectedSlackWorkspace(null);
        (0, $51715e1248b3403e$export$ced2c8904ba748c6)();
    }, [
        showFlag,
        slackDisconnect
    ]);
    const onThirdPartyIntegrationsChange = (0, $42omo.useCallback)(async ()=>{
        if (!cloudId) return;
        try {
            const integrationsResponse = await (0, $ktS3V.fetchExistingIntegrations)(cloudId);
            if (!integrationsResponse) return;
            setIntegrations(integrationsResponse.connectedIntegrations);
            setIntegrationMetadata(integrationsResponse.integrationMetadata);
            // set slack workspaces from EXUS filtered by valid scope
            setSlackWorkspaces(integrationsResponse.integrationMetadata?.[(0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE]?.teams?.filter((workspace)=>workspace.scopeState !== (0, $7oH3p.ScopeState).NO_SCOPE) || []);
        } catch (error) {
            const { errorMessage: errorMessage, responseCode: responseCode } = (0, $j9g2s.resolveError)(error);
            analytics.fetchExistingIntegrationsFailed({
                ari: cloudId,
                errorMessage: errorMessage,
                responseCode: responseCode
            });
            return;
        }
    }, [
        cloudId,
        analytics
    ]);
    const closeSlackConnectDialog = ()=>setIsSlackConnectDialogOpen(false);
    const openSlackConnectDialog = ()=>setIsSlackConnectDialogOpen(true);
    const infiSpotlight = {
        isEnabled: (0, $dh538.fg)('vd-1794-disable-infi-spotlight') ? false : displayInfiSpotlight,
        isLoading: isLoading
    };
    const queryThirdParty = (0, $42omo.useCallback)(async (searchText)=>{
        if (!cloudId || !searchText || searchText.trim().length === 0 || connectedIntegrations.size === 0) return [];
        const ufoExperienceId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        (0, $91dcab74875d7081$export$5e9287b6a10f8075)((0, $91dcab74875d7081$export$c27b328e50448605), ufoExperienceId, {
            connectedIntegrations: Array.from(connectedIntegrations).join(', ')
        });
        const isNonSlackIntegrationConnected = connectedIntegrations.has((0, $9kYFb.GOOGLE_SERVICE)) || connectedIntegrations.has((0, $9kYFb.MICROSOFT_SERVICE));
        // query backend for users on if MS/Google are connected
        let users = isNonSlackIntegrationConnected ? await (0, $ktS3V.search)(searchText, cloudId).catch((e)=>{
            (0, $91dcab74875d7081$export$8dda83bafca11b77)((0, $91dcab74875d7081$export$c27b328e50448605), ufoExperienceId);
            return [];
        }) : [];
        if (slackUserSearcher.current) {
            const slackUsers = slackUserSearcher.current.search(searchText).map((result)=>result.item);
            users = (0, $16469612d1ee3fff$export$6b9f91f1f35a2e37)([
                users,
                slackUsers.slice(0, Math.min(slackUsers.length, (0, $9kYFb.MAX_USERS)))
            ]);
        }
        const fuse = (0, $16469612d1ee3fff$export$459d5a134a493201)(users);
        const searchResult = fuse.search(searchText).map((result)=>result.item);
        (0, $91dcab74875d7081$export$c5a5cf072c836c0e)((0, $91dcab74875d7081$export$c27b328e50448605), ufoExperienceId);
        return searchResult.slice(0, Math.min(searchResult.length, (0, $9kYFb.MAX_USERS)));
    }, [
        connectedIntegrations,
        cloudId
    ]);
    const openSlackSettings = (0, $42omo.useCallback)(()=>{
        (0, $16469612d1ee3fff$export$8970233c3a7a7b7e)(Boolean(selectedSlackWorkspace), slackWorkspaces, isSlackConnectDialogOpen, openSlackConnectDialog, onChangeSelectedSlackWorkspace, productId, onCancelButtonClick);
    }, [
        isSlackConnectDialogOpen,
        onChangeSelectedSlackWorkspace,
        onCancelButtonClick,
        slackWorkspaces,
        selectedSlackWorkspace,
        productId
    ]);
    // We use this useEffect to open the slack settings after some
    // state (e.g. slackWorkspaces) is changed. we have this on it's own
    // useEffect since we want it to run after setState has finished
    (0, $42omo.useEffect)(()=>{
        // Do nothing if user did not manually connect
        if (!isAfterSlackConnect) return;
        setIsAfterSlackConnect(false);
        openSlackSettings();
    }, [
        isAfterSlackConnect,
        openSlackSettings,
        slackWorkspaces
    ]);
    const onConnectProvider = (0, $b47ec171650f5108$export$1ce02b3868b8dd2f)({
        analytics: analytics,
        integrations: integrations,
        onThirdPartyIntegrationsChange: onThirdPartyIntegrationsChange,
        openSlackSettings: openSlackSettings,
        setIsAfterSlackConnect: setIsAfterSlackConnect,
        showFlag: showFlag,
        slackWorkspaces: slackWorkspaces
    });
    const onDisconnectProvider = (0, $42omo.useCallback)((serviceKey)=>{
        if (serviceKey === (0, $9kYFb.PLATFORM_SLACK_SERVICE)) {
            if (slackWorkspaces.length) openSlackConnectDialog();
            else {
                setSelectedSlackWorkspace(null);
                (0, $51715e1248b3403e$export$ced2c8904ba748c6)();
                onThirdPartyIntegrationsChange().then(()=>showFlag && showFlag(slackDisconnect()));
            }
            return;
        }
        const manageAppsUrl = `${(0, $dedJV.getATLContextUrl)('id')}/manage-profile/apps`;
        window.open(manageAppsUrl);
        if (onCancelButtonClick) onCancelButtonClick();
    }, [
        onCancelButtonClick,
        onThirdPartyIntegrationsChange,
        showFlag,
        slackDisconnect,
        slackWorkspaces.length
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($061c9fd816a80862$var$ThirdPartyStateContext.Provider, {
        value: {
            isLoading: isLoading || isOrgSettingsLoading,
            isOk: isOk,
            slackWorkspaces: slackWorkspaces,
            selectedSlackWorkspace: selectedSlackWorkspace,
            isSlackConnectDialogOpen: isSlackConnectDialogOpen,
            integrations: connectedIntegrations,
            enabledIntegrations: enabledIntegrations,
            updateIntegrations: updateThirdPartyIntegrations,
            openSlackConnectDialog: openSlackConnectDialog,
            closeSlackConnectDialog: closeSlackConnectDialog,
            onDisconnectSlackWorkspace: onDisconnectSlackWorkspace,
            onThirdPartyIntegrationsChange: onThirdPartyIntegrationsChange,
            onChangeSelectedSlackWorkspace: onChangeSelectedSlackWorkspace,
            queryThirdParty: queryThirdParty,
            infiSpotlight: infiSpotlight,
            getUserByThirdPartyId: getUserByThirdPartyId,
            cacheUserByThirdPartyId: cacheUserByThirdPartyId,
            onConnectProvider: onConnectProvider,
            onDisconnectProvider: onDisconnectProvider,
            abortThirdPartyRequests: abortThirdPartyRequests,
            orgSettings: orgSettings,
            isConnected: isConnected,
            hideThirdPartyConnectLegend: hideThirdPartyConnectLegend
        },
        children: children
    });
};
const $061c9fd816a80862$export$8569d1ff85ba1bfc = ()=>{
    const state = (0, $42omo.useContext)($061c9fd816a80862$var$ThirdPartyStateContext);
    if (state === undefined) throw new Error('useThirdPartyState must be used within a ThirdPartyStateProvider');
    return state;
};










const $7b7358fe3ea7b2f6$export$4ebc92125c7b235c = 'noScopeMessage';
const $7b7358fe3ea7b2f6$export$e25e35805e13a213 = 'partialScopeMessage';
const $7b7358fe3ea7b2f6$var$THIRD_PARTY_DROPDOWN_MENU = 'thirdPartyDropdownMenu';
const $7b7358fe3ea7b2f6$var$SLACK_CONNECT_MODAL = 'slackConnectModal';
const $7b7358fe3ea7b2f6$export$2707ebe13f6c03b7 = {
    ADD_NOW: 'addNow',
    ADD_SLACK_ACCOUNTS: 'addSlackAccounts',
    DISCONNECT: 'disconnect',
    DONE: 'done',
    INTEGRATION_SETTINGS: 'integrationSettings',
    MAYBE_LATER: 'maybeLater',
    SHOW_ME_HOW: 'showMeHow'
};
class $7b7358fe3ea7b2f6$export$fd3aba480a4de341 extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    updateConnectionShown(serviceKey, scope) {
        const name = scope === (0, $7oH3p.ScopeState).NO_SCOPE ? $7b7358fe3ea7b2f6$export$4ebc92125c7b235c : $7b7358fe3ea7b2f6$export$e25e35805e13a213;
        this.fireScreen({
            name: name,
            attributes: {
                integration: serviceKey
            }
        });
    }
    updateWarningClicked(serviceKey, orgId, scopeState) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).LINK,
            actionSubjectId: (0, $5LksM.AnalyticsActionSubjectId).UPDATE_WARNING,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                orgId: orgId,
                scopeState: scopeState
            }
        });
    }
    scopeUpdateButtonClicked(serviceKey, scopeState) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $5LksM.AnalyticsActionSubjectId).CONTINUE_UPDATE,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                scopeState: scopeState
            }
        });
    }
    integrationSettingsButtonClicked(serviceKey, orgId) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: $7b7358fe3ea7b2f6$export$2707ebe13f6c03b7.INTEGRATION_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                orgId: orgId
            }
        });
    }
    thirdPartyDropdownMenuShown(thirdParty, orgId) {
        this.fireScreen({
            name: $7b7358fe3ea7b2f6$var$THIRD_PARTY_DROPDOWN_MENU,
            attributes: {
                thirdParty: thirdParty,
                orgId: orgId
            }
        });
    }
    slackConnectModalShown() {
        this.fireScreen({
            name: $7b7358fe3ea7b2f6$var$SLACK_CONNECT_MODAL
        });
    }
    slackDoneButtonClicked(teamId) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: $7b7358fe3ea7b2f6$export$2707ebe13f6c03b7.DONE,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                selectedTeamId: teamId
            }
        });
    }
    slackDisconnectButtonClicked(teamId) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: $7b7358fe3ea7b2f6$export$2707ebe13f6c03b7.DISCONNECT,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                selectedTeamId: teamId
            }
        });
    }
    connectButtonClicked(serviceKey) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $5LksM.AnalyticsActionSubjectId).CONNECT,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                integration: serviceKey,
                source: this.commonAttributes.source,
                product: this.commonAttributes.productId
            }
        });
    }
}



const $f348a991e583462f$var$styles = {
    footerWrapper: "_1bsb1osq",
    disconnectButton: "_1rjcze3t _18zrze3t _bfhksm61"
};
const $f348a991e583462f$var$SlackWorkspacesDialog = ()=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $7b7358fe3ea7b2f6$export$fd3aba480a4de341));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isSlackDisconnectDialogOpen, setIsSlackDisconnectDialogOpen] = (0, $42omo.useState)(false);
    const connectedSlackWorkspaceId = (0, $51715e1248b3403e$export$85295e886b0bc188)();
    const autoConnectSlack = (0, $42omo.useMemo)(()=>{
        return (0, $1f7bcce4a8632612$export$df4f69f663fe2d96)((0, $5LksM.ExperimentKeys).SLACK_AUTO_CONNECT, (0, $5LksM.Cohort).NOT_ENROLLED, false) === (0, $5LksM.Cohort).VARIATION;
    }, []);
    const { slackWorkspaces: slackWorkspaces, openSlackConnectDialog: openSlackConnectDialog, closeSlackConnectDialog: closeSlackConnectDialog, isSlackConnectDialogOpen: isSlackConnectDialogOpen, onChangeSelectedSlackWorkspace: onChangeSelectedSlackWorkspace, onDisconnectSlackWorkspace: onDisconnectSlackWorkspace } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const [selectedOption, setSelectedOption] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        setSelectedOption(slackWorkspaces.find((w)=>w.id === connectedSlackWorkspaceId) || slackWorkspaces[0]);
    }, [
        slackWorkspaces,
        connectedSlackWorkspaceId
    ]);
    const closeSlackDisconnectDialog = ()=>{
        setIsSlackDisconnectDialogOpen(false);
        openSlackConnectDialog();
    };
    const openSlackDisconnectDialog = ()=>setIsSlackDisconnectDialogOpen(true);
    const onDisconnectSlackLink = ()=>{
        analytics.slackDisconnectButtonClicked(connectedSlackWorkspaceId);
        closeSlackConnectDialog();
        openSlackDisconnectDialog();
    };
    const onDisconnectClick = ()=>{
        onDisconnectSlackWorkspace();
        setIsSlackDisconnectDialogOpen(false);
    };
    const onConnectSlackWorkspaceButton = ()=>{
        if (selectedOption) {
            analytics.slackDoneButtonClicked(selectedOption.id);
            if (selectedOption.id !== connectedSlackWorkspaceId) onChangeSelectedSlackWorkspace(selectedOption);
            closeSlackConnectDialog();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (isSlackConnectDialogOpen) analytics.slackConnectModalShown();
    }, [
        analytics,
        isSlackConnectDialogOpen
    ]);
    const DisconnectModalFooter = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "end",
                xcss: $f348a991e583462f$var$styles.footerWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hArLp.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6e2bacb232cd6284$export$2e2bcd8739ae039), {
                            actionSubjectId: "disconnectCancel",
                            analyticsAttributes: {
                                selectedTeamId: connectedSlackWorkspaceId
                            },
                            type: "submit",
                            onClick: closeSlackDisconnectDialog,
                            children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).cancelButton)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6e2bacb232cd6284$export$2e2bcd8739ae039), {
                            actionSubjectId: "disconnectConfirm",
                            analyticsAttributes: {
                                selectedTeamId: connectedSlackWorkspaceId
                            },
                            appearance: "danger",
                            type: "submit",
                            onClick: onDisconnectClick,
                            children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).disconnectButton)
                        })
                    ]
                })
            })
        });
    const ConnectModalHeader = ()=>{
        const { formatMessage: formatMessage } = (0, $8C5kA.default)();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
            hasCloseButton: true,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                children: formatMessage(connectedSlackWorkspaceId ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).slackWorkspacesManageDialogHeading : (0, $c35877e38bf8c63c$export$defe85febe8b728c).slackWorkspacesConnectDialogHeading)
            })
        });
    };
    const ConnectModalFooter = ()=>{
        const { formatMessage: formatMessage } = (0, $8C5kA.default)();
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
            children: [
                connectedSlackWorkspaceId && autoConnectSlack === false && /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    onClick: onDisconnectSlackLink,
                    xcss: $f348a991e583462f$var$styles.disconnectButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.danger",
                        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackWorkspacesDialogDisconnectSlack)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                    type: "submit",
                    appearance: "primary" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ,
                    style: {
                        marginLeft: 'auto'
                    },
                    isDisabled: !Boolean(selectedOption),
                    onClick: onConnectSlackWorkspaceButton,
                    children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackWorkspacesDoneButton)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            slackWorkspaces && /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isSlackConnectDialogOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
                    width: 'small',
                    shouldScrollInViewport: true,
                    onClose: closeSlackConnectDialog,
                    testId: "slack-workspace-dialog",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)(ConnectModalHeader, {}),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    as: "p",
                                    children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackWorkspacesDialogBody)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("br", {}),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6e01042a1bb4acb4$export$2e2bcd8739ae039), {
                                    slackWorkspaces: slackWorkspaces,
                                    selectedOption: selectedOption,
                                    onSelect: setSelectedOption
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3ce6ff93cec29bbc$export$2e2bcd8739ae039), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)(ConnectModalFooter, {})
                    ]
                })
            }),
            connectedSlackWorkspaceId && autoConnectSlack === false && /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isSlackDisconnectDialogOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
                    width: 'small',
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                appearance: "danger",
                                children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackWorkspacesDisconnectDialogHeading)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                            children: [
                                formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackWorkspacesDisconnectDialogBody),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3ce6ff93cec29bbc$export$2e2bcd8739ae039), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)(DisconnectModalFooter, {})
                    ]
                })
            })
        ]
    });
};
const $f348a991e583462f$var$analyticsContextData = {
    source: (0, $5LksM.AnalyticsSource).SLACK_CONNECT_MODAL,
    componentName: 'slackConnectModal'
};
var $f348a991e583462f$export$2e2bcd8739ae039 = (0, $ggbZE.default)($f348a991e583462f$var$analyticsContextData)($f348a991e583462f$var$SlackWorkspacesDialog);





parcelRequire("42omo");





var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");


var $8JHjV = parcelRequire("8JHjV");











var $hbgPG = parcelRequire("hbgPG");

const $07330006f53205cd$export$b3f21e4c1b35ac72 = 'CreateableSelect';
const $07330006f53205cd$export$fec77d3db2f319e5 = 'UserPicker';
const $07330006f53205cd$export$518dae76d6af34f8 = 'TeamOrUserPicker';
const $07330006f53205cd$export$6bcb65c6ec0ed966 = (role)=>role === 'admin';













var $ahaN7 = parcelRequire("ahaN7");








parcelRequire("42omo");


var $dAYOx = parcelRequire("dAYOx");




parcelRequire("42omo");




/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // TODO : https://product-fabric.atlassian.net/browse/DSP-3537



parcelRequire("42omo");

function $4108c3cbc0d21824$export$6314f2dd65e45f24(props) {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.6412 6.42664L20.0279 3.11999C17.9479 1.18666 15.2413 0 12.0012 0C7.30792 0 3.25458 2.69332 1.28125 6.6133L5.16125 9.62662C6.13458 6.7333 8.82792 4.63998 12.0012 4.63998C14.2546 4.63998 15.7746 5.61331 16.6412 6.42664Z",
                fill: "#EB4335"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.52 12.2666C23.52 11.2799 23.44 10.5599 23.2667 9.81323H12V14.2665H18.6133C18.48 15.3732 17.76 17.0399 16.16 18.1599L19.9467 21.0932C22.2133 18.9999 23.52 15.9199 23.52 12.2666V12.2666V12.2666Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.17333 14.3732C4.92 13.6266 4.77333 12.8266 4.77333 11.9999C4.77333 11.1733 4.92 10.3733 5.16 9.6266L1.28 6.61328C0.466667 8.23994 0 10.0666 0 11.9999C0 13.9332 0.466667 15.7599 1.28 17.3866L5.17333 14.3732V14.3732Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0006 24C15.2406 24 17.9606 22.9334 19.9473 21.0934L16.1606 18.1601C15.1473 18.8667 13.7873 19.3601 12.0006 19.3601C8.82728 19.3601 6.13394 17.2667 5.17394 14.3734L1.29395 17.3867C3.26728 21.3067 7.30728 24 12.0006 24V24V24Z",
                fill: "#34A853"
            })
        ]
    });
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // TODO : https://product-fabric.atlassian.net/browse/DSP-3537



parcelRequire("42omo");

function $8923e8bde8ba859a$export$ad6b83e535366949(props) {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0.5 0H11.9047V11.4047H0.5V0Z",
                        fill: "#F25022"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.0952 0H24.4999V11.4047H13.0952V0Z",
                        fill: "#7FBA00"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0.5 12.5955H11.9047V24.0001H0.5V12.5955Z",
                        fill: "#00A4EF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.0952 12.5955H24.4999V24.0001H13.0952V12.5955Z",
                        fill: "#FFB900"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "23.9999",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // TODO : https://product-fabric.atlassian.net/browse/DSP-3537



parcelRequire("42omo");

function $64e004f955af5e01$export$b33fb54b08bb6422(props) {
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.53305 15.1364C5.53305 16.5215 4.40159 17.6529 3.01653 17.6529C1.63146 17.6529 0.5 16.5215 0.5 15.1364C0.5 13.7513 1.63146 12.6199 3.01653 12.6199H5.53305V15.1364Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M6.7998 15.1373C6.7998 13.7522 7.93127 12.6207 9.31633 12.6207C10.7014 12.6207 11.8329 13.7522 11.8329 15.1373V21.4383C11.8329 22.8234 10.7014 23.9548 9.31633 23.9548C7.93127 23.9548 6.7998 22.8234 6.7998 21.4383V15.1373Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.31633 5.03305C7.93127 5.03305 6.7998 3.90159 6.7998 2.51653C6.7998 1.13146 7.93127 0 9.31633 0C10.7014 0 11.8329 1.13146 11.8329 2.51653V5.03305H9.31633Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.3176 6.30078C10.7027 6.30078 11.8341 7.43224 11.8341 8.81731C11.8341 10.2024 10.7027 11.3338 9.3176 11.3338H3.01653C1.63146 11.3338 0.5 10.2024 0.5 8.81731C0.5 7.43224 1.63146 6.30078 3.01653 6.30078H9.3176Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M19.4219 8.81731C19.4219 7.43224 20.5533 6.30078 21.9384 6.30078C23.3235 6.30078 24.4549 7.43224 24.4549 8.81731C24.4549 10.2024 23.3235 11.3338 21.9384 11.3338H19.4219V8.81731Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M18.1517 8.8176C18.1517 10.2027 17.0202 11.3341 15.6352 11.3341C14.2501 11.3341 13.1187 10.2027 13.1187 8.8176V2.51653C13.1187 1.13146 14.2501 0 15.6352 0C17.0202 0 18.1517 1.13146 18.1517 2.51653V8.8176Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.6371 18.9215C17.0222 18.9215 18.1537 20.053 18.1537 21.438C18.1537 22.8231 17.0222 23.9546 15.6371 23.9546C14.2521 23.9546 13.1206 22.8231 13.1206 21.438V18.9215H15.6371Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.6366 17.6529C14.2516 17.6529 13.1201 16.5215 13.1201 15.1364C13.1201 13.7513 14.2516 12.6199 15.6366 12.6199H21.9377C23.3228 12.6199 24.4542 13.7513 24.4542 15.1364C24.4542 16.5215 23.3228 17.6529 21.9377 17.6529H15.6366Z",
                        fill: "#ECB22E"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "23.9999",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
}






const $9d2ab656303e6488$var$ICON_HEIGHT = 16;
const $9d2ab656303e6488$var$ICON_WIDTH = $9d2ab656303e6488$var$ICON_HEIGHT;
const $9d2ab656303e6488$export$9da1038490aaa764 = (integration)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let icon = null;
    let connectButtonText = null;
    let toolTip = null;
    switch(integration){
        case 0, $9kYFb.PLATFORM_SLACK_SERVICE:
            icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $64e004f955af5e01$export$b33fb54b08bb6422), {
                height: $9d2ab656303e6488$var$ICON_HEIGHT,
                width: $9d2ab656303e6488$var$ICON_WIDTH
            }, integration);
            connectButtonText = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackThirdPartyButton);
            toolTip = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackThirdPartyConnectedTooltip);
            break;
        case 0, $9kYFb.GOOGLE_SERVICE:
            icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $4108c3cbc0d21824$export$6314f2dd65e45f24), {
                height: $9d2ab656303e6488$var$ICON_HEIGHT,
                width: $9d2ab656303e6488$var$ICON_WIDTH
            }, integration);
            connectButtonText = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).googleThirdPartyButton);
            toolTip = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).googleThirdPartyConnectedTooltip);
            break;
        case 0, $9kYFb.MICROSOFT_SERVICE:
            icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $8923e8bde8ba859a$export$ad6b83e535366949), {
                height: $9d2ab656303e6488$var$ICON_HEIGHT,
                width: $9d2ab656303e6488$var$ICON_WIDTH
            }, integration);
            connectButtonText = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).microsoftThirdPartyButton);
            toolTip = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).microsoftThirdPartyConnectedTooltip);
            break;
    }
    return {
        icon: icon,
        connectButtonText: connectButtonText,
        toolTip: toolTip
    };
};


const $c5365b562f33ab79$var$ConnectIntegrationMenuItem = ({ integration: integration, onClick: onClick })=>{
    const { icon: icon, connectButtonText: connectButtonText } = (0, $9d2ab656303e6488$export$9da1038490aaa764)(integration);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        testId: `${integration}-connect-menu-item`,
        elemBefore: icon,
        onClick: onClick,
        children: connectButtonText
    });
};
var $c5365b562f33ab79$export$2e2bcd8739ae039 = $c5365b562f33ab79$var$ConnectIntegrationMenuItem;


















const $2e09f20380770bfd$var$ManageIntegrationMenuItem = ({ integration: integration, onClick: onClick })=>{
    const menuTitle = (0, $42omo.useMemo)(()=>{
        switch(integration){
            case (0, $7oH3p.Integration).GOOGLE_SERVICE:
                return (0, $c35877e38bf8c63c$export$defe85febe8b728c).revokeGoogleMenuItemTitle;
            case (0, $7oH3p.Integration).MICROSOFT_SERVICE:
                return (0, $c35877e38bf8c63c$export$defe85febe8b728c).revokeMicrosoftMenuItemTitle;
            case (0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE:
                return (0, $c35877e38bf8c63c$export$defe85febe8b728c).manageSlackMenuItemTitle;
        }
        return undefined;
    }, [
        integration
    ]);
    if (!menuTitle) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        testId: `manage-${integration}-integration-menu-item`,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...menuTitle
        })
    });
};
var $2e09f20380770bfd$export$2e2bcd8739ae039 = $2e09f20380770bfd$var$ManageIntegrationMenuItem;









class $315ee3b8ba7849ed$export$eb38bfb0a571f3e4 extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    dropdownMenuItemClicked(analyticsContext = {
        attributes: {}
    }) {
        this.fireUI({
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).DROPDOWN_ITEM,
            actionSubjectId: analyticsContext.actionSubjectId,
            attributes: analyticsContext.attributes
        });
    }
}


const $7d40b1e1838205d7$var$ThirdPartyMenuGroup = ()=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $315ee3b8ba7849ed$export$eb38bfb0a571f3e4));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enabledIntegrations: enabledIntegrations, integrations: connectedIntegrations, onConnectProvider: onConnectProvider, onDisconnectProvider: onDisconnectProvider } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const connectableIntegrations = (0, $42omo.useMemo)(()=>[
            ...enabledIntegrations
        ].filter((itg)=>!connectedIntegrations.has(itg)), [
        connectedIntegrations,
        enabledIntegrations
    ]);
    const handleConnectItemClick = (0, $42omo.useCallback)((serviceKey)=>()=>{
            analytics.dropdownMenuItemClicked({
                actionSubjectId: 'connectIntegration',
                attributes: {
                    integration: serviceKey
                }
            });
            if (onConnectProvider) onConnectProvider({
                serviceKey: serviceKey
            });
        }, [
        analytics,
        onConnectProvider
    ]);
    const handleManageConnectionItemClick = (0, $42omo.useCallback)((serviceKey)=>()=>{
            analytics.dropdownMenuItemClicked({
                actionSubjectId: 'manageIntegration',
                attributes: {
                    integration: serviceKey
                }
            });
            if (onDisconnectProvider) onDisconnectProvider(serviceKey);
        }, [
        analytics,
        onDisconnectProvider
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            connectableIntegrations.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                title: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).connectToDropdownItemGroupTitle),
                children: connectableIntegrations.map((integration)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c5365b562f33ab79$export$2e2bcd8739ae039), {
                        onClick: handleConnectItemClick(integration),
                        integration: integration
                    }, `${integration}`))
            }),
            connectedIntegrations.size > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                title: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).manageConnectionsDropItemGroupTitle),
                children: [
                    ...connectedIntegrations
                ].map((integration)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2e09f20380770bfd$export$2e2bcd8739ae039), {
                        onClick: handleManageConnectionItemClick(integration),
                        integration: integration
                    }, `${integration}`))
            })
        ]
    });
};
var $7d40b1e1838205d7$export$2e2bcd8739ae039 = $7d40b1e1838205d7$var$ThirdPartyMenuGroup;


/* AdminMenuGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















var $2sbaw = parcelRequire("2sbaw");



















const $bd307ea31e114db7$var$styles = {
    dropdownItemIcon: "_2hwxu2gc"
};
const $bd307ea31e114db7$var$AdminMenuGroup = ({ onAdminMenuItemClick: onAdminMenuItemClick })=>{
    const invitePeopleData = (0, $9xnOK.useInvitePeopleContext)();
    const cloudId = invitePeopleData.cloudId ?? '';
    const analytics = (0, $2dswi.useAnalytics)((0, $315ee3b8ba7849ed$export$eb38bfb0a571f3e4));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const adminMenuTitle = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).adminDropdownItemGroupTitle);
    const onSiteAccessSettingsMenuItemClick = (0, $42omo.useCallback)((event)=>{
        onAdminMenuItemClick?.(event);
        analytics.dropdownMenuItemClicked({
            actionSubjectId: 'siteAccessSettingsLink',
            attributes: {
                integration: invitePeopleData?.source,
                product: invitePeopleData?.productId
            }
        });
    }, [
        analytics,
        invitePeopleData?.productId,
        invitePeopleData?.source,
        onAdminMenuItemClick
    ]);
    const onUserManagementMenuItemClick = (0, $42omo.useCallback)((event)=>{
        onAdminMenuItemClick?.(event);
        analytics.dropdownMenuItemClicked({
            actionSubjectId: 'userManagementLink',
            attributes: {
                integration: invitePeopleData?.source,
                product: invitePeopleData?.productId
            }
        });
    }, [
        analytics,
        invitePeopleData?.productId,
        invitePeopleData?.source,
        onAdminMenuItemClick
    ]);
    const userManagementMenuItem = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
            testId: "testId-invite-people-user-management-menu-item",
            href: (0, $j9g2s.adminHubManageUsersHref)(cloudId),
            onClick: onUserManagementMenuItemClick,
            target: "new",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $bd307ea31e114db7$var$styles.dropdownItemIcon,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2sbaw))), {
                            color: "currentColor",
                            label: "open",
                            LEGACY_size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).formUserManagementLabel
                        })
                    })
                ]
            })
        });
    }, [
        cloudId,
        onUserManagementMenuItemClick
    ]);
    const siteAccessSettingsMenuItem = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
            testId: "testId-invite-people-manage-access-settings-menu-item",
            href: `${(0, $j9g2s.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
            onClick: onSiteAccessSettingsMenuItemClick,
            target: "new",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $bd307ea31e114db7$var$styles.dropdownItemIcon,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2sbaw))), {
                            color: "currentColor",
                            label: "open",
                            LEGACY_size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).formManageAccessSettingsLabel
                        })
                    })
                ]
            })
        });
    }, [
        cloudId,
        onSiteAccessSettingsMenuItemClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
        title: adminMenuTitle,
        children: [
            userManagementMenuItem,
            siteAccessSettingsMenuItem
        ]
    });
};
var $bd307ea31e114db7$export$2e2bcd8739ae039 = $bd307ea31e114db7$var$AdminMenuGroup;






const $254e221545d6b311$export$d9b273488cd8ce6f = ({ onAdminMenuItemClick: onAdminMenuItemClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { userRole: userRole } = (0, $9xnOK.useInvitePeopleContext)();
    // Enabled integrations are to show Connect To menu items
    // Connected integrations are to show Revoke menu items
    const { integrations: connectedIntegrations } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const relevantIntegrationSize = connectedIntegrations.size;
    const thirdPartyMenuGroup = relevantIntegrationSize > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7d40b1e1838205d7$export$2e2bcd8739ae039), {}) : null;
    const adminMenuGroup = (0, $07330006f53205cd$export$6bcb65c6ec0ed966)(userRole) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $bd307ea31e114db7$export$2e2bcd8739ae039), {
        onAdminMenuItemClick: onAdminMenuItemClick
    }) : null;
    if (!adminMenuGroup && !thirdPartyMenuGroup) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "testId-invite-people-dropdown-menu",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $52EPl.default), {
            placement: "bottom-end",
            zIndex: 560,
            trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...providedProps,
                    ref: triggerRef,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8JHjV))),
                    label: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).formMoreActionsButtonLabel),
                    appearance: "subtle"
                }),
            testId: "testId-invite-people-dropdown-menu",
            shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-growth-core'),
            children: [
                thirdPartyMenuGroup,
                adminMenuGroup
            ]
        })
    });
};
var $254e221545d6b311$export$2e2bcd8739ae039 = $254e221545d6b311$export$d9b273488cd8ce6f;


/* FormTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















const $60bd051b33cc88bf$var$styles = {
    wrapper: "_1q511ejb _85i5v77o"
};
const $60bd051b33cc88bf$var$FormTitle = ({ productOptions: productOptions, selectedProducts: selectedProducts, titleId: titleId })=>{
    const { jiraSubProduct: jiraSubProduct, productTitle: productTitle } = (0, $9xnOK.useInvitePeopleContext)();
    const getProductForTitle = (0, $42omo.useCallback)(()=>{
        if (selectedProducts.length === 1) {
            const selectedOption = (productOptions || []).find(({ value: value })=>value === selectedProducts[0]);
            if (selectedOption) {
                const isJiraProduct = [
                    (0, $j9g2s.JiraWorkManagementProduct).id,
                    (0, $j9g2s.JiraSoftwareProduct).id
                ].includes(selectedOption.value);
                return isJiraProduct ? (0, $j9g2s.JiraProduct).label : selectedOption.label;
            } else return !!jiraSubProduct ? (0, $j9g2s.getProductTitle)(jiraSubProduct) : productTitle;
        }
        return null;
    }, [
        productTitle,
        productOptions,
        jiraSubProduct,
        selectedProducts
    ]);
    const selectedProductTitle = getProductForTitle();
    const formattedSelectedProductTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).formTitleProduct,
        values: {
            product: selectedProductTitle
        }
    });
    const formattedDefaultTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).formTitle
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $60bd051b33cc88bf$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
            as: "h1",
            id: titleId ?? 'invite-people-title',
            size: "medium",
            children: !!selectedProductTitle ? formattedSelectedProductTitle : formattedDefaultTitle
        })
    });
};
var $60bd051b33cc88bf$export$2e2bcd8739ae039 = $60bd051b33cc88bf$var$FormTitle;



/* InvitePeopleForm.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $bRPo1 = parcelRequire("bRPo1");


var $g5gZt = parcelRequire("g5gZt");


var $bedQP = parcelRequire("bedQP");












/* ProductSelect.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $jVhgp = parcelRequire("jVhgp");


var $1bHXt = parcelRequire("1bHXt");


var $c9mMn = parcelRequire("c9mMn");

var $3hOY6 = parcelRequire("3hOY6");







var $9d81r = parcelRequire("9d81r");




var $1s5hv = parcelRequire("1s5hv");




var $3gadb = parcelRequire("3gadb");


















var $4Nwes = parcelRequire("4Nwes");










const $0f21e0bfb996b3cf$export$b610bb2c8703b7d1 = (availableProducts, productId, jiraSubProduct, collections = {})=>{
    const products = availableProducts.map((product)=>'id' in product ? product.id : product.value);
    const isTwcEnabled = collections[(0, $5LksM.CollectionType).TEAMWORK_COLLECTION]?.isEnabled;
    const key = productId === 'jira' ? jiraSubProduct : productId;
    const twcProducts = collections[(0, $5LksM.CollectionType).TEAMWORK_COLLECTION]?.products || [];
    const isTwcProduct = key && twcProducts.includes(key);
    if (isTwcEnabled && isTwcProduct && twcProducts.length) {
        const availableTwcProducts = products.filter((product)=>twcProducts.includes(product)).sort((a, b)=>{
            if (a === key) return -1;
            if (b === key) return 1;
            return 0;
        });
        if (availableTwcProducts.length === twcProducts.length) return {
            isTwcPreselected: true,
            twcProducts: availableTwcProducts
        };
    }
    return {
        isTwcPreselected: false,
        twcProducts: []
    };
};


const $335ec1f6409eadfb$var$defaultProduct = (id, label)=>({
        id: id,
        label: label,
        landingPath: '',
        directAccessLocation: 'others.core-invites',
        icon: (0, $4Nwes.AtlassianIcon)
    });
const $335ec1f6409eadfb$export$41e1984324a860ca = (options)=>{
    const hasBothJSWAndJWM = options.find((option)=>option.value === (0, $j9g2s.JiraWorkManagementProduct).id) && options.find((option)=>option.value === (0, $j9g2s.JiraSoftwareProduct).id);
    return options.map((option)=>{
        const product = (0, $j9g2s.getProductById)(option.value);
        // If has both JSW and JWM in selected products
        // then return the original JiraWorkManagementProduct that has Jira Work Management label and JWM Icon
        if (hasBothJSWAndJWM && option.value === (0, $j9g2s.JiraWorkManagementProduct).id) return 0, $j9g2s.JiraWorkManagementProduct;
        return product || $335ec1f6409eadfb$var$defaultProduct(option.value, option.label);
    });
};
const $335ec1f6409eadfb$export$f4f954eb8b707ede = (inviteProducts)=>{
    const hasBothJSWAndJWM = inviteProducts.find((product)=>product.id === (0, $j9g2s.JiraWorkManagementProduct).id) && inviteProducts.find((product)=>product.id === (0, $j9g2s.JiraSoftwareProduct).id);
    return inviteProducts.map((option)=>{
        const product = (0, $j9g2s.getProductById)(option.id);
        // If has both JSW and JWM in available products
        // then return the original JiraWorkManagementProduct that has Jira Work Management label and JWM Icon
        if (hasBothJSWAndJWM && option.id === (0, $j9g2s.JiraWorkManagementProduct).id) return 0, $j9g2s.JiraWorkManagementProduct;
        return product || $335ec1f6409eadfb$var$defaultProduct(option.id, option.name);
    });
};
const $335ec1f6409eadfb$export$eff484b0acab3de5 = (availableProducts, productId, jiraSubProduct, collections = {})=>{
    /*
	 Puma experiment: Puma-54 TWC for Core Invites
	 go/puma-experiments
	*/ const { isTwcPreselected: isTwcPreselected, twcProducts: twcProducts } = (0, $0f21e0bfb996b3cf$export$b610bb2c8703b7d1)(availableProducts, productId, jiraSubProduct, collections);
    if (isTwcPreselected) return availableProducts.map((product)=>{
        const isTeamworkProduct = twcProducts.includes(product.id);
        return {
            value: product.id,
            label: product.label,
            group: isTeamworkProduct ? (0, $5LksM.CollectionType).TEAMWORK_COLLECTION : undefined,
            isReadOnly: isTeamworkProduct
        };
    });
    return availableProducts.map((product)=>{
        return {
            value: product.id,
            label: product.label
        };
    });
};
const $335ec1f6409eadfb$export$e30dd649ce5911e1 = (ids)=>{
    return ids.map((id)=>({
            value: id,
            label: (0, $j9g2s.getProductTitle)(id) || id
        }));
};
const $335ec1f6409eadfb$export$877992b5aa6eda64 = (availableProductOptions, productId, jiraSubProduct, collections = {})=>{
    /*
	 Puma experiment: Puma-54 TWC for Core Invites
	 go/puma-experiments
	*/ const { isTwcPreselected: isTwcPreselected, twcProducts: twcProducts } = (0, $0f21e0bfb996b3cf$export$b610bb2c8703b7d1)(availableProductOptions, productId, jiraSubProduct, collections);
    if (isTwcPreselected) return twcProducts.map((value)=>({
            label: value,
            value: value
        }));
    if (jiraSubProduct) {
        const jiraSubProducts = availableProductOptions.filter((product)=>product.value === jiraSubProduct || product.value === (0, $j9g2s.JiraWorkManagementProduct).id);
        // handle case when the current product is JWM but JWM is not in the invite-capabilites response
        if (jiraSubProducts.length === 0) {
            const jiraSoftware = availableProductOptions.find((item)=>item.value === (0, $j9g2s.JiraSoftwareProduct).id);
            if (jiraSoftware) return [
                jiraSoftware
            ];
            const jiraServiceManagement = availableProductOptions.find((item)=>item.value === (0, $j9g2s.JiraServiceManagementProduct).id);
            if (jiraServiceManagement) return [
                jiraServiceManagement
            ];
        // fallthrough when there are no jira product capabilities
        } else return jiraSubProducts;
    }
    if (availableProductOptions.length === 1) // If there's exactly one product subscription, we should use it when sending
    // the invite
    return availableProductOptions;
    const currentProducts = availableProductOptions.filter((product)=>product.value.includes(productId));
    const fallbackProductList = productId !== 'platform' ? [
        {
            value: productId,
            label: (0, $j9g2s.getProductTitle)(productId)
        }
    ] : [];
    return currentProducts.length > 0 ? currentProducts : fallbackProductList;
};
const $335ec1f6409eadfb$var$isNotJiraCore = (product)=>product !== (0, $j9g2s.JiraWorkManagementProduct).id;
const $335ec1f6409eadfb$var$isAnyJira = (product)=>product.startsWith('jira');
const $335ec1f6409eadfb$var$isNonCoreJira = (product)=>$335ec1f6409eadfb$var$isAnyJira(product) && $335ec1f6409eadfb$var$isNotJiraCore(product);
const $335ec1f6409eadfb$export$3f18758b465dbbc9 = (products)=>products?.some($335ec1f6409eadfb$var$isNonCoreJira) || false;
const $335ec1f6409eadfb$export$2ffa8edc2268aa15 = (selectedProducts)=>$335ec1f6409eadfb$export$3f18758b465dbbc9(selectedProducts) ? selectedProducts.filter($335ec1f6409eadfb$var$isNotJiraCore) : selectedProducts;
const $335ec1f6409eadfb$export$928425bd23b53f11 = ({ productOptions: productOptions, productId: productId, jiraSubProduct: jiraSubProduct, collections: collections })=>$335ec1f6409eadfb$export$2ffa8edc2268aa15($335ec1f6409eadfb$export$877992b5aa6eda64($335ec1f6409eadfb$export$eff484b0acab3de5(productOptions, productId, jiraSubProduct, collections), productId, jiraSubProduct, collections).map((product)=>product.value));














class $3648d194cf84152e$export$87f10ac80394eda7 {
    async isPermissionPermitted(request) {
        const path = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.PERMS_URL)}`;
        const { permissionId: permissionId, cloudId: cloudId } = request;
        const data = {
            permissionId: permissionId,
            resourceId: `ari:cloud:platform::site/${cloudId}`
        };
        return (0, $5YNlj.postJson)(path, 'isPermissionPermitted', data);
    }
    async getUsersWithoutAccess(cloudId, products, accountIds) {
        const path = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.ELIGIBLE_USERS)}`;
        const request = {
            cloudId: cloudId,
            products: products,
            accountIds: accountIds
        };
        return (0, $5YNlj.postJson)(path, 'get-eligible-users', request);
    }
    async getUserRole(cloudId) {
        try {
            const [{ permitted: isInviteUsersPermitted }, { permitted: isManagePermitted }] = await Promise.all([
                this.isPermissionPermitted({
                    permissionId: 'invite-users',
                    cloudId: cloudId
                }),
                this.isPermissionPermitted({
                    permissionId: 'manage',
                    cloudId: cloudId
                })
            ]);
            let role;
            if (isInviteUsersPermitted && isManagePermitted) role = 'admin';
            else if (isInviteUsersPermitted && !isManagePermitted) role = 'trusted';
            else role = 'basic';
            return {
                role: role,
                isInviteUsersPermitted: isInviteUsersPermitted,
                isManagePermitted: isManagePermitted
            };
        } catch (err) {
            //if something breaks while getting user role, fallback to 'basic'
            return {
                role: 'basic',
                errorMessage: `Error while getting user role: ${err instanceof Error ? err.message : String(err)}!`
            };
        }
    }
}
const $3648d194cf84152e$export$c2fb70172d8b4300 = new $3648d194cf84152e$export$87f10ac80394eda7();








class $2c96b0fa6c9f8a62$export$353491dc426ad77f {
    async getAccountInfo() {
        const fetchUrl = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}/me`;
        const resp = await (0, $5YNlj.fetchJson)(fetchUrl, 'getAccountInfo');
        return resp;
    }
}











class $9f84c3ec6012736d$export$db1a8fab85ca9503 {
    async getOpenInviteState(product, cloudId) {
        const resourceARI = `ari:cloud:${product}::site/${cloudId}`;
        const path = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.OPEN_INVITE_URL)}?resource=${resourceARI}`;
        const cacheValue = this.openInviteCache.get(resourceARI);
        if (cacheValue) return {
            response: cacheValue,
            cached: true
        };
        try {
            const resp = await (0, $5YNlj.fetchJson)(path, 'getOpenInviteState');
            const openInviteInfo = {
                ...resp,
                getOpenInvite: true
            };
            (0, $j9g2s.tryCacheWithClear)(this.openInviteCache, resourceARI, openInviteInfo, 50);
            return {
                response: openInviteInfo,
                cached: false
            };
        } catch (err) {
            const openInviteInfo = {
                getOpenInvite: false,
                mode: 'REQUEST_ACCESS'
            };
            const { responseCode: responseCode } = (0, $j9g2s.resolveError)(err);
            if (responseCode && responseCode >= (0, $5YNlj.RespCodes).BAD_REQUESTS && responseCode <= (0, $5YNlj.RespCodes).CLIENT_CLOSED_REQUEST) (0, $j9g2s.tryCacheWithClear)(this.openInviteCache, resourceARI, openInviteInfo, 50);
            throw err;
        }
    }
    // Will only update to DIRECT_ACCESS for open invite settings.
    async enableOpenInvite(product, cloudId) {
        const resource = `ari:cloud:${product}::site/${cloudId}`;
        // only need to enable OPEN_INVITE (DIRECT_ACCESS) for our experiment
        const mode = 'DIRECT_ACCESS';
        const path = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.OPEN_INVITE_URL)}`;
        const request = {
            resource: resource,
            mode: mode
        };
        await (0, $5YNlj.putJson)(path, 'enableOpenInvite', request);
        return {
            success: true,
            enableOpenInvite: true
        };
    }
    async getOpenInviteNote(orgId) {
        const url = (0, $7GQiN.getOpenInviteNoteUrl)((0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL), orgId);
        const response = await (0, $5YNlj.fetchJson)(url, 'getOpenInviteNote');
        return response;
    }
    constructor(){
        this.openInviteCache = void 0;
        this.clearCache = ()=>{
            this.openInviteCache.clear();
        };
        this.openInviteCache = new Map();
    }
}



var $2vYoS = parcelRequire("2vYoS");







const $bf742a49800dd991$export$4699366f3c37153b = (cloudId, userId)=>`${0, $7GQiN.PERSONALIZATION_URL}/site/${cloudId}/user/${userId}`;
const $bf742a49800dd991$export$35bc6862a72d40bd = (cloudId)=>`${0, $7GQiN.PERSONALIZATION_URL}/site/${cloudId}`;
class $bf742a49800dd991$export$c5b41f73d41fa593 {
    constructor(){
        this.getPersonalizationSiteTraits = (cloudId)=>(0, $5YNlj.fetchJson)($bf742a49800dd991$export$35bc6862a72d40bd(cloudId), 'getPeronalizationSiteTraits');
        this.getPersonalizationSiteUserTraits = (cloudId, userId)=>(0, $5YNlj.fetchJson)($bf742a49800dd991$export$4699366f3c37153b(cloudId, userId), 'getPersonalizationSiteUserTraits');
    }
}
const $bf742a49800dd991$export$d3e1efd45b274804 = new $bf742a49800dd991$export$c5b41f73d41fa593();


const $a44a4a0d19730078$export$d3e1efd45b274804 = new (0, $bf742a49800dd991$export$c5b41f73d41fa593)();
const $a44a4a0d19730078$export$c993591f6996ca09 = new (0, $bTj8C.InviteApiClientImpl)();
const $a44a4a0d19730078$export$c2fb70172d8b4300 = new (0, $3648d194cf84152e$export$87f10ac80394eda7)();
const $a44a4a0d19730078$export$a389cf813a8a5b61 = new (0, $2c96b0fa6c9f8a62$export$353491dc426ad77f)();
const $a44a4a0d19730078$export$4f6a946e6e09a73b = new (0, $9f84c3ec6012736d$export$db1a8fab85ca9503)();
const $a44a4a0d19730078$export$1c37f95483f1b2d0 = new (0, $2vYoS.HaveISeenItClient)();











class $60ea0975e4f98e28$export$395cad012eb6716e extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    productSelectRendered(productOptions) {
        const { userRole: userRole, source: source } = this.commonAttributes;
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).DROPDOWN,
            actionSubjectId: 'customizedProductSelect',
            action: (0, $5LksM.AnalyticsAction).RENDERED,
            attributes: {
                integration: source,
                source: source,
                userRole: userRole,
                productOptions: productOptions
            }
        });
    }
    selectAllClicked(productsSelected) {
        const { productTitle: productTitle, source: source, userRole: userRole } = this.commonAttributes;
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).DROPDOWN_ITEM,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            actionSubjectId: 'selectAll',
            attributes: {
                integration: source,
                source: source,
                product: productTitle.toLowerCase(),
                productsSelected: productsSelected,
                permissionLevel: userRole
            }
        });
    }
    getAvailableProductsSucceeded(resourceAri, availableResourcesAri) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITE_CAPABILITIES,
            actionSubjectId: resourceAri,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: {
                availableResourcesAri: availableResourcesAri
            }
        });
    }
    getAvailableProductsFailed(resourceAri) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITE_CAPABILITIES,
            actionSubjectId: resourceAri,
            action: (0, $5LksM.AnalyticsAction).FAILED
        });
    }
    getCollectionsSucceeded(resourceAri, hasTeamworkCollection) {
        const { productTitle: productTitle, source: source, subProduct: subProduct, jiraSubProduct: jiraSubProduct, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_COLLECTIONS,
            actionSubjectId: resourceAri,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: {
                hasTeamworkCollection: hasTeamworkCollection,
                productTitle: productTitle,
                source: source,
                subProduct: subProduct,
                jiraSubProduct: jiraSubProduct,
                userRole: userRole
            }
        });
    }
    getCollectionsFailed(resourceAri) {
        const { productTitle: productTitle, source: source, subProduct: subProduct, jiraSubProduct: jiraSubProduct, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_COLLECTIONS,
            actionSubjectId: resourceAri,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                productTitle: productTitle,
                source: source,
                subProduct: subProduct,
                jiraSubProduct: jiraSubProduct,
                userRole: userRole
            }
        });
    }
    groupsRendered(productsSelected, options) {
        const { productTitle: productTitle, source: source, subProduct: subProduct, jiraSubProduct: jiraSubProduct, userRole: userRole } = this.commonAttributes;
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).DROPDOWN,
            actionSubjectId: 'twcForCoreInvites',
            action: (0, $5LksM.AnalyticsAction).RENDERED,
            attributes: {
                productsSelected: productsSelected,
                productTitle: productTitle,
                source: source,
                subProduct: subProduct,
                jiraSubProduct: jiraSubProduct,
                userRole: userRole,
                options: options
            }
        });
    }
}







var $2KIzJ = parcelRequire("2KIzJ");


const $8efc6a9cd7fde791$export$b1a2fdcd2fdbc1e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $8efc6a9cd7fde791$export$bfcb57024ef3c3d = async (cloudId, resourceAri, analytics)=>{
    try {
        (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getInviteCapabilities.startMark);
        const response = await (0, $a44a4a0d19730078$export$c993591f6996ca09).inviteCapabilities(cloudId);
        (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getInviteCapabilities.endMark);
        // Get unique capabilities.
        const resources = [
            // Create map (matching keys override) and get just the values
            ...new Map([
                ...response.directInvite,
                ...response.invitePendingApproval
            ].map((item)=>[
                    item.id,
                    item
                ])).values()
        ];
        analytics.getAvailableProductsSucceeded(resourceAri, resources.map(({ id: id })=>`ari:cloud:${id}::site/${cloudId}`));
        if (!resources?.length) return {
            productOptions: [],
            inviteCapabilities: {
                directInvite: [],
                invitePendingApproval: []
            }
        };
        const resourcesAsOptions = (0, $335ec1f6409eadfb$export$f4f954eb8b707ede)(resources).filter((p)=>(0, $j9g2s.isProductIdWhiteListed)(p.id));
        return {
            productOptions: resourcesAsOptions,
            inviteCapabilities: response
        };
    } catch (err) {
        analytics.getAvailableProductsFailed(resourceAri);
        return {
            productOptions: [],
            inviteCapabilities: {
                directInvite: [],
                invitePendingApproval: []
            }
        };
    }
};
const $8efc6a9cd7fde791$export$a9dbfb18603d6a77 = async (cloudId, resourceAri, analytics)=>{
    if (!cloudId) return {};
    try {
        (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getCollections.startMark);
        const response = await (0, $a44a4a0d19730078$export$c993591f6996ca09).getCollections({
            cloudId: cloudId
        });
        (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getCollections.endMark);
        analytics.getCollectionsSucceeded(resourceAri, !!response?.[(0, $5LksM.CollectionType).TEAMWORK_COLLECTION]?.isEnabled);
        return response;
    } catch (error) {
        analytics.getCollectionsFailed(resourceAri);
        return {};
    }
};
const $8efc6a9cd7fde791$export$e46bb22811a53085 = ({ resourceAri: resourceAri, children: children, productOptions: productOptions })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $60ea0975e4f98e28$export$395cad012eb6716e));
    const { cloudId: cloudId, jiraSubProduct: jiraSubProduct, productId: productId } = (0, $9xnOK.useInvitePeopleContext)();
    const { collections: gqlCollections, shouldFetchCollections: shouldFetchCollections } = (0, $2KIzJ.useCollections)();
    const productOptionsFiltered = productOptions ? (0, $335ec1f6409eadfb$export$41e1984324a860ca)(productOptions).filter((p)=>(0, $j9g2s.isProductIdWhiteListed)(p.id)) : [];
    const [collections, setCollections] = (0, $42omo.useState)(gqlCollections);
    const [availableProducts, setAvailableProducts] = (0, $42omo.useState)(productOptionsFiltered);
    const [selectedProducts, setSelectedProducts] = (0, $42omo.useState)((0, $335ec1f6409eadfb$export$928425bd23b53f11)({
        productOptions: availableProducts,
        productId: productId,
        jiraSubProduct: jiraSubProduct,
        collections: collections
    }));
    const [inviteCapabilities, setInviteCapabilities] = (0, $42omo.useState)({
        directInvite: [],
        invitePendingApproval: []
    });
    const hasPreselectedTwc = (0, $42omo.useMemo)(()=>(0, $0f21e0bfb996b3cf$export$b610bb2c8703b7d1)(availableProducts, productId, jiraSubProduct, collections).isTwcPreselected, [
        availableProducts,
        productId,
        jiraSubProduct,
        collections
    ]);
    const [isFetchProductsLoading, setIsFetchProductsLoading] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        const fetchProductData = async ()=>{
            if (productOptionsFiltered.length === 0 && isFetchProductsLoading) {
                const availableProductsPromise = $8efc6a9cd7fde791$export$bfcb57024ef3c3d(cloudId || '', resourceAri, analytics);
                const collectionsPromise = shouldFetchCollections ? $8efc6a9cd7fde791$export$a9dbfb18603d6a77(cloudId, resourceAri, analytics) : undefined;
                const [availableProducts, collectionsResponse] = await Promise.all([
                    availableProductsPromise,
                    collectionsPromise
                ]);
                const { productOptions: productOptions, inviteCapabilities: inviteCapabilities } = availableProducts;
                setAvailableProducts(productOptions);
                setInviteCapabilities(inviteCapabilities);
                const collections = (shouldFetchCollections ? collectionsResponse : gqlCollections) || {};
                if (shouldFetchCollections) setCollections(collections);
                setSelectedProducts((0, $335ec1f6409eadfb$export$928425bd23b53f11)({
                    productOptions: productOptions,
                    productId: productId,
                    jiraSubProduct: jiraSubProduct,
                    collections: collections
                }));
            }
            setIsFetchProductsLoading(false);
        };
        fetchProductData();
    }, [
        cloudId,
        productId,
        jiraSubProduct,
        gqlCollections,
        shouldFetchCollections,
        resourceAri,
        isFetchProductsLoading,
        productOptionsFiltered.length,
        analytics
    ]);
    const availableProductOptions = (0, $42omo.useMemo)(()=>(0, $335ec1f6409eadfb$export$eff484b0acab3de5)(availableProducts, productId, jiraSubProduct, collections), [
        availableProducts,
        productId,
        jiraSubProduct,
        collections
    ]);
    const hasPermissionToInviteOrRequestAccess = (0, $42omo.useMemo)(()=>{
        if (!productId || !cloudId || isFetchProductsLoading) return false;
        const { directInvite: directInvite, invitePendingApproval: invitePendingApproval } = inviteCapabilities;
        if (productId === 'platform') return directInvite.length > 0 || invitePendingApproval.length > 0;
        const currentProductId = jiraSubProduct || productId;
        const currentProductAri = (0, $j9g2s.makeAri)(currentProductId, cloudId);
        const hasRelatedProduct = (config)=>{
            if (productId === (0, $j9g2s.JiraProduct).id) {
                if (!jiraSubProduct || jiraSubProduct === 'unknown') return config.ari.indexOf((0, $j9g2s.JiraWorkManagementProduct).id) > 0 || config.ari.indexOf((0, $j9g2s.JiraServiceManagementProduct).id) > 0 || config.ari.indexOf((0, $j9g2s.JiraSoftwareProduct).id) > 0 || config.ari.indexOf((0, $j9g2s.JiraProductDiscovery).id) > 0;
                else if (jiraSubProduct === (0, $j9g2s.JiraWorkManagementProduct).id) return config.ari.indexOf((0, $j9g2s.JiraWorkManagementProduct).id) > 0 || config.ari.indexOf((0, $j9g2s.JiraSoftwareProduct).id) > 0;
            }
            return config.ari === currentProductAri;
        };
        return directInvite.some(hasRelatedProduct) || invitePendingApproval.some(hasRelatedProduct);
    }, [
        cloudId,
        jiraSubProduct,
        inviteCapabilities,
        isFetchProductsLoading,
        productId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($8efc6a9cd7fde791$export$b1a2fdcd2fdbc1e5.Provider, {
        value: {
            selectedProducts: selectedProducts,
            availableProducts: availableProducts,
            setAvailableProducts: setAvailableProducts,
            availableProductOptions: availableProductOptions,
            setSelectedProducts: setSelectedProducts,
            isFetchProductsLoading: isFetchProductsLoading,
            inviteCapabilities: inviteCapabilities,
            hasPermissionToInviteOrRequestAccess: hasPermissionToInviteOrRequestAccess,
            hasPreselectedTwc: hasPreselectedTwc
        },
        children: children
    });
};
const $8efc6a9cd7fde791$export$964e8498268f0fe3 = ()=>{
    const state = (0, $42omo.useContext)($8efc6a9cd7fde791$export$b1a2fdcd2fdbc1e5);
    if (state === undefined) throw new Error('useProducts must be used within a ProductsStateContextProvider');
    return state;
};











var $8tSmd = parcelRequire("8tSmd");




const $18d0ff54ab41cb9e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    teamworkCollectionGroupLabel: {
        id: "people-and-team.invite-people.form.teamwork-collection-group-label",
        defaultMessage: "Teamwork Collection"
    },
    teamworkCollectionGroupTooltipJira: {
        id: "people-and-team.invite-people.form.teamwork-collection-group-tooltip-jira",
        defaultMessage: "With Teamwork Collection, they can also access Confluence and Loom for free."
    },
    teamworkCollectionGroupTooltipConfluence: {
        id: "people-and-team.invite-people.form.teamwork-collection-group-tooltip-confluence",
        defaultMessage: "With Teamwork Collection, they can also access Jira and Loom for free."
    },
    defaultGroupLabel: {
        id: "people-and-team.invite-people.form.tooltip-group-label",
        defaultMessage: "Other apps"
    }
});





const $7e6c16ceb2649a10$var$DEFAULT_LABEL = (0, $18d0ff54ab41cb9e$export$defe85febe8b728c).defaultGroupLabel;
const $7e6c16ceb2649a10$var$groupLabels = {
    [(0, $5LksM.CollectionType).TEAMWORK_COLLECTION]: (productKey)=>{
        let tooltip;
        if (productKey === 'confluence') tooltip = (0, $18d0ff54ab41cb9e$export$defe85febe8b728c).teamworkCollectionGroupTooltipConfluence;
        else if (productKey === 'jira-software') tooltip = (0, $18d0ff54ab41cb9e$export$defe85febe8b728c).teamworkCollectionGroupTooltipJira;
        return {
            label: (0, $18d0ff54ab41cb9e$export$defe85febe8b728c).teamworkCollectionGroupLabel,
            tooltip: tooltip
        };
    }
};
const $7e6c16ceb2649a10$export$f8f07e3a5ea06051 = (formatMessage, productOptions, productKey)=>{
    const ungrouped = [];
    const grouped = new Map();
    for (const option of productOptions)if (option.group) {
        const group = grouped.get(option.group) || [];
        group.push(option);
        grouped.set(option.group, group);
    } else ungrouped.push(option);
    const groups = Array.from(grouped.entries());
    if (!groups.length) return ungrouped;
    const options = groups.map(([key, options])=>{
        const copy = $7e6c16ceb2649a10$var$groupLabels[key]?.(productKey);
        if (!copy) return {
            label: key,
            options: options
        };
        const label = formatMessage(copy?.label);
        const tooltip = copy?.tooltip ? formatMessage(copy.tooltip) : undefined;
        return {
            label: label,
            tooltip: tooltip,
            options: options
        };
    });
    if (ungrouped.length) options.push({
        label: formatMessage($7e6c16ceb2649a10$var$DEFAULT_LABEL),
        options: ungrouped
    });
    return options;
};





const $4e9bb9323fa5b517$var$MAX_VISIBLE_PRODUCTS = 2;
const $4e9bb9323fa5b517$var$styles = {
    fieldWrapper: "_kqswh2mm",
    iconWrapper: "_2rko12b0 _1reo15vq _18m915vq _1rjcv77o _18zrv77o _1bsb1f4h _4t3i1f4h _18u01b66 _2hwxu2gc",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    readOnlyLabelWrapper: "_syaz1fxt",
    label: "_11c81vhk _1e0c1ule _k48p1pd9 _syaz131l _19pkze3t _otyr1b66",
    productValues: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    chooseAllButtonWrapper: "_1rjcu2gc _bozgv47k _y4tiutpp",
    groupTooltip: "_y3gn1h6o"
};
const $4e9bb9323fa5b517$var$controlStyles = {
    root: "_2rko12b0 _1h6dmuej _80omtlke _bfhk1j9a _4t3ickbl _19bvutpp _4cvx1j28 _irr315ej",
    menuIsOpen: "_bfhkfg4m _irr3fg4m",
    focused: "_1h6d1p6i _bfhkm7j4 _4cvx1p6i",
    menuIsOpenFocused: "_1h6d1j28 _4cvx1j28"
};
const $4e9bb9323fa5b517$var$valueContainerStyles = {
    root: "_syaz1fxt _1e0c1txw _1n261q9c _1ul9ze3t _ahgnglyw",
    menuIsOpen: "_syaz1e6v"
};
const $4e9bb9323fa5b517$var$isJiraCoreImplied = (option, selectedOptions)=>option.value === (0, $j9g2s.JiraWorkManagementProduct).id && (0, $335ec1f6409eadfb$export$3f18758b465dbbc9)(selectedOptions.map((option)=>option.value));
const $4e9bb9323fa5b517$var$customOptionLabel = (option, { context: context, selectValue: selectValue })=>{
    let LabelIcon = (0, $j9g2s.getProductIcon)(option.value); // If the label is Jira Work Management (due to JSW and JWM is shown in same place)
    // then it should render original JWM icon instead of the rebranded Jira icon.
    const isJiraWorkManagement = option.label === (0, $j9g2s.JiraWorkManagementProduct).label;
    if (isJiraWorkManagement) LabelIcon = (0, $j9g2s.JiraWorkManagementProduct).icon;
    if (context === 'menu') {
        const isImpliedJiraCore = $4e9bb9323fa5b517$var$isJiraCoreImplied(option, selectValue);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: isImpliedJiraCore ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).optionIncludedWithOtherJiraProductsAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).optionIncludedWithOtherJiraProducts
            }) : undefined,
            position: 'right',
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                testId: `test-id-option-${option.value}`,
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $4e9bb9323fa5b517$var$styles.iconWrapper,
                        backgroundColor: !isJiraWorkManagement && (0, $dh538.fg)('platform-logo-rebrand') ? undefined : 'color.background.neutral',
                        children: /*#__PURE__*/ (0, $l998X.jsx)(LabelIcon, {
                            size: "small",
                            appearance: "brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: (0, $1bHXt.cx)($4e9bb9323fa5b517$var$styles.labelWrapper, option.isReadOnly && $4e9bb9323fa5b517$var$styles.readOnlyLabelWrapper),
                        children: option.label
                    }),
                    isImpliedJiraCore && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9d81r))), {
                        label: 'EditorPanelIcon',
                        color: "var(--ds-icon-subtle, #626F86)"
                    })
                ]
            })
        });
    }
    return option.label;
};
const $4e9bb9323fa5b517$var$ProductSelect = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onMenuOpen: onMenuOpen, formInvalid: formInvalid }, ref)=>{
    const firedGroupRendered = (0, $42omo.useRef)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const analytics = (0, $2dswi.useAnalytics)((0, $60ea0975e4f98e28$export$395cad012eb6716e));
    const { jiraSubProduct: jiraSubProduct, productId: productId } = (0, $9xnOK.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts, setSelectedProducts: setSelectedProducts, availableProductOptions: availableProductOptions } = (0, $8efc6a9cd7fde791$export$964e8498268f0fe3)();
    const [isInvalid, setIsInvalid] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    (0, $42omo.useEffect)(()=>{
        analytics.productSelectRendered(availableProductOptions);
    }, [
        availableProductOptions,
        analytics
    ]);
    const shouldGroupOptions = (0, $42omo.useMemo)(()=>availableProductOptions.filter(({ group: group })=>Boolean(group)).length, [
        availableProductOptions
    ]);
    const options = (0, $42omo.useMemo)(()=>shouldGroupOptions ? (0, $7e6c16ceb2649a10$export$f8f07e3a5ea06051)(formatMessage, availableProductOptions, productId === 'jira' ? jiraSubProduct : productId) : availableProductOptions, [
        shouldGroupOptions,
        formatMessage,
        availableProductOptions,
        productId,
        jiraSubProduct
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!firedGroupRendered.current && shouldGroupOptions) {
            firedGroupRendered.current = true;
            analytics.groupsRendered(selectedProducts, options);
        }
    }, [
        analytics,
        shouldGroupOptions,
        options,
        selectedProducts
    ]);
    (0, $42omo.useEffect)(()=>{
        if (formInvalid && (!selectedProducts || !selectedProducts.length)) setIsInvalid(formInvalid);
    }, [
        formInvalid,
        selectedProducts
    ]); // Disable JWM if another jira product is selected
    const isOptionDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((option)=>{
        return option.value === (0, $j9g2s.JiraWorkManagementProduct).id && (0, $335ec1f6409eadfb$export$3f18758b465dbbc9)(selectedProducts) || !!option.isReadOnly;
    }, [
        selectedProducts
    ]);
    const isOptionSelected = (option, selectedOptions)=>{
        return selectedOptions.some((currentOption)=>option.value === currentOption.value) || $4e9bb9323fa5b517$var$isJiraCoreImplied(option, selectedOptions);
    };
    const handleOnChangeProduct = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((values, _action)=>{
        if (!values) return;
        const selectedOptions = [
            ...values
        ];
        setSelectedProducts((0, $335ec1f6409eadfb$export$2ffa8edc2268aa15)(selectedOptions.map((option)=>option.value)));
        setIsInvalid(!(selectedOptions && selectedOptions.length));
    }, [
        setSelectedProducts
    ]);
    const customMenuListFactory = ({ onSelectAll: onSelectAll = (_allProducts)=>{} })=>(props)=>{
            const onClickSelectAll = ()=>{
                const allOptions = [
                    ...props.options
                ];
                props.setValue(allOptions, 'select-option');
                onSelectAll(allOptions);
            }; // If has grouping, hide select all
            const hasGrouping = props.options.some((item)=>item?.options);
            if (hasGrouping) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).MenuList, {
                ...props
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $3hOY6.components).MenuList, {
                ...props,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $4e9bb9323fa5b517$var$styles.chooseAllButtonWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            onMouseDown: onClickSelectAll,
                            appearance: "link",
                            spacing: "none" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            ,
                            style: {
                                fontWeight: "var(--ds-font-weight-regular, 400)"
                            },
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).selectAllOption
                            })
                        })
                    }),
                    props.children
                ]
            });
        };
    const handleMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        setIsOpen(true);
        if (onMenuOpen) onMenuOpen();
    }, [
        onMenuOpen
    ]);
    const handleMenuClose = ()=>setIsOpen(false);
    const customComponents = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            MenuList: customMenuListFactory({
                onSelectAll: (selectedProducts)=>{
                    analytics.selectAllClicked(selectedProducts.map((p)=>String(p.value)));
                    setIsOpen(false);
                }
            }),
            GroupHeading: (props)=>{
                const { tooltip: tooltip } = props.data;
                if (tooltip) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).GroupHeading, {
                    ...props,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        gap: "space.050",
                        alignItems: "center",
                        children: [
                            props.children,
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $4e9bb9323fa5b517$var$styles.groupTooltip,
                                    children: tooltip
                                }),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
                                    label: tooltip
                                })
                            })
                        ]
                    })
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).GroupHeading, {
                    ...props
                });
            },
            MultiValue: (props)=>{
                const selectValue = props.selectProps.value || []; // `index` *is* passed by react-select, despite not being in MultiValueProps
                const { data: data, index: index } = props;
                const isLast = index === selectValue.length - 1;
                let suffix = ',';
                if (isLast) suffix = '';
                else if (index >= 1) suffix = ', ...';
                return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
                    children: [
                        data.label,
                        suffix,
                        "\xa0"
                    ]
                });
            },
            Option: (props)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $c9mMn.CheckboxOption), {
                    ...props
                });
            },
            ValueContainer: ({ children: children, ...props })=>{
                const selectedOptions = children[0];
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $3hOY6.components).ValueContainer, {
                    ...props,
                    xcss: (0, $1bHXt.cx)($4e9bb9323fa5b517$var$valueContainerStyles.root, props.selectProps.menuIsOpen && $4e9bb9323fa5b517$var$valueContainerStyles.menuIsOpen),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                            as: "span",
                            xcss: $4e9bb9323fa5b517$var$styles.productValues,
                            children: children
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            children: props.hasValue && selectedOptions.length > $4e9bb9323fa5b517$var$MAX_VISIBLE_PRODUCTS && `(+${selectedOptions.length - $4e9bb9323fa5b517$var$MAX_VISIBLE_PRODUCTS})`
                        })
                    ]
                });
            },
            Control: (props)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Control, {
                    ...props,
                    xcss: (0, $1bHXt.cx)($4e9bb9323fa5b517$var$controlStyles.root, props.menuIsOpen && $4e9bb9323fa5b517$var$controlStyles.menuIsOpen, props.isFocused && $4e9bb9323fa5b517$var$controlStyles.focused, props.menuIsOpen && props.isFocused && $4e9bb9323fa5b517$var$controlStyles.menuIsOpenFocused)
                });
            }
        }), [
        analytics
    ]);
    const customStyles = {
        // main area
        control: (provided, state)=>({
                ...provided,
                cursor: 'pointer',
                background: state.selectProps.menuIsOpen ? "var(--ds-background-selected, #E9F2FF)" : state.isFocused ? "var(--ds-background-neutral, #091E420F)" : "var(--ds-background-input, #FFFFFF)",
                height: '48px',
                paddingLeft: "var(--ds-space-150, 12px)",
                borderRadius: "var(--ds-radius-small, 4px)",
                borderColor: state.isFocused ? state.selectProps.menuIsOpen ? 'transparent' : "var(--ds-border-focused, #388BFF)" : "var(--ds-border, #091E4224)",
                ':hover': {
                    background: state.selectProps.menuIsOpen ? "var(--ds-background-selected, #E9F2FF)" : "var(--ds-background-neutral-hovered, #091E4224)",
                    borderColor: state.isFocused ? state.selectProps.menuIsOpen ? 'transparent' : "var(--ds-border-focused, #388BFF)" : 'transparent'
                }
            }),
        valueContainer: (provided, state)=>({
                ...provided,
                color: state.selectProps.menuIsOpen ? "var(--ds-text-brand, #0C66E4)" : "var(--ds-text, #172B4D)",
                display: 'flex',
                flexWrap: 'nowrap',
                minWidth: 0,
                [`> span > span:nth-child(n + ${$4e9bb9323fa5b517$var$MAX_VISIBLE_PRODUCTS + 1})`]: {
                    display: 'none'
                }
            }),
        placeholder: (provided, state)=>({
                ...provided,
                color: state.selectProps.menuIsOpen ? "var(--ds-text-brand, #0C66E4)" : "var(--ds-text, #172B4D)"
            }),
        dropdownIndicator: (provided, state)=>({
                ...provided,
                color: state.selectProps.menuIsOpen ? "var(--ds-text-brand, #0C66E4)" : "var(--ds-text, #172B4D)",
                ':hover': 'none'
            }),
        menuPortal: (provided)=>({
                ...provided,
                zIndex: (0, $5LksM.ZIndex).FLOATING
            })
    };
    const selectedValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const selectedOptions = (0, $335ec1f6409eadfb$export$e30dd649ce5911e1)(selectedProducts);
        const hasBothJSWAndJWM = availableProductOptions.find(({ value: value })=>value === (0, $j9g2s.JiraWorkManagementProduct).id) && availableProductOptions.find(({ value: value })=>value === (0, $j9g2s.JiraSoftwareProduct).id); // If JSW and JWM are both shown in options,
        // it should show original label of JWM as Jira Work Management instead of rebranded Jira label
        return hasBothJSWAndJWM ? selectedOptions.map((option)=>option.value === (0, $j9g2s.JiraWorkManagementProduct).id ? {
                label: (0, $j9g2s.JiraWorkManagementProduct).label,
                value: option.value
            } : option) : selectedOptions;
    }, [
        selectedProducts,
        availableProductOptions
    ]);
    const errorMessage = (0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).noProductSelectedMessageAltAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).noProductSelectedMessage;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "invite-people-product-select-list",
        children: (formProps)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                testId: "test-id-invite-people-select-product",
                xcss: $4e9bb9323fa5b517$var$styles.fieldWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        as: "label",
                        htmlFor: "product-select",
                        xcss: $4e9bb9323fa5b517$var$styles.label,
                        children: [
                            selectedProducts.length === 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).productSelectNoCurrentProductAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).productSelectNoCurrentProduct
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).productSelectAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).productSelect
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                        isMulti: true,
                        styles: customStyles,
                        isClearable: false,
                        isSearchable: false,
                        name: "product-select",
                        inputId: "product-select",
                        descriptionId: `${formProps.fieldProps.id}-error`,
                        placeholder: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).selectPlaceholderAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).selectPlaceholder
                        }),
                        className: "checkbox-select",
                        classNamePrefix: "select",
                        closeMenuOnSelect: false,
                        components: customComponents,
                        hideSelectedOptions: false,
                        options: options,
                        value: selectedValue,
                        formatOptionLabel: $4e9bb9323fa5b517$var$customOptionLabel,
                        onChange: handleOnChangeProduct,
                        isOptionDisabled: isOptionDisabled,
                        isOptionSelected: isOptionSelected,
                        onMenuOpen: handleMenuOpen,
                        onMenuClose: handleMenuClose,
                        menuIsOpen: isOpen,
                        validationState: isInvalid ? 'error' : 'default',
                        menuPortalTarget: document.body,
                        menuPosition: 'absolute',
                        isRequired: true,
                        ref: ref
                    }),
                    isInvalid ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...errorMessage
                        })
                    }) : null
                ]
            })
    });
});
var $4e9bb9323fa5b517$export$2e2bcd8739ae039 = $4e9bb9323fa5b517$var$ProductSelect;


/* InviteeList.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $kSKAi = parcelRequire("kSKAi");

var $6O3OC = parcelRequire("6O3OC");










var $1ddf05c3d0a9924c$export$3496ae3c3008d7e5 = /*#__PURE__*/ function(CORE_INVITES_IN_JIRA_PROJECTS) {
    CORE_INVITES_IN_JIRA_PROJECTS["CONTROL"] = "control";
    CORE_INVITES_IN_JIRA_PROJECTS["NOT_ENROLLED"] = "not-enrolled";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_ONLY"] = "invite-only-variation";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_ONLY_NOT_ENROLLED"] = "invite-only-not-enrolled";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_RA"] = "invite-ra-variation";
    CORE_INVITES_IN_JIRA_PROJECTS["INVITE_RA_NOT_ENROLLED"] = "invite-ra-variation";
    return CORE_INVITES_IN_JIRA_PROJECTS;
}({});



var $jL3L2 = parcelRequire("jL3L2");

const $3c20d8d89926317b$export$f3c297c96e0df944 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $3c20d8d89926317b$export$3eb662c848c7349f = 'core-invites';
const $3c20d8d89926317b$export$b9157093d5c4e7cd = ({ children: children })=>{
    const { coreInvitesInJiraProjects: coreInvitesInJiraProjectsCohort } = (0, $jL3L2.useExperimentalFeatures)();
    const isCoreInvitesInJiraProjectEnabled = coreInvitesInJiraProjectsCohort === (0, $1ddf05c3d0a9924c$export$3496ae3c3008d7e5).INVITE_ONLY || coreInvitesInJiraProjectsCohort === (0, $1ddf05c3d0a9924c$export$3496ae3c3008d7e5).INVITE_RA;
    return /*#__PURE__*/ (0, $l998X.jsx)($3c20d8d89926317b$export$f3c297c96e0df944.Provider, {
        value: {
            isCoreInvitesInJiraProjectEnabled: isCoreInvitesInJiraProjectEnabled
        },
        children: children
    });
};
const $3c20d8d89926317b$export$2a48237687fafe42 = ()=>{
    const state = (0, $42omo.useContext)($3c20d8d89926317b$export$f3c297c96e0df944);
    if (state === undefined) throw new Error('useCoreInvitesJiraProjectContext must be used within a CoreInvitesJiraProjectStateContextProvider');
    return state;
};





/* ThirdPartyConnectedTo.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $5rIoV = parcelRequire("5rIoV");


var $auNCB = parcelRequire("auNCB");








var $14Meb = parcelRequire("14Meb");


var $6cnUO = parcelRequire("6cnUO");














const $fdcb47a8099c9381$var$MAX_INTEGRATIONS_WITH_LABEL = 3;
const $fdcb47a8099c9381$var$styles = {
    wrapper: "_19pku2gc",
    fieldSet: "_1e0c1bgi",
    connectedIntegrationWrapper: "_2rkolb4i _11c8dcr7 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1mou1b66 _195g12x7 _4t3i7vkz _1e0c1txw _2lx2vrvc _1bah1h6o _syaz131l _bfhkvuon _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31yvi",
    connectedPlatformSlackServiceWrapper: "_irr315ej",
    connectedIntegrationText: "_195g1b66 _syaz1fxt"
};
const $fdcb47a8099c9381$var$ConnectedIntegration = ({ integration: integration, shouldShowLabel: shouldShowLabel = true })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $7b7358fe3ea7b2f6$export$fd3aba480a4de341));
    const { onDisconnectProvider: onDisconnectProvider } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const { orgId: orgId } = (0, $9xnOK.useInvitePeopleContext)();
    const [hover, setHover] = (0, $42omo.useState)(false);
    let { icon: icon } = (0, $9d2ab656303e6488$export$9da1038490aaa764)(integration);
    const { connectButtonText: connectButtonText, toolTip: toolTip } = (0, $9d2ab656303e6488$export$9da1038490aaa764)(integration);
    if (hover) icon = integration === (0, $9kYFb.PLATFORM_SLACK_SERVICE) ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14Meb))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: 'small',
        size: 'small',
        spacing: "compact",
        label: 'settings'
    }, integration) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5rIoV))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: 'small',
        size: 'small',
        spacing: "compact",
        label: 'unlink'
    }, integration);
    const onMouseOver = (0, $42omo.useCallback)(()=>{
        if (!hover) setHover(true);
    }, [
        hover
    ]);
    const onMouseOut = (0, $42omo.useCallback)(()=>{
        if (hover) setHover(false);
    }, [
        hover
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        analytics.integrationSettingsButtonClicked(integration, orgId);
        onDisconnectProvider(integration);
    }, [
        integration,
        analytics,
        onDisconnectProvider,
        orgId
    ]);
    const integrationComponent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
        testId: `testId-invite-people-third-party-${integration}`,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onClick: onClick,
        href: "#",
        xcss: (0, $1Whri.cx)($fdcb47a8099c9381$var$styles.connectedIntegrationWrapper, integration === (0, $9kYFb.PLATFORM_SLACK_SERVICE) && $fdcb47a8099c9381$var$styles.connectedPlatformSlackServiceWrapper),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                position: "bottom",
                content: toolTip,
                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    children: icon
                })
            }),
            shouldShowLabel && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $fdcb47a8099c9381$var$styles.connectedIntegrationText
                ]),
                children: connectButtonText
            })
        ]
    });
    return integrationComponent;
};
const $fdcb47a8099c9381$var$ThirdPartyConnectedTo = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { integrations: integrations, updateIntegrations: updateIntegrations } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            alignInline: "start",
            xcss: $fdcb47a8099c9381$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $l998X.jsxs)("fieldset", {
                className: (0, $gMc0m.default)([
                    $fdcb47a8099c9381$var$styles.fieldSet
                ]),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "legend",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            weight: "regular",
                            children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).thirdPartyConnectedTo)
                        })
                    }),
                    [
                        ...integrations
                    ].map((integration)=>{
                        if (updateIntegrations.noScope.has(integration)) return null;
                        return /*#__PURE__*/ (0, $l998X.jsx)($fdcb47a8099c9381$var$ConnectedIntegration, {
                            integration: integration,
                            shouldShowLabel: integrations.size <= $fdcb47a8099c9381$var$MAX_INTEGRATIONS_WITH_LABEL
                        }, integration);
                    })
                ]
            })
        })
    });
};
var $fdcb47a8099c9381$export$2e2bcd8739ae039 = $fdcb47a8099c9381$var$ThirdPartyConnectedTo;

/* UpdateConnection.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $2Agkp = parcelRequire("2Agkp");


var $5MACL = parcelRequire("5MACL");







var $eyWa4 = parcelRequire("eyWa4");



















const $95d6cc27ea873a20$var$styles = {
    wrapper: "_11c82smr _19pku2gc",
    popupWrapper: "_11c82smr _1moupxbi _195gpxbi _kqswh2mm _1bsbp2n4",
    popupBody: "_1mouu2gc",
    popupButtonWrapper: "_2rkolb4i _80omtlke",
    buttonTitle: "_18zr1b66 _1e0c116y _y3gn1e5h _o5724jg8"
};
const $95d6cc27ea873a20$var$UpdateIntegration = ({ integration: integration, scopeState: scopeState })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $7b7358fe3ea7b2f6$export$fd3aba480a4de341));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { orgId: orgId } = (0, $9xnOK.useInvitePeopleContext)();
    const { onConnectProvider: onConnectProvider, onDisconnectProvider: onDisconnectProvider } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const [showPopup, setShowPopup] = (0, $42omo.useState)(false);
    const [hover, setHover] = (0, $42omo.useState)(false);
    let product = null;
    let popupTitle = null;
    let popupBody = null;
    let buttonTitle = null;
    let space = null;
    const iconColor = {
        error: {
            color: "var(--ds-icon-danger, #C9372C)",
            accent: "var(--ds-icon-danger, #C9372C)"
        },
        warning: {
            color: "var(--ds-icon-danger, #C9372C)",
            accent: "var(--ds-icon-danger, #C9372C)"
        }
    };
    switch(integration){
        case 0, $9kYFb.PLATFORM_SLACK_SERVICE:
            product = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackThirdPartyButton);
            break;
        case 0, $9kYFb.GOOGLE_SERVICE:
            product = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).googleThirdPartyButton);
            space = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).googleSpace);
            break;
        case 0, $9kYFb.MICROSOFT_SERVICE:
            product = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).microsoftThirdPartyButton);
            break;
    } // No scope messaging more general, will replace detailed partial scope messaging
    if (scopeState === (0, $7oH3p.ScopeState).NO_SCOPE) {
        if (integration === (0, $9kYFb.PLATFORM_SLACK_SERVICE)) {
            popupTitle = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewConnectionTitle, {
                integration: product
            });
            popupBody = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewConnectionDescription, {
                integration: product
            });
            buttonTitle = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewConnection, {
                integration: product
            });
        } else {
            popupTitle = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessNoScopeTitle);
            popupBody = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessNoScopeDescription, {
                integration: product
            });
            buttonTitle = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessNoScope, {
                integration: product
            });
        }
    }
    if (scopeState === (0, $7oH3p.ScopeState).PARTIAL_SCOPE) {
        popupTitle = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessPartialAccessTitle, {
            integration: product,
            space: space
        });
        popupBody = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessPartialAccessDescription, {
            integration: product,
            space: space
        });
        buttonTitle = formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessPartialScope, {
            integration: product
        });
    }
    const toggleHover = (0, $42omo.useCallback)(()=>setHover(!hover), [
        hover
    ]);
    const closePopup = (0, $42omo.useCallback)(()=>setShowPopup(false), []);
    const onUpdateClick = (0, $42omo.useCallback)(()=>{
        analytics.updateWarningClicked(integration, orgId || null, scopeState);
        setShowPopup(!showPopup);
    }, [
        integration,
        orgId,
        analytics,
        showPopup,
        scopeState
    ]);
    const onDisconnectClick = (0, $42omo.useCallback)(()=>{
        onDisconnectProvider(integration);
    }, [
        integration,
        onDisconnectProvider
    ]);
    (0, $42omo.useEffect)(()=>{
        analytics.updateConnectionShown(integration, scopeState);
    }, [
        integration,
        scopeState,
        analytics
    ]);
    const handleContinueButton = (0, $42omo.useCallback)(()=>{
        if (onConnectProvider) {
            analytics.scopeUpdateButtonClicked(integration, scopeState);
            onConnectProvider({
                serviceKey: integration
            });
        }
    }, [
        onConnectProvider,
        integration,
        scopeState,
        analytics
    ]);
    const continueButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleContinueButton,
        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessContinue)
    });
    const disconnectButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $6e2bacb232cd6284$export$2e2bcd8739ae039), {
        actionSubjectId: "disconnectUpdate",
        analyticsAttributes: {
            integration: integration,
            orgId: orgId,
            fromMenu: false
        },
        appearance: "link",
        spacing: "none",
        onClick: onDisconnectClick,
        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessDisconnect)
    });
    const notNowButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $6e2bacb232cd6284$export$2e2bcd8739ae039), {
        actionSubjectId: "notNowUpdate",
        analyticsAttributes: {
            integration: integration
        },
        appearance: "link",
        spacing: "none",
        onClick: closePopup,
        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).reviewAccessNotNow)
    });
    const PopupContent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $95d6cc27ea873a20$var$styles.popupWrapper,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    children: popupTitle
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    xcss: $95d6cc27ea873a20$var$styles.popupBody,
                    children: popupBody
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    alignBlock: "start",
                    xcss: $95d6cc27ea873a20$var$styles.popupButtonWrapper,
                    space: "space.050",
                    children: [
                        continueButton,
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            as: "span",
                            children: "\u2022"
                        }),
                        scopeState === (0, $7oH3p.ScopeState).NO_SCOPE ? disconnectButton : notNowButton
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        onClose: closePopup,
        isOpen: showPopup,
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)(PopupContent, {}),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                ...triggerProps,
                appearance: "subtle-link",
                spacing: "none",
                onClick: onUpdateClick,
                onMouseEnter: toggleHover,
                onMouseLeave: toggleHover,
                iconBefore: scopeState === (0, $7oH3p.ScopeState).NO_SCOPE ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Agkp))), {
                    label: 'error',
                    color: showPopup || hover ? iconColor.error.accent : iconColor.error.color,
                    spacing: "spacious"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5MACL))), {
                    label: 'warning',
                    color: showPopup || hover ? iconColor.warning.accent : iconColor.warning.color,
                    spacing: "spacious"
                }),
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    alignItems: 'center',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    fontWeight: "var(--ds-font-weight-regular, 400)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    alignSelf: 'flex-start'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    as: "span",
                    xcss: $95d6cc27ea873a20$var$styles.buttonTitle,
                    children: buttonTitle
                })
            }),
        offset: [
            0,
            4
        ],
        zIndex: (0, $dTk3A.layers).flag(),
        placement: "bottom-start",
        shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-growth-core')
    });
};
const $95d6cc27ea873a20$var$UpdateConnection = ({ scope: scope })=>{
    const { updateIntegrations: updateIntegrations } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const updatableIntegrations = (0, $42omo.useMemo)(()=>{
        switch(scope){
            case (0, $7oH3p.ScopeState).NO_SCOPE:
                return updateIntegrations.noScope;
            case (0, $7oH3p.ScopeState).PARTIAL_SCOPE:
                return updateIntegrations.partialScope;
            default:
                return null;
        }
    }, [
        scope,
        updateIntegrations
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $95d6cc27ea873a20$var$styles.wrapper,
        children: updatableIntegrations && [
            ...updatableIntegrations
        ].map((integration)=>/*#__PURE__*/ (0, $l998X.jsx)($95d6cc27ea873a20$var$UpdateIntegration, {
                integration: integration,
                scopeState: scope
            }, integration))
    });
};
var $95d6cc27ea873a20$export$2e2bcd8739ae039 = $95d6cc27ea873a20$var$UpdateConnection;

































const $6b80a0b689aa0987$export$1260260645448a22 = (previousViralSettingMap, domainResults)=>{
    const viralSettingsMap = {};
    domainResults.forEach((result)=>{
        const domain = result.key;
        viralSettingsMap[domain] = {
            ...result.value,
            isChecked: previousViralSettingMap[domain] ? previousViralSettingMap[domain].isChecked : result.value.isChecked
        };
    });
    return viralSettingsMap;
};
const $6b80a0b689aa0987$export$f84202e4f11078fa = (viralSettingsMap)=>{
    const unchecked = [];
    const checked = [];
    const viralSettingsDomains = Object.keys(viralSettingsMap);
    viralSettingsDomains.filter((domain)=>viralSettingsMap[domain].desPromotionEligible).forEach((domain)=>{
        const viralSetting = viralSettingsMap[domain];
        if (viralSetting.isChecked) checked.push(domain);
        else unchecked.push(domain);
    });
    return {
        checked: checked,
        unchecked: unchecked
    };
};
const $6b80a0b689aa0987$export$24931e58402304dd = (domainResults)=>{
    return domainResults.filter((result)=>result.status === 'fulfilled').map((item)=>item.value);
};
const $6b80a0b689aa0987$export$bea1fc390abe3bc5 = (result)=>{
    const successDomain = result.status === 'fulfilled' && result.value ? result.value.domain : '';
    const errorDomain = result.status === 'failed' && result.errorDetails ? result.errorDetails.domain : '';
    // '' is falsy.
    return successDomain || errorDomain;
};
const $6b80a0b689aa0987$export$8080b7556d9d6445 = (promise)=>{
    return promise.then((result)=>Promise.resolve([
            result,
            undefined
        ])).catch((error)=>Promise.resolve([
            undefined,
            error
        ]));
};
const $6b80a0b689aa0987$export$f433b2fa9a26fb63 = (domain, isChecked, desPromotionEligible)=>{
    return {
        key: domain,
        value: {
            isChecked: isChecked,
            desPromotionEligible: desPromotionEligible
        }
    };
};





class $ea7dd8a8597d7d7f$export$98add1c97bc6ec46 extends (0, $2vYoS.HaveISeenItClient) {
    // A wrapper for getFlag that includes Viral Settings analytics
    async getFlagWithAnalytics(props, analytics) {
        const { flagKey: flagKey, product: product, domain: domain } = props;
        try {
            const { response: response, cached: cached } = await this.getFlag(flagKey);
            if (!cached) analytics.fetchHISIFlagSucceeded({
                flagKey: flagKey,
                product: product,
                domain: domain,
                value: response.status
            });
            return response.status;
        } catch (error) {
            analytics.fetchHISIFlagFailed({
                flagKey: flagKey,
                product: product,
                domain: domain
            });
            return Promise.reject(error);
        }
    }
    // A wrapper for postFlag that includes Viral Settings analytics
    async postFlagWithAnalytics(props, analytics) {
        const { flagKey: flagKey, product: product, domain: domain } = props;
        try {
            await this.postFlag(flagKey);
            analytics.createHISIFlagSucceeded({
                flagKey: flagKey,
                product: product,
                domain: domain
            });
        } catch  {
            analytics.createHisiFlagFailed({
                flagKey: flagKey,
                product: product,
                domain: domain
            });
        }
    }
    constructor(){
        super();
    }
}
const $ea7dd8a8597d7d7f$export$57cae7afb40bd58f = new $ea7dd8a8597d7d7f$export$98add1c97bc6ec46();



















const $08d09738c2efcd1c$export$da46cb6a7468a9c2 = 'virality';
const $08d09738c2efcd1c$export$5bcb1a08900e562e = 'data:image/svg+xml;base64,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';
const $08d09738c2efcd1c$export$cd5b61e2523869c9 = 'confluence.ondemand.activationDate';
const $08d09738c2efcd1c$export$f54381c274f897fb = 'jira-software.ondemand.activationDate';
const $08d09738c2efcd1c$export$ad9850d60736acbb = 'jira-software';
const $08d09738c2efcd1c$export$c04487fe1ed80406 = 'firstIntentToInvite';














const $7ece582fc820a8cc$var$DEFAULT_SOURCE = 'unknown';
const $7ece582fc820a8cc$var$DEFAULT_VIEW_AS = 'unknown';
const $7ece582fc820a8cc$export$3eb662c848c7349f = 'core-invites';
const $7ece582fc820a8cc$export$1c4ce4f476bc0521 = ({ children: children, inviteeProvider: inviteeProvider, plugins: plugins, resourceAri: resourceAri, source: source = $7ece582fc820a8cc$var$DEFAULT_SOURCE, subProduct: subProduct, userEmail: userEmailProp, accountId: accountIdProp, userRole: userRoleProp, viewAs: viewAs = $7ece582fc820a8cc$var$DEFAULT_VIEW_AS, orgId: orgId, disableNoInviteError: disableNoInviteError = false, experimental_featuredUsers: experimental_featuredUsers, experimental_inlineThirdPartyButtons: experimental_inlineThirdPartyButtons, experimental_productContext: experimental_productContext })=>{
    const [userEmail, setUserEmail] = (0, $42omo.useState)(userEmailProp);
    const [accountId, setAccountId] = (0, $42omo.useState)(accountIdProp);
    const needToFetchUserEmail = !userEmailProp || !accountIdProp;
    const [isUserEmailLoading, setIsUserEmailLoading] = (0, $42omo.useState)(needToFetchUserEmail);
    const [userRole, setUserRole] = (0, $42omo.useState)(userRoleProp || 'basic'); // TODO shouldn't this default to undefined while we load it?
    const needToFetchUserRole = !userRoleProp;
    const [isUserRoleLoading, setIsUserRoleLoading] = (0, $42omo.useState)(needToFetchUserRole);
    const isLoading = isUserEmailLoading || isUserRoleLoading;
    const { inviteFromAssignModal: inviteFromAssignModalCohort, isEligibleForInviteAndAssignFromBoard: isEligibleForInviteAndAssignFromBoard, invitePromptOnLinkV3: invitePromptOnLinkV3Cohort } = (0, $jL3L2.useExperimentalFeatures)();
    const contextValue = (0, $42omo.useMemo)(()=>{
        const productId = (0, $j9g2s.getProductIdFromResource)(resourceAri) || '';
        const [, loggedInEmailDomain] = userEmail?.split('@') ?? [];
        return {
            flow: $7ece582fc820a8cc$export$3eb662c848c7349f,
            growthInitiative: (0, $08d09738c2efcd1c$export$da46cb6a7468a9c2),
            cloudId: (0, $j9g2s.getCloudIdFromResource)(resourceAri),
            inviteeProvider: inviteeProvider,
            plugins: plugins,
            productId: productId,
            productTitle: (0, $j9g2s.getProductTitleFromAri)(resourceAri),
            jiraSubProduct: productId === 'jira' && subProduct && subProduct !== 'unknown' ? (0, $j9g2s.normalizeJiraSubProduct)(subProduct) : subProduct,
            source: source,
            subProduct: subProduct,
            userRole: userRole,
            viewAs: viewAs,
            inviteFromAssignModalCohort: inviteFromAssignModalCohort,
            invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort,
            isEligibleForInviteAndAssignFromBoard: isEligibleForInviteAndAssignFromBoard,
            orgId: orgId,
            isLoading: isLoading,
            loggedInEmailDomain: loggedInEmailDomain,
            userEmail: userEmail,
            accountId: accountId,
            disableNoInviteError: disableNoInviteError,
            experimental_featuredUsers: experimental_featuredUsers,
            experimental_inlineThirdPartyButtons: experimental_inlineThirdPartyButtons,
            experimental_productContext: experimental_productContext
        };
    }, [
        disableNoInviteError,
        isEligibleForInviteAndAssignFromBoard,
        inviteFromAssignModalCohort,
        invitePromptOnLinkV3Cohort,
        inviteeProvider,
        isLoading,
        orgId,
        plugins,
        resourceAri,
        source,
        subProduct,
        userEmail,
        accountId,
        userRole,
        viewAs,
        experimental_featuredUsers,
        experimental_inlineThirdPartyButtons,
        experimental_productContext
    ]);
    const analytics = (0, $2dswi.useAnalyticsWithAttributes)((0, $bc2394fc0ac6358f$export$314fcea5dcdb0997), (0, $hbgPG.useCommonAttributesFrom)(contextValue));
    (0, $42omo.useEffect)(()=>{
        const fetchUserEmail = async ()=>{
            try {
                (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getAccountInfo.startMark);
                const accountInfo = await (0, $a44a4a0d19730078$export$a389cf813a8a5b61).getAccountInfo();
                (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getAccountInfo.endMark);
                setUserEmail(accountInfo.email);
                setAccountId(accountInfo.account_id);
            } catch (err) {
                analytics.accountInfoFailed(String(err));
            } finally{
                setIsUserEmailLoading(false);
            }
        };
        if (needToFetchUserEmail) fetchUserEmail();
    }, [
        analytics,
        needToFetchUserEmail
    ]);
    const cloudId = contextValue.cloudId;
    (0, $42omo.useEffect)(()=>{
        async function fetchUserRole() {
            try {
                setIsUserRoleLoading(true);
                (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getUserPermission.startMark);
                const perms = await (0, $a44a4a0d19730078$export$c2fb70172d8b4300).getUserRole(cloudId);
                (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).mark((0, $91dcab74875d7081$export$a968444c71dc68c6).getUserPermission.endMark);
                if (perms.errorMessage) analytics.getPermsFailed(`ari:cloud:platform::site/${cloudId}`, perms.errorMessage);
                else analytics.getPermsSucceeded(`ari:cloud:platform::site/${cloudId}`, perms.isInviteUsersPermitted, perms.isManagePermitted);
                setUserRole(perms.role);
            } finally{
                setIsUserRoleLoading(false);
            }
        }
        if (needToFetchUserRole) fetchUserRole();
    }, [
        cloudId,
        resourceAri,
        analytics,
        userRoleProp,
        needToFetchUserRole
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9xnOK.InvitePeopleStateContext).Provider, {
        value: contextValue,
        children: children
    });
};


const $33a8a9183a4cf16a$export$fda1575ee29e8f5 = {
    DIRECT_ACCESS_CHECKBOX: 'directAccessCheckbox',
    USER_INVITES_CHECKBOX: 'userInvitesCheckbox'
};
class $33a8a9183a4cf16a$export$79c486b6beac7a88 extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    userInvitesCheckboxRendered(attributes) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).CHECKBOX,
            actionSubjectId: $33a8a9183a4cf16a$export$fda1575ee29e8f5.USER_INVITES_CHECKBOX,
            action: (0, $5LksM.AnalyticsAction).RENDERED,
            attributes: {
                ...attributes,
                flow: (0, $7ece582fc820a8cc$export$3eb662c848c7349f)
            }
        });
    }
    userInvitesCheckboxClicked(attributes) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).CHECKBOX,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            // To match naming of checkbox clicked event from admin hub
            actionSubjectId: $33a8a9183a4cf16a$export$fda1575ee29e8f5.USER_INVITES_CHECKBOX,
            attributes: {
                ...attributes,
                flow: (0, $7ece582fc820a8cc$export$3eb662c848c7349f)
            }
        });
    }
    directAccessCheckboxRendered(attributes) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).CHECKBOX,
            actionSubjectId: $33a8a9183a4cf16a$export$fda1575ee29e8f5.DIRECT_ACCESS_CHECKBOX,
            action: (0, $5LksM.AnalyticsAction).RENDERED,
            attributes: {
                ...attributes,
                flow: (0, $7ece582fc820a8cc$export$3eb662c848c7349f)
            }
        });
    }
    directAccessCheckboxClicked(attributes) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).CHECKBOX,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            actionSubjectId: $33a8a9183a4cf16a$export$fda1575ee29e8f5.DIRECT_ACCESS_CHECKBOX,
            attributes: {
                ...attributes,
                flow: (0, $7ece582fc820a8cc$export$3eb662c848c7349f)
            }
        });
    }
    createHisiFlagFailed(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $5LksM.AnalyticsAction).CREATE_FAILED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    createHISIFlagSucceeded(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $5LksM.AnalyticsAction).CREATED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    fetchHISIFlagFailed(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $5LksM.AnalyticsAction).FETCH_FAILED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    fetchHISIFlagSucceeded(attributes) {
        const { cloudId: cloudId } = this.commonAttributes;
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_INVITE_SETTINGS_HISI,
            action: (0, $5LksM.AnalyticsAction).FETCHED,
            attributes: {
                ...attributes,
                cloudId: cloudId
            }
        });
    }
    getUserInvitesSettingsSucceededSLO(ari) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_USER_INVITES_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: {
                ari: ari
            }
        });
    }
    getUserInvitesSettingsFailureSLO(attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_GET_USER_INVITES_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
    getDirectAccessSettingSucceededSLO(request) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_DIRECT_ACCESS_SETTING,
            action: (0, $5LksM.AnalyticsAction).SUCCEEDED,
            attributes: {
                ...request
            }
        });
    }
    getDirectAccessSettingFailureSLO(request, attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLO_GET_DIRECT_ACCESS_SETTING,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                ...request,
                ...attributes
            }
        });
    }
    getUserInvitesSettingsFailure(attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_USER_INVITES_SETTINGS,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: attributes
        });
    }
    getDirectAccessSettingFailure(request, attributes) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).GET_DIRECT_ACCESS_SETTING,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                ...request,
                ...attributes
            }
        });
    }
}


const $697d9a4dae0ec121$var$EMPTY_DOMAINS = {};
const $697d9a4dae0ec121$export$72e5b7b8f170d556 = (props)=>{
    const { domains: domains, cloudId: cloudId, products: products, role: role, selectHasBeenFocused: selectHasBeenFocused, emails: emails, disableViralSettings: disableViralSettings } = props;
    const analytics = (0, $2dswi.useAnalytics)((0, $33a8a9183a4cf16a$export$79c486b6beac7a88));
    const [enableOpenInvite, setEnableOpenInvite] = (0, $42omo.useState)(false);
    const [showOpenInvite, setShowOpenInvite] = (0, $42omo.useState)(false);
    const [viralSettingsByDomain, setViralSettingsByDomain] = (0, $42omo.useState)({});
    const [viralSettingsDESEligibleStates, setViralSettingsDESEligibleStates] = (0, $42omo.useState)({
        checked: [],
        unchecked: []
    });
    const product = products && products[0];
    const isViralSettingsEnabled = (0, $42omo.useMemo)(()=>{
        return !disableViralSettings && (0, $07330006f53205cd$export$6bcb65c6ec0ed966)(role) && products && products.length === 1 && (selectHasBeenFocused || emails.filter((v)=>v).length > 0);
    }, [
        products,
        selectHasBeenFocused,
        emails,
        role,
        disableViralSettings
    ]);
    const eligibleDomains = (0, $42omo.useMemo)(()=>{
        return Object.keys(viralSettingsByDomain).filter((domain)=>viralSettingsByDomain[domain].desPromotionEligible);
    }, [
        viralSettingsByDomain
    ]);
    //Clear cache on render.
    (0, $42omo.useEffect)(()=>{
        (0, $a44a4a0d19730078$export$c993591f6996ca09).clearDESCache();
        (0, $a44a4a0d19730078$export$4f6a946e6e09a73b).clearCache();
        (0, $ea7dd8a8597d7d7f$export$57cae7afb40bd58f).clearCache();
    }, []);
    const getUserInvitesSetting = (0, $42omo.useCallback)(async (product, cloudId)=>{
        const ari = (0, $j9g2s.makeAri)(product, cloudId);
        try {
            const { response: response, cached: cached } = await (0, $a44a4a0d19730078$export$4f6a946e6e09a73b).getOpenInviteState(product, cloudId);
            if (!cached) analytics.getUserInvitesSettingsSucceededSLO(ari);
            return response;
        } catch (err) {
            const { errorMessage: errorMessage, responseCode: responseCode } = (0, $j9g2s.resolveError)(err);
            analytics.getUserInvitesSettingsFailure({
                ari: ari,
                errorMessage: errorMessage,
                responseCode: responseCode
            });
            // in the case of the response being Forbidden, neither an SLO success or error should be fired
            if (!(0, $j9g2s.isForbidden)(responseCode)) {
                if ((0, $j9g2s.isAcceptableFailure)(errorMessage, responseCode)) analytics.getUserInvitesSettingsSucceededSLO(ari);
                else analytics.getUserInvitesSettingsFailureSLO({
                    ari: ari,
                    errorMessage: errorMessage,
                    responseCode: responseCode
                });
            }
        }
    }, [
        analytics
    ]);
    const getDirectAccessEligibility = (0, $42omo.useCallback)(async (request)=>{
        try {
            const response = await (0, $a44a4a0d19730078$export$c993591f6996ca09).getDirectAccessSetting(request);
            const { response: fetchedResponse, cached: cached } = response;
            if (!cached) analytics.getDirectAccessSettingSucceededSLO(request);
            return {
                ...fetchedResponse,
                desPromotionEligible: 'desPromotionEligible' in fetchedResponse && fetchedResponse?.desPromotionEligible ? fetchedResponse.desPromotionEligible : false
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage } = (0, $j9g2s.resolveError)(err);
            const attributes = {
                domain: request.domain,
                responseCode: responseCode,
                errorMessage: errorMessage
            };
            analytics.getDirectAccessSettingFailure(request, attributes);
            const isSuccess = (0, $j9g2s.isAcceptableFailureForDirectAccess)(errorMessage, responseCode) || (0, $j9g2s.isAcceptableFailure)(errorMessage, responseCode);
            // in the case of the response being Forbidden, neither an SLO success or error should be fired
            if (!(0, $j9g2s.isForbidden)(responseCode)) {
                if (isSuccess) analytics.getDirectAccessSettingSucceededSLO(request);
                else analytics.getDirectAccessSettingFailureSLO(request, attributes);
            }
            return {
                domain: request.domain,
                errorMessage: errorMessage
            };
        }
    }, [
        analytics
    ]);
    // Fetches all domain settings in parallel and return the resolved responses
    const getDomainViralSettings = (0, $42omo.useCallback)((product, cloudId)=>(0, $j9g2s.waitForAllPromises)([
            ...domains.map((domain)=>{
                const request = {
                    domain: domain,
                    productAri: (0, $j9g2s.makeAri)(product, cloudId),
                    setting: 'DIRECT_ACCESS'
                };
                return getDirectAccessEligibility(request);
            })
        ]), [
        domains,
        getDirectAccessEligibility
    ]);
    // Gets the default value for the open invite checkbox. Uses HISI and fallbacks to true
    const userInviteDefaultValue = (0, $42omo.useCallback)(async (product, cloudId, shouldShowOpenInvite)=>{
        // if the invite checkbox isnt being shown it should default to false
        if (!shouldShowOpenInvite) return false;
        return (0, $ea7dd8a8597d7d7f$export$57cae7afb40bd58f).getFlagWithAnalytics({
            flagKey: (0, $2vYoS.createHISIOpenInviteFlagKey)(product, cloudId),
            product: product
        }, analytics).then((wasExposed)=>{
            // Default value is true if this is their first exposure, and false if we know they have been previously exposed.
            return !wasExposed;
        }, (_)=>{
            // Will default to checked in the case that HISI fails
            return true;
        });
    }, [
        analytics
    ]);
    // Get the default value for a domain using HISI, fallbacks to isChecked true if elligible for promotion
    const getDesDefaultValue = (0, $42omo.useCallback)(async (product, cloudId, domainResponse)=>{
        const domain = (0, $6b80a0b689aa0987$export$bea1fc390abe3bc5)(domainResponse);
        // in the case that the domain is eligible for promotion
        if (domainResponse.status === 'fulfilled' && domain && domainResponse.value.desPromotionEligible) {
            const desPromotionEligible = domainResponse.value.desPromotionEligible;
            return (0, $ea7dd8a8597d7d7f$export$57cae7afb40bd58f).getFlagWithAnalytics({
                flagKey: (0, $2vYoS.createHISIDomainFlagKey)(product, cloudId, domain),
                product: product,
                domain: domain
            }, analytics).then((wasExposed)=>{
                // Default value is true if this is their first exposure, and false if we know they have been previously exposed.
                return (0, $6b80a0b689aa0987$export$f433b2fa9a26fb63)(domain, !wasExposed, desPromotionEligible);
            }, (_)=>{
                // If HISI unavailable assume this is their first exposure and return isCheck = true
                return (0, $6b80a0b689aa0987$export$f433b2fa9a26fb63)(domain, true, desPromotionEligible);
            });
        } else // is not eligible for promotion, do not show checkbox (desPromotion = false) and set is checked to false for safety
        return (0, $6b80a0b689aa0987$export$f433b2fa9a26fb63)(domain, false, false);
    }, [
        analytics
    ]);
    // Gets all the HISI settings (open invite and domain) in parallel and returns in an array
    const getHISIDomainSettings = (0, $42omo.useCallback)((domainResponses)=>(0, $j9g2s.waitForAllPromises)([
            ...domainResponses.map((domainResponse)=>{
                return getDesDefaultValue(product, cloudId, domainResponse);
            })
        ]), [
        cloudId,
        product,
        getDesDefaultValue
    ]);
    const handleShouldShowOpenInvite = (0, $42omo.useCallback)(async ()=>{
        const [openInviteState, error] = await (0, $6b80a0b689aa0987$export$8080b7556d9d6445)(getUserInvitesSetting(product, cloudId));
        const shouldShowOpenInvite = openInviteState && openInviteState.getOpenInvite && openInviteState.mode === 'REQUEST_ACCESS' && !error;
        setShowOpenInvite(shouldShowOpenInvite);
    }, [
        product,
        cloudId,
        getUserInvitesSetting
    ]);
    const handleDomains = (0, $42omo.useCallback)(async ()=>{
        const domainResults = await getDomainViralSettings(product, cloudId);
        const domainResultsWithDefaultValue = await getHISIDomainSettings(domainResults);
        const viralSettingsByDomainValueObjectFromResponse = (0, $6b80a0b689aa0987$export$24931e58402304dd)(domainResultsWithDefaultValue);
        setViralSettingsByDomain((previousViralSettingMap)=>{
            // Create a map using the completed domain object with defaultValues
            const viralSettingsMap = (0, $6b80a0b689aa0987$export$1260260645448a22)(previousViralSettingMap, viralSettingsByDomainValueObjectFromResponse);
            setViralSettingsDESEligibleStates((0, $6b80a0b689aa0987$export$f84202e4f11078fa)(viralSettingsMap));
            return viralSettingsMap;
        });
    }, [
        cloudId,
        getHISIDomainSettings,
        getDomainViralSettings,
        product
    ]);
    const handleViralSettingsByDomainCheckbox = (newDomainState)=>{
        setViralSettingsByDomain(newDomainState);
        setViralSettingsDESEligibleStates((0, $6b80a0b689aa0987$export$f84202e4f11078fa)(newDomainState));
    };
    // useEffect to determine whether or not viral settings section should be displayed
    // triggers fetch calls to HISI if it should be displayed
    (0, $42omo.useEffect)(()=>{
        // reset value to false on change
        if (!isViralSettingsEnabled) {
            setEnableOpenInvite(false);
            setViralSettingsByDomain($697d9a4dae0ec121$var$EMPTY_DOMAINS);
        }
        if (isViralSettingsEnabled) {
            handleShouldShowOpenInvite();
            handleDomains();
        }
    }, [
        isViralSettingsEnabled,
        handleShouldShowOpenInvite,
        handleDomains
    ]);
    // Determine initial state of open invite checkbox when showOpenInvite is updated.
    (0, $42omo.useEffect)(()=>{
        const handleDefaultOpenInvite = async ()=>{
            // Does not need error handled as userInviteDefaultValue catches the error
            const openInviteDefaultValue = await userInviteDefaultValue(product, cloudId, showOpenInvite);
            // will be default to undefined if shouldShowOpenInvite is false
            setEnableOpenInvite(openInviteDefaultValue);
        };
        handleDefaultOpenInvite();
    }, [
        showOpenInvite,
        product,
        cloudId,
        userInviteDefaultValue
    ]);
    const responseObject = {
        viralSettingsByDomain: viralSettingsByDomain,
        eligibleDomains: eligibleDomains,
        viralSettingsDESEligibleStates: viralSettingsDESEligibleStates,
        handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox,
        setEnableOpenInvite: setEnableOpenInvite,
        isViralSettingsEnabled: isViralSettingsEnabled,
        showOpenInvite: showOpenInvite,
        enableOpenInvite: enableOpenInvite
    };
    return responseObject;
};



























class $80b8179434a3b864$export$be0471201c1b7dbc extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    inviteeListItemAdded(id, attributes) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITEE_LIST_ITEM,
            actionSubjectId: (0, $5LksM.AnalyticsActionSubject).INVITEE_LIST_ITEM + id,
            action: (0, $5LksM.AnalyticsAction).ADDED,
            attributes: {
                ...attributes
            }
        });
    }
    inviteeListFocused(id) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITEE_LIST,
            actionSubjectId: (0, $5LksM.AnalyticsActionSubject).INVITEE_LIST + id,
            action: (0, $5LksM.AnalyticsAction).CLICKED
        });
    }
    inviteeListPrefilled(numUsersPrefilled) {
        const { source: source } = this.commonAttributes;
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITEE_LIST,
            action: (0, $5LksM.AnalyticsAction).PREFILLED,
            attributes: {
                numUsersPrefilled: numUsersPrefilled,
                source: source
            }
        });
    }
    teamOrUserPickerViewed(attributes) {
        this.fireScreen({
            name: (0, $5LksM.AnalyticsActionSubject).TEAM_OR_USER_PICKER,
            attributes: attributes
        });
    }
    slackChannelClicked(teamId) {
        this.fireUI({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).BUTTON,
            actionSubjectId: (0, $5LksM.AnalyticsActionSubject).INVITEE_LIST_ITEM_USER_PICKER,
            action: (0, $5LksM.AnalyticsAction).CLICKED,
            attributes: {
                source: (0, $5LksM.AnalyticsActionSubject).TEAM_OR_USER_PICKER,
                teamId: teamId
            }
        });
    }
    slackUserSelected() {
        this.fireTrack({
            action: (0, $5LksM.AnalyticsAction).SELECTED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).SLACK_USER
        });
    }
    userPickerTyped(attributes) {
        this.fireTrack({
            action: (0, $5LksM.AnalyticsAction).TYPED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_PICKER,
            attributes: {
                context: 'invite-user-picker',
                pickerType: 'multi',
                numberOfResults: attributes.results.length,
                ...attributes
            }
        });
    }
    userPickerAutoOpened(attributes) {
        this.fireUI({
            action: (0, $5LksM.AnalyticsAction).AUTO_OPENED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).USER_PICKER,
            attributes: {
                context: 'invite-user-picker',
                pickerType: 'multi',
                ...attributes
            }
        });
    }
}





const $4c3f7cb6ca1e08be$export$9b360043fbff7382 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $4c3f7cb6ca1e08be$export$72f281f17133b74f = (options, includeGroupsInIds)=>options.filter((option)=>includeGroupsInIds || option.type !== 'group' && option.type !== 'team').map((option)=>{
        if ((0, $6O3OC.isEmail)(option)) {
            const nameOrId = option.name || option.id;
            return {
                email: nameOrId
            };
        }
        if ((0, $6O3OC.isUser)(option)) {
            if (option.email) return {
                email: option.email
            };
            else {
                const id = option.id;
                return {
                    id: id
                };
            }
        }
        // Use the id if option is not of type USER or EMAIL
        const id = option.id;
        return {
            id: id
        };
    });
const $4c3f7cb6ca1e08be$export$ac13055eb7c14776 = (options)=>options.filter((option)=>option.type === 'group').map(({ id: id })=>({
            id: id
        }));
const $4c3f7cb6ca1e08be$export$9b43b9b644b4adc5 = (options)=>options.filter((option)=>option.type === 'team').map(({ id: id })=>({
            id: id
        }));
const $4c3f7cb6ca1e08be$export$15763c41b3a95990 = (options)=>{
    const emailsAndIds = $4c3f7cb6ca1e08be$export$72f281f17133b74f(options, true);
    return {
        emails: emailsAndIds.flatMap((item)=>(0, $5LksM.isUserWithEmail)(item) && item.email ? [
                item.email
            ] : []),
        // only get ID if email does not exist and ID exists.
        ids: emailsAndIds.flatMap((item)=>item.id && !(0, $5LksM.isUserWithEmail)(item) ? [
                item.id
            ] : [])
    };
};
const $4c3f7cb6ca1e08be$export$a6210aced9c88789 = (options, invitedUser)=>{
    const user = options.find((option)=>{
        if ((0, $6O3OC.isExternalUser)(option)) return option.email === invitedUser.email || option.id === invitedUser.id;
        return false;
    });
    return user ? user.externalUserType : undefined;
};
const $4c3f7cb6ca1e08be$export$6dbd1016efd8086d = ({ allowEmail: allowEmail, children: children, initialInvitees: initialInvitees, experimental_userPickerByline: experimental_userPickerByline, inviteeListLabelText: inviteeListLabelText, inviteeListPlaceholderText: inviteeListPlaceholderText, inviteeListRequired: inviteeListRequired, groupByTypeOrder: groupByTypeOrder })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $80b8179434a3b864$export$be0471201c1b7dbc));
    const [userPickerOptions, setUserPickerOptions] = (0, $42omo.useState)(()=>initialInvitees ?? []);
    const [trailingText, setTrailingText] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState('');
    (0, $42omo.useEffect)(()=>{
        if (initialInvitees && initialInvitees.length > 0) analytics.inviteeListPrefilled(initialInvitees.length);
    }, [
        initialInvitees,
        analytics
    ]);
    // emails ands ids that are in the user picker. This array will be used when inviting.
    const users = $4c3f7cb6ca1e08be$export$72f281f17133b74f(userPickerOptions, false);
    const groups = $4c3f7cb6ca1e08be$export$ac13055eb7c14776(userPickerOptions);
    const teams = (0, $42omo.useMemo)(()=>(0, $dh538.fg)('support_teams_in_jira_project_role') ? $4c3f7cb6ca1e08be$export$9b43b9b644b4adc5(userPickerOptions) : [], [
        userPickerOptions
    ]);
    // emails and ids as string arrays.
    const { emails: emails, ids: ids } = $4c3f7cb6ca1e08be$export$15763c41b3a95990(userPickerOptions);
    const contextValue = (0, $42omo.useMemo)(()=>{
        const getName = (id)=>{
            return userPickerOptions.find((item)=>item.id === id)?.name || id;
        };
        const getUser = (id)=>userPickerOptions.find((user)=>user.id === id);
        const getExternalUserType = (user)=>$4c3f7cb6ca1e08be$export$a6210aced9c88789(userPickerOptions, user);
        return {
            // NOTE: default value of `allowEmail` is `true` given backwards compatibility,
            //       since UserPicker's `allowEmail` was always `true` before the Invite People `allowEmail` prop
            allowEmail: allowEmail ?? true,
            userPickerOptions: userPickerOptions,
            setUserPickerOptions: setUserPickerOptions,
            trailingText: trailingText,
            setTrailingText: setTrailingText,
            users: users,
            groups: groups,
            teams: teams,
            emails: emails,
            ids: ids,
            getName: getName,
            getUser: getUser,
            getExternalUserType: getExternalUserType,
            experimental_userPickerByline: experimental_userPickerByline,
            inviteeListLabelText: inviteeListLabelText,
            inviteeListPlaceholderText: inviteeListPlaceholderText,
            inviteeListRequired: inviteeListRequired,
            groupByTypeOrder: groupByTypeOrder
        };
    }, [
        allowEmail,
        userPickerOptions,
        trailingText,
        users,
        groups,
        teams,
        emails,
        ids,
        experimental_userPickerByline,
        inviteeListLabelText,
        inviteeListPlaceholderText,
        inviteeListRequired,
        groupByTypeOrder
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($4c3f7cb6ca1e08be$export$9b360043fbff7382.Provider, {
        value: contextValue,
        children: children
    });
};
const $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed = ()=>{
    const state = (0, $42omo.useContext)($4c3f7cb6ca1e08be$export$9b360043fbff7382);
    if (state === undefined) throw new Error('useInviteeListStateContext must be used within a InviteeListStateContextProvider');
    return state;
};


const $371c856e822ce028$var$ViralSettingsStateContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $371c856e822ce028$export$565fe958259f8ed8 = ({ children: children, disableViralSettings: disableViralSettings, onInviteeListFocus: onInviteeListFocusProp })=>{
    const [uniqueEmailDomains, setUniqueEmailDomains] = (0, $42omo.useState)([]);
    const [selectHasBeenFocused, setSelectHasBeenFocused] = (0, $42omo.useState)(false);
    const onInviteeListFocus = (0, $42omo.useCallback)(()=>{
        setSelectHasBeenFocused(true);
        onInviteeListFocusProp?.();
    }, [
        setSelectHasBeenFocused,
        onInviteeListFocusProp
    ]);
    const { emails: emails } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    const { cloudId: cloudId, userRole: userRole } = (0, $9xnOK.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts } = (0, $8efc6a9cd7fde791$export$964e8498268f0fe3)();
    const { viralSettingsByDomain: viralSettingsByDomain, eligibleDomains: eligibleDomains, viralSettingsDESEligibleStates: viralSettingsDESEligibleStates, showOpenInvite: showOpenInvite, handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox, enableOpenInvite: enableOpenInvite, setEnableOpenInvite: setEnableOpenInvite, isViralSettingsEnabled: isViralSettingsEnabled } = (0, $697d9a4dae0ec121$export$72e5b7b8f170d556)({
        domains: uniqueEmailDomains,
        cloudId: cloudId || '',
        products: selectedProducts,
        role: userRole,
        selectHasBeenFocused: selectHasBeenFocused,
        emails: emails,
        disableViralSettings: disableViralSettings
    });
    const onOpenInviteChange = (0, $42omo.useCallback)((event)=>{
        setEnableOpenInvite(event?.target.checked);
    }, [
        setEnableOpenInvite
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>{
        return {
            viralSettingsByDomain: viralSettingsByDomain,
            eligibleDomains: eligibleDomains,
            viralSettingsDESEligibleStates: viralSettingsDESEligibleStates,
            showOpenInvite: showOpenInvite,
            handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox,
            openInviteEnabled: enableOpenInvite,
            onOpenInviteChange: onOpenInviteChange,
            setEnableOpenInvite: setEnableOpenInvite,
            isViralSettingsEnabled: isViralSettingsEnabled,
            uniqueEmailDomains: uniqueEmailDomains,
            setUniqueEmailDomains: setUniqueEmailDomains,
            selectHasBeenFocused: selectHasBeenFocused,
            onInviteeListFocus: onInviteeListFocus
        };
    }, [
        viralSettingsByDomain,
        eligibleDomains,
        viralSettingsDESEligibleStates,
        showOpenInvite,
        handleViralSettingsByDomainCheckbox,
        enableOpenInvite,
        onOpenInviteChange,
        setEnableOpenInvite,
        isViralSettingsEnabled,
        uniqueEmailDomains,
        setUniqueEmailDomains,
        selectHasBeenFocused,
        onInviteeListFocus
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($371c856e822ce028$var$ViralSettingsStateContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $371c856e822ce028$export$5ab4720aaf50c15c = ()=>{
    const state = (0, $42omo.useContext)($371c856e822ce028$var$ViralSettingsStateContext);
    if (state === undefined) throw new Error('useViralSettingsContext must be used within a ViralSettingsContext provider');
    return state;
};





const $c65096914147ff68$export$21805fee57372823 = (delay)=>{
    const timeout = (0, $42omo.useRef)();
    const debounce = (0, $42omo.useMemo)(()=>{
        const debounce = (callback)=>{
            clearTimeout(timeout.current);
            timeout.current = window.setTimeout(callback, delay);
        };
        return debounce;
    }, [
        delay
    ]);
    (0, $42omo.useEffect)(()=>()=>clearTimeout(timeout.current), []);
    return debounce;
};



const $3c78fe130026aff9$export$fd7e7522f281d3fd = {
    validationState: 'error',
    reason: 'overflow',
    errorMessage: (0, $c35877e38bf8c63c$export$defe85febe8b728c).tooManyEmailAddresses
};
const $3c78fe130026aff9$export$50c8bce072597428 = {
    validationState: 'error',
    reason: 'overflow',
    errorMessage: (0, $c35877e38bf8c63c$export$defe85febe8b728c).tooManyEmailAddressesInProject
};
const $3c78fe130026aff9$export$89d3193818991094 = {
    validationState: 'error',
    reason: 'invalid-email',
    errorMessage: (0, $c35877e38bf8c63c$export$defe85febe8b728c).invalidMultipleEmailMessage
};
const $3c78fe130026aff9$export$46acf7cabfde1718 = [
    {
        validationState: 'default'
    }
];
const $3c78fe130026aff9$export$2c8433e5dc4daaba = {
    validationState: 'error',
    reason: 'inviting-self',
    errorMessage: (0, $c35877e38bf8c63c$export$defe85febe8b728c).inviteSelfMessage
};
// Email Validations
// Extends default validation found in /packages/elements/user-picker/src/components/emailValidation.ts
// by checking that the domain does not end in a symbol
const $3c78fe130026aff9$var$validRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const $3c78fe130026aff9$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $3c78fe130026aff9$export$18148d12c805c5b0 = (inputText)=>{
    // Email will display as an option in the user picker and willbe selectable
    if (inputText.match($3c78fe130026aff9$var$validRegex)) return 'VALID';
    // Potential emails will not be domain auto completed by the user picker (validation check is still completed on these emails)
    if (inputText.match($3c78fe130026aff9$var$potentialRegex)) return 'POTENTIAL';
    // Invalid emails will have the domain auto complete option from the user picker
    return 'INVALID';
};
const $3c78fe130026aff9$export$5e63894f961a3223 = (validationList, reason)=>validationList.reduce((error, validationItem)=>error || !!reason && validationItem.reason === reason && validationItem.validationState === 'error' || validationItem.validationState === 'error', false);
const $3c78fe130026aff9$export$4a1e16a3f293dded = (emails, ids, maxEmails, userEmail, coreInvitesInJiraProjectEnabled)=>{
    const isOverflowing = emails.concat(ids).length > maxEmails;
    const hasInvalidEmail = emails.some((v)=>$3c78fe130026aff9$export$18148d12c805c5b0(v) === 'INVALID');
    const isInvitingSelf = userEmail && emails.includes(userEmail);
    const validationList = [];
    if (isOverflowing) validationList.push(coreInvitesInJiraProjectEnabled ? $3c78fe130026aff9$export$50c8bce072597428 : $3c78fe130026aff9$export$fd7e7522f281d3fd);
    if (hasInvalidEmail) validationList.push($3c78fe130026aff9$export$89d3193818991094);
    if (!coreInvitesInJiraProjectEnabled && isInvitingSelf) validationList.push($3c78fe130026aff9$export$2c8433e5dc4daaba);
    if (validationList.length > 0) return validationList;
    return $3c78fe130026aff9$export$46acf7cabfde1718;
};




const $0a2be26ef0070cb7$var$styles = {
    fieldWrapper: "_kqswh2mm",
    label: "_11c81vhk _1e0c1ule _k48p1pd9 _syaz131l _19pkze3t _otyr1b66"
};
const $0a2be26ef0070cb7$var$UserPickerError = ({ validationList: validationList, isEmptyInput: isEmptyInput, maxEmails: maxEmails })=>{
    const message = (0, $c35877e38bf8c63c$export$defe85febe8b728c).inviteeListPickerNoteAlt;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "testId-invite-people-invitee-list-error-messages",
        children: [
            (0, $42omo.Children).toArray(validationList.map((validationState)=>validationState.validationState === 'error' && validationState.errorMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...validationState.errorMessage,
                        values: {
                            maxEmails: maxEmails
                        }
                    })
                }))),
            isEmptyInput && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...message
                })
            })
        ]
    });
};
const $0a2be26ef0070cb7$var$InviteeList = /*#__PURE__*/ (0, $42omo.forwardRef)(({ maxEmails: maxEmails = 10, onInviteeListChange: onInviteeListChange = ()=>{}, showEmptyError: showEmptyError = false, autoFocus: autoFocus = false }, ref)=>{
    const [inputValue, setInputValue] = (0, $42omo.useState)(undefined);
    const analytics = (0, $2dswi.useAnalytics)((0, $80b8179434a3b864$export$be0471201c1b7dbc));
    const { isCoreInvitesInJiraProjectEnabled: isCoreInvitesInJiraProjectEnabled } = (0, $3c20d8d89926317b$export$2a48237687fafe42)();
    const { allowEmail: allowEmail, setUserPickerOptions: setUserPickerOptions, userPickerOptions: userPickerOptions, experimental_userPickerByline: experimental_userPickerByline, inviteeListLabelText: inviteeListLabelText, inviteeListPlaceholderText: inviteeListPlaceholderText, inviteeListRequired: inviteeListRequired = true, groupByTypeOrder: groupByTypeOrder } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    const { onInviteeListFocus: onInviteeListFocus } = (0, $371c856e822ce028$export$5ab4720aaf50c15c)();
    const { queryThirdParty: queryThirdParty, integrations: integrations, updateIntegrations: updateIntegrations, isConnected: thirdPartyConnected } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const { invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort, inviteeProvider: inviteeProvider, loggedInEmailDomain: loggedInEmailDomain, userEmail: userEmail } = (0, $9xnOK.useInvitePeopleContext)();
    const [hasValidationError, validationList] = (0, $42omo.useMemo)(()=>{
        const { emails: emails, ids: ids } = (0, $4c3f7cb6ca1e08be$export$15763c41b3a95990)(userPickerOptions);
        const validationList = (0, $3c78fe130026aff9$export$4a1e16a3f293dded)(emails, ids, maxEmails, userEmail, isCoreInvitesInJiraProjectEnabled);
        return [
            (0, $3c78fe130026aff9$export$5e63894f961a3223)(validationList),
            validationList
        ];
    }, [
        maxEmails,
        userPickerOptions,
        userEmail,
        isCoreInvitesInJiraProjectEnabled
    ]); // This is used to make the "Enter up to 10 email addresses" an error if
    // the field is empty; EXCEPT it won't show until the form has been submitted
    const isEmptyInput = userPickerOptions.length === 0 && showEmptyError;
    const onFocusEventWithAnalytics = (0, $42omo.useCallback)((pickerId)=>()=>{
            analytics.inviteeListFocused(pickerId);
            onInviteeListFocus();
        }, [
        analytics,
        onInviteeListFocus
    ]);
    const userPickerTypedDebounce = (0, $c65096914147ff68$export$21805fee57372823)(2000);
    const getNewEmail = (prevEmails, emails)=>{
        const newEmails = emails.filter((email)=>!prevEmails.includes(email));
        return newEmails.shift() || '';
    };
    const onUserSelectionChange = (0, $42omo.useCallback)((value)=>{
        let values = [];
        if (Array.isArray(value)) values = value;
        else if (value) values = [
            value
        ];
        for (const value of values){
            if ((0, $6O3OC.isEmail)(value)) {
                value.name = (0, $j9g2s.removeZeroWidthCharacters)(value.name);
                value.id = (0, $j9g2s.removeZeroWidthCharacters)(value.id);
            }
            if ((0, $6O3OC.isExternalUser)(value) && value.sources.includes('slack')) analytics.slackUserSelected();
        }
        const { emails: emails } = (0, $4c3f7cb6ca1e08be$export$15763c41b3a95990)(values);
        setUserPickerOptions((prevEmails)=>{
            // Only fire analytics event if an email is added
            const { emails: previousEmailsStrings } = (0, $4c3f7cb6ca1e08be$export$15763c41b3a95990)(prevEmails);
            prevEmails.length < values.length && analytics.inviteeListItemAdded((0, $07330006f53205cd$export$fec77d3db2f319e5), {
                domains: [
                    (0, $j9g2s.extractDomainFromEmail)(getNewEmail(previousEmailsStrings, emails)) || ''
                ]
            });
            return values;
        });
    }, [
        setUserPickerOptions,
        analytics
    ]); // Validator and call onInviteeListChange
    (0, $42omo.useEffect)(()=>{
        const { emails: emails, ids: ids } = (0, $4c3f7cb6ca1e08be$export$15763c41b3a95990)(userPickerOptions);
        if (emails.length === 0 && ids.length === 0) {
            onInviteeListChange([], []);
            return;
        }
        const selectOptions = [
            ...emails,
            ...ids
        ]; // Finally, send back all entered email addresses to the parent component
        onInviteeListChange(selectOptions, // valid emails
        emails.filter((email)=>(0, $3c78fe130026aff9$export$18148d12c805c5b0)(email) === 'VALID'));
    }, [
        userPickerOptions,
        maxEmails,
        onInviteeListChange,
        userEmail
    ]);
    const loadOptionsBase = (0, $42omo.useCallback)(async (searchText)=>{
        if (!searchText || searchText.trim().length === 0) return [];
        const onInviteeLoadOptionsPromise = inviteeProvider?.onInviteeLoadOptions({
            searchText: searchText
        }) ?? Promise.resolve([]);
        const queryThirdPartyPromise = queryThirdParty(searchText);
        const [thirdPartySearch, inviteeLoadOptionsSearch] = await Promise.all([
            queryThirdPartyPromise,
            onInviteeLoadOptionsPromise
        ]);
        const providedAdditionalUsers = [];
        const groups = [];
        const teams = [];
        inviteeLoadOptionsSearch.forEach((item)=>{
            if (item.type === 'group') groups.push(item);
            else if (item.type === 'team') teams.push(item);
            else providedAdditionalUsers.push(item);
        });
        let mergedExternalUsers = thirdPartySearch;
        if (providedAdditionalUsers.length > 0) mergedExternalUsers = (0, $16469612d1ee3fff$export$a23f84077156f281)({
            providedAdditionalUsers: providedAdditionalUsers,
            searchText: searchText,
            connectedThirdPartyUsers: thirdPartySearch
        });
        const options = (0, $dh538.fg)('support_teams_in_jira_project_role') ? [
            ...groups,
            ...teams,
            ...mergedExternalUsers
        ] : [
            ...groups,
            ...mergedExternalUsers
        ];
        const { onInviteeResultsMerged: onInviteeResultsMerged } = inviteeProvider || {};
        if (onInviteeResultsMerged) return onInviteeResultsMerged(options);
        return options;
    }, [
        inviteeProvider,
        queryThirdParty
    ]);
    const withTypedEvent = (0, $42omo.useCallback)((loadOptions)=>async (searchText)=>{
            const options = await loadOptions(searchText);
            if (searchText !== undefined) userPickerTypedDebounce(()=>{
                analytics.userPickerTyped({
                    queryLength: searchText.length,
                    results: options.map((option)=>({
                            type: option.type ?? null,
                            // Note that sources from cache will only be added if option
                            // is loaded from org-people-picker
                            sources: option.sources
                        }))
                });
            });
            return options;
        }, [
        analytics,
        userPickerTypedDebounce
    ]);
    const loadOptions = (0, $42omo.useMemo)(()=>withTypedEvent(loadOptionsBase), [
        loadOptionsBase,
        withTypedEvent
    ]);
    const customStyles = (0, $42omo.useMemo)(()=>{
        return {
            control: (css, state)=>{
                const borderColor = hasValidationError || isEmptyInput ? "var(--ds-border-danger, #E2483D)" : state.isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border, #091E4224)";
                return {
                    ...css,
                    borderColor: borderColor,
                    backgroundColor: state.isFocused ? "var(--ds-background-input-hovered, #F7F8F9)" : "var(--ds-background-input, #FFFFFF)",
                    ':hover': {
                        ...css[':hover'],
                        backgroundColor: "var(--ds-background-input-hovered, #F7F8F9)",
                        borderColor: borderColor
                    }
                };
            },
            menuPortal: (provided)=>({
                    ...provided,
                    zIndex: (0, $5LksM.ZIndex).FLOATING
                })
        };
    }, [
        isEmptyInput,
        hasValidationError
    ]);
    const commonUserPickerProps = (0, $42omo.useMemo)(()=>{
        const onInputChange = (query)=>{
            const trimmedValue = query?.trimStart();
            setInputValue(trimmedValue);
        };
        const pickerPlaceholder = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).inviteeListUserPickerPlaceholder
        });
        const placeholder = inviteeListPlaceholderText || pickerPlaceholder;
        const props = {
            ariaLive: 'polite',
            autoFocus: autoFocus,
            onChange: onUserSelectionChange,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: '100%',
            value: userPickerOptions,
            isValidEmail: (0, $3c78fe130026aff9$export$18148d12c805c5b0),
            isClearable: true,
            isMulti: true,
            allowEmail: allowEmail,
            suggestEmailsForDomain: loggedInEmailDomain,
            styles: customStyles,
            menuPortalTarget: document.body,
            menuPosition: 'absolute',
            onInputChange: onInputChange,
            search: inputValue,
            required: inviteeListRequired,
            groupByTypeOrder: groupByTypeOrder
        };
        return props;
    }, [
        inviteeListPlaceholderText,
        autoFocus,
        onUserSelectionChange,
        userPickerOptions,
        allowEmail,
        loggedInEmailDomain,
        customStyles,
        inputValue,
        inviteeListRequired,
        groupByTypeOrder
    ]);
    const shouldLoadOptions = !!inviteeProvider?.onInviteeLoadOptions || integrations.size > 0;
    const renderPicker = (0, $42omo.useCallback)((describedByFieldId)=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kSKAi.UserPicker), {
                    fieldId: "invite-user-picker",
                    inputId: "invite-user-picker",
                    "aria-describedby": describedByFieldId,
                    "aria-labelledby": "invite-user-picker-label",
                    onFocus: onFocusEventWithAnalytics((0, $07330006f53205cd$export$fec77d3db2f319e5)),
                    loadOptions: shouldLoadOptions ? loadOptions : undefined,
                    forwardedRef: ref,
                    ...commonUserPickerProps
                }),
                !!invitePromptOnLinkV3Cohort && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    as: "span",
                    size: "small",
                    color: "color.text.subtlest",
                    children: experimental_userPickerByline
                })
            ]
        });
    }, [
        onFocusEventWithAnalytics,
        shouldLoadOptions,
        loadOptions,
        commonUserPickerProps,
        invitePromptOnLinkV3Cohort,
        experimental_userPickerByline,
        ref
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "invite-people-invitee-list",
        children: (formProps)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                testId: "testId-invite-people-invitee-list",
                xcss: $0a2be26ef0070cb7$var$styles.fieldWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        as: "label",
                        htmlFor: 'invite-user-picker',
                        id: 'invite-user-picker-label',
                        xcss: $0a2be26ef0070cb7$var$styles.label,
                        children: [
                            inviteeListLabelText || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).inviteeListLabelThirdParty
                            }),
                            inviteeListRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                        ]
                    }),
                    renderPicker(`${formProps.fieldProps.id}-error`),
                    /*#__PURE__*/ (0, $l998X.jsx)($0a2be26ef0070cb7$var$UserPickerError, {
                        validationList: validationList,
                        isEmptyInput: isEmptyInput,
                        maxEmails: maxEmails
                    }),
                    thirdPartyConnected && /*#__PURE__*/ (0, $l998X.jsx)((0, $fdcb47a8099c9381$export$2e2bcd8739ae039), {}),
                    !!updateIntegrations.partialScope.size && /*#__PURE__*/ (0, $l998X.jsx)((0, $95d6cc27ea873a20$export$2e2bcd8739ae039), {
                        scope: (0, $7oH3p.ScopeState).PARTIAL_SCOPE
                    }),
                    thirdPartyConnected && !!updateIntegrations.noScope.size && /*#__PURE__*/ (0, $l998X.jsx)((0, $95d6cc27ea873a20$export$2e2bcd8739ae039), {
                        scope: (0, $7oH3p.ScopeState).NO_SCOPE
                    })
                ]
            })
    });
});
var $0a2be26ef0070cb7$export$2e2bcd8739ae039 = $0a2be26ef0070cb7$var$InviteeList;


/* ThirdPartyConnect.tsx generated by @compiled/babel-plugin v0.36.1 */ 










































const $3481624e45d9702c$export$8671d8ac2bda7bc8 = 'is-infi-spotlight-seen';
const $3481624e45d9702c$export$e5692b7aaa5c63e4 = ()=>(0, $j9g2s.getBooleanLocalStorageKey)($3481624e45d9702c$export$8671d8ac2bda7bc8);
const $3481624e45d9702c$export$4e9307cba9aec850 = (isInfiSpotlightSeen)=>(0, $j9g2s.updateLocalStorageKey)($3481624e45d9702c$export$8671d8ac2bda7bc8, isInfiSpotlightSeen.toString());














var $5RBJ9 = parcelRequire("5RBJ9");



var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");











class $2ff191762c54cae7$export$60a9f789989731cd extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    spotlightViewed() {
        this.fireScreen({
            name: (0, $5LksM.AnalyticsActionSubject).INFI_SPOTLIGHT
        });
    }
    spotlightDismissed() {
        this.fireTrack({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INFI_SPOTLIGHT,
            action: (0, $5LksM.AnalyticsAction).CLOSED
        });
    }
}


const $dd051b99d07d51c7$var$SpotlightWithScreenEvent = ({ dismissSpotlight: dismissSpotlight })=>{
    const intl = (0, $8C5kA.default)();
    const analytics = (0, $2dswi.useAnalytics)((0, $2ff191762c54cae7$export$60a9f789989731cd));
    (0, $42omo.useEffect)(()=>{
        analytics.spotlightViewed();
    }, [
        analytics
    ]);
    const handleDismissButtonClick = (0, $42omo.useCallback)(()=>{
        analytics.spotlightDismissed();
        dismissSpotlight();
    }, [
        analytics,
        dismissSpotlight
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5RBJ9.default), {
        testId: "testId-invite-people-infi-spotlight",
        dialogPlacement: 'bottom center',
        dialogWidth: 354,
        actions: [
            {
                onClick: handleDismissButtonClick,
                text: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).infiSpotlightAction)
            }
        ],
        heading: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).infiSpotlightTitle),
        target: "coreInvitesThirdPartyConnectSpotlight",
        targetRadius: 3,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).infiSpotlightDescription
        })
    }, "coreInvitesThirdPartyConnectSpotlight");
};
const $dd051b99d07d51c7$var$InfiSpotlight = ({ children: children, spotlightHidden: spotlightHidden, dismissSpotlight: dismissSpotlight })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $6cnUO.default), {
        blanketIsTinted: false,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
                name: "coreInvitesThirdPartyConnectSpotlight",
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2Fndw.default), {
                children: !spotlightHidden && /*#__PURE__*/ (0, $l998X.jsx)($dd051b99d07d51c7$var$SpotlightWithScreenEvent, {
                    dismissSpotlight: dismissSpotlight
                })
            })
        ]
    });
var $dd051b99d07d51c7$export$2e2bcd8739ae039 = $dd051b99d07d51c7$var$InfiSpotlight;



const $ef288515e67c7cc8$export$cc46799898138921 = ()=>(0, $061c9fd816a80862$export$8569d1ff85ba1bfc)().infiSpotlight;





const $fb7d3fed76b83d58$var$ICON_SIZE = {
    height: 16,
    width: 16
};
const $fb7d3fed76b83d58$var$styles = {
    wrapper: "_11c82smr _syaz131l",
    header: "_11c81vhk _18zrze3t _k48p1pd9 _otyr1b66",
    buttonGroup: "_195g1i6y _2mzuglyw _19pkze3t _otyrze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    buttonIcon: "_1mouu2gc _2hwxu2gc",
    connectButtonWrapper: "_1e0c1bgi",
    connectButton: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rko12b0 _1mou1b66 _195gv77o _1h6dmuej _1dqonqa1 _189ee4h9 _1e0c1txw _4t3i1ylp _4cvr1h6o _1bah1h6o _bfhk1j9a _1lhce4h9 _4cvxmuej _irr31d5g _1wjne4h9 _q4ztmuej _1di6ip91",
    connectButtonSmall: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1mou1b66 _195gv77o _1dqo15vq _1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _bfhk1j9a _1lhce4h9 _4cvxmuej _irr31d5g _1wjne4h9 _q4ztmuej _1di6ip91",
    headerSmall: "_11c81vhk _18zrze3t _k48p1pd9 _otyr1b66 _19pk1b66"
};
const $fb7d3fed76b83d58$var$ThirdPartyConnect = ()=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $7b7358fe3ea7b2f6$export$fd3aba480a4de341));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enabledIntegrations: enabledIntegrations, onConnectProvider: onConnectProvider, updateIntegrations: updateIntegrations, hideThirdPartyConnectLegend: hideThirdPartyConnectLegend } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const { isEnabled: isInfiSpotlightEnabled } = (0, $ef288515e67c7cc8$export$cc46799898138921)();
    const { experimental_inlineThirdPartyButtons: experimental_inlineThirdPartyButtons } = (0, $9xnOK.useInvitePeopleContext)();
    const handleClick = (0, $42omo.useCallback)((serviceKey)=>()=>{
            if (onConnectProvider) {
                analytics.connectButtonClicked(serviceKey);
                onConnectProvider({
                    serviceKey: serviceKey
                });
            }
        }, [
        analytics,
        onConnectProvider
    ]);
    const [spotlightHidden, setSpotlightHidden] = (0, $42omo.useState)(!!(0, $3481624e45d9702c$export$e5692b7aaa5c63e4)());
    (0, $42omo.useEffect)(()=>{
        if (isInfiSpotlightEnabled && spotlightHidden) (0, $3481624e45d9702c$export$4e9307cba9aec850)(true);
    }, [
        isInfiSpotlightEnabled,
        spotlightHidden
    ]);
    const dismissSpotlight = (0, $42omo.useCallback)(()=>{
        if (isInfiSpotlightEnabled) setSpotlightHidden(true);
    }, [
        isInfiSpotlightEnabled
    ]);
    const wrapWithNudgeToInvite = (slackButton)=>slackButton;
    const googleButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $fb7d3fed76b83d58$var$styles.connectButtonWrapper,
        as: "li",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: handleClick((0, $9kYFb.GOOGLE_SERVICE)),
            testId: "testId-invite-people-connect-google",
            xcss: (0, $1Whri.cx)($fb7d3fed76b83d58$var$styles.connectButton, experimental_inlineThirdPartyButtons && $fb7d3fed76b83d58$var$styles.connectButtonSmall),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                as: "span",
                alignBlock: "center",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4108c3cbc0d21824$export$6314f2dd65e45f24), {
                        ...$fb7d3fed76b83d58$var$ICON_SIZE,
                        className: (0, $gMc0m.default)([
                            $fb7d3fed76b83d58$var$styles.buttonIcon
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text",
                        size: "medium",
                        weight: "medium",
                        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).googleThirdPartyButton)
                    })
                ]
            })
        })
    });
    const slackButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "li",
        xcss: $fb7d3fed76b83d58$var$styles.connectButtonWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: handleClick((0, $9kYFb.PLATFORM_SLACK_SERVICE)),
            testId: `testId-invite-people-connect-slack`,
            xcss: (0, $1Whri.cx)($fb7d3fed76b83d58$var$styles.connectButton, experimental_inlineThirdPartyButtons && $fb7d3fed76b83d58$var$styles.connectButtonSmall),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                as: "span",
                alignBlock: "center",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $64e004f955af5e01$export$b33fb54b08bb6422), {
                        ...$fb7d3fed76b83d58$var$ICON_SIZE,
                        className: (0, $gMc0m.default)([
                            $fb7d3fed76b83d58$var$styles.buttonIcon
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text",
                        size: "medium",
                        weight: "medium",
                        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).slackThirdPartyButton)
                    })
                ]
            })
        })
    });
    const microsoftButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "li",
        xcss: $fb7d3fed76b83d58$var$styles.connectButtonWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: handleClick((0, $9kYFb.MICROSOFT_SERVICE)),
            testId: "testId-invite-people-connect-microsoft",
            xcss: (0, $1Whri.cx)($fb7d3fed76b83d58$var$styles.connectButton, experimental_inlineThirdPartyButtons && $fb7d3fed76b83d58$var$styles.connectButtonSmall),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                as: "span",
                alignBlock: "center",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8923e8bde8ba859a$export$ad6b83e535366949), {
                        ...$fb7d3fed76b83d58$var$ICON_SIZE,
                        className: (0, $gMc0m.default)([
                            $fb7d3fed76b83d58$var$styles.buttonIcon
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text",
                        size: "medium",
                        weight: "medium",
                        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).microsoftThirdPartyButton)
                    })
                ]
            })
        })
    });
    const buttonGroup = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        shouldWrap: true,
        spread: "space-between",
        xcss: $fb7d3fed76b83d58$var$styles.buttonGroup,
        as: "ul",
        children: [
            enabledIntegrations.has((0, $9kYFb.GOOGLE_SERVICE)) && googleButton,
            enabledIntegrations.has((0, $9kYFb.PLATFORM_SLACK_SERVICE)) && wrapWithNudgeToInvite(slackButton),
            enabledIntegrations.has((0, $9kYFb.MICROSOFT_SERVICE)) && microsoftButton
        ]
    });
    const inLineLegendAndButtonGroupSmall = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        shouldWrap: true,
        spread: "space-between",
        xcss: $fb7d3fed76b83d58$var$styles.buttonGroup,
        as: "ul",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "legend",
                xcss: $fb7d3fed76b83d58$var$styles.headerSmall,
                children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).thirdPartyConnect)
            }),
            enabledIntegrations.has((0, $9kYFb.GOOGLE_SERVICE)) && googleButton,
            enabledIntegrations.has((0, $9kYFb.PLATFORM_SLACK_SERVICE)) && wrapWithNudgeToInvite(slackButton),
            enabledIntegrations.has((0, $9kYFb.MICROSOFT_SERVICE)) && microsoftButton
        ]
    });
    if (experimental_inlineThirdPartyButtons) return /*#__PURE__*/ (0, $l998X.jsx)("fieldset", {
        className: (0, $gMc0m.default)([
            $fb7d3fed76b83d58$var$styles.wrapper
        ]),
        children: inLineLegendAndButtonGroupSmall
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("fieldset", {
        className: (0, $gMc0m.default)([
            $fb7d3fed76b83d58$var$styles.wrapper
        ]),
        children: [
            !hideThirdPartyConnectLegend && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "legend",
                xcss: $fb7d3fed76b83d58$var$styles.header,
                children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).thirdPartyConnect)
            }),
            isInfiSpotlightEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dd051b99d07d51c7$export$2e2bcd8739ae039), {
                spotlightHidden: spotlightHidden,
                dismissSpotlight: dismissSpotlight,
                children: buttonGroup
            }) : buttonGroup,
            !!updateIntegrations.noScope.size && /*#__PURE__*/ (0, $l998X.jsx)((0, $95d6cc27ea873a20$export$2e2bcd8739ae039), {
                scope: (0, $7oH3p.ScopeState).NO_SCOPE
            })
        ]
    });
};
var $fb7d3fed76b83d58$export$2e2bcd8739ae039 = $fb7d3fed76b83d58$var$ThirdPartyConnect;


/* ViralSettings.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");












/* SlideAnimationWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");




const $7da72fdc7516c71e$var$styles = {
    wrapper: "_1reo15vq _18m915vq"
};
const $7da72fdc7516c71e$export$ceb13420774e5c3b = ({ children: children, shouldTriggerAnimation: shouldTriggerAnimation })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
        children: shouldTriggerAnimation && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $7da72fdc7516c71e$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h3cbw.default), {
                enterFrom: "top",
                fade: "inout",
                children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ...props,
                        children: children
                    })
            })
        })
    });














var $7gpC4 = parcelRequire("7gpC4");


var $fT2ta = parcelRequire("fT2ta");











const $77506ce288ac720d$export$11078a062caad4af = (props)=>{
    const { show: show, onChange: onChange, checkboxTheme: checkboxTheme = 'DEFAULT', isChecked: isChecked } = props;
    const analytics = (0, $2dswi.useAnalytics)((0, $33a8a9183a4cf16a$export$79c486b6beac7a88));
    (0, $42omo.useEffect)(()=>{
        show && analytics.userInvitesCheckboxRendered({
            container: checkboxTheme,
            value: isChecked
        });
    }, [
        show,
        checkboxTheme,
        isChecked,
        analytics
    ]);
    const onChangeWrapper = (event)=>{
        const value = event.target.checked;
        analytics.userInvitesCheckboxClicked({
            value: value,
            container: checkboxTheme
        });
        onChange(event);
    };
    if (!show) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
        entranceDirection: "top",
        children: (animationProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                paddingBlockStart: checkboxTheme === 'MODAL' ? 'space.150' : 'space.050',
                ...animationProps,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                    testId: "testId-invite-people-viral-settings-open-invite",
                    onChange: onChangeWrapper,
                    isChecked: isChecked,
                    label: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).openInviteDescription
                                })
                            }),
                            checkboxTheme === 'MODAL' && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtlest",
                                size: "small",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).openInviteExtendedDescription
                                })
                            })
                        ]
                    })
                })
            })
    });
};
var $77506ce288ac720d$export$2e2bcd8739ae039 = $77506ce288ac720d$export$11078a062caad4af;



























const $91d6589f2df60b78$var$CheckboxWithAnalytics = ({ children: children, domain: domain, value: value, container: container })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $33a8a9183a4cf16a$export$79c486b6beac7a88));
    (0, $42omo.useEffect)(()=>{
        analytics.directAccessCheckboxRendered({
            domain: domain,
            container: container,
            value: value
        });
    }, [
        domain,
        container,
        value,
        analytics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children
    });
};
const $91d6589f2df60b78$export$2ecf71c9432abb54 = (props)=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $33a8a9183a4cf16a$export$79c486b6beac7a88));
    const { viralSettingsByDomain: viralSettingsByDomain, checkboxTheme: checkboxTheme = 'DEFAULT', onChange: onChange } = props;
    const onChangeWrapper = (updatedViralSettingsByDomain, domain)=>{
        analytics.directAccessCheckboxClicked({
            value: updatedViralSettingsByDomain[domain].isChecked,
            domain: domain,
            container: checkboxTheme
        });
        onChange(updatedViralSettingsByDomain);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: Object.keys(viralSettingsByDomain).filter((domain)=>viralSettingsByDomain[domain].desPromotionEligible).map((domain)=>{
            const value = !!viralSettingsByDomain?.[domain].isChecked;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                entranceDirection: "top",
                children: (animationProps)=>/*#__PURE__*/ (0, $l998X.jsx)($91d6589f2df60b78$var$CheckboxWithAnalytics, {
                        domain: domain,
                        value: value,
                        container: checkboxTheme,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            paddingBlockStart: checkboxTheme === 'MODAL' ? 'space.150' : 'space.050',
                            ...animationProps,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                testId: `testId-invite-people-viral-settings-direct-access-${domain}`,
                                isChecked: value,
                                onChange: (e)=>{
                                    onChangeWrapper({
                                        ...viralSettingsByDomain,
                                        [domain]: {
                                            ...viralSettingsByDomain[domain],
                                            isChecked: e.target.checked
                                        }
                                    }, domain);
                                },
                                label: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            color: "color.text",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).directAccessDescription,
                                                values: {
                                                    domainWithStyling: /*#__PURE__*/ (0, $l998X.jsxs)("b", {
                                                        children: [
                                                            "<@",
                                                            domain,
                                                            ">"
                                                        ]
                                                    })
                                                }
                                            })
                                        }),
                                        checkboxTheme === 'MODAL' && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            color: "color.text.subtlest",
                                            size: "small",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).directAccessExtendedDescription
                                            })
                                        })
                                    ]
                                })
                            }, `viral-settings-direct-access-checkbox-${domain}`)
                        })
                    })
            }, `viral-settings-direct-access-checkbox-fade-in${domain}`);
        })
    });
};
var $91d6589f2df60b78$export$2e2bcd8739ae039 = $91d6589f2df60b78$export$2ecf71c9432abb54;





const $52d5df541e55fbf3$var$styles = {
    heading: "_11c81vhk _syaz131l",
    formSection: "_otyrpxbi"
};
const $52d5df541e55fbf3$export$e42106b9b5ecbfaf = ({ product: product })=>{
    const { viralSettingsByDomain: viralSettingsByDomain, eligibleDomains: eligibleDomains, showOpenInvite: showOpenInvite, onOpenInviteChange: onOpenInviteChange, handleViralSettingsByDomainCheckbox: handleViralSettingsByDomainCheckbox, openInviteEnabled: openInviteEnabled } = (0, $371c856e822ce028$export$5ab4720aaf50c15c)();
    const productTitle = (0, $j9g2s.getProductTitle)(product);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7da72fdc7516c71e$export$ceb13420774e5c3b), {
        shouldTriggerAnimation: showOpenInvite || eligibleDomains.length > 0,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            testId: "testId-invite-people-viral-settings",
            xcss: $52d5df541e55fbf3$var$styles.formSection,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    alignBlock: "center",
                    spread: "space-between",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-test-id": "testId-invite-people-viral-settings-title",
                        className: (0, $gMc0m.default)([
                            $52d5df541e55fbf3$var$styles.heading
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsHeading,
                            values: {
                                product: productTitle
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $77506ce288ac720d$export$2e2bcd8739ae039), {
                    show: showOpenInvite,
                    isChecked: openInviteEnabled,
                    onChange: onOpenInviteChange
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $91d6589f2df60b78$export$2e2bcd8739ae039), {
                    viralSettingsByDomain: viralSettingsByDomain,
                    onChange: handleViralSettingsByDomainCheckbox
                })
            ]
        })
    });
};
var $52d5df541e55fbf3$export$2e2bcd8739ae039 = $52d5df541e55fbf3$export$e42106b9b5ecbfaf;


/* LineDivider.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






const $6ef077d08e307031$var$styles = {
    wrapper: "_11c81o8v _syaz131l _otyrpxbi",
    line: "_1h6dmuej _1dqonqa1 _189ee4h9 _1bsb1osq"
};
const $6ef077d08e307031$export$b5f2c46c0231ba4e = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $6ef077d08e307031$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "span",
            xcss: $6ef077d08e307031$var$styles.line
        })
    });
};



/* Recaptcha.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $a502B = parcelRequire("a502B");

var $fAdjB = parcelRequire("fAdjB");











var $2huiC = parcelRequire("2huiC");





const $dd23ed6a7a4e50fe$var$styles = {
    wrapper: "_11c81o8v _syaz131l"
};
const $dd23ed6a7a4e50fe$export$537aeeb398c07c0a = ({ isLoading: isLoading, onChange: onChange })=>{
    const { source: source } = (0, $9xnOK.useInvitePeopleContext)();
    const { isRecaptchaLoaded: isRecaptchaLoaded, getRecaptchaToken: getRecaptchaToken, recaptchaLoadErrorReason: recaptchaLoadErrorReason } = (0, $fAdjB.useInvisibleRecaptcha)({
        siteKey: (0, $j9g2s.getRecaptchaSiteKey)(),
        displayBadge: false,
        analyticsChannel: (0, $2huiC.ANALYTICS_CHANNEL),
        analyticsSource: `${(0, $5LksM.AnalyticsActionSubject).CORE_INVITE_COMPONENT}_${source}`
    });
    const isInitialLoad = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        if (isInitialLoad.current) {
            (0, $91dcab74875d7081$export$b97b16bc7fe47920).start();
            isInitialLoad.current = false;
        }
        if (isRecaptchaLoaded) (0, $91dcab74875d7081$export$b97b16bc7fe47920).success();
        if (recaptchaLoadErrorReason) (0, $91dcab74875d7081$export$b97b16bc7fe47920).failure();
        onChange({
            isRecaptchaLoaded: isRecaptchaLoaded,
            getRecaptchaToken: getRecaptchaToken,
            recaptchaLoadErrorReason: recaptchaLoadErrorReason
        });
    }, [
        onChange,
        isRecaptchaLoaded,
        getRecaptchaToken,
        recaptchaLoadErrorReason
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "recaptcha-footer",
        "data-loading": isLoading,
        xcss: $dd23ed6a7a4e50fe$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a502B.default), {})
    });
};






/* PluginRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 













const $e2fb36e6761bf104$export$458bac823ccb0e85 = ()=>{
    const { groups: groups, users: users, teams: teams } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    const { selectedProducts: selectedProducts, inviteCapabilities: inviteCapabilities, hasPreselectedTwc: hasPreselectedTwc } = (0, $8efc6a9cd7fde791$export$964e8498268f0fe3)();
    const { userPickerOptions: inviteeListOptions } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    return (0, $42omo.useMemo)(()=>({
            groups: groups,
            inviteCapabilities: inviteCapabilities,
            inviteeListOptions: inviteeListOptions,
            selectedProducts: selectedProducts,
            users: users,
            teams: teams,
            hasPreselectedTwc: hasPreselectedTwc
        }), [
        groups,
        inviteCapabilities,
        inviteeListOptions,
        selectedProducts,
        users,
        teams,
        hasPreselectedTwc
    ]);
};


const $f1b4245f0c83c606$var$styles = {
    formSection: "_otyrpxbi"
};
const $f1b4245f0c83c606$export$8a533d10ba2da272 = /*#__PURE__*/ (0, $42omo.memo)(({ plugins: plugins, location: location })=>{
    const invitePeopleData = (0, $e2fb36e6761bf104$export$458bac823ccb0e85)();
    const plugin = plugins?.[location];
    if (!plugin) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $f1b4245f0c83c606$var$styles.formSection,
        children: plugin.render(invitePeopleData)
    }, `plugin-${location}`);
});






var $ho4zm = parcelRequire("ho4zm");





var $esRft = parcelRequire("esRft");





const $8d8aaaf8d890f989$var$styles = {
    form: "_19pkze3t _otyr1ejb",
    formSection: "_otyrpxbi",
    featuredUserSection: "_19pku2gc",
    featuredUserTagVisualRefresh: "_1e0c1txw _4cvr1h6o _19bvv77o _d0altlke",
    featuredUserTagLegacy: "_19bv12x7 _ca0qv77o _d0altlke",
    featuredUserPressable: "_bfhk1j28 _ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1y15tlke"
};
const $8d8aaaf8d890f989$var$InvitePeopleForm = /*#__PURE__*/ (0, $42omo.forwardRef)(({ shouldRenderProductSelect: shouldRenderProductSelect, productOptions: productOptions, handleProductSelectMenuOpen: handleProductSelectMenuOpen, showEmptyError: showEmptyError, maxNumberOfInputs: maxNumberOfInputs, onInviteeListChange: onInviteeListChange, selectedProducts: selectedProducts, showSecondarySection: showSecondarySection, recaptcha: recaptcha, setRecaptcha: setRecaptcha }, ref)=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $bc2394fc0ac6358f$export$314fcea5dcdb0997));
    const { isOk: enableThirdPartyInvites, integrations: thirdPartyIntegrations, isConnected: thirdPartyConnected } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const { plugins: plugins, invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort, experimental_featuredUsers: experimental_featuredUsers } = (0, $9xnOK.useInvitePeopleContext)();
    const { setUserPickerOptions: setUserPickerOptions } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    const { showOpenInvite: showOpenInvite, eligibleDomains: eligibleDomains, isViralSettingsEnabled: isViralSettingsEnabled } = (0, $371c856e822ce028$export$5ab4720aaf50c15c)();
    const showViralSettingsSection = isViralSettingsEnabled && (showOpenInvite || eligibleDomains.length > 0);
    const hasSecondarySection = !invitePromptOnLinkV3Cohort && (shouldRenderProductSelect || showViralSettingsSection) && showSecondarySection;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const currentProduct = selectedProducts[0];
    const isCurrentProductInitiallyUndefined = (0, $42omo.useRef)(currentProduct === undefined);
    const inviteeListRef = (0, $42omo.useRef)(null);
    const productSelectRef = (0, $42omo.useRef)(null);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            focusInviteeList: ()=>{
                if (inviteeListRef.current) inviteeListRef.current.focus();
            },
            focusProductSelect: ()=>{
                if (productSelectRef.current) productSelectRef.current.focus();
            }
        }));
    const secondarySectionTitle = (0, $42omo.useMemo)(()=>{
        if (isCurrentProductInitiallyUndefined.current) {
            if (shouldRenderProductSelect && showViralSettingsSection) return (0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingNoCurrentProductAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingNoCurrentProduct;
            else if (shouldRenderProductSelect) return (0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingWithProductSelectorNoCurrentProductAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingWithProductSelectorNoCurrentProduct;
            else return (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingWithViralSettings;
        }
        if (shouldRenderProductSelect && showViralSettingsSection) return (0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeading;
        else if (shouldRenderProductSelect) return (0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingWithProductSelectorAppify : (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingWithProductSelector;
        else return (0, $c35877e38bf8c63c$export$defe85febe8b728c).secondarySectionHeadingWithViralSettings;
    }, [
        shouldRenderProductSelect,
        showViralSettingsSection
    ]);
    const [featuredUsers, setFeaturedUsers] = (0, $42omo.useState)([]);
    const [selectedFeaturedUsers, setSelectedFeaturedUsers] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        (0, $j9g2s.getFeaturedUsers)(experimental_featuredUsers).then((u)=>{
            const users = u || [];
            setFeaturedUsers(users);
        });
    }, [
        experimental_featuredUsers
    ]);
    const visibleFeaturedUsers = ()=>{
        const sameUser = (user1, user2)=>{
            return user1.id ? user1.id === user2.id : user1.email ? user1.email === user2.email : false;
        };
        const unselectedFeaturedUsers = featuredUsers?.filter((user)=>!selectedFeaturedUsers.some((selected)=>sameUser(selected, user)));
        const visibleFeaturedUsers = unselectedFeaturedUsers.slice(0, 4);
        return visibleFeaturedUsers;
    };
    const handleAddFeaturedUser = (userToInvite)=>{
        if (userToInvite) {
            setUserPickerOptions((prevOptions)=>[
                    ...prevOptions,
                    userToInvite
                ]);
            analytics.featuredUserTagClicked({
                featuredUser: userToInvite
            });
        }
        setSelectedFeaturedUsers((prevUsers)=>{
            return [
                ...prevUsers,
                userToInvite
            ];
        });
    };
    const shouldShowFeaturedUsers = experimental_featuredUsers && featuredUsers.length > 0;
    const FeaturedUserTagVisualRefresh = (user)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            xcss: $8d8aaaf8d890f989$var$styles.featuredUserPressable,
            onClick: ()=>handleAddFeaturedUser(user),
            "aria-label": `Add ${user.name} to project`,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
                appearance: "rounded",
                text: user.name ?? 'Unknown User',
                elemBefore: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $8d8aaaf8d890f989$var$styles.featuredUserTagVisualRefresh,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                            label: "Add icon",
                            LEGACY_size: "small",
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                            borderColor: "transparent",
                            size: "xsmall",
                            src: user.avatarUrl,
                            label: `Avatar for ${user.name}`
                        })
                    ]
                }),
                "data-testid": `featured-user-${user.id}`
            }, user.id)
        }, user.id);
    };
    const FeaturedUserTagLegacy = (user)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            xcss: $8d8aaaf8d890f989$var$styles.featuredUserPressable,
            onClick: ()=>handleAddFeaturedUser(user),
            "aria-label": `Add ${user.name} to project`,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
                appearance: "default",
                text: user.name ?? 'Unknown User',
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $8d8aaaf8d890f989$var$styles.featuredUserTagLegacy,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                        label: "Add icon",
                        LEGACY_size: "small",
                        size: "small"
                    })
                })
            }, user.id)
        }, user.id);
    };
    const FeaturedUserTag = (0, $bedQP.componentWithFG)('platform-component-visual-refresh', FeaturedUserTagVisualRefresh, FeaturedUserTagLegacy);
    return /*#__PURE__*/ (0, $l998X.jsxs)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
        },
        className: (0, $gMc0m.default)([
            $8d8aaaf8d890f989$var$styles.form
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $8d8aaaf8d890f989$var$styles.formSection,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $0a2be26ef0070cb7$export$2e2bcd8739ae039), {
                        maxEmails: maxNumberOfInputs,
                        onInviteeListChange: onInviteeListChange,
                        showEmptyError: showEmptyError,
                        ref: inviteeListRef
                    }),
                    shouldShowFeaturedUsers && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $8d8aaaf8d890f989$var$styles.featuredUserSection,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bRPo1.default), {
                            children: visibleFeaturedUsers().map((user)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                    content: user.tooltip ?? '',
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(FeaturedUserTag, {
                                        ...user
                                    }, user.id)
                                }, user.id))
                        })
                    })
                ]
            }),
            enableThirdPartyInvites && !invitePromptOnLinkV3Cohort && thirdPartyIntegrations && !thirdPartyConnected && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $8d8aaaf8d890f989$var$styles.formSection,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb7d3fed76b83d58$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f1b4245f0c83c606$export$8a533d10ba2da272), {
                plugins: plugins,
                location: "belowInviteeList"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7da72fdc7516c71e$export$ceb13420774e5c3b), {
                shouldTriggerAnimation: hasSecondarySection,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6ef077d08e307031$export$b5f2c46c0231ba4e), {}),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $8d8aaaf8d890f989$var$styles.formSection,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                size: "xsmall",
                                as: "h2",
                                children: formatMessage(secondarySectionTitle)
                            })
                        }),
                        shouldRenderProductSelect && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $8d8aaaf8d890f989$var$styles.formSection,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4e9bb9323fa5b517$export$2e2bcd8739ae039), {
                                productOptions: productOptions,
                                onMenuOpen: handleProductSelectMenuOpen,
                                formInvalid: showEmptyError,
                                ref: productSelectRef
                            })
                        }),
                        showViralSettingsSection && /*#__PURE__*/ (0, $l998X.jsx)((0, $52d5df541e55fbf3$export$2e2bcd8739ae039), {
                            product: selectedProducts[0]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f1b4245f0c83c606$export$8a533d10ba2da272), {
                plugins: plugins,
                location: "footer"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $8d8aaaf8d890f989$var$styles.formSection,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dd23ed6a7a4e50fe$export$537aeeb398c07c0a), {
                    isLoading: !recaptcha?.isRecaptchaLoaded && !recaptcha?.recaptchaLoadErrorReason,
                    onChange: setRecaptcha
                })
            })
        ]
    });
});
var $8d8aaaf8d890f989$export$2e2bcd8739ae039 = $8d8aaaf8d890f989$var$InvitePeopleForm;
















class $edfa25fb2392ddad$export$84804bd348f3aafb extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    pluginsValidationFailed({ error: error }) {
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).VALIDATION,
            actionSubjectId: (0, $5LksM.AnalyticsActionSubjectId).PLUGINS,
            action: (0, $5LksM.AnalyticsAction).FAILED,
            attributes: {
                error: error
            }
        });
    }
}

const $ecebb2fed148b1e5$export$d0b1421dbb7d2df3 = async ({ analytics: analytics, invitePeopleData: invitePeopleData, plugins: plugins })=>{
    const pluginValidationSuccessfulResult = {
        isValid: true
    };
    if (!plugins) return pluginValidationSuccessfulResult;
    try {
        const onValidatePromises = Object.keys(plugins).map((location)=>plugins[location]?.onValidate?.(invitePeopleData) ?? Promise.resolve(pluginValidationSuccessfulResult));
        const onValidateResults = await Promise.all(onValidatePromises);
        return {
            isValid: onValidateResults.every(({ isValid: isValid })=>isValid)
        };
    } catch (error) {
        analytics.pluginsValidationFailed({
            error: String(error)
        });
        return {
            isValid: false
        };
    }
};




var $8TTLA = parcelRequire("8TTLA");


var $lCdxa = parcelRequire("lCdxa");


var $1bY7o = parcelRequire("1bY7o");

const $4ea4e20d99ec6988$var$styles = {
    formWrapper: "_195g1wug _kqswh2mm _p12f1j8x",
    formHeader: "_2lx21sbv",
    formHeaderMenu: "_1wpzesu3 _2lx21sbv",
    formTitleBylineWrapper: "_2hwxxy5q _r8nt1wq8",
    formTitleByline: "_1reo15vq _18m915vq _k48pi7a9 _19pkze3t _1bto1l2s _o5721q9c",
    formDescriptionWrapper: "_19pku2gc _otyrpxbi",
    formFooter: "_otyr1ejb",
    buttonWrapper: "_otyrpxbi",
    rightAlignedButtonWrapper: "_1bahesu3",
    copyLinkWithRightAlignedButtons: "_1bah1yb4 _4cvr1h6o"
};
const $4ea4e20d99ec6988$var$ActionButtons = ({ hideCancelButton: hideCancelButton, experimental_submitButtonRef: experimental_submitButtonRef, isSendingInvitation: isSendingInvitation, onCancelButtonClick: onCancelButtonClick, source: source, productId: productId, cancelButtonLabel: cancelButtonLabel, getInviteButtonAnalyticsAttributes: getInviteButtonAnalyticsAttributes, recaptcha: recaptcha, handleSendButtonClick: handleSendButtonClick, getSubmitButtonText: getSubmitButtonText })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            !(hideCancelButton || experimental_submitButtonRef) && /*#__PURE__*/ (0, $l998X.jsx)((0, $e7b7940dcdf139c7$export$2e2bcd8739ae039), {
                testId: "testId-invite-people-cancel-button",
                interactionName: "invite-people-form.cancel",
                actionSubjectId: 'cancelButton',
                appearance: "subtle",
                isDisabled: isSendingInvitation,
                onClick: onCancelButtonClick,
                analyticsAttributes: {
                    integration: source,
                    source: source,
                    product: productId
                },
                children: cancelButtonLabel ? cancelButtonLabel : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).cancelButton
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e7b7940dcdf139c7$export$2e2bcd8739ae039), {
                ref: experimental_submitButtonRef,
                actionSubjectId: 'inviteButton',
                analyticsAttributes: getInviteButtonAnalyticsAttributes,
                appearance: "primary",
                form: "invitePeopleForm",
                interactionName: "invite-people-form.submit",
                isLoading: isSendingInvitation || !recaptcha?.isRecaptchaLoaded && !recaptcha?.recaptchaLoadErrorReason,
                onClick: handleSendButtonClick,
                type: "submit",
                children: getSubmitButtonText()
            })
        ]
    });
};
const $4ea4e20d99ec6988$var$InviteModalWithCopyLinkBtn = ({ actionButtonsProps: actionButtonsProps, analytics: analytics, experimental_copyLink: experimental_copyLink })=>{
    const intl = (0, $8C5kA.default)();
    const { productId: productId } = (0, $9xnOK.useInvitePeopleContext)();
    const { copyLink: copyLink, copyLinkOrigin: copyLinkOrigin } = (0, $42omo.useMemo)(()=>{
        const rawCopyLink = experimental_copyLink || window.location.href;
        const origin = new (0, $6Co6F.default)({
            product: productId
        });
        return {
            copyLink: origin.addToUrl(rawCopyLink),
            copyLinkOrigin: origin
        };
    }, [
        productId,
        experimental_copyLink
    ]);
    const handleCopyLink = (0, $42omo.useCallback)(()=>{
        analytics.copyLinkButtonClicked({
            originAttributes: copyLinkOrigin.toAnalyticsAttributes({
                hasGeneratedId: true
            })
        });
    }, [
        analytics,
        copyLinkOrigin
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $1Whri.cx)($4ea4e20d99ec6988$var$styles.buttonWrapper, $4ea4e20d99ec6988$var$styles.copyLinkWithRightAlignedButtons),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lCdxa.CopyLinkButton), {
                link: copyLink,
                onLinkCopy: handleCopyLink,
                isDisabled: false,
                copyLinkButtonText: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).copyLinkButtonText),
                copiedToClipboardText: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).copiedToClipboardMessage),
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    label: ""
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.100",
                xcss: $4ea4e20d99ec6988$var$styles.rightAlignedButtonWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)($4ea4e20d99ec6988$var$ActionButtons, {
                    ...actionButtonsProps
                })
            })
        ]
    });
};
const $4ea4e20d99ec6988$var$InvitePeopleComponent = ({ alignButtons: alignButtons, cancelButtonLabel: cancelButtonLabel, experimental_formTitleByline: experimental_formTitleByline, experimental_submitButtonRef: experimental_submitButtonRef, experimental_copyLink: experimental_copyLink, formDescription: formDescription, formTitle: formTitle, hideFormHeader: hideFormHeader, hideCancelButton: hideCancelButton, isSendingInvitation: isSendingInvitation, maxNumberOfInputs: maxNumberOfInputs, onCancelButtonClick: onCancelButtonClick, onInviteButtonClick: onInviteButtonClick, onInviteeListChange: onInviteeListChange, productOptions: productOptions, showProductSelect: showProductSelect, selectedProducts: selectedProducts, sendButtonLabel: customSendButtonLabel, showSecondarySection: showSecondarySection, titleId: titleId, onAdminMenuItemClick: onAdminMenuItemClick })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $bc2394fc0ac6358f$export$314fcea5dcdb0997));
    const pluginAnalytics = (0, $2dswi.useAnalytics)((0, $edfa25fb2392ddad$export$84804bd348f3aafb));
    const invitePeopleData = (0, $e2fb36e6761bf104$export$458bac823ccb0e85)();
    const [showEmptyError, setShowEmptyError] = (0, $42omo.useState)(false);
    const invitePeopleFormRef = (0, $42omo.useRef)(null);
    const { invitePromptOnLinkV3Cohort: invitePromptOnLinkV3Cohort, jiraSubProduct: jiraSubProduct, loggedInEmailDomain: loggedInEmailDomain, plugins: plugins, productId: productId, source: source, userRole: userRole, userEmail: userEmail } = (0, $9xnOK.useInvitePeopleContext)();
    const { isCoreInvitesInJiraProjectEnabled: isCoreInvitesInJiraProjectEnabled } = (0, $3c20d8d89926317b$export$2a48237687fafe42)();
    const { inviteFromAssignModal: inviteFromAssignModalCohort, restoreInviteButton: restoreInviteButtonExperimentEnabled } = (0, $jL3L2.useExperimentalFeatures)();
    const { isOk: enableThirdPartyInvites, integrations: thirdPartyIntegrations, orgSettings: thirdPartyOrgSettings } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const [recaptcha, setRecaptcha] = (0, $42omo.useState)();
    const { emails: emails, ids: ids } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    (0, $42omo.useEffect)(()=>{
        analytics.inviteComponentViewed({
            hasGmailDomain: (0, $j9g2s.hasGmailDomain)(loggedInEmailDomain),
            isConnectedToSlack: thirdPartyIntegrations.has((0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE),
            ...thirdPartyOrgSettings
        });
    }, [
        analytics,
        loggedInEmailDomain,
        thirdPartyIntegrations,
        thirdPartyOrgSettings
    ]);
    const isBasicUser = userRole === 'basic';
    const shouldRenderProductSelect = showProductSelect && // Display empty product selector when we are unable to determine
    // the defaultProducts that should be selected.
    (selectedProducts?.length === 0 || productOptions && productOptions.length > 1 && // show for trusted|admin users
    (!isBasicUser || // OR if Product is Jira and there's no subproduct explicitly passed in
    productId === 'jira' && !jiraSubProduct || // OR if Product is 'platform', which indicates that the caller doesn't
    // know what product subscriptions are available.
    productId === 'platform')); /**
                               * Checks the internal inputs from Invite People (inviteeList and validationState from the user picker), without checking plugins validation.
                               * Plugins validation is done through `pluginsOnValidate`.
                               */ 
    const isInternalFormDataValid = ()=>{
        const inputValues = [
            ...emails,
            ...ids
        ];
        const isInviteesEmpty = !inputValues.filter((item)=>item.length).length;
        const isProductsEmpty = shouldRenderProductSelect && selectedProducts.length === 0;
        const validationList = (0, $3c78fe130026aff9$export$4a1e16a3f293dded)(emails, ids, maxNumberOfInputs, userEmail, isCoreInvitesInJiraProjectEnabled);
        if (isInviteesEmpty || isProductsEmpty) {
            if (isInviteesEmpty && invitePeopleFormRef.current) invitePeopleFormRef.current.focusInviteeList();
            else if (isProductsEmpty && invitePeopleFormRef.current) invitePeopleFormRef.current.focusProductSelect();
            setShowEmptyError(true);
            return false;
        } // We also want to cap the number of emails/ids allowed to maxNumberOfInputs
        if (inputValues.filter((item)=>item.length).length > maxNumberOfInputs) {
            if (isInviteesEmpty && invitePeopleFormRef.current) invitePeopleFormRef.current.focusInviteeList();
            return false;
        } // When any other error occurs, redirect focus to the first input so the user can re-navigate through the form
        if (isInviteesEmpty && invitePeopleFormRef.current) invitePeopleFormRef.current.focusInviteeList();
         // If the there is an error state from the the user picker then the button is disabled
        return !(0, $3c78fe130026aff9$export$5e63894f961a3223)(validationList);
    };
    const getInviteButtonAnalyticsAttributes = ()=>{
        const inputValues = [
            ...emails,
            ...ids
        ];
        let formError; // TODO: remove `formError` from `inviteButton button clicked` event and create a new `validation` event with `formError` and the plugins validation data.
        //       https://atlassian.slack.com/archives/C0138SD4YTH/p1669849389985509?thread_ts=1669768434.466429&cid=C0138SD4YTH
        if (!isInternalFormDataValid()) {
            if (selectedProducts.length === 0) formError = (0, $dh538.fg)('product-terminology-refresh') ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).noProductSelectedMessageAltAppify.defaultMessage : (0, $c35877e38bf8c63c$export$defe85febe8b728c).noProductSelectedMessage.defaultMessage;
            else formError = inputValues.filter((val)=>val.length).length ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).invalidEmailMessage.defaultMessage : (0, $c35877e38bf8c63c$export$defe85febe8b728c).emptyEmailMessage.defaultMessage;
        } else formError = undefined;
        return {
            product: productId,
            numberOfEmails: emails.length,
            numberOfUniqueEmails: [
                ...new Set(emails)
            ].length,
            formError: formError,
            invitedProducts: selectedProducts,
            integration: source,
            source: source,
            inviteFromAssignModalCohort: inviteFromAssignModalCohort
        };
    };
    const handleSendButtonClick = async ()=>{
        if (!isInternalFormDataValid()) return;
        const { isValid: isValid } = await (0, $ecebb2fed148b1e5$export$d0b1421dbb7d2df3)({
            analytics: pluginAnalytics,
            invitePeopleData: invitePeopleData,
            plugins: plugins
        });
        if (!isValid) return;
        (0, $91dcab74875d7081$export$57415b8193dc14c8).addMetadata({
            isThirdPartyIntegrated: Boolean(thirdPartyIntegrations.size > 0)
        });
        (0, $91dcab74875d7081$export$57415b8193dc14c8).start();
        await onInviteButtonClick(false, recaptcha?.getRecaptchaToken);
    };
    const getUniqueValidEmails = (0, $42omo.useCallback)(()=>{
        return [
            ...new Set(emails)
        ];
    }, [
        emails
    ]);
    const handleProductSelectMenuOpen = ()=>{
        analytics.productSelectDropdownOpened({
            productOptions: productOptions?.map((product)=>product.value),
            selectedProducts: selectedProducts
        });
    };
    const getSubmitButtonText = ()=>{
        if (customSendButtonLabel) return customSendButtonLabel;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).sendInviteButton,
            values: {
                numberOfInputs: getUniqueValidEmails().length + ids.length
            }
        });
    };
    const actionButtonsProps = {
        hideCancelButton: hideCancelButton,
        experimental_submitButtonRef: experimental_submitButtonRef,
        isSendingInvitation: isSendingInvitation,
        onCancelButtonClick: onCancelButtonClick,
        source: source,
        productId: productId,
        cancelButtonLabel: cancelButtonLabel,
        getInviteButtonAnalyticsAttributes: getInviteButtonAnalyticsAttributes,
        recaptcha: recaptcha,
        handleSendButtonClick: handleSendButtonClick,
        getSubmitButtonText: getSubmitButtonText
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "testId-invite-people-form",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $4ea4e20d99ec6988$var$styles.formWrapper,
            children: [
                enableThirdPartyInvites && /*#__PURE__*/ (0, $l998X.jsx)((0, $f348a991e583462f$export$2e2bcd8739ae039), {}),
                !hideFormHeader && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    spread: "space-between",
                    xcss: $4ea4e20d99ec6988$var$styles.formHeader,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: "space.100",
                            xcss: $4ea4e20d99ec6988$var$styles.formHeaderMenu,
                            children: [
                                onCancelButtonClick && /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                                    onClick: onCancelButtonClick
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $254e221545d6b311$export$d9b273488cd8ce6f), {
                                    onAdminMenuItemClick: onAdminMenuItemClick
                                })
                            ]
                        }),
                        formTitle ? formTitle : /*#__PURE__*/ (0, $l998X.jsx)((0, $60bd051b33cc88bf$export$2e2bcd8739ae039), {
                            productOptions: productOptions,
                            selectedProducts: selectedProducts,
                            titleId: titleId
                        })
                    ]
                }),
                !!invitePromptOnLinkV3Cohort && experimental_formTitleByline && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    xcss: $4ea4e20d99ec6988$var$styles.formTitleBylineWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "medium",
                        children: experimental_formTitleByline
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4ea4e20d99ec6988$var$styles.formDescriptionWrapper,
                    testId: "invite-people-form-description-wrapper",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        id: "invite-people-form-description",
                        children: formDescription
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f1b4245f0c83c606$export$8a533d10ba2da272), {
                    plugins: plugins,
                    location: "header"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8d8aaaf8d890f989$export$2e2bcd8739ae039), {
                    shouldRenderProductSelect: shouldRenderProductSelect,
                    productOptions: productOptions,
                    handleProductSelectMenuOpen: handleProductSelectMenuOpen,
                    showEmptyError: showEmptyError,
                    onCancelButtonClick: onCancelButtonClick,
                    maxNumberOfInputs: maxNumberOfInputs,
                    onInviteeListChange: onInviteeListChange,
                    selectedProducts: selectedProducts,
                    showSecondarySection: showSecondarySection,
                    recaptcha: recaptcha,
                    setRecaptcha: setRecaptcha,
                    ref: invitePeopleFormRef
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4ea4e20d99ec6988$var$styles.formFooter,
                    children: restoreInviteButtonExperimentEnabled ? /*#__PURE__*/ (0, $l998X.jsx)($4ea4e20d99ec6988$var$InviteModalWithCopyLinkBtn, {
                        actionButtonsProps: actionButtonsProps,
                        analytics: analytics,
                        experimental_copyLink: experimental_copyLink
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        space: "space.100",
                        xcss: (0, $1Whri.cx)($4ea4e20d99ec6988$var$styles.buttonWrapper, alignButtons === 'right' && $4ea4e20d99ec6988$var$styles.rightAlignedButtonWrapper),
                        children: /*#__PURE__*/ (0, $l998X.jsx)($4ea4e20d99ec6988$var$ActionButtons, {
                            ...actionButtonsProps
                        })
                    })
                })
            ]
        })
    });
};
var $4ea4e20d99ec6988$export$2e2bcd8739ae039 = $4ea4e20d99ec6988$var$InvitePeopleComponent;

















var $9hlns = parcelRequire("9hlns");










parcelRequire("42omo");














const $a72e3e0dcdf6ef0f$var$getOpenInviteSuccessFlag = (cloudId, product, intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $6fnsQ).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).openInviteSuccessFlagTitle, {
            product: product
        }),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).openInviteSuccessFlagDescription),
        actions: [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsSuccessFlagActionLabel),
                href: `${(0, $j9g2s.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a72e3e0dcdf6ef0f$var$getDirectAccessSuccessFlag = (domains, cloudId, product, intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $6fnsQ).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).directAccessSuccessFlagTitle, {
            product: product
        }),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).directAccessSuccessFlagDescription, {
            domains: domains.map((domain)=>`@${domain}`).join(', ')
        }),
        actions: [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsSuccessFlagActionLabel),
                href: `${(0, $j9g2s.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a72e3e0dcdf6ef0f$var$getViralSettingsSuccessFlag = (domains, cloudId, product, intl)=>{
    return {
        appearance: 'success',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            label: "success",
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $6fnsQ).G400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsSuccessFlagTitle, {
            product: product
        }),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsSuccessFlagDescription, {
            domains: domains.map((domain)=>`@${domain}`).join(', ')
        }),
        actions: [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsSuccessFlagActionLabel),
                href: `${(0, $j9g2s.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a72e3e0dcdf6ef0f$var$getOpenInviteFailureFlag = (cloudId, product, intl)=>{
    return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Agkp))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $6fnsQ).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).openInviteFailureFlagTitle),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).openInviteFailureFlagDescription, {
            product: product
        }),
        actions: [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsFailureFlagActionLabel),
                href: `${(0, $j9g2s.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a72e3e0dcdf6ef0f$var$getDirectAccessFailureFlag = (domain, cloudId, product, intl)=>{
    return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Agkp))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $6fnsQ).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).directAccessFailureFlagTitle),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).directAccessFailureFlagDescription, {
            domain: `@${domain}`,
            product: product
        }),
        actions: [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viralSettingsFailureFlagActionLabel),
                href: `${(0, $j9g2s.CLOUD_ADMIN_URL)}/s/${cloudId}/signup`,
                target: '_blank'
            }
        ]
    };
};
const $a72e3e0dcdf6ef0f$export$f8472417a92ca559 = (openInviteEnabled, directAccessAllDomainsEnabled, domains, cloudId, product, intl)=>{
    let flags = [];
    if (openInviteEnabled && directAccessAllDomainsEnabled) return [
        $a72e3e0dcdf6ef0f$var$getViralSettingsSuccessFlag(domains, cloudId, product, intl)
    ];
    if (openInviteEnabled) flags.push($a72e3e0dcdf6ef0f$var$getOpenInviteSuccessFlag(cloudId, product, intl));
    else if (openInviteEnabled === false) flags.push($a72e3e0dcdf6ef0f$var$getOpenInviteFailureFlag(cloudId, product, intl));
    if (directAccessAllDomainsEnabled) flags.push($a72e3e0dcdf6ef0f$var$getDirectAccessSuccessFlag(domains, cloudId, product, intl));
    else if (directAccessAllDomainsEnabled === false) domains.forEach((domain)=>flags.push($a72e3e0dcdf6ef0f$var$getDirectAccessFailureFlag(domain, cloudId, product, intl)));
    return flags;
};







const $84c014bc7edb542b$export$19902b66d8fa0a2c = ()=>{
    const { viralSettingsDESEligibleStates: { checked: domains } } = (0, $371c856e822ce028$export$5ab4720aaf50c15c)();
    const { cloudId: cloudId } = (0, $9xnOK.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts } = (0, $8efc6a9cd7fde791$export$964e8498268f0fe3)();
    const intl = (0, $8C5kA.default)();
    return (openInviteEnabled, directAccessAllDomainsEnabled)=>(0, $a72e3e0dcdf6ef0f$export$f8472417a92ca559)(openInviteEnabled, directAccessAllDomainsEnabled, domains, cloudId || '', (0, $j9g2s.getProductTitle)(selectedProducts[0]), intl);
};









var $1e2E5 = parcelRequire("1e2E5");



/* eslint-disable import/dynamic-import-chunkname */ 


const $22f634db1faac917$export$94d2d72df36bbb16 = [
    'en-GB',
    'en-US',
    'en-ZZ',
    // Used by i18n team in staging
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];






























function $22f634db1faac917$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("dWfpn"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("kSuk0"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("dWGY6"));
        case 'en-GB':
            return (parcelRequire("7KS9L"));
        case 'en-US':
        case 'en':
            return (parcelRequire("5MxVp"));
        case 'en-ZZ':
            return (parcelRequire("2WGuF"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("9Mnao"));
        case 'et-EE':
        case 'et':
            return (parcelRequire("1HQPB"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("fc7zv"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("hYpMd"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("aGqhs"));
        case 'is-IS':
        case 'is':
            return (parcelRequire("l3BdI"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("ybArY"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("6BggT"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("4ODkP"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("6hwtI"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("luiUS"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("agjg3"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("6qFHP"));
        case 'pt-PT':
            return (parcelRequire("kULMA"));
        case 'ro-RO':
        case 'ro':
            return (parcelRequire("kI4CZ"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("6KIqT"));
        case 'sk-SK':
        case 'sk':
            return (parcelRequire("2cUSM"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("gJFmv"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("eq9aJ"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("eDwao"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("aOkbU"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("aEYmR"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("d1Xwc"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("8nrbV"));
    }
    return Promise.resolve({
        default: {}
    });
}
function $22f634db1faac917$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $42omo.useState)({});
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $22f634db1faac917$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}











class $f45f52fd8b42a6ce$export$35b5385dadcb5bc3 extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    translationMessageError(attributes) {
        this.fireOperational({
            action: (0, $5LksM.AnalyticsAction).FAILED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).TRANSLATION_MESSAGE,
            attributes: attributes
        });
    }
}


const $88f006b3600fe55d$var$InvitePeopleIntlProvider = ({ children: children })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $f45f52fd8b42a6ce$export$35b5385dadcb5bc3));
    const { locale: locale } = (0, $8C5kA.default)();
    const { messages: messages } = (0, $22f634db1faac917$export$5ac26fa9b941854e)(locale);
    const onErrorHandler = (0, $42omo.useCallback)((error)=>{
        analytics.translationMessageError({
            error: {
                locale: locale,
                errorMessage: error.message.trim()
            }
        });
    }, [
        analytics,
        locale
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        messages: messages,
        locale: locale,
        onError: onErrorHandler,
        children: children
    }, locale);
};
var $88f006b3600fe55d$export$2e2bcd8739ae039 = $88f006b3600fe55d$var$InvitePeopleIntlProvider;





parcelRequire("42omo");




/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

















var $7Ivrq = parcelRequire("7Ivrq");


const $be5c12f2420d1640$var$styles = {
    wrapper: "_1rjcoahv _18zroahv",
    contentWrapper: "_y3gn1h6o",
    imageWrapper: "_4t3iuuw1 _otyrxy5q",
    headingWrapper: "_p12fp3fh _otyr1ejb",
    messageWrapper: "_p12fp3fh"
};
const $be5c12f2420d1640$export$42f84e610f279c31 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $be5c12f2420d1640$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $be5c12f2420d1640$var$styles.contentWrapper,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    xcss: $be5c12f2420d1640$var$styles.imageWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                        width: "100%",
                        height: "100%",
                        src: (0, $7Ivrq.default),
                        alt: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).errorImageAltText)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    xcss: $be5c12f2420d1640$var$styles.headingWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        as: "h3",
                        size: "medium",
                        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).errorHeading)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    xcss: $be5c12f2420d1640$var$styles.messageWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        as: "p",
                        children: formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).errorText)
                    })
                })
            ]
        })
    });
};
var $be5c12f2420d1640$export$2e2bcd8739ae039 = $be5c12f2420d1640$export$42f84e610f279c31;








class $7c2c4930e4b3822b$export$627f773fbbb39e extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    errorBoundaryRendered(attributes) {
        const { productTitle: productTitle, source: source, subProduct: subProduct } = this.commonAttributes;
        this.fireOperational({
            action: (0, $5LksM.AnalyticsAction).RENDERED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).ERROR_BOUNDARY,
            attributes: {
                product: productTitle,
                source: source,
                subProduct: subProduct,
                ...attributes
            }
        });
    }
    inviteFormFailedToLoad(error) {
        const { source: source } = this.commonAttributes;
        this.fireOperational({
            action: (0, $5LksM.AnalyticsAction).FAILED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITE_FORM,
            attributes: {
                error: error,
                integration: source
            }
        });
    }
}



var $dacem = parcelRequire("dacem");

const $8ba2c889aa40448c$export$e926676385687eaf = (props)=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $7c2c4930e4b3822b$export$627f773fbbb39e));
    const { children: children, errorCallback: errorCallback } = props;
    const onError = (error, info)=>{
        analytics.errorBoundaryRendered({
            error: {
                message: error.message,
                stack: info?.componentStack || error.stack
            }
        });
        analytics.inviteFormFailedToLoad({
            message: error.message,
            stack: info?.componentStack || error.stack
        });
        errorCallback && errorCallback();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dacem.BaseErrorBoundary), {
        ErrorComponent: (0, $be5c12f2420d1640$export$42f84e610f279c31),
        onError: onError,
        children: children
    });
};
var $8ba2c889aa40448c$export$2e2bcd8739ae039 = $8ba2c889aa40448c$export$e926676385687eaf;



const $9317b5071d1060b1$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $9317b5071d1060b1$var$hasPerformanceAPIAvailable = $9317b5071d1060b1$var$isPerformanceAPIAvailable();
const $9317b5071d1060b1$var$measureMap = new Map();
function $9317b5071d1060b1$export$b62aa2130c86b59b(measureName) {
    if (!$9317b5071d1060b1$var$hasPerformanceAPIAvailable) return;
    performance.mark(`${measureName}::start`);
    $9317b5071d1060b1$var$measureMap.set(measureName, performance.now());
}
function $9317b5071d1060b1$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!$9317b5071d1060b1$var$hasPerformanceAPIAvailable) return;
    // `startMeasure` is not called with `measureName` before.
    if (!$9317b5071d1060b1$var$measureMap.get(measureName)) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $9317b5071d1060b1$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $9317b5071d1060b1$export$6f766653554dac02(measureName);
    }
}
function $9317b5071d1060b1$export$6f766653554dac02(measureName) {
    if (!$9317b5071d1060b1$var$hasPerformanceAPIAvailable) return;
    $9317b5071d1060b1$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

















const $0f1e7fd4549e3166$var$useViralSettingsHaveISeenIt = ()=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $33a8a9183a4cf16a$export$79c486b6beac7a88));
    const setViralSettingsHaveISeenIt = (0, $42omo.useCallback)((flagKey, product, domain)=>{
        return (0, $ea7dd8a8597d7d7f$export$57cae7afb40bd58f).postFlagWithAnalytics({
            flagKey: flagKey,
            product: product,
            domain: domain
        }, analytics);
    }, [
        analytics
    ]);
    return {
        setViralSettingsHaveISeenIt: setViralSettingsHaveISeenIt
    };
};
var $0f1e7fd4549e3166$export$2e2bcd8739ae039 = $0f1e7fd4549e3166$var$useViralSettingsHaveISeenIt;
















const $9902d023e25e43e7$var$SKIPPED_RESPONSE = {
    responseStatus: (0, $5LksM.InviteProcessingResponseStatus).SKIPPED,
    flags: []
};
const $9902d023e25e43e7$var$isAcceptable = (errorMessage, statusCode)=>{
    return (0, $j9g2s.isAcceptableFailureForDirectAccess)(errorMessage, statusCode) || (0, $j9g2s.isAcceptableFailure)(errorMessage, statusCode);
};
const $9902d023e25e43e7$var$useDirectAccessSettings = ({ selectedProducts: selectedProducts, viralSettingsDESEligibleStates: viralSettingsDESEligibleStates, isViralSettingsEnabled: isViralSettingsEnabled })=>{
    const { productId: productId, ...invitePeopleData } = (0, $9xnOK.useInvitePeopleContext)();
    const cloudId = invitePeopleData.cloudId ?? '';
    const analytics = (0, $2dswi.useAnalytics)((0, $bc2394fc0ac6358f$export$314fcea5dcdb0997));
    const { setViralSettingsHaveISeenIt: setViralSettingsHaveISeenIt } = (0, $0f1e7fd4549e3166$export$2e2bcd8739ae039)();
    const processDirectAccessSettings = (0, $42omo.useCallback)(async ()=>{
        // Adding empty flag array in preparation for flags to be refactored from getViralSettingsFlags in near future
        if (!isViralSettingsEnabled || selectedProducts.length !== 1 || !cloudId) return $9902d023e25e43e7$var$SKIPPED_RESPONSE;
        const product = selectedProducts[0];
        const { checked: domains, unchecked: uncheckedDomains } = viralSettingsDESEligibleStates;
        uncheckedDomains.forEach((domain)=>{
            const domainKey = (0, $2vYoS.createHISIDomainFlagKey)(product, cloudId, domain);
            setViralSettingsHaveISeenIt(domainKey, product, domain);
        });
        // Only add request if there are domains to update
        if (domains.length === 0) return $9902d023e25e43e7$var$SKIPPED_RESPONSE;
        const location = (0, $j9g2s.getDirectAccessLocation)(productId);
        try {
            (0, $91dcab74875d7081$export$323b055db80365a2).start();
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).updateDirectAccessSettings.startMark);
            const response = await (0, $a44a4a0d19730078$export$c993591f6996ca09).updateDirectAccessSettings({
                cloudId: cloudId,
                product: product,
                domains: domains,
                location: location
            });
            analytics.approvedDomainsSettingsSucceededSLO({
                addedDomains: domains
            });
            (0, $91dcab74875d7081$export$323b055db80365a2).success();
            return {
                responseStatus: (0, $5LksM.InviteProcessingResponseStatus).SUCCESS,
                response: response,
                flags: []
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage, error: error } = (0, $j9g2s.resolveError)(err);
            analytics.approvedDomainsSettingsFailed({
                proposedDomains: domains,
                responseCode: responseCode,
                errorMessage: errorMessage
            });
            const isSuccess = $9902d023e25e43e7$var$isAcceptable(errorMessage, responseCode);
            if (isSuccess) {
                // no domains were added so we will send an empty value for the addedDomains attribute
                analytics.approvedDomainsSettingsSucceededSLO({
                    addedDomains: []
                });
                (0, $91dcab74875d7081$export$323b055db80365a2).success();
            } else {
                analytics.approvedDomainsSettingsFailedSLO({
                    proposedDomains: domains,
                    responseCode: responseCode,
                    errorMessage: errorMessage
                });
                (0, $91dcab74875d7081$export$323b055db80365a2).failure();
            }
            return {
                responseStatus: (0, $5LksM.InviteProcessingResponseStatus).ERROR,
                error: error,
                flags: []
            };
        } finally{
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).updateDirectAccessSettings.endMark);
        }
    }, [
        analytics,
        cloudId,
        isViralSettingsEnabled,
        productId,
        selectedProducts,
        setViralSettingsHaveISeenIt,
        viralSettingsDESEligibleStates
    ]);
    return {
        processDirectAccessSettings: processDirectAccessSettings
    };
};
var $9902d023e25e43e7$export$2e2bcd8739ae039 = $9902d023e25e43e7$var$useDirectAccessSettings;























const $8ef8c810757a1f07$var$SKIPPED_RESPONSE = {
    responseStatus: (0, $5LksM.InviteProcessingResponseStatus).SKIPPED,
    flags: []
};
const $8ef8c810757a1f07$var$useOpenInvite = ({ showOpenInvite: showOpenInvite, enableOpenInvite: enableOpenInvite, selectedProducts: selectedProducts, isViralSettingsEnabled: isViralSettingsEnabled })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $bc2394fc0ac6358f$export$314fcea5dcdb0997));
    const invitePeopleData = (0, $9xnOK.useInvitePeopleContext)();
    const cloudId = invitePeopleData.cloudId ?? '';
    const { setViralSettingsHaveISeenIt: setViralSettingsHaveISeenIt } = (0, $0f1e7fd4549e3166$export$2e2bcd8739ae039)();
    const processOpenInviteSettings = (0, $42omo.useCallback)(async ()=>{
        // Adding empty flag array in preparation for flags to be refactored from getViralSettingsFlags in near future
        if (!isViralSettingsEnabled || selectedProducts.length !== 1 || !cloudId) return $8ef8c810757a1f07$var$SKIPPED_RESPONSE;
        const product = selectedProducts[0];
        if (!enableOpenInvite && showOpenInvite) {
            // If unchecked and open invite is shown
            const openInviteKey = (0, $2vYoS.createHISIOpenInviteFlagKey)(product, cloudId);
            setViralSettingsHaveISeenIt(openInviteKey, product);
            return $8ef8c810757a1f07$var$SKIPPED_RESPONSE;
        }
        if (!enableOpenInvite) return $8ef8c810757a1f07$var$SKIPPED_RESPONSE;
        const productAri = (0, $j9g2s.makeAri)(product, cloudId);
        try {
            (0, $91dcab74875d7081$export$78c49e7734a12bcb).start();
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).updateOpenInviteSettings.startMark);
            const response = await (0, $a44a4a0d19730078$export$4f6a946e6e09a73b).enableOpenInvite(product, cloudId);
            analytics.userInviteSettingsSucceededSLO({
                newState: 'enabled',
                productAri: productAri
            });
            (0, $91dcab74875d7081$export$78c49e7734a12bcb).success();
            return {
                responseStatus: (0, $5LksM.InviteProcessingResponseStatus).SUCCESS,
                response: response,
                flags: []
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage, error: error } = (0, $j9g2s.resolveError)(err);
            analytics.userInviteSettingsFailed({
                proposedNewState: 'enabled',
                productAri: productAri,
                responseCode: responseCode,
                errorMessage: errorMessage
            });
            if ((0, $j9g2s.isAcceptableFailure)(errorMessage, responseCode)) {
                // user invite setting state was not changed so we will send null as the newState attribute
                analytics.userInviteSettingsSucceededSLO({
                    newState: null,
                    productAri: productAri
                });
                (0, $91dcab74875d7081$export$78c49e7734a12bcb).success();
            } else {
                analytics.userInviteSettingsFailedSLO({
                    proposedNewState: 'enabled',
                    productAri: productAri,
                    responseCode: responseCode,
                    errorMessage: errorMessage
                });
                (0, $91dcab74875d7081$export$78c49e7734a12bcb).failure();
            }
            return {
                responseStatus: (0, $5LksM.InviteProcessingResponseStatus).ERROR,
                error: error,
                flags: []
            };
        } finally{
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).updateOpenInviteSettings.endMark);
        }
    }, [
        isViralSettingsEnabled,
        selectedProducts,
        cloudId,
        enableOpenInvite,
        showOpenInvite,
        setViralSettingsHaveISeenIt,
        analytics
    ]);
    return {
        processOpenInviteSettings: processOpenInviteSettings
    };
};
var $8ef8c810757a1f07$export$2e2bcd8739ae039 = $8ef8c810757a1f07$var$useOpenInvite;





























parcelRequire("42omo");








var $7D93v = parcelRequire("7D93v");

















const $2bfe8f3e8a23c4b3$export$86072b504af31b29 = (responseArray, getName)=>{
    if (!responseArray.length) return '';
    return (0, $5LksM.isUserWithEmail)(responseArray[0]) ? responseArray[0].email : getName(responseArray[0].id);
};
const $2bfe8f3e8a23c4b3$var$getManageUserAccessLink = (cloudId, invited)=>{
    if (invited.length === 0) return undefined;
    const [user] = invited;
    if (invited.length === 1 && user.id) return (0, $j9g2s.adminHubManageUserHref)(cloudId, user.id);
    return (0, $j9g2s.adminHubManageUsersHref)(cloudId);
};
const $2bfe8f3e8a23c4b3$export$dbe4723f1df81b00 = (result, cloudId, userRole, products, getName, intl, onReopenHandler)=>{
    const isAdmin = userRole === 'admin';
    const { invited: invited = [], accessRequested: accessRequested = [] } = result;
    let successTitle = (0, $c35877e38bf8c63c$export$defe85febe8b728c).genericSuccessFlagTitle;
    if (invited.length || accessRequested.length) {
        let descriptionMessage = (0, $c35877e38bf8c63c$export$defe85febe8b728c).hybridSuccessFlagDescription;
        const isInviteOnly = invited.length && !accessRequested.length;
        const isAccessRequestOnly = !invited.length && accessRequested.length;
        if (isInviteOnly) descriptionMessage = (0, $c35877e38bf8c63c$export$defe85febe8b728c).inviteSuccessFlagDescriptionSingleProductEmail;
        else if (isAccessRequestOnly) {
            descriptionMessage = (0, $c35877e38bf8c63c$export$defe85febe8b728c).requestAccessSuccessFlagDescription;
            successTitle = (0, $c35877e38bf8c63c$export$defe85febe8b728c).requestAccessSuccessFlagTitle;
        } else if (invited.length === 1 && accessRequested.length === 1) {
            descriptionMessage = (0, $c35877e38bf8c63c$export$defe85febe8b728c).hybridSuccessFlagDescriptionOneEach;
            successTitle = (0, $c35877e38bf8c63c$export$defe85febe8b728c).hybridSuccessFlagTitle;
        }
        const formattedMessageValues = {
            inviteCount: invited.length,
            requestAccessCount: accessRequested.length,
            emailInvited: $2bfe8f3e8a23c4b3$export$86072b504af31b29(invited, getName),
            emailRequestedAccess: $2bfe8f3e8a23c4b3$export$86072b504af31b29(accessRequested, getName),
            product: products.length > 1 ? null : (0, $j9g2s.getProductTitle)(products[0]),
            productCount: products.length,
            b: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    as: "strong",
                    children: chunks
                }),
            p: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    as: "p",
                    children: chunks
                })
        };
        let userAccessLink = isAdmin && (0, $dh538.fg)('core-invites-on-success-manage-user-access-link') ? $2bfe8f3e8a23c4b3$var$getManageUserAccessLink(cloudId, invited) : undefined;
        const actions = [];
        if (userAccessLink) actions.push({
            content: intl.formatMessage(invited.length > 1 ? (0, $c35877e38bf8c63c$export$defe85febe8b728c).manageUsersAccessActionLabel : (0, $c35877e38bf8c63c$export$defe85febe8b728c).manageUserAccessActionLabel),
            href: userAccessLink,
            target: '_blank'
        });
        if (onReopenHandler) actions.push({
            content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).addMorePeopleActionLabel),
            onClick: onReopenHandler
        });
        return {
            appearance: 'success',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
                label: "success",
                spacing: "spacious",
                color: `var(--ds-icon-success, ${(0, $6fnsQ).G400})`,
                LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
            }),
            title: intl.formatMessage(successTitle),
            description: intl.formatMessage(descriptionMessage, {
                ...formattedMessageValues,
                invitedHybridPluralCoreInvitesOptimisation: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).invitedHybridPlural, formattedMessageValues),
                requestAccessHybridPluralCoreInvitesOptimisation: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).requestAccessHybridPlural, formattedMessageValues)
            }),
            actions: actions
        };
    }
    return null;
};
const $2bfe8f3e8a23c4b3$export$7a23a73c35436772 = (result, userRole, getName, intl)=>{
    const { error: error } = result;
    const isAdmin = userRole === 'admin';
    if (error && error.length) return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Agkp))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $6fnsQ).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).inviteFailedFlagTitle, {
            isAdmin: isAdmin,
            failedInviteCount: error.length
        }),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).inviteFailedFlagDescription, {
            isAdmin: isAdmin,
            emailFailedToInvite: $2bfe8f3e8a23c4b3$export$86072b504af31b29(error, getName),
            failedInviteCount: error.length,
            b: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    as: "strong",
                    children: chunks
                })
        }),
        actions: isAdmin ? [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).contactSupportActionLabel),
                href: 'https://support.atlassian.com/contact/',
                target: '_blank'
            }
        ] : []
    };
    return null;
};
const $2bfe8f3e8a23c4b3$export$cb537c6a6762d3e3 = (userRole, intl)=>{
    const isAdmin = userRole === 'admin';
    return {
        appearance: 'error',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Agkp))), {
            label: "error",
            spacing: "spacious",
            color: `var(--ds-icon-danger, ${(0, $6fnsQ).R400})`,
            LEGACY_secondaryColor: `var(--ds-icon-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).genericFailedFlagTitle),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).genericFailedFlagDescription, {
            isAdmin: isAdmin
        }),
        actions: isAdmin ? [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).contactSupportActionLabel),
                href: 'https://support.atlassian.com/contact/',
                target: '_blank'
            }
        ] : []
    };
};
const $2bfe8f3e8a23c4b3$export$facdb825a1c5a8e0 = (result, cloudId, userRole, failedUsers, products, intl)=>{
    const { failure: failure } = result;
    if (!failure) return null;
    if (failure.code !== 'licence-exceeded') return $2bfe8f3e8a23c4b3$export$cb537c6a6762d3e3(userRole, intl);
    const billingUrl = (0, $j9g2s.getBillingUrl)(products, cloudId);
    return {
        appearance: 'warning',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7D93v))), {
            label: failure.code,
            color: `var(--ds-icon-warning, ${(0, $6fnsQ).Y300})`,
            LEGACY_secondaryColor: `var(--ds-icon-warning-inverse, ${(0, $6fnsQ).N0})`
        }),
        title: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).licenceExceededFlagTitle, {
            failedInviteCount: failedUsers.length
        }),
        description: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).licenceExceededFlagDescription, {
            failedInviteCount: failedUsers.length,
            userRole: userRole
        }),
        actions: userRole === 'admin' ? [
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).upgradePlanActionLabel),
                href: billingUrl,
                target: '_blank'
            },
            {
                content: intl.formatMessage((0, $c35877e38bf8c63c$export$defe85febe8b728c).viewUsersActionLabel),
                href: `${(0, $j9g2s.CLOUD_ADMIN_URL)}/s/${cloudId}/users`,
                target: '_blank'
            }
        ] : []
    };
};


const $fe1daa60b96638ed$export$ab5fb7206b83c9ad = (onReopenHandler)=>{
    const { cloudId: cloudId, userRole: userRole } = (0, $9xnOK.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts } = (0, $8efc6a9cd7fde791$export$964e8498268f0fe3)();
    const { users: users, getName: getName } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    const intl = (0, $8C5kA.default)();
    return {
        failure: (result)=>(0, $2bfe8f3e8a23c4b3$export$facdb825a1c5a8e0)(result, cloudId, userRole, users, selectedProducts, intl),
        error: (result)=>(0, $2bfe8f3e8a23c4b3$export$7a23a73c35436772)(result, userRole, getName, intl),
        genericError: ()=>(0, $2bfe8f3e8a23c4b3$export$cb537c6a6762d3e3)(userRole, intl),
        success: (result)=>(0, $2bfe8f3e8a23c4b3$export$dbe4723f1df81b00)(result, cloudId, userRole, selectedProducts, getName, intl, onReopenHandler)
    };
};

















const $8c3fa868372febc1$var$useInviteUsers = ({ continueUrl: continueUrl, onInviteCompletedHandler: onInviteCompletedHandler, onReopenHandler: onReopenHandler })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $bc2394fc0ac6358f$export$314fcea5dcdb0997));
    const { cloudId: cloudId, productId: productId, source: source, experimental_productContext: experimental_productContext } = (0, $9xnOK.useInvitePeopleContext)();
    const { selectedProducts: selectedProducts, hasPreselectedTwc: hasPreselectedTwc } = (0, $8efc6a9cd7fde791$export$964e8498268f0fe3)();
    const { users: users, getExternalUserType: getExternalUserType, userPickerOptions: userPickerOptions } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    const instanceUrl = (0, $j9g2s.getInstanceUrl)();
    const inviteUsersFlags = (0, $fe1daa60b96638ed$export$ab5fb7206b83c9ad)(onReopenHandler);
    const { confluenceXflowOnboarding: confluenceXflowOnboarding, invitePromptOnLinkV3: invitePromptOnLinkV3 } = (0, $jL3L2.useExperimentalFeatures)();
    const fireInviteSuccessAnalytics = (0, $42omo.useCallback)(({ result: result, origin: origin, userPickerOptions: userPickerOptions, inviteFromSuccessModal: inviteFromSuccessModal })=>{
        const originAttributes = origin.toAnalyticsAttributes({
            hasGeneratedId: true
        });
        const { invited: invited, accessRequested: accessRequested } = result;
        const getOption = (user)=>userPickerOptions?.find((option)=>(option.type === 'user' || option.type === 'external_user') && option.email === user.email && option.isExternal);
        invited.forEach((user)=>{
            const option = getOption(user);
            analytics.userInvited({
                originAttributes: originAttributes,
                userId: user.id,
                products: selectedProducts,
                inviteResult: user.results,
                externalUserType: getExternalUserType(user),
                isUserEmailVisible: (0, $5LksM.isUserWithEmail)(user),
                isAioliv3Enabled: invitePromptOnLinkV3,
                inviteFromSuccessModal: inviteFromSuccessModal,
                hasPreselectedTwc: hasPreselectedTwc,
                ...option ? {
                    sources: option.sources
                } : {}
            });
        });
        accessRequested.forEach((user)=>{
            const option = getOption(user);
            analytics.userAccessRequested({
                originAttributes: originAttributes,
                userId: user.id,
                products: selectedProducts,
                inviteResult: user.results,
                externalUserType: getExternalUserType(user),
                isUserEmailVisible: (0, $5LksM.isUserWithEmail)(user),
                isAioliv3Enabled: invitePromptOnLinkV3,
                hasPreselectedTwc: hasPreselectedTwc,
                ...option ? {
                    sources: option.sources
                } : {}
            });
        });
    }, [
        selectedProducts,
        getExternalUserType,
        analytics,
        invitePromptOnLinkV3,
        hasPreselectedTwc
    ]);
    const handleInviteFailureResponse = (0, $42omo.useCallback)(({ result: result, flags: flags })=>{
        const { failure: failure } = result;
        const { message: message, code: code, status: status } = failure;
        const inviteFormSubmittedConfig = {
            metadata: {
                inviteeCount: users.length,
                productCount: selectedProducts.length
            }
        };
        // There should not be a failure SLO event if the error is a user network failure error
        if (!(0, $j9g2s.isAcceptableFailureForUserInvite)(failure)) {
            if ((0, $j9g2s.shouldReportFailedInvite)(failure)) {
                (0, $91dcab74875d7081$export$57415b8193dc14c8).failure(inviteFormSubmittedConfig);
                analytics.inviteFailedSLO(invitePromptOnLinkV3, code, message, status);
                if (invitePromptOnLinkV3) (0, $91dcab74875d7081$export$f4c946ac2a44c48a).failure();
            } else {
                (0, $91dcab74875d7081$export$57415b8193dc14c8).success(inviteFormSubmittedConfig);
                analytics.inviteSucceededSLO(invitePromptOnLinkV3);
                if (invitePromptOnLinkV3) (0, $91dcab74875d7081$export$f4c946ac2a44c48a).success();
            }
        }
        const failureFlag = inviteUsersFlags.failure(result);
        onInviteCompletedHandler?.(result);
        if (failureFlag) flags.push(failureFlag);
    }, [
        users.length,
        selectedProducts.length,
        inviteUsersFlags,
        onInviteCompletedHandler,
        analytics,
        invitePromptOnLinkV3
    ]);
    const handleInviteSuccessResponse = (0, $42omo.useCallback)(({ result: result, origin: origin, flags: flags, userPickerOptions: userPickerOptions, inviteFromSuccessModal: inviteFromSuccessModal })=>{
        onInviteCompletedHandler?.(result);
        analytics.inviteSucceededSLO(invitePromptOnLinkV3);
        (0, $91dcab74875d7081$export$57415b8193dc14c8).success({
            metadata: {
                inviteeCount: result.invited.length + result.accessRequested.length,
                productCount: selectedProducts.length
            }
        });
        if (invitePromptOnLinkV3) (0, $91dcab74875d7081$export$f4c946ac2a44c48a).success();
        fireInviteSuccessAnalytics({
            result: result,
            origin: origin,
            userPickerOptions: userPickerOptions,
            inviteFromSuccessModal: inviteFromSuccessModal
        });
        const successFlag = inviteUsersFlags.success(result);
        if (successFlag) flags.push(successFlag);
        const errorFlag = inviteUsersFlags.error(result);
        if (errorFlag) flags.push(errorFlag);
    }, [
        onInviteCompletedHandler,
        analytics,
        selectedProducts.length,
        fireInviteSuccessAnalytics,
        inviteUsersFlags,
        invitePromptOnLinkV3
    ]);
    const inviteUsers = (0, $42omo.useCallback)(async (getRecaptchaToken, inviteFromSuccessModal)=>{
        let productContinueUrl = continueUrl;
        if (!productContinueUrl) productContinueUrl = selectedProducts.length === 1 ? `${instanceUrl}${(0, $j9g2s.getLandingPathByProduct)(selectedProducts[0])}` : instanceUrl;
        // Also try to find urls that forward newly invited users to jira setting pages and redirect them to a product landing page instead.
        // We should do this so newly invited users are not seeing a permission denied screen when accessing restricted pages.
        if (productContinueUrl.match(/.*\/jira.*\/settings/gim)) productContinueUrl = selectedProducts.length === 1 ? `${instanceUrl}${(0, $j9g2s.getLandingPathByProduct)(selectedProducts[0])}` : instanceUrl;
        const origin = new (0, $6Co6F.default)({
            product: productId
        });
        const productContinueUrlWithOrigin = origin.addToUrl(productContinueUrl);
        const inviteContinueUrl = `${productContinueUrlWithOrigin}&source=${source}`;
        const resources = selectedProducts.map((selectedProduct)=>`ari:cloud:${selectedProduct}::site/${cloudId}`);
        const inviteRequest = async (usersToInvite)=>{
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).getRecaptchaToken.startMark);
            const recaptchaToken = await getRecaptchaToken?.('v1_invitations_invite').catch(// If token generation fails we want to just continue with the
            // request without a recaptcha token (the lib will fire an event)
            ()=>undefined);
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).getRecaptchaToken.endMark);
            const recaptchaAction = `${productId}-${source}`;
            const recaptchaOptions = {
                recaptchaToken: recaptchaToken,
                recaptchaAction: recaptchaAction
            };
            try {
                let result;
                if (confluenceXflowOnboarding) result = await (0, $a44a4a0d19730078$export$c993591f6996ca09).inviteUsersV3({
                    users: usersToInvite,
                    continueUrl: inviteContinueUrl,
                    resources: resources,
                    suppressInviteEmail: false,
                    metadata: experimental_productContext ? {
                        productContext: experimental_productContext
                    } : undefined
                });
                else result = await (0, $a44a4a0d19730078$export$c993591f6996ca09).inviteUsers({
                    users: usersToInvite,
                    continueUrl: inviteContinueUrl,
                    resources: resources,
                    suppressInviteEmail: false,
                    metadata: experimental_productContext ? {
                        productContext: experimental_productContext
                    } : undefined
                }, recaptchaOptions);
                if ('failure' in result) {
                    const { message: message, code: code, status: status } = result.failure;
                    analytics.inviteRequestFailed(selectedProducts, !!recaptchaToken, code, message, status, inviteFromSuccessModal);
                } else {
                    const { invited: invited, accessRequested: accessRequested, error: error } = result;
                    analytics.inviteRequestSucceeded(selectedProducts, {
                        invited: invited.map((u)=>u.id),
                        accessRequested: accessRequested.map((u)=>u.id),
                        error: error.map(({ error: error })=>error)
                    }, !!recaptchaToken, inviteFromSuccessModal);
                }
                return result;
            } catch (err) {
                const { code: code, message: message, status: status } = (0, $5YNlj.getErrorDetails)(err);
                analytics.inviteRequestFailed(selectedProducts, !!recaptchaToken, code, message, status, inviteFromSuccessModal);
                throw err;
            }
        };
        const inviteRequestParallel = async ()=>{
            const result = {
                invited: [],
                accessRequested: [],
                error: []
            };
            const userBatches = (0, $j9g2s.chunk)(users, (0, $bTj8C.INVITE_API_MAX_USERS));
            const responses = await Promise.allSettled(userBatches.map(async (userBatch)=>{
                try {
                    const response = await inviteRequest(userBatch);
                    if ('failure' in response) for (const user of userBatch)result.error.push({
                        ...user,
                        error: response.failure
                    });
                    else {
                        result.invited.push(...response.invited);
                        result.accessRequested.push(...response.accessRequested);
                        result.error.push(...response.error);
                    }
                    return response;
                } catch (err) {
                    for (const user of userBatch)result.error.push({
                        ...user,
                        error: {
                            code: err.code,
                            message: err.message || String(err)
                        }
                    });
                    throw err;
                }
            }));
            const rejectedResponse = responses.find((response)=>response.status === 'rejected');
            const successResponse = responses.find((response)=>response.status === 'fulfilled' && !('failure' in response.value));
            const failureResponse = responses.find((response)=>response.status === 'fulfilled' && 'failure' in response.value);
            if (rejectedResponse && !successResponse && !failureResponse) throw rejectedResponse.reason;
            if (!successResponse && failureResponse) return failureResponse.value;
            return result;
        };
        try {
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).inviteUsersPromise.startMark);
            if (invitePromptOnLinkV3) (0, $91dcab74875d7081$export$f4c946ac2a44c48a).start();
            const result = invitePromptOnLinkV3 ? await inviteRequestParallel() : await inviteRequest(users);
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).inviteUsersPromise.endMark);
            const flags = [];
            if ('failure' in result) handleInviteFailureResponse({
                result: result,
                flags: flags
            });
            else handleInviteSuccessResponse({
                result: result,
                origin: origin,
                flags: flags,
                userPickerOptions: userPickerOptions,
                inviteFromSuccessModal: inviteFromSuccessModal
            });
            return {
                responseStatus: (0, $5LksM.InviteProcessingResponseStatus).SUCCESS,
                response: result,
                flags: flags
            };
        } catch (err) {
            (0, $91dcab74875d7081$export$57415b8193dc14c8).mark((0, $91dcab74875d7081$export$d9b2187d827ca57a).inviteUsersPromise.endMark);
            const { code: code, message: message, status: status } = (0, $5YNlj.getErrorDetails)(err);
            if (!(0, $j9g2s.isAcceptableFailure)(message, status)) analytics.inviteFailedSLO(invitePromptOnLinkV3, code, message, status);
            // TODO: add metadata indicating failure, migrate off custom SLO event to using UFO only
            (0, $91dcab74875d7081$export$57415b8193dc14c8).failure({
                metadata: {
                    inviteeCount: users.length,
                    productCount: selectedProducts.length
                }
            });
            if (invitePromptOnLinkV3) (0, $91dcab74875d7081$export$f4c946ac2a44c48a).failure();
            return {
                responseStatus: (0, $5LksM.InviteProcessingResponseStatus).ERROR,
                error: err,
                flags: [
                    inviteUsersFlags.genericError()
                ]
            };
        }
    }, [
        continueUrl,
        productId,
        selectedProducts,
        instanceUrl,
        cloudId,
        analytics,
        users,
        handleInviteFailureResponse,
        handleInviteSuccessResponse,
        inviteUsersFlags,
        confluenceXflowOnboarding,
        userPickerOptions,
        invitePromptOnLinkV3,
        source,
        experimental_productContext
    ]);
    return {
        inviteUsers: inviteUsers
    };
};
var $8c3fa868372febc1$export$2e2bcd8739ae039 = $8c3fa868372febc1$var$useInviteUsers;






/* NoInvitePermission.tsx generated by @compiled/babel-plugin v0.36.1 */ 







































class $d881ec7d603d504e$export$35663e3a57687cac extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    viewedNoInvitePermissionScreen() {
        const { disableNoInviteError: disableNoInviteError, inviteFromAssignModalCohort: inviteFromAssignModalCohort, orgId: orgId, source: source, userRole: userRole } = this.commonAttributes;
        this.fireScreen({
            name: (0, $5LksM.AnalyticsActionSubject).NO_INVITE_PERMOISSION_SCREEN,
            attributes: {
                disableNoInviteError: disableNoInviteError,
                inviteFromAssignModalCohort: inviteFromAssignModalCohort,
                orgId: orgId,
                source: source,
                userRole: userRole
            }
        });
    }
    getLinkedOrgSent(attributes) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).FETCH_LINKED_ORG,
            action: (0, $5LksM.AnalyticsAction).SENT,
            attributes: {
                source: source,
                userRole: userRole,
                ...attributes
            }
        });
    }
    getOpenInviteNoteSent(attributes) {
        const { source: source, userRole: userRole } = this.commonAttributes;
        this.fireOperational({
            actionSubject: (0, $5LksM.AnalyticsActionSubject).FETCH_OPEN_INVITE_NOTE,
            action: (0, $5LksM.AnalyticsAction).SENT,
            attributes: {
                source: source,
                userRole: userRole,
                ...attributes
            }
        });
    }
}


/* LazyLoadWarningIllustration.tsx generated by @compiled/babel-plugin v0.36.1 */ 














const $f0b532f818d16e1f$var$styles = {
    wrapper: "_2hwxpxbi",
    placeholder: "_1bsbvbgk _4t3io7ol"
};

const $f0b532f818d16e1f$var$LazyLoadedWarningIllustration = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kTfQt")).catch((err)=>{
        throw err;
    }));
const $f0b532f818d16e1f$var$Placeholder = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($f0b532f818d16e1f$var$styles.wrapper, $f0b532f818d16e1f$var$styles.placeholder),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $f0b532f818d16e1f$var$styles.placeholder
        })
    });
var $f0b532f818d16e1f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dacem.BaseErrorBoundary), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)($f0b532f818d16e1f$var$Placeholder, {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($f0b532f818d16e1f$var$styles.wrapper, $f0b532f818d16e1f$var$styles.placeholder),
                children: /*#__PURE__*/ (0, $l998X.jsx)($f0b532f818d16e1f$var$LazyLoadedWarningIllustration, {})
            })
        })
    });














var $aee757f8baf0852b$export$2e2bcd8739ae039 = (orgId)=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(!!orgId);
    const [openInviteNote, setOpenInviteNote] = (0, $42omo.useState)(undefined);
    const analytics = (0, $2dswi.useAnalytics)((0, $d881ec7d603d504e$export$35663e3a57687cac));
    (0, $42omo.useEffect)(()=>{
        const getCustomisedErrorMessage = async ()=>{
            if (!isLoading || !orgId) return;
            let note;
            try {
                (0, $91dcab74875d7081$export$afcd850890541869).mark((0, $91dcab74875d7081$export$d90144118191fa45).getOpenInviteNote.startMark);
                const response = await (0, $a44a4a0d19730078$export$4f6a946e6e09a73b).getOpenInviteNote(orgId);
                // TODO: remove hardcoded responseCode once available from fetchJson
                analytics.getOpenInviteNoteSent({
                    orgId: orgId,
                    responseCode: 200
                });
                note = response.note;
            } catch (err) {
                const { errorMessage: errorMessage, responseCode: responseCode } = (0, $j9g2s.resolveError)(err);
                analytics.getOpenInviteNoteSent({
                    errorMessage: errorMessage,
                    orgId: orgId,
                    responseCode: responseCode
                });
            } finally{
                (0, $91dcab74875d7081$export$afcd850890541869).mark((0, $91dcab74875d7081$export$d90144118191fa45).getOpenInviteNote.endMark);
            }
            setOpenInviteNote(note);
            setIsLoading(false);
        };
        getCustomisedErrorMessage();
    }, [
        analytics,
        isLoading,
        orgId,
        setOpenInviteNote
    ]);
    return {
        isLoading: isLoading,
        openInviteNote: openInviteNote,
        failedGetOpenInviteNote: !isLoading && !!orgId && openInviteNote === undefined
    };
};





const $0d8e43dbda8f0bbf$var$styles = {
    formWrapper: "_195g1wug _kqswh2mm _p12f1j8x",
    descriptionWrapper: "_1moupxbi",
    buttonWrapper: "_2lx21sbv _1n261q9c _otyrpxbi",
    spinnerWrapper: "_1mouxncg _195gxncg _18m91wug",
    headingWrapper: "_1q511ejb _85i5v77o _1bsb1osq _1e0c1txw _1bah1yb4 _4cvr1h6o",
    footer: "_otyr1ejb"
};
const $0d8e43dbda8f0bbf$var$NoInvitePermission = ({ onAcknowledgeButtonClick: onAcknowledgeButtonClick, onCloseButtonClick: onCloseButtonClick })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $d881ec7d603d504e$export$35663e3a57687cac));
    const { jiraSubProduct: jiraSubProduct, orgId: orgId, productId: productId, userRole: userRole } = (0, $9xnOK.useInvitePeopleContext)();
    const { failedGetOpenInviteNote: failedGetOpenInviteNote, isLoading: isFetchingOpenInviteNote, openInviteNote: openInviteNote } = (0, $aee757f8baf0852b$export$2e2bcd8739ae039)(orgId);
    (0, $42omo.useEffect)(()=>{
        (0, $91dcab74875d7081$export$afcd850890541869).addMetadata({
            orgId: orgId,
            userRole: userRole
        });
        (0, $91dcab74875d7081$export$afcd850890541869).start();
    }, [
        orgId,
        userRole
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isFetchingOpenInviteNote) (0, $91dcab74875d7081$export$afcd850890541869).success({
            metadata: {
                orgId: orgId,
                userRole: userRole,
                failedGetOpenInviteNote: failedGetOpenInviteNote
            }
        });
    }, [
        failedGetOpenInviteNote,
        isFetchingOpenInviteNote,
        orgId,
        userRole
    ]);
    (0, $42omo.useEffect)(()=>{
        analytics.viewedNoInvitePermissionScreen();
    }, [
        analytics
    ]);
    const Wrapper = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: "testId-no-invite-permission",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $0d8e43dbda8f0bbf$var$styles.formWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        spread: "space-between",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                            xcss: $0d8e43dbda8f0bbf$var$styles.headingWrapper,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                    as: "h1",
                                    id: "invite-people-title",
                                    size: "medium",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).noInvitePermissionTitle
                                    })
                                }),
                                onCloseButtonClick && /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                                    onClick: onCloseButtonClick
                                })
                            ]
                        })
                    }),
                    children
                ]
            })
        });
    if (isFetchingOpenInviteNote) return /*#__PURE__*/ (0, $l998X.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            alignInline: "center",
            testId: "testId-no-invite-permission-spinner",
            xcss: $0d8e43dbda8f0bbf$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                xcss: $0d8e43dbda8f0bbf$var$styles.descriptionWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $f0b532f818d16e1f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        as: "p",
                        testId: "testId-no-invite-permission-description",
                        children: !!openInviteNote ? openInviteNote : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).defaultNoInvitePermissionDescription,
                            values: {
                                productName: (0, $j9g2s.getProductTitle)(jiraSubProduct || productId)
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $0d8e43dbda8f0bbf$var$styles.footer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    space: "space.100",
                    xcss: $0d8e43dbda8f0bbf$var$styles.buttonWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e7b7940dcdf139c7$export$2e2bcd8739ae039), {
                        actionSubjectId: 'closeNoInvitePermissionButton',
                        appearance: "primary",
                        onClick: onAcknowledgeButtonClick,
                        type: "button",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $c35877e38bf8c63c$export$defe85febe8b728c).noInvitePermissionButtonTitle
                        })
                    })
                })
            })
        ]
    });
};
var $0d8e43dbda8f0bbf$export$2e2bcd8739ae039 = $0d8e43dbda8f0bbf$var$NoInvitePermission;

































class $70200ceff76bf410$var$TwcForCoreInvitesExperimentContextAnalytics extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    twcForCoreInvitesExposed(attributes) {
        const { productTitle: productTitle, source: source, subProduct: subProduct } = this.commonAttributes;
        this.fireTrack({
            action: (0, $5LksM.AnalyticsAction).EXPOSED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).INVITE_PEOPLE_FEATURE,
            actionSubjectId: 'twcForCoreInvites',
            attributes: {
                product: productTitle,
                source: source,
                subProduct: subProduct,
                ...attributes
            }
        });
    }
}
const $70200ceff76bf410$var$collectionsContextValue = {
    collections: {},
    shouldFetchCollections: true
};
const $70200ceff76bf410$export$7767c145cddad4a2 = ({ children: children })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $9xnOK.useInvitePeopleContext)();
    const twcForCoreInvitesCohort = (0, $42omo.useMemo)(()=>{
        if (!(0, $j9g2s.isEnglishLocale)(locale)) return 'not-enrolled';
        return (0, $1f7bcce4a8632612$export$df4f69f663fe2d96)('twc-for-core-invites', 'not-enrolled', true);
    }, [
        locale
    ]);
    const analytics = (0, $2dswi.useAnalytics)($70200ceff76bf410$var$TwcForCoreInvitesExperimentContextAnalytics);
    const hasFired = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        if (!hasFired.current && [
            'variant',
            'control'
        ].includes(twcForCoreInvitesCohort)) {
            hasFired.current = true;
            analytics.twcForCoreInvitesExposed({
                twcForCoreInvitesCohort: twcForCoreInvitesCohort
            });
        }
    }, [
        analytics,
        twcForCoreInvitesCohort
    ]);
    if (twcForCoreInvitesCohort === 'variant') {
        if ((0, $dh538.fg)('core-invites-fetch-collections')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2KIzJ.CollectionsContextState).Provider, {
            value: $70200ceff76bf410$var$collectionsContextValue,
            children: children
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2KIzJ.CollectionsContext), {
            cloudId: cloudId,
            children: children
        });
    }
    return children;
};


const $1b862a838d3b4c0f$var$styles = {
    spinnerWrapper: "_1mouxncg _195gxncg _1tke1lit _18m91wug"
};
const $1b862a838d3b4c0f$var$InvitePeopleContainer = ({ _hasError: _hasError, alignButtons: alignButtons = 'right', cancelButtonLabel: cancelButtonLabel, continueUrl: continueUrl, onInviteCompletedHandler: onInviteCompletedHandler, experimental_formTitleByline: experimental_formTitleByline, experimental_onReopenHandler: experimental_onReopenHandler, formDescription: formDescription, formTitle: formTitle, hideFormHeader: hideFormHeader, showProductSelect: showProductSelect = true, hideCancelButton: hideCancelButton, isInitialLoad: isInitialLoad, maxNumberOfInputs: maxNumberOfInputs = (0, $bTj8C.INVITE_API_MAX_USERS), onCancelHandler: onCancelHandler, onSendHandler: onSendHandler, onSubmit: onSubmit, sendButtonLabel: sendButtonLabel, setIsInitialLoad: setIsInitialLoad, showFlag: showFlag, titleId: titleId, experimental_submitButtonRef: experimental_submitButtonRef, forceLoading: forceLoading, experimental_onInviteeListChangeHandler: experimental_onInviteeListChangeHandler, experimental_featuredUsers: experimental_featuredUsers, experimental_productContext: experimental_productContext, experimental_copyLink: experimental_copyLink, onAdminMenuItemClick: onAdminMenuItemClick })=>{
    const analytics = (0, $2dswi.useAnalytics)((0, $bc2394fc0ac6358f$export$314fcea5dcdb0997));
    const invitePeopleData = (0, $e2fb36e6761bf104$export$458bac823ccb0e85)();
    const { emails: emails, users: users } = (0, $4c3f7cb6ca1e08be$export$ec7b6d9ecf7a2aed)();
    const { disableNoInviteError: disableNoInviteError, isLoading: invitePeopleLoading, source: source, userRole: userRole } = (0, $9xnOK.useInvitePeopleContext)();
    const { availableProductOptions: availableProductOptions, isFetchProductsLoading: isFetchProductsLoading, hasPermissionToInviteOrRequestAccess: hasPermissionToInviteOrRequestAccess, selectedProducts: selectedProducts } = (0, $8efc6a9cd7fde791$export$964e8498268f0fe3)();
    const [isSendingInvitation, setIsSendingInvitation] = (0, $42omo.useState)(false);
    const { isOk: thirdPartyOk, isLoading: isThirdPartyLoading, abortThirdPartyRequests: abortThirdPartyRequests } = (0, $061c9fd816a80862$export$8569d1ff85ba1bfc)();
    const { isLoading: isInfiSpotlightLoading } = (0, $ef288515e67c7cc8$export$cc46799898138921)();
    const { viralSettingsDESEligibleStates: viralSettingsDESEligibleStates, showOpenInvite: showOpenInvite, openInviteEnabled: enableOpenInvite, uniqueEmailDomains: uniqueEmailDomains, setUniqueEmailDomains: setUniqueEmailDomains, isViralSettingsEnabled: isViralSettingsEnabled } = (0, $371c856e822ce028$export$5ab4720aaf50c15c)();
    const [shouldShowSecondarySection, setShouldShowSecondarySection] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).addMetadata({
            source: source,
            thirdPartyEnabled: thirdPartyOk,
            isInitialLoad: isInitialLoad
        });
        if (setIsInitialLoad && isInitialLoad) setIsInitialLoad(false);
    // calling this effect shouldn't depend on changes to `isInitialLoad`
    // eslint-disable-next-line
    }, [
        source,
        thirdPartyOk
    ]);
    (0, $42omo.useEffect)(()=>abortThirdPartyRequests, [
        abortThirdPartyRequests
    ]);
    const onInviteeListChangeCallback = (0, $42omo.useCallback)(()=>{
        if ((0, $07330006f53205cd$export$6bcb65c6ec0ed966)(userRole)) setUniqueEmailDomains((0, $j9g2s.getUniqueEmailDomains)(emails));
        if (users && users.length > 0) setShouldShowSecondarySection(true);
        // Execute the callback passed by the consumer passing the emails as an argument
        experimental_onInviteeListChangeHandler?.(emails);
    }, [
        userRole,
        setUniqueEmailDomains,
        emails,
        users,
        experimental_onInviteeListChangeHandler
    ]);
    const { processDirectAccessSettings: processDirectAccessSettings } = (0, $9902d023e25e43e7$export$2e2bcd8739ae039)({
        viralSettingsDESEligibleStates: viralSettingsDESEligibleStates,
        selectedProducts: selectedProducts,
        isViralSettingsEnabled: isViralSettingsEnabled
    });
    const { processOpenInviteSettings: processOpenInviteSettings } = (0, $8ef8c810757a1f07$export$2e2bcd8739ae039)({
        showOpenInvite: showOpenInvite,
        enableOpenInvite: enableOpenInvite,
        selectedProducts: selectedProducts,
        isViralSettingsEnabled: isViralSettingsEnabled
    });
    const { inviteUsers: inviteUsers } = (0, $8c3fa868372febc1$export$2e2bcd8739ae039)({
        continueUrl: continueUrl,
        onInviteCompletedHandler: onInviteCompletedHandler,
        onReopenHandler: experimental_onReopenHandler
    });
    const getViralSettingsFlags = (0, $84c014bc7edb542b$export$19902b66d8fa0a2c)();
    const [viralSettingsFlags, setViralSettingsFlags] = (0, $42omo.useState)([]);
    const onSubmitCallback = (0, $42omo.useCallback)(async (isSuccessModal, getRecaptchaToken)=>{
        const featuredUsersAnayticsOnSubmit = async ()=>{
            const featuredUsers = await (0, $j9g2s.getFeaturedUsers)(experimental_featuredUsers);
            if (featuredUsers && featuredUsers.length > 0) analytics.featuredUsersInviteSucceeded({
                featuredUsersInvited: featuredUsers?.filter((featuredUser)=>users.some((user)=>user.id && user.id === featuredUser.id || user.email && user.email === featuredUser.email)).length ?? 0,
                totalUsersInvited: users.length
            });
        };
        const inviteSuccessContentOnSubmit = async ()=>{
            const response = await inviteUsers(getRecaptchaToken, true);
            if (response.flags && showFlag) {
                [
                    ...response.flags,
                    ...viralSettingsFlags
                ].forEach(showFlag);
                onSendHandler?.();
            }
        };
        const invitePeopleOnSubmit = async ()=>{
            const openInviteSettingsPromise = processOpenInviteSettings();
            const directAccessSettingsPromise = processDirectAccessSettings();
            const inviteUsersPromise = inviteUsers(getRecaptchaToken, false);
            const response = await Promise.allSettled([
                openInviteSettingsPromise,
                directAccessSettingsPromise,
                inviteUsersPromise
            ]);
            const [openInviteResponse, directAccessSettingsResponse, inviteUsersResponse] = response;
            let flags = [];
            if (openInviteResponse.status === 'fulfilled' && directAccessSettingsResponse.status === 'fulfilled') {
                flags.push(...getViralSettingsFlags((0, $j9g2s.resolveInviteProcessingResponseStatus)(openInviteResponse.value.responseStatus), (0, $j9g2s.resolveInviteProcessingResponseStatus)(directAccessSettingsResponse.value.responseStatus)));
                setViralSettingsFlags([
                    ...flags
                ]);
            }
            if (inviteUsersResponse.status === 'fulfilled' && inviteUsersResponse.value.flags) flags.push(...inviteUsersResponse.value.flags);
            showFlag && flags.forEach(showFlag);
            onSendHandler?.();
            return {
                openInviteResponse: openInviteResponse,
                directAccessSettingsResponse: directAccessSettingsResponse,
                inviteUsersResponse: inviteUsersResponse
            };
        };
        try {
            setIsSendingInvitation(true);
            if (experimental_featuredUsers) await featuredUsersAnayticsOnSubmit();
            const internalOnSubmit = isSuccessModal ? inviteSuccessContentOnSubmit : invitePeopleOnSubmit;
            if (onSubmit && !isSuccessModal) await onSubmit({
                defaultOnSubmit: invitePeopleOnSubmit,
                invitePeopleData: invitePeopleData,
                getRecaptchaToken: getRecaptchaToken,
                traceContext: (0, $lMdlY.getActiveTrace)()
            });
            else await internalOnSubmit();
        } finally{
            setIsSendingInvitation(false);
        }
    }, [
        getViralSettingsFlags,
        viralSettingsFlags,
        invitePeopleData,
        inviteUsers,
        onSendHandler,
        onSubmit,
        processDirectAccessSettings,
        processOpenInviteSettings,
        showFlag,
        analytics,
        experimental_featuredUsers,
        users
    ]);
    const isFormLoading = isThirdPartyLoading || invitePeopleLoading || isFetchProductsLoading || isInfiSpotlightLoading;
    (0, $42omo.useEffect)(()=>{
        if (isFormLoading) (0, $9317b5071d1060b1$export$b62aa2130c86b59b)('inviteFormLoad');
        else {
            (0, $9317b5071d1060b1$export$37c25be427bec097)('inviteFormLoad', (duration, _)=>{
                analytics.inviteFormLoaded(duration, hasPermissionToInviteOrRequestAccess);
            });
            (0, $9317b5071d1060b1$export$37c25be427bec097)('coreInvitesCompleteLoaded', (duration, _)=>{
                analytics.componentCompleteLoaded(duration, hasPermissionToInviteOrRequestAccess);
            });
        }
    }, [
        analytics,
        hasPermissionToInviteOrRequestAccess,
        isFormLoading
    ]);
    const onCancelButtonClick = (0, $42omo.useCallback)(async (isSuccessModal)=>{
        abortThirdPartyRequests();
        if (onCancelHandler) onCancelHandler();
        if (isSuccessModal) showFlag && viralSettingsFlags.forEach(showFlag);
    }, [
        abortThirdPartyRequests,
        onCancelHandler,
        showFlag,
        viralSettingsFlags
    ]);
    const shouldDisplayNoInvitePermissionMessage = !disableNoInviteError && !hasPermissionToInviteOrRequestAccess;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $8ba2c889aa40448c$export$2e2bcd8739ae039), {
        errorCallback: ()=>{
            (0, $91dcab74875d7081$export$2a3414fdbfd8a2af).failure();
        },
        children: [
            isFormLoading || forceLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "center",
                testId: "testId-invite-people-spinner",
                xcss: $1b862a838d3b4c0f$var$styles.spinnerWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
            }) : shouldDisplayNoInvitePermissionMessage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $0d8e43dbda8f0bbf$export$2e2bcd8739ae039), {
                onAcknowledgeButtonClick: onCancelButtonClick,
                onCloseButtonClick: onCancelButtonClick
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $4ea4e20d99ec6988$export$2e2bcd8739ae039), {
                alignButtons: alignButtons,
                cancelButtonLabel: cancelButtonLabel,
                hideCancelButton: hideCancelButton,
                formTitle: formTitle,
                hideFormHeader: hideFormHeader,
                formDescription: formDescription,
                maxNumberOfInputs: maxNumberOfInputs,
                isSendingInvitation: isSendingInvitation,
                onInviteButtonClick: onSubmitCallback,
                onCancelButtonClick: onCancelButtonClick,
                sendButtonLabel: sendButtonLabel,
                productOptions: availableProductOptions,
                onInviteeListChange: onInviteeListChangeCallback,
                showFlag: showFlag,
                showProductSelect: showProductSelect,
                uniqueEmailDomains: uniqueEmailDomains,
                selectedProducts: selectedProducts,
                showSecondarySection: shouldShowSecondarySection,
                titleId: titleId,
                experimental_formTitleByline: experimental_formTitleByline,
                experimental_submitButtonRef: experimental_submitButtonRef,
                experimental_productContext: experimental_productContext,
                experimental_copyLink: experimental_copyLink,
                onAdminMenuItemClick: onAdminMenuItemClick
            }),
            _hasError && /*#__PURE__*/ (0, $l998X.jsx)((0, $j9g2s.Buggy), {}),
            !isFormLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $es0xC.ExperienceSuccess), {
                experience: (0, $91dcab74875d7081$export$2a3414fdbfd8a2af)
            })
        ]
    });
};
const $1b862a838d3b4c0f$var$InvitePeople = (0, $jL3L2.withExperimentalFeatures)((props)=>{
    const { allowEmail: allowEmail, enableThirdParty: enableThirdParty, inviteeProvider: inviteeProvider, onCancelHandler: onCancelHandler, orgId: orgId, plugins: plugins, productOptions: productOptions, resourceAri: resourceAri, showFlag: showFlag, displayInfiSpotlight: displayInfiSpotlight, source: source, subProduct: subProduct, userRole: userRole, viewAs: viewAs, disableViralSettings: disableViralSettings = false, disableNoInviteError: disableNoInviteError = false, onInviteeListFocus: onInviteeListFocus, initialInvitees: initialInvitees, experimental_userPickerByline: experimental_userPickerByline, experimental_featuredUsers: experimental_featuredUsers, experimental_productContext: experimental_productContext, inviteeListLabelText: inviteeListLabelText, inviteeListPlaceholderText: inviteeListPlaceholderText, inviteeListRequired: inviteeListRequired, hideThirdPartyConnectLegend: hideThirdPartyConnectLegend, groupByTypeOrder: groupByTypeOrder, experimental_inlineThirdPartyButtons: experimental_inlineThirdPartyButtons = false } = props;
    (0, $24xEE.useUFOComponentExperience)((0, $91dcab74875d7081$export$2a3414fdbfd8a2af));
    // Disable all third party invites when we are in FedRAMP or Oasis (Isolated Cloud) environment
    let enableThirdPartyProp = (0, $lzcvT.isFedRamp)() || (0, $T9xHm.isIsolatedCloud)() ? false : enableThirdParty;
    (0, $42omo.useEffect)(()=>(0, $9317b5071d1060b1$export$b62aa2130c86b59b)('coreInvitesCompleteLoaded'), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7ece582fc820a8cc$export$1c4ce4f476bc0521), {
        inviteeProvider: inviteeProvider,
        orgId: orgId,
        plugins: plugins,
        resourceAri: resourceAri,
        source: source,
        subProduct: subProduct,
        userRole: userRole,
        viewAs: viewAs,
        disableNoInviteError: disableNoInviteError,
        experimental_featuredUsers: experimental_featuredUsers,
        experimental_inlineThirdPartyButtons: experimental_inlineThirdPartyButtons,
        experimental_productContext: experimental_productContext,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $88f006b3600fe55d$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $061c9fd816a80862$export$7e31acee6ee63234), {
                enableThirdParty: enableThirdPartyProp,
                showFlag: showFlag,
                onCancelButtonClick: onCancelHandler,
                displayInfiSpotlight: displayInfiSpotlight,
                hideThirdPartyConnectLegend: hideThirdPartyConnectLegend,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3c20d8d89926317b$export$b9157093d5c4e7cd), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $70200ceff76bf410$export$7767c145cddad4a2), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8efc6a9cd7fde791$export$e46bb22811a53085), {
                            resourceAri: resourceAri,
                            productOptions: productOptions,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4c3f7cb6ca1e08be$export$6dbd1016efd8086d), {
                                allowEmail: allowEmail,
                                initialInvitees: initialInvitees,
                                experimental_userPickerByline: experimental_userPickerByline,
                                inviteeListLabelText: inviteeListLabelText,
                                inviteeListPlaceholderText: inviteeListPlaceholderText,
                                inviteeListRequired: inviteeListRequired,
                                groupByTypeOrder: groupByTypeOrder,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $371c856e822ce028$export$565fe958259f8ed8), {
                                    disableViralSettings: disableViralSettings,
                                    onInviteeListFocus: onInviteeListFocus,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)($1b862a838d3b4c0f$var$InvitePeopleContainer, {
                                        ...props
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
});
const $1b862a838d3b4c0f$var$analyticsContextData = {
    source: (0, $5LksM.AnalyticsSource).ADD_PEOPLE,
    componentName: 'addPeople'
};
const $1b862a838d3b4c0f$export$9dbc3ab01ac4df16 = (0, $ggbZE.default)($1b862a838d3b4c0f$var$analyticsContextData)($1b862a838d3b4c0f$var$InvitePeople);
var $1b862a838d3b4c0f$export$2e2bcd8739ae039 = $1b862a838d3b4c0f$var$InvitePeople;
module.exports["InvitePeopleWithAnalytics"] = $1b862a838d3b4c0f$export$9dbc3ab01ac4df16;

});

parcelRegister("es0xC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $365762c5ab7d4323$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $42omo.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};
module.exports["ExperienceSuccess"] = $365762c5ab7d4323$export$4962f3898bd5c829;

});

parcelRegister("7oH3p", function(module, exports) {
var $ebd617a0c92966ab$export$8912007324034abd = /*#__PURE__*/ function(Integration) {
    Integration["GOOGLE_SERVICE"] = "google-invites";
    Integration["MICROSOFT_SERVICE"] = "microsoft-invites";
    Integration["PLATFORM_SLACK_SERVICE"] = "slack";
    return Integration;
}({});
var $ebd617a0c92966ab$export$fe404a09c1c6b674 = /*#__PURE__*/ function(ScopeState) {
    ScopeState["NO_SCOPE"] = "no-scope";
    ScopeState["PARTIAL_SCOPE"] = "partial-scope";
    ScopeState["FULL_SCOPE"] = "full-scope";
    return ScopeState;
}({});
module.exports["Integration"] = $ebd617a0c92966ab$export$8912007324034abd;
module.exports["ScopeState"] = $ebd617a0c92966ab$export$fe404a09c1c6b674;

});

parcelRegister("ktS3V", function(module, exports) {

var $3uVVG = parcelRequire("3uVVG");


var $lFI1p = parcelRequire("lFI1p");


var $bGwCT = parcelRequire("bGwCT");


var $7TH2w = parcelRequire("7TH2w");


var $eWRwJ = parcelRequire("eWRwJ");




var $b452f85d8daf41be$var$AnalyticsActionSubject = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["THIRD_PARTY_INTEGRATION"] = "thirdPartyIntegration";
    return AnalyticsActionSubject;
}($b452f85d8daf41be$var$AnalyticsActionSubject || {});
var $b452f85d8daf41be$var$AnalyticsAction = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["CONNECTED"] = "connected";
    return AnalyticsAction;
}($b452f85d8daf41be$var$AnalyticsAction || {});
const $b452f85d8daf41be$export$e36afdcb278d2465 = (createAnalyticsEvent, serviceKey, analyticsChannel = (0, $lFI1p.ANALYTICS_CHANNEL), teamId, eventAttributes)=>{
    const fireEventWithPayload = (0, $eWRwJ.default)(analyticsChannel)({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "thirdPartyIntegration",
        action: "connected",
        attributes: {
            integration: serviceKey,
            teamId: teamId,
            ...eventAttributes
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $b452f85d8daf41be$export$c19a27308ae179b = (createAnalyticsEvent, serviceKey, analyticsChannel = (0, $lFI1p.ANALYTICS_CHANNEL), error, eventAttributes)=>{
    const fireEventWithPayload = (0, $eWRwJ.default)(analyticsChannel)({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "thirdPartyIntegration",
        action: "failed",
        attributes: {
            integration: serviceKey,
            errorType: error ? error.type : undefined,
            ...eventAttributes
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};


const $5abd071dc4475982$var$exusThirdPartyUrl = (path)=>`${0, $lFI1p.DEFAULT_STARGATE_SERVICE_URL}${0, $lFI1p.EXUS_THIRDPARTY_PATH}/${path}`;
const $5abd071dc4475982$var$exusOrgsUrl = (path)=>`${0, $lFI1p.DEFAULT_STARGATE_SERVICE_URL}${0, $lFI1p.EXUS_ORGS_PATH}/${path}`;
const $5abd071dc4475982$export$49def98438208aa5 = async (cloudId, shouldRetry = false)=>{
    const maxAttempts = shouldRetry ? (0, $lFI1p.INTEGRATIONS_FETCH_RETRIES_COUNT) : 0;
    const queryString = new URLSearchParams({
        cloudId: cloudId
    });
    const fetchUrl = $5abd071dc4475982$var$exusThirdPartyUrl((0, $lFI1p.INTEGRATIONS_PATH));
    const result = await (0, $bGwCT.retryFetch)({
        request: ()=>fetch(`${fetchUrl}?${queryString}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }),
        canRetryCheck: (0, $bGwCT.httpRetryPolicy)({
            maxAttempts: maxAttempts
        })
    });
    if (result.ok) return result.result;
    else if (!result.aborted) throw new (0, $bGwCT.FetchError)(`Unable to fetch integrations, status: ${result.code} text: ${result.message}`, result.status);
};
const $5abd071dc4475982$export$8f22789f6b8c44c4 = (serviceKey, analytics, callback)=>{
    const url = $5abd071dc4475982$var$exusThirdPartyUrl(`connect?serviceKey=${serviceKey}`);
    const windowLeft = window.screen.width / 2 - (0, $lFI1p.WINDOW_WIDTH) / 2;
    const windowTop = window.screen.height / 2 - (0, $lFI1p.WINDOW_HEIGHT) / 2;
    const options = `menubar, width=${(0, $lFI1p.WINDOW_WIDTH)}, height=${(0, $lFI1p.WINDOW_HEIGHT)}, top=${windowTop}, left=${windowLeft}`;
    (0, $3uVVG.auth)(url, options).then(()=>{
        (0, $b452f85d8daf41be$export$e36afdcb278d2465)(analytics.createAnalyticsEvent, serviceKey, analytics.analyticsChannel, analytics.teamId, analytics.attributes);
        callback?.(true);
    }).catch((error)=>{
        (0, $b452f85d8daf41be$export$c19a27308ae179b)(analytics.createAnalyticsEvent, serviceKey, analytics.analyticsChannel, error, analytics.attributes);
        callback?.(false, error);
    });
};
const $5abd071dc4475982$export$d76128d007d19019 = async (query, cloudId)=>{
    const queryString = new URLSearchParams({
        query: query,
        cloudId: cloudId
    });
    const fetchUrl = $5abd071dc4475982$var$exusThirdPartyUrl(`search?${queryString}`);
    const resp = await (0, $bGwCT.fetchJson)(fetchUrl, (0, $lFI1p.SEARCH_ACTION));
    return resp.map((d)=>{
        return {
            id: d.email,
            email: d.email,
            name: d.displayName,
            publicName: d.displayName,
            avatarUrl: d.avatarUrl,
            type: 'external_user',
            isExternal: true,
            sources: d.sources.map((s)=>s.toLowerCase())
        };
    });
};
const $5abd071dc4475982$export$a9cfb3d0ddea2a6c = async (orgId)=>{
    const fetchUrl = $5abd071dc4475982$var$exusOrgsUrl(`${orgId}/settings`);
    return (0, $bGwCT.fetchJson)(fetchUrl, (0, $lFI1p.ORG_SETTINGS_ACTION));
};
module.exports["fetchExistingIntegrations"] = $5abd071dc4475982$export$49def98438208aa5;
module.exports["search"] = $5abd071dc4475982$export$d76128d007d19019;
module.exports["fetchOrgSettings"] = $5abd071dc4475982$export$a9cfb3d0ddea2a6c;

});

parcelRegister("dWfpn", function(module, exports) {

let $a25ca4ef2e9cc770$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a25ca4ef2e9cc770$var$load("7oczk").then(()=>parcelRequire('6jaKQ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("kSuk0", function(module, exports) {

let $f3305f074d70a305$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3305f074d70a305$var$load("e2gl6").then(()=>parcelRequire('bCdvh'));

});

parcelRegister("dWGY6", function(module, exports) {

let $a27205c0d151d0a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a27205c0d151d0a2$var$load("9oo3s").then(()=>parcelRequire('1QKar'));

});

parcelRegister("7KS9L", function(module, exports) {

let $5a56d6a2f4b421bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a56d6a2f4b421bb$var$load("fP9up").then(()=>parcelRequire('7czmZ'));

});

parcelRegister("5MxVp", function(module, exports) {

let $435bc03bef9f6d86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $435bc03bef9f6d86$var$load("hc0i6").then(()=>parcelRequire('6uRAk'));

});

parcelRegister("2WGuF", function(module, exports) {

let $2251f5e5485c83b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2251f5e5485c83b7$var$load("15E48").then(()=>parcelRequire('3vpcy'));

});

parcelRegister("9Mnao", function(module, exports) {

let $71ea912895f65c4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71ea912895f65c4c$var$load("1ZyUV").then(()=>parcelRequire('jMHtk'));

});

parcelRegister("1HQPB", function(module, exports) {

let $13e2c9ceaa3c5b37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $13e2c9ceaa3c5b37$var$load("6tijD").then(()=>parcelRequire('dhjV2'));

});

parcelRegister("fc7zv", function(module, exports) {

let $b0fdd99812a8b7f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b0fdd99812a8b7f2$var$load("6fkVy").then(()=>parcelRequire('kmk42'));

});

parcelRegister("hYpMd", function(module, exports) {

let $d15c08f47eb02b31$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d15c08f47eb02b31$var$load("5nw5x").then(()=>parcelRequire('jCgZH'));

});

parcelRegister("aGqhs", function(module, exports) {

let $7c72366785ad0691$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c72366785ad0691$var$load("jK12s").then(()=>parcelRequire('dR5Vp'));

});

parcelRegister("l3BdI", function(module, exports) {

let $f546bff01d7a4100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f546bff01d7a4100$var$load("6lWvL").then(()=>parcelRequire('qyPeA'));

});

parcelRegister("ybArY", function(module, exports) {

let $066c2a0248caef6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $066c2a0248caef6e$var$load("kk9To").then(()=>parcelRequire('iDNMw'));

});

parcelRegister("6BggT", function(module, exports) {

let $4ce2d1fa69a87626$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ce2d1fa69a87626$var$load("lyt83").then(()=>parcelRequire('03ctk'));

});

parcelRegister("4ODkP", function(module, exports) {

let $381a5803a66198a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $381a5803a66198a6$var$load("2uvfp").then(()=>parcelRequire('ihPIs'));

});

parcelRegister("6hwtI", function(module, exports) {

let $492d861b6dde9969$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $492d861b6dde9969$var$load("4Wx8B").then(()=>parcelRequire('7icLO'));

});

parcelRegister("luiUS", function(module, exports) {

let $fa4b12bbcf94d4bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa4b12bbcf94d4bc$var$load("huTg5").then(()=>parcelRequire('2ywPV'));

});

parcelRegister("agjg3", function(module, exports) {

let $778a5641c3f02064$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $778a5641c3f02064$var$load("fPfEd").then(()=>parcelRequire('UCSZY'));

});

parcelRegister("6qFHP", function(module, exports) {

let $4ae585b6478b4ecb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ae585b6478b4ecb$var$load("fTYhL").then(()=>parcelRequire('fDUiS'));

});

parcelRegister("kULMA", function(module, exports) {

let $f39e1a4371c155f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f39e1a4371c155f3$var$load("dVHhf").then(()=>parcelRequire('4jCEq'));

});

parcelRegister("kI4CZ", function(module, exports) {

let $f13b81b1db98fc30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f13b81b1db98fc30$var$load("2SsCI").then(()=>parcelRequire('54J5r'));

});

parcelRegister("6KIqT", function(module, exports) {

let $4ea98161e486a4c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ea98161e486a4c8$var$load("kVi5E").then(()=>parcelRequire('fIzY1'));

});

parcelRegister("2cUSM", function(module, exports) {

let $19b8d36fe574d127$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19b8d36fe574d127$var$load("6HoYh").then(()=>parcelRequire('9w9df'));

});

parcelRegister("gJFmv", function(module, exports) {

let $c2f0eef56a61ae22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2f0eef56a61ae22$var$load("kOAvl").then(()=>parcelRequire('7HDKc'));

});

parcelRegister("eq9aJ", function(module, exports) {

let $a7fa9bc8e0ad992e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7fa9bc8e0ad992e$var$load("5ErHy").then(()=>parcelRequire('5eKpq'));

});

parcelRegister("eDwao", function(module, exports) {

let $aa7da8d928f854c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa7da8d928f854c8$var$load("jJzpI").then(()=>parcelRequire('gBIBz'));

});

parcelRegister("aOkbU", function(module, exports) {

let $7dee3c6737a46517$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7dee3c6737a46517$var$load("2PvRH").then(()=>parcelRequire('7Ekxw'));

});

parcelRegister("aEYmR", function(module, exports) {

let $7c2c77909c5a4278$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c2c77909c5a4278$var$load("eUGjU").then(()=>parcelRequire('FLgrK'));

});

parcelRegister("d1Xwc", function(module, exports) {

let $97c9897064d4bfe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97c9897064d4bfe5$var$load("drbCf").then(()=>parcelRequire('ajoLB'));

});

parcelRegister("8nrbV", function(module, exports) {

let $6195905a66187afe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6195905a66187afe$var$load("5dk6T").then(()=>parcelRequire('jC8gw'));

});

parcelRegister("7Ivrq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5effbc078ecd6d0$export$2e2bcd8739ae039);
var $c5effbc078ecd6d0$export$2e2bcd8739ae039 = `data:image/png;base64,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`;

});

parcelRegister("kTfQt", function(module, exports) {

let $f3553c3c52953eea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3553c3c52953eea$var$load("7pAFt").then(()=>parcelRequire('76TSf'));

});

parcelRegister("bTj8C", function(module, exports) {

var $5LksM = parcelRequire("5LksM");


var $7GQiN = parcelRequire("7GQiN");


var $j9g2s = parcelRequire("j9g2s");


var $5YNlj = parcelRequire("5YNlj");


var $2KIzJ = parcelRequire("2KIzJ");

const $8cb8f05ca2f4f447$var$LICENCE_EXCEEDED_ARI_REGEX = /(\[ari:.*?)(\/.*)(\])/;
const $8cb8f05ca2f4f447$export$d42990f9794abc1 = 10;
class $8cb8f05ca2f4f447$export$72a09965ba18562f {
    // only emails are supported for invites - VULN-1024816
    async inviteUsers(request, recaptchaOptions) {
        return this.inviteUsersCommon(request, (0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL) + (0, $7GQiN.BULK_INVITE_URL), recaptchaOptions);
    }
    // support both aaid and emails, users have to be in the same org, using v3/invitations/invite
    async inviteUsersV3(request, recaptchaOptions) {
        return this.inviteUsersCommon(request, (0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL) + (0, $7GQiN.BULK_INVITE_URL_V3), recaptchaOptions);
    }
    async inviteUsersCommon(request, url, recaptchaOptions) {
        try {
            const inviteApiResponse = await (0, $5YNlj.postJson)(url, 'inviteUsers', request, recaptchaOptions);
            return this.handleInviteUsersSuccessResponse(inviteApiResponse);
        } catch (err) {
            if (err instanceof (0, $5YNlj.FetchError)) {
                const inviteApiResponse = err.responseJson;
                if (inviteApiResponse) {
                    const failureResponse = {
                        status: err.responseCode,
                        ...inviteApiResponse
                    };
                    return this.handleInviteUsersFailureResponse(failureResponse);
                }
            }
            throw err;
        }
    }
    async inviteCapabilities(cloudId) {
        const resource = `ari:cloud:platform::site/${cloudId}`;
        const url = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.INVITE_CAPABILITIES)}?resource=${resource}`;
        const capabilitiesResponse = await (0, $5YNlj.fetchJson)(url, 'inviteCapabilities');
        return this.handleCapabilitiesResponse(capabilitiesResponse);
    }
    handleCapabilitiesResponse(response) {
        const directInvite = {};
        const invitePendingApproval = new Set();
        if (Array.isArray(response)) response.forEach((entry)=>{
            if ('NONE' !== entry.directInvite.mode) directInvite[entry.resourceARI] = entry.directInvite.domains;
            if (!invitePendingApproval.has(entry.resourceARI) && 'NONE' !== entry.invitePendingApproval.mode) invitePendingApproval.add(entry.resourceARI);
        });
        return {
            directInvite: this.getProductDetailsWithDomains(directInvite),
            invitePendingApproval: this.getProductDetails(Array.from(invitePendingApproval))
        };
    }
    cleanErrorMessage(message) {
        // Remove AIDs from ARIs in error messages to better group in logs
        // - Licence Exceeded for resources:[ari:cloud:confluence::site/aaaaaaaa-64d4-469e-91df-bbbbbbbbbbbb]
        return message ? message.replace($8cb8f05ca2f4f447$var$LICENCE_EXCEEDED_ARI_REGEX, '$1$3') : '';
    }
    handleInviteUsersFailureResponse(errorResponse) {
        return {
            failure: {
                ...errorResponse,
                message: this.cleanErrorMessage(errorResponse.message)
            }
        };
    }
    hasUser(users, invitedUser) {
        return users.some((user)=>(0, $5LksM.isUserWithEmail)(user) && (0, $5LksM.isUserWithEmail)(invitedUser) && user.email === invitedUser.email || user.id === invitedUser.id);
    }
    handleInviteUsersSuccessResponse(response) {
        return response.reduce((accumulator, userResponse)=>{
            const user = (0, $5LksM.isUserWithEmail)(userResponse) ? {
                id: userResponse.id,
                email: userResponse.email
            } : {
                id: userResponse.id
            };
            Object.keys(userResponse.results).forEach((resource)=>{
                switch(userResponse.results[resource]){
                    case 'INVITED':
                    case 'USER_EXISTS':
                        if (!this.hasUser(accumulator.invited, user)) accumulator.invited.push({
                            ...user,
                            results: userResponse.results
                        });
                        break;
                    case 'INVITED_PENDING_APPROVAL':
                    case 'PENDING_INVITE_EXISTS':
                        if (!this.hasUser(accumulator.accessRequested, user)) accumulator.accessRequested.push({
                            ...user,
                            results: userResponse.results
                        });
                        break;
                    case 'NOT_INVITED':
                    case 'ERROR':
                        accumulator.error.push({
                            ...user,
                            error: userResponse.errorReasons[resource]
                        });
                        break;
                }
            });
            return accumulator;
        }, {
            invited: [],
            accessRequested: [],
            error: []
        });
    }
    async updateDirectAccessSettings({ product: product, cloudId: cloudId, location: location, domains: domains }) {
        const resource = `ari:cloud:${product}::site/${cloudId}`;
        const url = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.DIRECT_ACCESS_URL)}`;
        const request = {
            resource: resource,
            domains: domains,
            location: location,
            action: 'ACCEPT',
            setting: 'DIRECT_ACCESS'
        };
        await (0, $5YNlj.postRequest)(url, 'updateDirectAccessSettings', request);
        return {
            success: true,
            updateDirectAccessSettings: true
        };
    }
    async getDirectAccessSetting(request) {
        const performFetch = ()=>{
            const url = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.DIRECT_ACCESS_URL)}`;
            const queryParams = `resource=${request.productAri}&domain=${request.domain}&setting=${request.setting}${request.roleAri ? '&role=' + request.roleAri : ''}`;
            return (0, $5YNlj.fetchJson)(`${url}?${queryParams}`, 'getDirectAccessSetting');
        };
        const cacheValue = this.directAccessSettingsCache.get(request.domain);
        if (cacheValue) return {
            response: cacheValue,
            cached: true
        };
        try {
            const responseJson = await performFetch();
            (0, $j9g2s.tryCacheWithClear)(this.directAccessSettingsCache, request.domain, responseJson);
            return {
                response: responseJson,
                cached: false
            };
        } catch (err) {
            const { responseCode: responseCode, errorMessage: errorMessage } = (0, $j9g2s.resolveError)(err);
            if (responseCode && responseCode >= (0, $5YNlj.RespCodes).BAD_REQUESTS && responseCode <= (0, $5YNlj.RespCodes).CLIENT_CLOSED_REQUEST) {
                const failResponseJson = {
                    domain: request.domain,
                    errorMessage: errorMessage
                };
                (0, $j9g2s.tryCacheWithClear)(this.directAccessSettingsCache, request.domain, failResponseJson);
            }
            throw err;
        }
    }
    async getCollections({ cloudId: cloudId }) {
        const url = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.GRAPHQL_GATEWAY_URL)}`;
        const collectionsResponse = await (0, $5YNlj.fetchJson)(url, 'collections', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                query: (0, $2KIzJ.entitlementsQuery),
                variables: {
                    cloudId: cloudId,
                    skip: false
                }
            })
        });
        const hasTeamworkCollection = (0, $2KIzJ.getHasTeamworkCollection)(collectionsResponse.data);
        return {
            [(0, $5LksM.CollectionType).TEAMWORK_COLLECTION]: {
                isEnabled: hasTeamworkCollection,
                products: hasTeamworkCollection ? (0, $2KIzJ.twcProductKeys) : []
            }
        };
    }
    constructor(){
        this.directAccessSettingsCache = void 0;
        this.clearDESCache = ()=>{
            this.directAccessSettingsCache.clear();
        };
        this.getProductDetails = (productArray)=>productArray.map((p)=>({
                    name: (0, $j9g2s.getProductTitleFromAri)(p),
                    id: (0, $j9g2s.getProductIdFromResource)(p) || '',
                    ari: p
                }));
        this.getProductDetailsWithDomains = (productRecord)=>Object.keys(productRecord).map((p)=>({
                    name: (0, $j9g2s.getProductTitleFromAri)(p),
                    id: (0, $j9g2s.getProductIdFromResource)(p) || '',
                    ari: p,
                    domains: productRecord[p]
                }));
        this.directAccessSettingsCache = new Map();
    }
}
module.exports["INVITE_API_MAX_USERS"] = $8cb8f05ca2f4f447$export$d42990f9794abc1;
module.exports["InviteApiClientImpl"] = $8cb8f05ca2f4f447$export$72a09965ba18562f;

});

parcelRegister("2dswi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9xnOK = parcelRequire("9xnOK");


var $hbgPG = parcelRequire("hbgPG");


var $eWRwJ = parcelRequire("eWRwJ");


var $2huiC = parcelRequire("2huiC");

const $ec45a436a1859893$var$createAndFireEventOnPeopleTeams = (0, $eWRwJ.default)((0, $2huiC.ANALYTICS_CHANNEL));
const $ec45a436a1859893$export$c7d191551feb734 = (payload, createAnalyticsEvent)=>{
    const fire = $ec45a436a1859893$var$createAndFireEventOnPeopleTeams(payload);
    fire(createAnalyticsEvent);
};


const $9874e7f6acb0573b$export$e955abb82869dc84 = (AnalyticsClass)=>$9874e7f6acb0573b$export$961614c2c20d5679(AnalyticsClass, (0, $hbgPG.useCommonAttributesFrom)((0, $9xnOK.useInvitePeopleContext)()));
const $9874e7f6acb0573b$export$961614c2c20d5679 = (AnalyticsClass, commonAttributes)=>{
    const { fireAnalytics: fireAnalytics } = $9874e7f6acb0573b$var$useFireInvitePeopleAnalytics();
    // Why ref and .setCommonAttributes?
    // We want to keep returning the same instance even if attributes change,
    // as many data fetching effects depend on analytics.
    // Attributes can still change, e.g. if they are loaded asynchronously.
    const attributesRef = (0, $42omo.useRef)();
    attributesRef.current = commonAttributes;
    const memoizedInstance = (0, $42omo.useMemo)(()=>new AnalyticsClass(fireAnalytics, attributesRef.current), [
        AnalyticsClass,
        fireAnalytics
    ]);
    // Ensures events get the newest attributes when fired,
    // even if attributes changed after the instance was created.
    memoizedInstance.setCommonAttributes(attributesRef.current);
    return memoizedInstance;
};
const $9874e7f6acb0573b$var$useFireInvitePeopleAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useMemo)(()=>({
            fireAnalytics: (eventPayload)=>(0, $ec45a436a1859893$export$c7d191551feb734)(eventPayload, createAnalyticsEvent)
        }), [
        createAnalyticsEvent
    ]);
};
module.exports["useAnalytics"] = $9874e7f6acb0573b$export$e955abb82869dc84;
module.exports["useAnalyticsWithAttributes"] = $9874e7f6acb0573b$export$961614c2c20d5679;

});

parcelRegister("7XlxB", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");

class $667ad748cce3b144$export$8575d6a2e31b2c24 {
    setCommonAttributes(attributes) {
        this.commonAttributes = attributes;
    }
    fireUI(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $7TH2w.UI_EVENT_TYPE)
        });
    }
    fireTrack(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $7TH2w.TRACK_EVENT_TYPE)
        });
    }
    fireOperational(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE)
        });
    }
    fireScreen(payload) {
        this.fireAnalytics({
            ...payload,
            eventType: (0, $7TH2w.SCREEN_EVENT_TYPE)
        });
    }
    constructor(fireAnalytics, attributes){
        this.fireAnalytics = void 0;
        this.commonAttributes = void 0;
        this.fireAnalytics = fireAnalytics;
        this.setCommonAttributes(attributes);
    }
}
module.exports["BaseInvitePeopleAnalytics"] = $667ad748cce3b144$export$8575d6a2e31b2c24;

});

parcelRegister("9xnOK", function(module, exports) {
/**
 * This file is needed to avoid a circular dependency between two modules:
 * InvitePeopleContext and analytics (which causes a runtime error in Webpack).
 *
 * `useAnalytics()` grabs common attributes from `InvitePeopleContext`,
 * but `InvitePeopleContext` needs to fire analytics after fetching some data.
 *
 * This file can be imported by both modules, with analytics conditionally using
 * the raw InvitePeopleStateContext.
 */ 
var $42omo = parcelRequire("42omo");

const $f1d45a7b87f4c7b3$export$985ff699ae420a62 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $f1d45a7b87f4c7b3$export$6e1f061d7f85285a = ()=>{
    const state = (0, $42omo.useContext)($f1d45a7b87f4c7b3$export$985ff699ae420a62);
    if (state === undefined) throw new Error('useInvitePeopleContext must be used within a InvitePeopleStateContextProvider');
    return state;
};
module.exports["InvitePeopleStateContext"] = $f1d45a7b87f4c7b3$export$985ff699ae420a62;
module.exports["useInvitePeopleContext"] = $f1d45a7b87f4c7b3$export$6e1f061d7f85285a;

});

parcelRegister("hbgPG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jL3L2 = parcelRequire("jL3L2");

const $4eec5f40d7dfc2cc$export$b25016f1558e7ae4 = (invitePeopleState)=>{
    const experimentalFeatures = (0, $jL3L2.useExperimentalFeatures)();
    return (0, $42omo.useMemo)(()=>$4eec5f40d7dfc2cc$export$867943f6176417e3(invitePeopleState, experimentalFeatures), [
        invitePeopleState,
        experimentalFeatures
    ]);
};
const $4eec5f40d7dfc2cc$export$867943f6176417e3 = (invitePeopleState, experimentalFeatures)=>{
    const { userEmail: userEmail, loggedInEmailDomain: loggedInEmailDomain, ...invitePeopleStateFiltered } = invitePeopleState;
    return {
        ...invitePeopleStateFiltered,
        experimentalFeatures: experimentalFeatures
    };
};
module.exports["useCommonAttributesFrom"] = $4eec5f40d7dfc2cc$export$b25016f1558e7ae4;

});

parcelRegister("2vYoS", function(module, exports) {

var $7GQiN = parcelRequire("7GQiN");


var $j9g2s = parcelRequire("j9g2s");


var $5YNlj = parcelRequire("5YNlj");

const $8e06334fd8b5531b$var$OPEN_INVITE_TYPE = 'open-invite';
const $8e06334fd8b5531b$var$DOMAIN_TYPE = 'domain';
const $8e06334fd8b5531b$export$fe791c4fa892e400 = 'viral-options-default-to-checked';
const $8e06334fd8b5531b$export$7d8a8798453c33f0 = (product, cloudId, domain)=>{
    return `${cloudId}-${product}-${$8e06334fd8b5531b$export$fe791c4fa892e400}-${$8e06334fd8b5531b$var$DOMAIN_TYPE}-${domain}`;
};
const $8e06334fd8b5531b$export$3e2b0be751a9f82e = (product, cloudId)=>{
    return `${cloudId}-${product}-${$8e06334fd8b5531b$export$fe791c4fa892e400}-${$8e06334fd8b5531b$var$OPEN_INVITE_TYPE}`;
};
class $8e06334fd8b5531b$export$7167d21e29807887 {
    async getFlag(flagKey) {
        const cacheValue = this.flagsCache.get(flagKey);
        if (cacheValue) return {
            response: cacheValue,
            cached: true
        };
        const path = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.HAVE_I_SEEN_IT_URL)}?flagKey=${flagKey}`;
        const response = await (0, $5YNlj.fetchJson)(path, 'getFlagHISI');
        (0, $j9g2s.tryCacheWithClear)(this.flagsCache, flagKey, response, 50);
        const returnValue = {
            response: response,
            cached: false
        };
        return returnValue;
    }
    async postFlag(flagKey) {
        const path = `${(0, $7GQiN.DEFAULT_STARGATE_SERVICE_URL)}${(0, $7GQiN.HAVE_I_SEEN_IT_URL)}`;
        await (0, $5YNlj.postRequest)(path, 'postFlagHISI', {
            flagKey: flagKey
        });
        this.flagsCache.set(flagKey, {
            status: true,
            lastSeenDate: new Date().toISOString()
        });
    }
    constructor(){
        this.flagsCache = void 0;
        this.clearCache = ()=>{
            this.flagsCache.clear();
        };
        this.flagsCache = new Map();
    }
}
module.exports["createHISIDomainFlagKey"] = $8e06334fd8b5531b$export$7d8a8798453c33f0;
module.exports["createHISIOpenInviteFlagKey"] = $8e06334fd8b5531b$export$3e2b0be751a9f82e;
module.exports["HaveISeenItClient"] = $8e06334fd8b5531b$export$7167d21e29807887;

});

parcelRegister("5LksM", function(module, exports) {

var $7oH3p = parcelRequire("7oH3p");

var $96cbadf73c7b2e85$export$84ac6743b4a854ba = /*#__PURE__*/ function(InviteProcessingResponseStatus) {
    InviteProcessingResponseStatus["SUCCESS"] = "success";
    InviteProcessingResponseStatus["ERROR"] = "error";
    InviteProcessingResponseStatus["SKIPPED"] = "skipped";
    return InviteProcessingResponseStatus;
}({});
const $96cbadf73c7b2e85$export$e69af2c4378638a2 = 'FREE_EDITION';
const $96cbadf73c7b2e85$export$7bc7dd5faba7ad6b = 'STANDARD_EDITION';
const $96cbadf73c7b2e85$export$3fd0bbb8c68dc4c7 = 'PREMIUM_EDITION';
const $96cbadf73c7b2e85$export$5747d23113da6aa6 = 'UNLICENSED';
const $96cbadf73c7b2e85$export$df995a7dd740d05d = 'basic';
const $96cbadf73c7b2e85$export$f0687e90ca148638 = 'admin';
const $96cbadf73c7b2e85$export$22ffbac394665747 = 'trusted';
var $96cbadf73c7b2e85$export$e5ad17c39dfb6a42 = /*#__PURE__*/ function(IneligibilityReasons) {
    IneligibilityReasons["ERROR"] = "error";
    IneligibilityReasons["NON_ENGLISH"] = "non-english";
    IneligibilityReasons["NOT_ADMIN_USER"] = "not-admin-user";
    IneligibilityReasons["EDITION_NOT_FREE"] = "edition-not-free";
    IneligibilityReasons["NOT_HAMS"] = "not-hams";
    IneligibilityReasons["NO_COMMERCE_INFO"] = "no-commerce-info";
    IneligibilityReasons["NO_ELIGIBLE_USERS"] = "no-eligible-users";
    IneligibilityReasons["CONFLUENCE_BEFORE_JIRA"] = "confluence-before-jira";
    return IneligibilityReasons;
}({});
var $96cbadf73c7b2e85$export$7ba6a2f178cbf902 = /*#__PURE__*/ function(CollectionType) {
    CollectionType["TEAMWORK_COLLECTION"] = "TEAMWORK_COLLECTION";
    return CollectionType;
}({});
const $96cbadf73c7b2e85$export$d920ab469024b0a2 = (user)=>{
    // our usage involves Array<InvitedUser> and it could be an empty array,
    // which may result user to be undefined
    // See noUncheckedIndexedAccess in Typescript for details
    if (user && user.email) return true;
    return false;
};
const $96cbadf73c7b2e85$export$1f2663aaa83f036d = 'Failed to fetch';
const $96cbadf73c7b2e85$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $96cbadf73c7b2e85$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $96cbadf73c7b2e85$export$74522527b7af776f = 'getDesPromotionEligibleDomain.arg0.domainAri: a valid domain is required';
const $96cbadf73c7b2e85$export$dfe34f0e34543417 = 'Invalid domain';
const $96cbadf73c7b2e85$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $96cbadf73c7b2e85$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $96cbadf73c7b2e85$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $96cbadf73c7b2e85$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $96cbadf73c7b2e85$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $96cbadf73c7b2e85$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $96cbadf73c7b2e85$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $96cbadf73c7b2e85$export$e089e1d2018847da = 'Default group for the requested resource not found.';
var $96cbadf73c7b2e85$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ELIGIBILITY"] = "eligibility";
    AnalyticsActionSubject["INVITE_FORM"] = "inviteForm";
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["USER"] = "user";
    AnalyticsActionSubject["PRODUCT_ACCESS"] = "productAccess";
    AnalyticsActionSubject["INVITE"] = "invite";
    AnalyticsActionSubject["INVITE_REQUEST"] = "inviteRequest";
    AnalyticsActionSubject["SLO_INVITE_REQUEST"] = "sloInviteRequest";
    AnalyticsActionSubject["SLO_THIRD_PARTY_INIT"] = "sloThirdPartyInit";
    AnalyticsActionSubject["THIRD_PARTY_INIT"] = "thirdPartyInit";
    AnalyticsActionSubject["LINK"] = "link";
    AnalyticsActionSubject["BUTTON"] = "button";
    AnalyticsActionSubject["PERMS"] = "permissions";
    AnalyticsActionSubject["INVITE_CAPABILITIES"] = "inviteCapabilities";
    AnalyticsActionSubject["INVITE_PEOPLE_FEATURE"] = "feature";
    AnalyticsActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    AnalyticsActionSubject["DROPDOWN"] = "dropdown";
    AnalyticsActionSubject["INVITEE_LIST"] = "inviteeList";
    AnalyticsActionSubject["INVITEE_LIST_ITEM"] = "inviteeListItem";
    AnalyticsActionSubject["INVITEE_LIST_ITEM_USER_PICKER"] = "inviteeListItemUserPicker";
    AnalyticsActionSubject["USER_PICKER"] = "userPicker";
    AnalyticsActionSubject["CHECKBOX"] = "checkbox";
    AnalyticsActionSubject["SETTINGS"] = "settings";
    AnalyticsActionSubject["MODAL"] = "modal";
    AnalyticsActionSubject["THIRD_PARTY_INVITES"] = "thirdPartyInvites";
    AnalyticsActionSubject["THIRD_PARTY_INTEGRATION"] = "thirdPartyIntegration";
    AnalyticsActionSubject["THIRD_PARTY_INTEGRATIONS"] = "thirdPartyIntegrations";
    AnalyticsActionSubject["EMAIL_INPUT"] = "emailInput";
    AnalyticsActionSubject["GET_USER_INVITES_SETTINGS"] = "getUserInvitesSettings";
    AnalyticsActionSubject["GET_DIRECT_ACCESS_SETTING"] = "getDirectAccessSetting";
    AnalyticsActionSubject["APPROVED_DOMAIN_SETTINGS"] = "approvedDomainsSettings";
    AnalyticsActionSubject["USER_INVITE_SETTINGS"] = "userInvitesSettings";
    AnalyticsActionSubject["SLO_GET_USER_INVITES_SETTINGS"] = "sloGetUserInvitesSettings";
    AnalyticsActionSubject["SLO_GET_DIRECT_ACCESS_SETTING"] = "sloGetDirectAccessSetting";
    AnalyticsActionSubject["SLO_APPROVED_DOMAIN_SETTINGS"] = "sloApprovedDomainsSettings";
    AnalyticsActionSubject["SLO_USER_INVITE_SETTINGS"] = "sloUserInvitesSettings";
    AnalyticsActionSubject["CORE_INVITE_COMPONENT"] = "coreInviteComponent";
    AnalyticsActionSubject["USER_INVITE_SETTINGS_HISI"] = "userInvitesSettingsHISI";
    AnalyticsActionSubject["SLACK_WORKSPACES"] = "slackWorkspaces";
    AnalyticsActionSubject["ACCOUNT_INFO"] = "accountInfo";
    AnalyticsActionSubject["FETCH_EXISTING_INTEGRATIONS"] = "fetchExistingIntegrations";
    AnalyticsActionSubject["FETCH_ORG_SETTINGS"] = "fetchOrgSettings";
    AnalyticsActionSubject["VALIDATION"] = "validation";
    AnalyticsActionSubject["TEAM_MEMBER_PICKER"] = "teamMemberPicker";
    AnalyticsActionSubject["TEAM_OR_USER_PICKER"] = "teamOrUserPicker";
    AnalyticsActionSubject["SLACK_CHANNEL"] = "slackChannel";
    AnalyticsActionSubject["SLACK_USER"] = "slackUser";
    AnalyticsActionSubject["GET_SLACK_CHANNELS"] = "getSlackChannels";
    AnalyticsActionSubject["VIEW_SLACK_TEAM_MEMBERS"] = "viewSlackTeamMembers";
    AnalyticsActionSubject["NO_INVITE_PERMOISSION_SCREEN"] = "noInvitePermissionScreen";
    AnalyticsActionSubject["FETCH_LINKED_ORG"] = "fetchLinkedOrg";
    AnalyticsActionSubject["FETCH_OPEN_INVITE_NOTE"] = "fetchOpenInviteNote";
    AnalyticsActionSubject["TRANSLATION_MESSAGE"] = "translationMessage";
    AnalyticsActionSubject["INFI_SPOTLIGHT"] = "infiSpotlight";
    AnalyticsActionSubject["SET_USER_AS_ADMIN"] = "setUserAsAdmin";
    AnalyticsActionSubject["FETCH_COMMERCE_INFO"] = "fetchCommerceInfo";
    AnalyticsActionSubject["TEAM_INVITES"] = "teamInvites";
    AnalyticsActionSubject["FETCH_ELIGIBLE_USERS"] = "fetchEligibleUsers";
    AnalyticsActionSubject["DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL"] = "driveMultiProductsSuccessModal";
    AnalyticsActionSubject["PRODUCT_CHECKBOX"] = "productCheckbox";
    AnalyticsActionSubject["FEATURED_USER_TAG"] = "featuredUserTag";
    AnalyticsActionSubject["FEATURED_USERS"] = "featuredUsers";
    AnalyticsActionSubject["TWC_FOR_CORE_INVITES"] = "twcForCoreInvites";
    AnalyticsActionSubject["GET_COLLECTIONS"] = "getCollections";
    return AnalyticsActionSubject;
}({});
var $96cbadf73c7b2e85$export$19a393ff78a8b176 = /*#__PURE__*/ function(AnalyticsActionSubjectId) {
    AnalyticsActionSubjectId["CONNECT"] = "connect";
    AnalyticsActionSubjectId["CONTINUE_UPDATE"] = "continueUpdate";
    AnalyticsActionSubjectId["DISCONNECT_UPDATE"] = "disconnectUpdate";
    AnalyticsActionSubjectId["NOT_NOW_UPDATE"] = "notNowUpdate";
    AnalyticsActionSubjectId["UPDATE_WARNING"] = "updateWarning";
    AnalyticsActionSubjectId["FORM"] = "form";
    AnalyticsActionSubjectId["PLUGINS"] = "plugins";
    AnalyticsActionSubjectId["USER_MANAGEMENT"] = "userManagementLink";
    AnalyticsActionSubjectId["ADD_YOUR_TEAM"] = "addYourTeam";
    AnalyticsActionSubjectId["ENABLE_INVITE_LINK_CLOSE"] = "enableInviteLinkCloseButton";
    AnalyticsActionSubjectId["ENABLE_INVITE_LINK_TOGGLE"] = "enableInviteLinkToggle";
    AnalyticsActionSubjectId["COPY_INVITE_LINK_BUTTON"] = "copyInviteLinkButton";
    AnalyticsActionSubjectId["SUBMIT_DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL"] = "submitDriveMultiProductsSuccessModal";
    AnalyticsActionSubjectId["EXIT_DRIVE_MULTI_PRODUCTS_SUCCESS_MODAL"] = "exitDriveMultiProductsSuccessModal";
    return AnalyticsActionSubjectId;
}({});
var $96cbadf73c7b2e85$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["CHECKED"] = "checked";
    AnalyticsAction["UNCHECKED"] = "unchecked";
    AnalyticsAction["LOADED"] = "loaded";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["ADDED"] = "added";
    AnalyticsAction["INVITED"] = "invited";
    AnalyticsAction["REQUESTED"] = "requested";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["EXPOSED"] = "exposed";
    AnalyticsAction["OPENED"] = "opened";
    AnalyticsAction["AUTO_OPENED"] = "autoOpened";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["SKIPPED"] = "skipped";
    AnalyticsAction["CONNECTED"] = "connected";
    AnalyticsAction["CHANGED"] = "changed";
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["UPDATED"] = "updated";
    AnalyticsAction["UPDATE_FAILED"] = "updateFailed";
    AnalyticsAction["CREATED"] = "created";
    AnalyticsAction["CREATE_FAILED"] = "createFailed";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["FETCH_FAILED"] = "fetchFailed";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["HOVERED"] = "hovered";
    AnalyticsAction["TYPED"] = "typed";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["SELECTED"] = "selected";
    AnalyticsAction["EXCLUDED"] = "excluded";
    AnalyticsAction["PREFILLED"] = "prefilled";
    AnalyticsAction["DISMISSED"] = "dismissed";
    return AnalyticsAction;
}({});
var $96cbadf73c7b2e85$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["ADD_PEOPLE"] = "addPeople";
    AnalyticsSource["SLACK_CONNECT_MODAL"] = "slackConnectModal";
    return AnalyticsSource;
}({});
var $96cbadf73c7b2e85$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["VARIATION"] = "variation";
    Cohort["EXPERIMENT"] = "experiment";
    Cohort["CONTROL"] = "control";
    Cohort["NOT_ENROLLED"] = "not-enrolled";
    return Cohort;
}({});
var $96cbadf73c7b2e85$export$ccb31788083e2069 = /*#__PURE__*/ function(ZIndex) {
    ZIndex[ZIndex["MODAL"] = 510] = "MODAL";
    ZIndex[ZIndex["DRAWER"] = 550] = "DRAWER";
    ZIndex[ZIndex["FLOATING"] = 560] = "FLOATING";
    return ZIndex;
}({});
var $96cbadf73c7b2e85$export$69fafa75f060ba9 = /*#__PURE__*/ function(ExperimentKeys) {
    ExperimentKeys["SLACK_AUTO_CONNECT"] = "core_invites_auto_slack_select";
    ExperimentKeys["FEATURED_USERS"] = "recommend_teammates_in_project_invite";
    ExperimentKeys["SLACK_RECOMMENDATIONS"] = "project_invite_3p_slack_recommendations";
    return ExperimentKeys;
}({});
module.exports["InviteProcessingResponseStatus"] = $96cbadf73c7b2e85$export$84ac6743b4a854ba;
module.exports["CollectionType"] = $96cbadf73c7b2e85$export$7ba6a2f178cbf902;
module.exports["isUserWithEmail"] = $96cbadf73c7b2e85$export$d920ab469024b0a2;
module.exports["FAILED_FETCH_ERROR_MESSAGE"] = $96cbadf73c7b2e85$export$1f2663aaa83f036d;
module.exports["NETWORK_ERROR_MESSAGE"] = $96cbadf73c7b2e85$export$65e55894e6e38a89;
module.exports["HOST_NOT_FOUND_ERROR_MESSAGE"] = $96cbadf73c7b2e85$export$f25400ad927aa79c;
module.exports["INVALID_DOMAIN_ERROR_GET_MESSAGE"] = $96cbadf73c7b2e85$export$74522527b7af776f;
module.exports["INVALID_DOMAIN_POST_ERROR_MESSAGE"] = $96cbadf73c7b2e85$export$dfe34f0e34543417;
module.exports["EMAIL_BLOCKED"] = $96cbadf73c7b2e85$export$c53f16dd5442ef61;
module.exports["REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS"] = $96cbadf73c7b2e85$export$e27975535396141b;
module.exports["ERROR_KEY_NO_DEFAULT_GROUP"] = $96cbadf73c7b2e85$export$80a3c1a1eb6f063;
module.exports["NO_DEFAULT_GROUP_ERROR_MESSAGE"] = $96cbadf73c7b2e85$export$e089e1d2018847da;
module.exports["AnalyticsActionSubject"] = $96cbadf73c7b2e85$export$4bce2c1f3a5d9f61;
module.exports["AnalyticsActionSubjectId"] = $96cbadf73c7b2e85$export$19a393ff78a8b176;
module.exports["AnalyticsAction"] = $96cbadf73c7b2e85$export$30c16f5c43437fd7;
module.exports["AnalyticsSource"] = $96cbadf73c7b2e85$export$6890652a1aff7d1c;
module.exports["Cohort"] = $96cbadf73c7b2e85$export$b76685d1b5a37732;
module.exports["ZIndex"] = $96cbadf73c7b2e85$export$ccb31788083e2069;
module.exports["ExperimentKeys"] = $96cbadf73c7b2e85$export$69fafa75f060ba9;

});

parcelRegister("7GQiN", function(module, exports) {
const $0e61dc7e5cbfc47b$export$ab2f49a861856bab = '/gateway/api';
const $0e61dc7e5cbfc47b$export$66fa0c6c43bacd3 = '/permissions/permitted';
const $0e61dc7e5cbfc47b$export$c7fa419e71056b84 = '/invitations/invite';
const $0e61dc7e5cbfc47b$export$700fd7b853cf5f4c = '/v3/invitations/invite';
const $0e61dc7e5cbfc47b$export$df4d1d71f09676b7 = '/v3/invitations/capabilities';
const $0e61dc7e5cbfc47b$export$127769e597bc5ee5 = '/external-users/third-party';
const $0e61dc7e5cbfc47b$export$8502189f48a6b180 = '/invitations/v1/settings/open-invite';
const $0e61dc7e5cbfc47b$export$28fb02d117a2ff8e = '/gateway/api/tap-delivery/api/v3/personalization';
const $0e61dc7e5cbfc47b$export$e84ade9978c1dd85 = '/invitations/v1/settings/domain-enabled-signup-promotion';
const $0e61dc7e5cbfc47b$export$c1f083639d344e75 = '/flag/my';
const $0e61dc7e5cbfc47b$export$8bad17bb0225d989 = '/external-users/orgs';
const $0e61dc7e5cbfc47b$export$f25cfc1135892102 = `${$0e61dc7e5cbfc47b$export$ab2f49a861856bab}/bag`;
const $0e61dc7e5cbfc47b$export$6ec4e6be7b1593f6 = '/growth/ci-funnel-improvement/get-eligible-users';
const $0e61dc7e5cbfc47b$export$efdc9d34fc55b6ef = '/graphql';
const $0e61dc7e5cbfc47b$export$fccab8714d2fb082 = (stargateUrl, orgId)=>`${stargateUrl}/invitations/v1/access-settings/org/${orgId}/open-invite/note`;
module.exports["DEFAULT_STARGATE_SERVICE_URL"] = $0e61dc7e5cbfc47b$export$ab2f49a861856bab;
module.exports["PERMS_URL"] = $0e61dc7e5cbfc47b$export$66fa0c6c43bacd3;
module.exports["BULK_INVITE_URL"] = $0e61dc7e5cbfc47b$export$c7fa419e71056b84;
module.exports["BULK_INVITE_URL_V3"] = $0e61dc7e5cbfc47b$export$700fd7b853cf5f4c;
module.exports["INVITE_CAPABILITIES"] = $0e61dc7e5cbfc47b$export$df4d1d71f09676b7;
module.exports["EXUS_THIRDPARTY_PATH"] = $0e61dc7e5cbfc47b$export$127769e597bc5ee5;
module.exports["OPEN_INVITE_URL"] = $0e61dc7e5cbfc47b$export$8502189f48a6b180;
module.exports["PERSONALIZATION_URL"] = $0e61dc7e5cbfc47b$export$28fb02d117a2ff8e;
module.exports["DIRECT_ACCESS_URL"] = $0e61dc7e5cbfc47b$export$e84ade9978c1dd85;
module.exports["HAVE_I_SEEN_IT_URL"] = $0e61dc7e5cbfc47b$export$c1f083639d344e75;
module.exports["ELIGIBLE_USERS"] = $0e61dc7e5cbfc47b$export$6ec4e6be7b1593f6;
module.exports["GRAPHQL_GATEWAY_URL"] = $0e61dc7e5cbfc47b$export$efdc9d34fc55b6ef;
module.exports["getOpenInviteNoteUrl"] = $0e61dc7e5cbfc47b$export$fccab8714d2fb082;

});

parcelRegister("j9g2s", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ugvwf = parcelRequire("ugvwf");


var $93lRs = parcelRequire("93lRs");

var $lAFHW = parcelRequire("lAFHW");

var $4Nwes = parcelRequire("4Nwes");

var $fIkwO = parcelRequire("fIkwO");

var $l8sjW = parcelRequire("l8sjW");


var $dedJV = parcelRequire("dedJV");


var $bGwCT = parcelRequire("bGwCT");


var $5LksM = parcelRequire("5LksM");


var $9kYFb = parcelRequire("9kYFb");


var $5YNlj = parcelRequire("5YNlj");

const $81ec319ea7bdef09$var$userNetworkFailureMessages = [
    (0, $5LksM.FAILED_FETCH_ERROR_MESSAGE),
    (0, $5LksM.NETWORK_ERROR_MESSAGE),
    (0, $5LksM.HOST_NOT_FOUND_ERROR_MESSAGE)
];
const $81ec319ea7bdef09$var$RECAPTCHA_SITE_KEY_PROD = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $81ec319ea7bdef09$var$RECAPTCHA_SITE_KEY_STAGING = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $81ec319ea7bdef09$var$RECAPTCHA_SITE_KEY_DEV = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';
const $81ec319ea7bdef09$var$DEV_ENV_HOSTNAMES = [
    'localhost',
    '127.0.0.1',
    '0.0.0.0',
    'statlas.atl-paas.net',
    'atlaskit.atlassian.com'
];
const $81ec319ea7bdef09$export$86cd9788f4cc29d7 = (cloudId)=>`${$81ec319ea7bdef09$export$995f5f30765d3edb}/s/${cloudId}/users`;
const $81ec319ea7bdef09$export$4e11ce50a4515334 = (cloudId, accountId)=>`${$81ec319ea7bdef09$export$995f5f30765d3edb}/s/${cloudId}/users/${accountId}`;
const $81ec319ea7bdef09$export$1cfdf9a01e3f7773 = ()=>window.location.host.includes('-dev.com') ? false : true;
const $81ec319ea7bdef09$export$8d028de9c8e0908 = ()=>$81ec319ea7bdef09$var$DEV_ENV_HOSTNAMES.includes(window.location.hostname);
const $81ec319ea7bdef09$export$995f5f30765d3edb = `https://${(0, $dedJV.getATLContextDomain)('admin')}`;
const $81ec319ea7bdef09$export$c8d36b71889c2b08 = (email)=>{
    const parts = email.split('@');
    if (parts.length === 1) return null;
    else if (parts.length === 2 && !parts[0]) return null;
    else if (!parts[parts.length - 1]) return null;
    return parts[parts.length - 1];
};
const $81ec319ea7bdef09$export$ab73fcfda18c2aeb = (productId, cloudId)=>`ari:cloud:${productId}::site/${cloudId}`;
const $81ec319ea7bdef09$export$f8e7d14b19dc8ba5 = (resourceAri)=>{
    const splittedAri = resourceAri.split(':');
    const resourceOwner = splittedAri[2];
    const resourceTypeIdPair = splittedAri[4];
    const [resourceType, ...resourceIdParts] = resourceTypeIdPair.split('/');
    const resourceId = resourceIdParts.join('/');
    return {
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        resourceId: resourceId
    };
};
const $81ec319ea7bdef09$export$8be157e92249183 = (resourceAri)=>{
    try {
        const { resourceOwner: resourceOwner } = $81ec319ea7bdef09$export$f8e7d14b19dc8ba5(resourceAri);
        return resourceOwner;
    } catch (err) {
        return undefined;
    }
};
const $81ec319ea7bdef09$export$b0ff466e2a73d10e = (resourceAri)=>{
    try {
        const { resourceId: resourceId } = $81ec319ea7bdef09$export$f8e7d14b19dc8ba5(resourceAri);
        return resourceId;
    } catch (err) {
        return undefined;
    }
};
const $81ec319ea7bdef09$export$e944286c36b88887 = (provider)=>{
    if (!provider) return Promise.resolve(undefined);
    if (typeof provider === 'function') {
        const fn = provider;
        return fn();
    }
    return Promise.resolve(provider);
};
const $81ec319ea7bdef09$export$dd8cc78d5d02cf89 = {
    id: 'confluence',
    label: 'Confluence',
    landingPath: '/wiki',
    directAccessLocation: 'confluence.core-invites',
    icon: (0, $lAFHW.ConfluenceIcon)
};
const $81ec319ea7bdef09$export$40da91bfe15db8da = {
    id: 'jira-product-discovery',
    label: 'Jira Product Discovery',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $lAFHW.JiraProductDiscoveryIcon)
};
const $81ec319ea7bdef09$export$9179982b4340c968 = {
    id: 'jira-core',
    label: 'Jira Work Management',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $l8sjW.JiraWorkManagementIcon)
};
const $81ec319ea7bdef09$export$f6ec4e033f9ed599 = {
    ...$81ec319ea7bdef09$export$9179982b4340c968,
    label: 'Jira',
    icon: (0, $lAFHW.JiraIcon)
};
const $81ec319ea7bdef09$export$67dec66c2f84e131 = {
    id: 'jira-servicedesk',
    label: 'Jira Service Management',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $lAFHW.JiraServiceManagementIcon)
};
const $81ec319ea7bdef09$export$c4c2eceeb6e5488b = {
    id: 'jira-software',
    label: 'Jira Software',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $fIkwO.JiraSoftwareIcon)
};
const $81ec319ea7bdef09$export$8e461a64f2fe0930 = {
    ...$81ec319ea7bdef09$export$c4c2eceeb6e5488b,
    label: 'Jira',
    icon: (0, $lAFHW.JiraIcon)
};
const $81ec319ea7bdef09$export$b39a466562b19f41 = {
    id: 'jira',
    label: 'Jira',
    landingPath: '',
    directAccessLocation: 'jira.core-invites',
    icon: (0, $lAFHW.JiraIcon)
};
const $81ec319ea7bdef09$export$add2222f3be1ba4d = {
    id: 'trello',
    label: 'Trello',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.TrelloIcon)
};
const $81ec319ea7bdef09$export$bc1299297da00fd1 = {
    id: 'bitbucket',
    label: 'Bitbucket',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.BitbucketIcon)
};
const $81ec319ea7bdef09$export$258797e2c4e99332 = {
    id: 'statuspage',
    label: 'Statuspage',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.StatuspageIcon)
};
const $81ec319ea7bdef09$export$7cd05929724a15f2 = {
    id: 'opsgenie',
    label: 'Opsgenie',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.OpsgenieIcon)
};
const $81ec319ea7bdef09$export$31192b5cccb0825d = {
    id: 'compass',
    label: 'Compass',
    landingPath: '/compass',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.CompassIcon)
};
const $81ec319ea7bdef09$export$5c823b2196b36f8e = {
    id: 'townsquare',
    label: 'Atlas',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $93lRs.AtlasIcon)
};
const $81ec319ea7bdef09$export$742bd743f317c0cf = {
    id: 'avp',
    label: 'Atlassian Analytics',
    landingPath: '/analytics',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.AtlassianAnalyticsIcon)
};
const $81ec319ea7bdef09$export$31b8979f35864357 = {
    id: 'jira-product-discovery',
    label: 'Jira Product Discovery',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.JiraProductDiscoveryIcon)
};
const $81ec319ea7bdef09$export$5d1c3cf9f58560fa = {
    id: 'mercury',
    label: 'Focus',
    landingPath: '/focus',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.FocusIcon)
};
const $81ec319ea7bdef09$export$f036eb35a54338c1 = {
    id: 'loom',
    label: 'Loom',
    landingPath: '',
    directAccessLocation: 'others.core-invites',
    icon: (0, $lAFHW.LoomIcon)
};
const $81ec319ea7bdef09$var$products = [
    $81ec319ea7bdef09$export$dd8cc78d5d02cf89,
    $81ec319ea7bdef09$export$f6ec4e033f9ed599,
    $81ec319ea7bdef09$export$67dec66c2f84e131,
    $81ec319ea7bdef09$export$8e461a64f2fe0930,
    $81ec319ea7bdef09$export$b39a466562b19f41,
    $81ec319ea7bdef09$export$add2222f3be1ba4d,
    $81ec319ea7bdef09$export$bc1299297da00fd1,
    $81ec319ea7bdef09$export$258797e2c4e99332,
    $81ec319ea7bdef09$export$7cd05929724a15f2,
    $81ec319ea7bdef09$export$31192b5cccb0825d,
    $81ec319ea7bdef09$export$5c823b2196b36f8e,
    $81ec319ea7bdef09$export$742bd743f317c0cf,
    $81ec319ea7bdef09$export$31b8979f35864357,
    $81ec319ea7bdef09$export$5d1c3cf9f58560fa,
    $81ec319ea7bdef09$export$f036eb35a54338c1
];
const $81ec319ea7bdef09$export$776b50dd35ff8711 = (products, cloudId)=>{
    const baseUrl = `${$81ec319ea7bdef09$export$995f5f30765d3edb}/s/${cloudId}`;
    return products.length === 1 ? `${baseUrl}/billing/applications/change-edition/${products[0]}.ondemand` : `${baseUrl}/billing-preview`;
};
const $81ec319ea7bdef09$export$1ef808db151854b6 = (productId)=>!!$81ec319ea7bdef09$var$products.find((p)=>productId === p.id);
const $81ec319ea7bdef09$export$5db19e0f3922ef0f = (productId)=>$81ec319ea7bdef09$var$products.find((p)=>productId === p.id);
const $81ec319ea7bdef09$export$4289783c37f529ba = (productId)=>{
    const foundProduct = $81ec319ea7bdef09$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.label : productId || 'Atlassian';
};
const $81ec319ea7bdef09$export$ec409465a0eaca4c = (resourceAri)=>{
    const productId = $81ec319ea7bdef09$export$8be157e92249183(resourceAri);
    return $81ec319ea7bdef09$export$4289783c37f529ba(productId || '');
};
const $81ec319ea7bdef09$export$bc923b2c79b1b36c = (product)=>{
    const foundProduct = $81ec319ea7bdef09$var$products.find((p)=>product === p.label);
    return foundProduct ? foundProduct.id : product;
};
const $81ec319ea7bdef09$export$22a9451e3bf2233f = (productId)=>{
    const foundProduct = $81ec319ea7bdef09$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.icon : (0, $4Nwes.AtlassianIcon);
};
const $81ec319ea7bdef09$export$7c8eb7667509870c = (productId)=>{
    const foundProduct = $81ec319ea7bdef09$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.landingPath : '';
};
const $81ec319ea7bdef09$export$c9b3979837c2ee2e = (productId)=>{
    const foundProduct = $81ec319ea7bdef09$var$products.find((p)=>productId === p.id);
    return foundProduct ? foundProduct.directAccessLocation : 'others.core-invites';
};
const $81ec319ea7bdef09$export$a011c63d9bebc648 = ()=>{
    return window.location.origin;
};
const $81ec319ea7bdef09$export$837b3431660d7232 = (subProduct)=>`jira-${subProduct.toLowerCase()}`;
const $81ec319ea7bdef09$export$d0a8044dce8ff2fc = ()=>{
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $81ec319ea7bdef09$export$3ea53827ed349b2e = (locale)=>{
    return (locale || '').toLowerCase().startsWith('en');
};
function $81ec319ea7bdef09$export$6b52db8960fbef38() {
    (0, $42omo.useEffect)(()=>{
        throw new Error('Something wrong inside Invite people.');
    });
    return null;
}
const $81ec319ea7bdef09$export$271463dc013c475e = (emails)=>{
    const domains = new Set();
    emails.forEach((email)=>{
        const domain = $81ec319ea7bdef09$export$c8d36b71889c2b08(email);
        if (domain) domains.add(domain);
    });
    return Array.from(domains);
};
var $81ec319ea7bdef09$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $81ec319ea7bdef09$var$markFulfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
const $81ec319ea7bdef09$var$markRejected = (errorDetails)=>({
        status: "failed",
        errorDetails: errorDetails
    });
const $81ec319ea7bdef09$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then((successResponse)=>$81ec319ea7bdef09$var$markFulfilled(successResponse)).catch($81ec319ea7bdef09$var$markRejected)));
};
const $81ec319ea7bdef09$export$a117c7b833c15650 = (cache, key, value, size = 50)=>{
    if (cache.size >= size) cache.clear();
    cache.set(key, value);
};
const $81ec319ea7bdef09$export$9de493bcd9b1d977 = 'bad-request';
const $81ec319ea7bdef09$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $81ec319ea7bdef09$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $81ec319ea7bdef09$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $81ec319ea7bdef09$export$e5254cb9f7678ab9) return false;
    return true;
};
const $81ec319ea7bdef09$export$e1b6bb1617649e83 = (errorMessage)=>$81ec319ea7bdef09$var$userNetworkFailureMessages.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $81ec319ea7bdef09$export$7e9cf63a972dd62 = (statusCode)=>{
    return statusCode === 403;
};
const $81ec319ea7bdef09$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $81ec319ea7bdef09$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === (0, $5LksM.ERROR_KEY_NO_DEFAULT_GROUP) || errorMessage === (0, $5LksM.NO_DEFAULT_GROUP_ERROR_MESSAGE);
const $81ec319ea7bdef09$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $81ec319ea7bdef09$export$678d91a98f79a24d(message, status) || status === 400 && ($81ec319ea7bdef09$export$cb3290253184cb70(message, (0, $5LksM.EMAIL_BLOCKED)) || $81ec319ea7bdef09$export$cb3290253184cb70(message, (0, $5LksM.REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS))) || status === 412 && $81ec319ea7bdef09$export$395f41a02d6a8be0(key, message);
};
const $81ec319ea7bdef09$export$d167fb1c42f7d152 = (errorMessage, statusCode)=>statusCode === 400 && (errorMessage === (0, $5LksM.INVALID_DOMAIN_ERROR_GET_MESSAGE) || errorMessage.startsWith((0, $5LksM.INVALID_DOMAIN_POST_ERROR_MESSAGE))) || $81ec319ea7bdef09$export$7e9cf63a972dd62(statusCode);
const $81ec319ea7bdef09$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $81ec319ea7bdef09$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $81ec319ea7bdef09$export$6a44d7a50b763a1c = (status)=>{
    switch(status){
        case (0, $5LksM.InviteProcessingResponseStatus).SUCCESS:
            return true;
        case (0, $5LksM.InviteProcessingResponseStatus).ERROR:
            return false;
        case (0, $5LksM.InviteProcessingResponseStatus).SKIPPED:
            return undefined;
    }
};
const $81ec319ea7bdef09$export$90f8080789b02ddd = (loggedInEmailDomain)=>Boolean(loggedInEmailDomain && (0, $9kYFb.GOOGLE_MAIL_DOMAINS).includes(loggedInEmailDomain));
const $81ec319ea7bdef09$export$b164e8e46eadcf65 = (errorResponse)=>{
    if (errorResponse instanceof (0, $5YNlj.FetchError)) return {
        error: errorResponse,
        errorMessage: errorResponse.message,
        responseCode: errorResponse.responseCode
    };
    if (errorResponse instanceof (0, $bGwCT.FetchError)) return {
        error: errorResponse,
        errorMessage: errorResponse.message,
        responseCode: errorResponse.statusCode
    };
    if (errorResponse instanceof Error) return {
        error: errorResponse,
        errorMessage: errorResponse.message
    };
    const error = (0, $ugvwf.default)(errorResponse);
    return {
        error: error,
        errorMessage: error.message
    };
};
const $81ec319ea7bdef09$export$f6c02f8ff560b96f = ()=>$81ec319ea7bdef09$export$8d028de9c8e0908() ? $81ec319ea7bdef09$var$RECAPTCHA_SITE_KEY_DEV : $81ec319ea7bdef09$export$1cfdf9a01e3f7773() ? $81ec319ea7bdef09$var$RECAPTCHA_SITE_KEY_PROD : $81ec319ea7bdef09$var$RECAPTCHA_SITE_KEY_STAGING;
const $81ec319ea7bdef09$export$5f7ec48d69707ddd = (arr, size)=>{
    const chunks = [];
    let index = 0;
    do {
        const nextIndex = index + size;
        chunks.push(arr.slice(index, nextIndex));
        index = nextIndex;
    }while (index < arr.length);
    return chunks;
};
const $81ec319ea7bdef09$export$db16b8d6f03d2f57 = (slackUser)=>({
        id: slackUser.id,
        email: slackUser.email,
        name: slackUser.name,
        publicName: slackUser.displayName,
        avatarUrl: slackUser.avatarUrl,
        sources: [
            (0, $9kYFb.SLACK_SOURCE)
        ],
        type: 'user',
        isExternal: true
    });
const $81ec319ea7bdef09$export$d976e75aaf898758 = (s)=>s.replace(/[\u200B-\u200D\uFEFF]/g, '');
const $81ec319ea7bdef09$export$ffacee591afa903e = (key)=>{
    const value = $81ec319ea7bdef09$export$f22967b337b5cd11(key);
    if (!value) return null;
    if (![
        'true',
        'false'
    ].includes(value)) {
        $81ec319ea7bdef09$export$686c665f7e55a917(key);
        return null;
    }
    return value === 'true';
};
const $81ec319ea7bdef09$export$f22967b337b5cd11 = (key)=>{
    try {
        return localStorage.getItem(key);
    } catch (e) {
        return null;
    }
};
const $81ec319ea7bdef09$export$c27a17ef9ad21f43 = (key, value)=>{
    try {
        localStorage.setItem(key, value);
    } catch (e) {
        return null;
    }
};
const $81ec319ea7bdef09$export$686c665f7e55a917 = (key)=>{
    try {
        localStorage.removeItem(key);
    } catch (e) {
        return;
    }
};
const $81ec319ea7bdef09$export$e422989e057b7a56 = (orgId)=>`${$81ec319ea7bdef09$export$995f5f30765d3edb}/o/${orgId}/user-access-settings`;
module.exports["adminHubManageUsersHref"] = $81ec319ea7bdef09$export$86cd9788f4cc29d7;
module.exports["CLOUD_ADMIN_URL"] = $81ec319ea7bdef09$export$995f5f30765d3edb;
module.exports["adminHubManageUserHref"] = $81ec319ea7bdef09$export$4e11ce50a4515334;
module.exports["extractDomainFromEmail"] = $81ec319ea7bdef09$export$c8d36b71889c2b08;
module.exports["makeAri"] = $81ec319ea7bdef09$export$ab73fcfda18c2aeb;
module.exports["getProductIdFromResource"] = $81ec319ea7bdef09$export$8be157e92249183;
module.exports["getCloudIdFromResource"] = $81ec319ea7bdef09$export$b0ff466e2a73d10e;
module.exports["getFeaturedUsers"] = $81ec319ea7bdef09$export$e944286c36b88887;
module.exports["JiraProductDiscovery"] = $81ec319ea7bdef09$export$40da91bfe15db8da;
module.exports["JiraWorkManagementProduct"] = $81ec319ea7bdef09$export$9179982b4340c968;
module.exports["JiraServiceManagementProduct"] = $81ec319ea7bdef09$export$67dec66c2f84e131;
module.exports["JiraSoftwareProduct"] = $81ec319ea7bdef09$export$c4c2eceeb6e5488b;
module.exports["JiraProduct"] = $81ec319ea7bdef09$export$b39a466562b19f41;
module.exports["getBillingUrl"] = $81ec319ea7bdef09$export$776b50dd35ff8711;
module.exports["isProductIdWhiteListed"] = $81ec319ea7bdef09$export$1ef808db151854b6;
module.exports["getProductById"] = $81ec319ea7bdef09$export$5db19e0f3922ef0f;
module.exports["getProductTitle"] = $81ec319ea7bdef09$export$4289783c37f529ba;
module.exports["getProductTitleFromAri"] = $81ec319ea7bdef09$export$ec409465a0eaca4c;
module.exports["getProductIcon"] = $81ec319ea7bdef09$export$22a9451e3bf2233f;
module.exports["getLandingPathByProduct"] = $81ec319ea7bdef09$export$7c8eb7667509870c;
module.exports["getDirectAccessLocation"] = $81ec319ea7bdef09$export$c9b3979837c2ee2e;
module.exports["getInstanceUrl"] = $81ec319ea7bdef09$export$a011c63d9bebc648;
module.exports["normalizeJiraSubProduct"] = $81ec319ea7bdef09$export$837b3431660d7232;
module.exports["isEnglishLocale"] = $81ec319ea7bdef09$export$3ea53827ed349b2e;
module.exports["Buggy"] = $81ec319ea7bdef09$export$6b52db8960fbef38;
module.exports["getUniqueEmailDomains"] = $81ec319ea7bdef09$export$271463dc013c475e;
module.exports["waitForAllPromises"] = $81ec319ea7bdef09$export$b43fdcffd84b7b0f;
module.exports["tryCacheWithClear"] = $81ec319ea7bdef09$export$a117c7b833c15650;
module.exports["shouldReportFailedInvite"] = $81ec319ea7bdef09$export$90cda429f609d666;
module.exports["isForbidden"] = $81ec319ea7bdef09$export$7e9cf63a972dd62;
module.exports["isAcceptableFailureForUserInvite"] = $81ec319ea7bdef09$export$1c4c1f7e2d529330;
module.exports["isAcceptableFailure"] = $81ec319ea7bdef09$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForDirectAccess"] = $81ec319ea7bdef09$export$d167fb1c42f7d152;
module.exports["resolveInviteProcessingResponseStatus"] = $81ec319ea7bdef09$export$6a44d7a50b763a1c;
module.exports["hasGmailDomain"] = $81ec319ea7bdef09$export$90f8080789b02ddd;
module.exports["resolveError"] = $81ec319ea7bdef09$export$b164e8e46eadcf65;
module.exports["getRecaptchaSiteKey"] = $81ec319ea7bdef09$export$f6c02f8ff560b96f;
module.exports["chunk"] = $81ec319ea7bdef09$export$5f7ec48d69707ddd;
module.exports["slackToExternalUser"] = $81ec319ea7bdef09$export$db16b8d6f03d2f57;
module.exports["removeZeroWidthCharacters"] = $81ec319ea7bdef09$export$d976e75aaf898758;
module.exports["getBooleanLocalStorageKey"] = $81ec319ea7bdef09$export$ffacee591afa903e;
module.exports["getLocalStorageKey"] = $81ec319ea7bdef09$export$f22967b337b5cd11;
module.exports["removeLocalStorageKey"] = $81ec319ea7bdef09$export$686c665f7e55a917;
module.exports["updateLocalStorageKey"] = $81ec319ea7bdef09$export$c27a17ef9ad21f43;

});

parcelRegister("5YNlj", function(module, exports) {
class $60abc31cda5fa1a2$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
var $60abc31cda5fa1a2$export$162547ab8fc29e40 = /*#__PURE__*/ function(RespCodes) {
    RespCodes[RespCodes["NO_CONTENT"] = 204] = "NO_CONTENT";
    RespCodes[RespCodes["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    RespCodes[RespCodes["BAD_REQUESTS"] = 400] = "BAD_REQUESTS";
    RespCodes[RespCodes["CLIENT_CLOSED_REQUEST"] = 499] = "CLIENT_CLOSED_REQUEST";
    return RespCodes;
}({});
const $60abc31cda5fa1a2$var$handleFailedResponse = async (response, action)=>{
    let failedResponseJson;
    try {
        failedResponseJson = await response.json();
    } catch  {}
    throw new $60abc31cda5fa1a2$export$26e841bcf1aeb894(action, response.status, response, failedResponseJson);
};
const $60abc31cda5fa1a2$var$handleErrorResponse = (err, message)=>{
    if (err instanceof $60abc31cda5fa1a2$export$26e841bcf1aeb894) throw err;
    else if (err instanceof Error) err.message = message + `: ${err.message}`;
    throw err;
};
const $60abc31cda5fa1a2$export$42ff643f16b1faa2 = async (url, action, data)=>{
    try {
        const response = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            ...$60abc31cda5fa1a2$var$requestTemplate(data)
        });
        if (response.ok) return response;
        else return $60abc31cda5fa1a2$var$handleFailedResponse(response, action);
    } catch (err) {
        const message = `Error while executing post request for ${action}`;
        return $60abc31cda5fa1a2$var$handleErrorResponse(err, message);
    }
};
const $60abc31cda5fa1a2$export$6d71b655afe1638d = async (url, action, init)=>{
    try {
        const response = await fetch(url, {
            credentials: 'include',
            ...init
        });
        if (response.status === 304) return response.json();
        if (response.ok) // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
        return response.status === 204 ? undefined : response.json();
        else return $60abc31cda5fa1a2$var$handleFailedResponse(response, action);
    } catch (err) {
        const message = `Error while executing fetch for ${action}`;
        return $60abc31cda5fa1a2$var$handleErrorResponse(err, message);
    }
};
const $60abc31cda5fa1a2$var$requestTemplate = (data, recaptchaOptions)=>({
        headers: {
            'Content-Type': 'application/json',
            ...recaptchaOptions?.recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaOptions.recaptchaToken
            } : {},
            ...recaptchaOptions?.recaptchaAction ? {
                'Recaptcha-Action': recaptchaOptions.recaptchaAction
            } : {}
        },
        body: JSON.stringify(data)
    });
const $60abc31cda5fa1a2$export$c776284ef4b1209a = (url, action, data, recatpchaOptions)=>$60abc31cda5fa1a2$export$6d71b655afe1638d(url, action, {
        method: 'POST',
        ...$60abc31cda5fa1a2$var$requestTemplate(data, recatpchaOptions)
    });
const $60abc31cda5fa1a2$export$d9ed129193d2f249 = (url, action, data)=>$60abc31cda5fa1a2$export$6d71b655afe1638d(url, action, {
        method: 'PUT',
        ...$60abc31cda5fa1a2$var$requestTemplate(data)
    });
const $60abc31cda5fa1a2$var$isUnauthorisedError = (error)=>{
    return error.responseCode === 401;
};
const $60abc31cda5fa1a2$export$382fb8e6e96d8f6d = (error)=>{
    if (error instanceof $60abc31cda5fa1a2$export$26e841bcf1aeb894) return !$60abc31cda5fa1a2$var$isUnauthorisedError(error);
    return true;
};
const $60abc31cda5fa1a2$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: err instanceof $60abc31cda5fa1a2$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
module.exports["FetchError"] = $60abc31cda5fa1a2$export$26e841bcf1aeb894;
module.exports["RespCodes"] = $60abc31cda5fa1a2$export$162547ab8fc29e40;
module.exports["postRequest"] = $60abc31cda5fa1a2$export$42ff643f16b1faa2;
module.exports["fetchJson"] = $60abc31cda5fa1a2$export$6d71b655afe1638d;
module.exports["postJson"] = $60abc31cda5fa1a2$export$c776284ef4b1209a;
module.exports["putJson"] = $60abc31cda5fa1a2$export$d9ed129193d2f249;
module.exports["isSLOFailure"] = $60abc31cda5fa1a2$export$382fb8e6e96d8f6d;
module.exports["getErrorDetails"] = $60abc31cda5fa1a2$export$33e83b6fee5d732d;

});

parcelRegister("2KIzJ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $jS4lk = parcelRequire("jS4lk");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $gWF6I = parcelRequire("gWF6I");


var $u9agA = parcelRequire("u9agA");


var $9hlns = parcelRequire("9hlns");


var $lfrYz = parcelRequire("lfrYz");


var $5LksM = parcelRequire("5LksM");

const $16dc320d9e7d4344$export$3ff2e9aecc309414 = [
    'confluence',
    'jira-software',
    'loom'
];
const $16dc320d9e7d4344$export$4642b6cc5457d20b = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
// https://bitbucket.org/atlassian/commerce-experience/src/master/packages/commerce/ccp-keys/src/offering-relationship-keys.ts
const $16dc320d9e7d4344$var$TWC_OFFERING_RELATIONSHIP_IDS = [
    '9038a217-36b8-4272-a310-d595d2d3dacf',
    // free - staging
    'db8aa835-3e17-4774-98b0-e31f9b880b64',
    // free - production
    'b3a4aea9-5194-43bd-b36c-0b9c74ebe8d4',
    // standard - staging
    '4ecc43de-6a5e-4e35-a875-ac178f32fdd9',
    // standard - production
    '58381e9e-d3ac-4886-9813-acb4fe383375',
    // premium - staging
    '2b7e0a98-3bed-4e80-93c1-4a035d45a60f',
    // premium - production
    'd30dd83c-a8f0-4304-9e83-5f2640eeab1f',
    // enterprise - staging
    '64f91952-23bd-43ef-a600-8af6b34a6394' // enterprise - production
];
const $16dc320d9e7d4344$export$861a3b108f91ce8e = (entitlements)=>{
    const { tenantContexts: tenantContexts } = entitlements || {};
    if (tenantContexts?.length !== 1) return false;
    const [twcContext] = tenantContexts;
    const getCollectionEntitlements = (info)=>info?.entitlement?.relatesFromEntitlements?.map((entitlement)=>{
            const { relationshipType: relationshipType, relationshipId: relationshipId, entitlementId: entitlementId } = entitlement || {};
            if (!relationshipId || !relationshipType || !entitlementId) return undefined;
            if (relationshipType !== 'COLLECTION') return undefined;
            if (!$16dc320d9e7d4344$var$TWC_OFFERING_RELATIONSHIP_IDS.includes(relationshipId)) return undefined;
            return {
                entitlementId: entitlementId,
                relationshipId: relationshipId
            };
        }).filter((entitlement)=>entitlement !== undefined) || [];
    const [first, ...rest] = [
        twcContext?.confluenceEntitlementInfo,
        twcContext?.jiraEntitlementInfo,
        twcContext?.loomEntitlementInfo
    ].map(getCollectionEntitlements); // For each relationshipId, check if all products have the same entitlementId
    for (const { relationshipId: relationshipId, entitlementId: entitlementId } of first){
        if (!relationshipId || !entitlementId) continue;
         // Check if this relationshipId exists in all products with the same entitlementId
        const existsInAll = rest.every((productEntitlements)=>productEntitlements.some((e)=>e.relationshipId === relationshipId && e.entitlementId === entitlementId));
        if (existsInAll) return true;
    }
    return false;
};
const $16dc320d9e7d4344$export$eb50ba3953e0f8 = `
	query CollectionsContextEntitlementsQuery($cloudId: ID!, $skip: Boolean!) {
		tenantContexts(cloudIds: [$cloudId]) @skip(if: $skip) {
			confluenceEntitlementInfo: entitlementInfo(hamsProductKey: "confluence") {
				entitlement {
					relatesFromEntitlements {
						relationshipId
						entitlementId
						relationshipType
					}
				}
			}
			loomEntitlementInfo: entitlementInfo(hamsProductKey: "loom") {
				entitlement {
					relatesFromEntitlements {
						relationshipId
						entitlementId
						relationshipType
					}
				}
			}
			jiraEntitlementInfo: entitlementInfo(hamsProductKey: "jira-software") {
				entitlement {
					relatesFromEntitlements {
						relationshipId
						entitlementId
						relationshipType
					}
				}
			}
		}
	}
`;
const $16dc320d9e7d4344$var$CollectionsContextInternal = ({ children: children, cloudId: cloudId })=>{
    const entitlements = (0, $irOoi.useLazyLoadQuery)((0, $jS4lk.default), {
        cloudId: cloudId || '',
        skip: !cloudId
    }, {
        fetchKey: cloudId
    });
    const collections = (0, $42omo.useMemo)(()=>{
        const hasTeamworkCollection = !!cloudId && $16dc320d9e7d4344$export$861a3b108f91ce8e(entitlements);
        return {
            [(0, $5LksM.CollectionType).TEAMWORK_COLLECTION]: {
                isEnabled: hasTeamworkCollection,
                products: hasTeamworkCollection ? $16dc320d9e7d4344$export$3ff2e9aecc309414 : []
            }
        };
    }, [
        entitlements,
        cloudId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($16dc320d9e7d4344$export$4642b6cc5457d20b.Provider, {
        value: {
            collections: collections,
            shouldFetchCollections: false
        },
        children: children
    });
};
const $16dc320d9e7d4344$var$fallbackContextValue = {
    collections: {},
    shouldFetchCollections: false
};
const $16dc320d9e7d4344$export$2b5787016ed09c4d = ()=>{
    return (0, $42omo.useContext)($16dc320d9e7d4344$export$4642b6cc5457d20b) || $16dc320d9e7d4344$var$fallbackContextValue;
};
const $16dc320d9e7d4344$var$styles = {
    spinnerWrapper: "_1mouxncg _195gxncg _1tke1lit _18m91wug"
};
const $16dc320d9e7d4344$export$5c49ff335b6dd84d = ({ children: children, cloudId: cloudId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $16dc320d9e7d4344$var$styles.spinnerWrapper,
            testId: "invite-people-spinner-collections-context",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lfrYz.CollectionsErrorBoundary), {
            fallback: ()=>children,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.ConditionalRelayEnvironmentProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($16dc320d9e7d4344$var$CollectionsContextInternal, {
                    cloudId: cloudId,
                    children: children
                })
            })
        })
    });
module.exports["twcProductKeys"] = $16dc320d9e7d4344$export$3ff2e9aecc309414;
module.exports["CollectionsContextState"] = $16dc320d9e7d4344$export$4642b6cc5457d20b;
module.exports["getHasTeamworkCollection"] = $16dc320d9e7d4344$export$861a3b108f91ce8e;
module.exports["entitlementsQuery"] = $16dc320d9e7d4344$export$eb50ba3953e0f8;
module.exports["useCollections"] = $16dc320d9e7d4344$export$2b5787016ed09c4d;
module.exports["CollectionsContext"] = $16dc320d9e7d4344$export$5c49ff335b6dd84d;

});

parcelRegister("2huiC", function(module, exports) {
const $ed321ee07b2e6554$export$85183a312807388d = 'peopleTeams';
module.exports["ANALYTICS_CHANNEL"] = $ed321ee07b2e6554$export$85183a312807388d;

});

parcelRegister("jL3L2", function(module, exports) {
$parcel$export(module.exports, "withExperimentalFeatures", () => $286c1b8f3feaf26a$export$186c8989a43aa0bd);
$parcel$export(module.exports, "useExperimentalFeatures", () => $286c1b8f3feaf26a$export$de10fd32f1881334);

var $9YB9I = parcelRequire("9YB9I");

const { withExperimentalFeatures: $286c1b8f3feaf26a$export$186c8989a43aa0bd, useExperimentalFeatures: $286c1b8f3feaf26a$export$de10fd32f1881334 } = (0, $9YB9I.defineExperimentalFeatures)({
    inviteFromAssignModal: {
        oneOf: [
            'control',
            'not-enrolled',
            'variation'
        ],
        defaultValue: 'not-enrolled'
    },
    coreInvitesInJiraProjects: {
        oneOf: [
            'not-enrolled',
            'control',
            'invite-only-variation',
            'invite-only-not-enrolled',
            'invite-ra-variation',
            'invite-ra-not-enrolled'
        ],
        defaultValue: 'not-enrolled'
    },
    /**
	 * @deprecated
	 * This prop has no imapct on the component - holdouts are done using Statsig now
	 */ growthTeamHoldout: {
        oneOf: [
            'not-enrolled',
            'control',
            'variation'
        ],
        defaultValue: 'not-enrolled'
    },
    // Describes if the user is eligible for the invite and assign from board experiment
    // but is enrolled in the control cohort.
    isEligibleForInviteAndAssignFromBoard: false,
    // Specifically for Xflow to Confluence - Onboarding Setup Screen
    // Enable to invite same-org users by either AAID or Emails via /gateway/api/v3/invitations/invite
    confluenceXflowOnboarding: false,
    // A Jira experiment that triggers core invite when a user inserted a link in a project
    // and more than 3 project members require access to the linked resource
    invitePromptOnLinkV3: false,
    // A Jira experiment to re-add the Invite button in the global Nav.
    // When active, it adds a Copy Link button.
    restoreInviteButton: false
});
/**
 * **Removing** your experimental feature?
 *   - Move it here to avoid a MAJOR bump.
 *
 * Doing a MAJOR bump?
 *   - **Clear** this back to `{} as const`.
 */ const $286c1b8f3feaf26a$var$LEGACY_FEATURES = {
};

});

parcelRegister("9kYFb", function(module, exports) {

var $7oH3p = parcelRequire("7oH3p");

const { GOOGLE_SERVICE: $64dfb0d7e053f8a4$export$2d4bcc939d0de9de, MICROSOFT_SERVICE: $64dfb0d7e053f8a4$export$baca96d2908c1d98, PLATFORM_SLACK_SERVICE: $64dfb0d7e053f8a4$export$ec85cabf318c7730 } = (0, $7oH3p.Integration);
const $64dfb0d7e053f8a4$export$d67bd32411617d53 = 480;
const $64dfb0d7e053f8a4$export$cce5ee914c2ec5d9 = 924;
const $64dfb0d7e053f8a4$export$e45b57f6c6c40475 = 10;
const $64dfb0d7e053f8a4$export$62d0f9a4ff93a2b0 = 'https://marketplace.atlassian.com/apps/1216863/jira-cloud-for-slack-official';
const $64dfb0d7e053f8a4$export$86eddaf1565821f9 = 'https://marketplace.atlassian.com/apps/1219518/confluence-cloud-for-slack-official';
const $64dfb0d7e053f8a4$export$6409af570c59625b = [
    'jira',
    'confluence'
];
const $64dfb0d7e053f8a4$export$4dac05a082a29d1 = [
    'gmail.com',
    'googlemail.com'
];
const $64dfb0d7e053f8a4$export$d5b164c0daafb135 = 'Status: Failed fetching integrations.';
var $64dfb0d7e053f8a4$export$165bf6c90b245257 = /*#__PURE__*/ function(ThirdPartySource) {
    ThirdPartySource["SLACK_SOURCE"] = "slack";
    return ThirdPartySource;
}({});
const { SLACK_SOURCE: $64dfb0d7e053f8a4$export$88ece45bb5b3dbd0 } = $64dfb0d7e053f8a4$export$165bf6c90b245257;
module.exports["GOOGLE_SERVICE"] = $64dfb0d7e053f8a4$export$2d4bcc939d0de9de;
module.exports["MICROSOFT_SERVICE"] = $64dfb0d7e053f8a4$export$baca96d2908c1d98;
module.exports["PLATFORM_SLACK_SERVICE"] = $64dfb0d7e053f8a4$export$ec85cabf318c7730;
module.exports["WINDOW_WIDTH"] = $64dfb0d7e053f8a4$export$d67bd32411617d53;
module.exports["WINDOW_HEIGHT"] = $64dfb0d7e053f8a4$export$cce5ee914c2ec5d9;
module.exports["MAX_USERS"] = $64dfb0d7e053f8a4$export$e45b57f6c6c40475;
module.exports["JIRA_SLACK_URL"] = $64dfb0d7e053f8a4$export$62d0f9a4ff93a2b0;
module.exports["CONFLUENCE_SLACK_URL"] = $64dfb0d7e053f8a4$export$86eddaf1565821f9;
module.exports["GOOGLE_MAIL_DOMAINS"] = $64dfb0d7e053f8a4$export$4dac05a082a29d1;
module.exports["FETCH_INTEGRATIONS_FAILURE_MESSAGE"] = $64dfb0d7e053f8a4$export$d5b164c0daafb135;
module.exports["SLACK_SOURCE"] = $64dfb0d7e053f8a4$export$88ece45bb5b3dbd0;

});

parcelRegister("jS4lk", function(module, exports) {
/**
 * @generated SignedSource<<d52e27377bf741828f63793e48d733ad>>
 * @relayHash 4d19c6540d37b16e1b72c88e8cf9cfa6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4710a8cf32c5f44f980814d755dda2c63144b50f8d772fc1ec2ce2b0ff5b4e92
const $1b40b247c25f28de$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "relationshipId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v6 = [
        {
            "kind": "LinkedField",
            "name": "entitlement",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "relatesFromEntitlements",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        }
    ], v7 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "loom"
        }
    ], v8 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "jira-software"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        v9 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "entitlement",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "relatesFromEntitlements",
                    "plural": true,
                    "selections": [
                        v9 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CollectionsContextEntitlementsQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": "confluenceEntitlementInfo",
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": v6 /*: any*/ ,
                                    "storageKey": "entitlementInfo(hamsProductKey:\"confluence\")"
                                },
                                {
                                    "alias": "loomEntitlementInfo",
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": v6 /*: any*/ ,
                                    "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
                                },
                                {
                                    "alias": "jiraEntitlementInfo",
                                    "args": v8 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": v6 /*: any*/ ,
                                    "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CollectionsContextEntitlementsQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": "confluenceEntitlementInfo",
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": v10 /*: any*/ ,
                                    "storageKey": "entitlementInfo(hamsProductKey:\"confluence\")"
                                },
                                {
                                    "alias": "loomEntitlementInfo",
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": v10 /*: any*/ ,
                                    "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
                                },
                                {
                                    "alias": "jiraEntitlementInfo",
                                    "args": v8 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": v10 /*: any*/ ,
                                    "storageKey": "entitlementInfo(hamsProductKey:\"jira-software\")"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4710a8cf32c5f44f980814d755dda2c63144b50f8d772fc1ec2ce2b0ff5b4e92",
            "metadata": {},
            "name": "CollectionsContextEntitlementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1b40b247c25f28de$var$node.hash = "57f7192cdcb94cf46fef216a672be62d";
var $1b40b247c25f28de$export$2e2bcd8739ae039 = $1b40b247c25f28de$var$node;
module.exports["default"] = $1b40b247c25f28de$export$2e2bcd8739ae039;

});

parcelRegister("lfrYz", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7XlxB = parcelRequire("7XlxB");

var $2dswi = parcelRequire("2dswi");


var $5LksM = parcelRequire("5LksM");


var $dacem = parcelRequire("dacem");

class $78d553f5a0156a48$var$CollectionsErrorBoundaryAnalytics extends (0, $7XlxB.BaseInvitePeopleAnalytics) {
    errorBoundaryRendered(attributes) {
        const { productTitle: productTitle, source: source, subProduct: subProduct } = this.commonAttributes;
        this.fireOperational({
            action: (0, $5LksM.AnalyticsAction).RENDERED,
            actionSubject: (0, $5LksM.AnalyticsActionSubject).ERROR_BOUNDARY,
            actionSubjectId: 'twcForCoreInvites',
            attributes: {
                product: productTitle,
                source: source,
                subProduct: subProduct,
                ...attributes
            }
        });
    }
}
const $78d553f5a0156a48$export$7570de2478581fec = ({ children: children, fallback: fallback })=>{
    const analytics = (0, $2dswi.useAnalytics)($78d553f5a0156a48$var$CollectionsErrorBoundaryAnalytics);
    const onError = (error, info)=>{
        analytics.errorBoundaryRendered({
            error: {
                message: error.message,
                stack: info?.componentStack || error.stack
            }
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dacem.BaseErrorBoundary), {
        ErrorComponent: fallback,
        onError: onError,
        children: children
    });
};
module.exports["CollectionsErrorBoundary"] = $78d553f5a0156a48$export$7570de2478581fec;

});

parcelRegister("9YB9I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bt4S1 = parcelRequire("bt4S1");

const $547c5b6c005a9908$export$3cc2af425fada9c6 = (definitions)=>{
    let ExperimentalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext((0, $bt4S1.featuresResolver)(definitions)({}));
    const ExperimentalProvider = ({ value: propValue, children: children })=>{
        // Cache the resolver for each use of the Provider, using the useState() trick.
        // (Can't use useMemo() as it's just a performance hint, not a memoization guarantee)
        const [resolveFeatures] = (0, $42omo.useState)(()=>(0, $bt4S1.featuresResolver)(definitions));
        const resolved = resolveFeatures(propValue);
        return /*#__PURE__*/ (0, $l998X.jsx)(ExperimentalContext.Provider, {
            value: resolved,
            children: children
        });
    };
    const useExperimentalFeatures = ()=>(0, $42omo.useContext)(ExperimentalContext);
    const withExperimentalFeatures = (Component)=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)(ExperimentalProvider, {
                value: props.experimentalFeatures,
                children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                })
            });
    return {
        ExperimentalContext: ExperimentalContext,
        ExperimentalProvider: ExperimentalProvider,
        useExperimentalFeatures: useExperimentalFeatures,
        withExperimentalFeatures: withExperimentalFeatures
    };
};
module.exports["defineExperimentalFeatures"] = $547c5b6c005a9908$export$3cc2af425fada9c6;

});

parcelRegister("dacem", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $6c25ae2d1eb8bd89$export$688779ac61ee945f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, info) {
        this.props.onError?.(error, info);
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError) return ErrorComponent ? /*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {}) : null;
        return children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $6c25ae2d1eb8bd89$export$688779ac61ee945f;

});

parcelRegister("bt4S1", function(module, exports) {
const $e9b239f9b77b820e$export$8a08447eee49a4c8 = (definitions)=>{
    let prevFeaturesProp = null;
    let prevResult = null;
    let compiledDefinitions = null;
    return (featuresProp = {})=>{
        const changedResult = {};
        let changed = false;
        compiledDefinitions = compiledDefinitions ?? $e9b239f9b77b820e$var$compileFeatures(definitions);
        for (const featureKey of Object.keys(definitions)){
            const rawDefinition = definitions[featureKey];
            const compiledDefinition = compiledDefinitions[featureKey];
            const featureValueFromProp = featuresProp[featureKey];
            if (prevFeaturesProp && prevResult) {
                const prevFeatureValueFromProp = prevFeaturesProp[featureKey];
                if (featureValueFromProp === prevFeatureValueFromProp) {
                    changedResult[featureKey] = prevResult[featureKey];
                    continue;
                }
            }
            changed = true;
            changedResult[featureKey] = compiledDefinition.resolve(featureValueFromProp, rawDefinition);
        }
        const result = changed || prevResult === null ? changedResult : prevResult;
        prevFeaturesProp = featuresProp;
        prevResult = result;
        return result;
    };
};
const $e9b239f9b77b820e$var$compileFeatures = (definitions)=>{
    const result = {};
    for (let featureKey of Object.keys(definitions))result[featureKey] = $e9b239f9b77b820e$var$compileFeature(definitions, featureKey);
    return result;
};
const $e9b239f9b77b820e$var$compileFeature = (definitions, featureKey)=>{
    const definition = definitions[featureKey];
    if ($e9b239f9b77b820e$var$isCustomMultivariateDescriptor(definition)) return {
        resolve: $e9b239f9b77b820e$var$customMultivariateDescriptorResolver
    };
    else return {
        resolve: $e9b239f9b77b820e$var$simpleDefaultValueResolver
    };
};
const $e9b239f9b77b820e$var$isCustomMultivariateDescriptor = (definition)=>{
    if (!definition) return false;
    const descriptor = definition;
    return Array.isArray(descriptor.oneOf) && descriptor.defaultValue !== undefined;
};
const $e9b239f9b77b820e$var$simpleDefaultValueResolver = (valueFromProp, definition)=>valueFromProp ?? definition;
const $e9b239f9b77b820e$var$customMultivariateDescriptorResolver = (valueFromProp, definition)=>valueFromProp ?? definition.defaultValue;
module.exports["featuresResolver"] = $e9b239f9b77b820e$export$8a08447eee49a4c8;

});


//# sourceMappingURL=CoreInvites.935b8278.js.map
